/*! For license information please see main.1585e94e.js.LICENSE.txt */
!(function () {
  var e = {
      463: function (e, t, n) {
        'use strict';
        var r = n(791),
          o = n(296);
        function a(e) {
          for (var t = 'https://reactjs.org/docs/error-decoder.html?invariant=' + e, n = 1; n < arguments.length; n++)
            t += '&args[]=' + encodeURIComponent(arguments[n]);
          return (
            'Minified React error #' +
            e +
            '; visit ' +
            t +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        var i = new Set(),
          l = {};
        function u(e, t) {
          s(e, t), s(e + 'Capture', t);
        }
        function s(e, t) {
          for (l[e] = t, e = 0; e < t.length; e++) i.add(t[e]);
        }
        var c = !(
            'undefined' === typeof window ||
            'undefined' === typeof window.document ||
            'undefined' === typeof window.document.createElement
          ),
          f = Object.prototype.hasOwnProperty,
          d =
            /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
          p = {},
          h = {};
        function v(e, t, n, r, o, a, i) {
          (this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
            (this.attributeName = r),
            (this.attributeNamespace = o),
            (this.mustUseProperty = n),
            (this.propertyName = e),
            (this.type = t),
            (this.sanitizeURL = a),
            (this.removeEmptyString = i);
        }
        var m = {};
        'children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style'
          .split(' ')
          .forEach(function (e) {
            m[e] = new v(e, 0, !1, e, null, !1, !1);
          }),
          [
            ['acceptCharset', 'accept-charset'],
            ['className', 'class'],
            ['htmlFor', 'for'],
            ['httpEquiv', 'http-equiv'],
          ].forEach(function (e) {
            var t = e[0];
            m[t] = new v(t, 1, !1, e[1], null, !1, !1);
          }),
          ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (e) {
            m[e] = new v(e, 2, !1, e.toLowerCase(), null, !1, !1);
          }),
          ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (e) {
            m[e] = new v(e, 2, !1, e, null, !1, !1);
          }),
          'allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope'
            .split(' ')
            .forEach(function (e) {
              m[e] = new v(e, 3, !1, e.toLowerCase(), null, !1, !1);
            }),
          ['checked', 'multiple', 'muted', 'selected'].forEach(function (e) {
            m[e] = new v(e, 3, !0, e, null, !1, !1);
          }),
          ['capture', 'download'].forEach(function (e) {
            m[e] = new v(e, 4, !1, e, null, !1, !1);
          }),
          ['cols', 'rows', 'size', 'span'].forEach(function (e) {
            m[e] = new v(e, 6, !1, e, null, !1, !1);
          }),
          ['rowSpan', 'start'].forEach(function (e) {
            m[e] = new v(e, 5, !1, e.toLowerCase(), null, !1, !1);
          });
        var g = /[\-:]([a-z])/g;
        function w(e) {
          return e[1].toUpperCase();
        }
        function y(e, t, n, r) {
          var o = m.hasOwnProperty(t) ? m[t] : null;
          (null !== o
            ? 0 !== o.type
            : r || !(2 < t.length) || ('o' !== t[0] && 'O' !== t[0]) || ('n' !== t[1] && 'N' !== t[1])) &&
            ((function (e, t, n, r) {
              if (
                null === t ||
                'undefined' === typeof t ||
                (function (e, t, n, r) {
                  if (null !== n && 0 === n.type) return !1;
                  switch (typeof t) {
                    case 'function':
                    case 'symbol':
                      return !0;
                    case 'boolean':
                      return (
                        !r &&
                        (null !== n
                          ? !n.acceptsBooleans
                          : 'data-' !== (e = e.toLowerCase().slice(0, 5)) && 'aria-' !== e)
                      );
                    default:
                      return !1;
                  }
                })(e, t, n, r)
              )
                return !0;
              if (r) return !1;
              if (null !== n)
                switch (n.type) {
                  case 3:
                    return !t;
                  case 4:
                    return !1 === t;
                  case 5:
                    return isNaN(t);
                  case 6:
                    return isNaN(t) || 1 > t;
                }
              return !1;
            })(t, n, o, r) && (n = null),
            r || null === o
              ? (function (e) {
                  return !!f.call(h, e) || (!f.call(p, e) && (d.test(e) ? (h[e] = !0) : ((p[e] = !0), !1)));
                })(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, '' + n))
              : o.mustUseProperty
              ? (e[o.propertyName] = null === n ? 3 !== o.type && '' : n)
              : ((t = o.attributeName),
                (r = o.attributeNamespace),
                null === n
                  ? e.removeAttribute(t)
                  : ((n = 3 === (o = o.type) || (4 === o && !0 === n) ? '' : '' + n),
                    r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
        }
        'accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height'
          .split(' ')
          .forEach(function (e) {
            var t = e.replace(g, w);
            m[t] = new v(t, 1, !1, e, null, !1, !1);
          }),
          'xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type'.split(' ').forEach(function (e) {
            var t = e.replace(g, w);
            m[t] = new v(t, 1, !1, e, 'http://www.w3.org/1999/xlink', !1, !1);
          }),
          ['xml:base', 'xml:lang', 'xml:space'].forEach(function (e) {
            var t = e.replace(g, w);
            m[t] = new v(t, 1, !1, e, 'http://www.w3.org/XML/1998/namespace', !1, !1);
          }),
          ['tabIndex', 'crossOrigin'].forEach(function (e) {
            m[e] = new v(e, 1, !1, e.toLowerCase(), null, !1, !1);
          }),
          (m.xlinkHref = new v('xlinkHref', 1, !1, 'xlink:href', 'http://www.w3.org/1999/xlink', !0, !1)),
          ['src', 'href', 'action', 'formAction'].forEach(function (e) {
            m[e] = new v(e, 1, !1, e.toLowerCase(), null, !0, !0);
          });
        var b = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          x = Symbol.for('react.element'),
          k = Symbol.for('react.portal'),
          S = Symbol.for('react.fragment'),
          _ = Symbol.for('react.strict_mode'),
          E = Symbol.for('react.profiler'),
          C = Symbol.for('react.provider'),
          T = Symbol.for('react.context'),
          N = Symbol.for('react.forward_ref'),
          j = Symbol.for('react.suspense'),
          L = Symbol.for('react.suspense_list'),
          A = Symbol.for('react.memo'),
          R = Symbol.for('react.lazy');
        Symbol.for('react.scope'), Symbol.for('react.debug_trace_mode');
        var P = Symbol.for('react.offscreen');
        Symbol.for('react.legacy_hidden'), Symbol.for('react.cache'), Symbol.for('react.tracing_marker');
        var O = Symbol.iterator;
        function D(e) {
          return null === e || 'object' !== typeof e
            ? null
            : 'function' === typeof (e = (O && e[O]) || e['@@iterator'])
            ? e
            : null;
        }
        var I,
          M = Object.assign;
        function z(e) {
          if (void 0 === I)
            try {
              throw Error();
            } catch (n) {
              var t = n.stack.trim().match(/\n( *(at )?)/);
              I = (t && t[1]) || '';
            }
          return '\n' + I + e;
        }
        var V = !1;
        function B(e, t) {
          if (!e || V) return '';
          V = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            if (t)
              if (
                ((t = function () {
                  throw Error();
                }),
                Object.defineProperty(t.prototype, 'props', {
                  set: function () {
                    throw Error();
                  },
                }),
                'object' === typeof Reflect && Reflect.construct)
              ) {
                try {
                  Reflect.construct(t, []);
                } catch (s) {
                  var r = s;
                }
                Reflect.construct(e, [], t);
              } else {
                try {
                  t.call();
                } catch (s) {
                  r = s;
                }
                e.call(t.prototype);
              }
            else {
              try {
                throw Error();
              } catch (s) {
                r = s;
              }
              e();
            }
          } catch (s) {
            if (s && r && 'string' === typeof s.stack) {
              for (
                var o = s.stack.split('\n'), a = r.stack.split('\n'), i = o.length - 1, l = a.length - 1;
                1 <= i && 0 <= l && o[i] !== a[l];

              )
                l--;
              for (; 1 <= i && 0 <= l; i--, l--)
                if (o[i] !== a[l]) {
                  if (1 !== i || 1 !== l)
                    do {
                      if ((i--, 0 > --l || o[i] !== a[l])) {
                        var u = '\n' + o[i].replace(' at new ', ' at ');
                        return (
                          e.displayName && u.includes('<anonymous>') && (u = u.replace('<anonymous>', e.displayName)), u
                        );
                      }
                    } while (1 <= i && 0 <= l);
                  break;
                }
            }
          } finally {
            (V = !1), (Error.prepareStackTrace = n);
          }
          return (e = e ? e.displayName || e.name : '') ? z(e) : '';
        }
        function F(e) {
          switch (e.tag) {
            case 5:
              return z(e.type);
            case 16:
              return z('Lazy');
            case 13:
              return z('Suspense');
            case 19:
              return z('SuspenseList');
            case 0:
            case 2:
            case 15:
              return (e = B(e.type, !1));
            case 11:
              return (e = B(e.type.render, !1));
            case 1:
              return (e = B(e.type, !0));
            default:
              return '';
          }
        }
        function U(e) {
          if (null == e) return null;
          if ('function' === typeof e) return e.displayName || e.name || null;
          if ('string' === typeof e) return e;
          switch (e) {
            case S:
              return 'Fragment';
            case k:
              return 'Portal';
            case E:
              return 'Profiler';
            case _:
              return 'StrictMode';
            case j:
              return 'Suspense';
            case L:
              return 'SuspenseList';
          }
          if ('object' === typeof e)
            switch (e.$$typeof) {
              case T:
                return (e.displayName || 'Context') + '.Consumer';
              case C:
                return (e._context.displayName || 'Context') + '.Provider';
              case N:
                var t = e.render;
                return (
                  (e = e.displayName) ||
                    (e = '' !== (e = t.displayName || t.name || '') ? 'ForwardRef(' + e + ')' : 'ForwardRef'),
                  e
                );
              case A:
                return null !== (t = e.displayName || null) ? t : U(e.type) || 'Memo';
              case R:
                (t = e._payload), (e = e._init);
                try {
                  return U(e(t));
                } catch (n) {}
            }
          return null;
        }
        function H(e) {
          var t = e.type;
          switch (e.tag) {
            case 24:
              return 'Cache';
            case 9:
              return (t.displayName || 'Context') + '.Consumer';
            case 10:
              return (t._context.displayName || 'Context') + '.Provider';
            case 18:
              return 'DehydratedFragment';
            case 11:
              return (
                (e = (e = t.render).displayName || e.name || ''),
                t.displayName || ('' !== e ? 'ForwardRef(' + e + ')' : 'ForwardRef')
              );
            case 7:
              return 'Fragment';
            case 5:
              return t;
            case 4:
              return 'Portal';
            case 3:
              return 'Root';
            case 6:
              return 'Text';
            case 16:
              return U(t);
            case 8:
              return t === _ ? 'StrictMode' : 'Mode';
            case 22:
              return 'Offscreen';
            case 12:
              return 'Profiler';
            case 21:
              return 'Scope';
            case 13:
              return 'Suspense';
            case 19:
              return 'SuspenseList';
            case 25:
              return 'TracingMarker';
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
              if ('function' === typeof t) return t.displayName || t.name || null;
              if ('string' === typeof t) return t;
          }
          return null;
        }
        function q(e) {
          switch (typeof e) {
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
            case 'object':
              return e;
            default:
              return '';
          }
        }
        function W(e) {
          var t = e.type;
          return (e = e.nodeName) && 'input' === e.toLowerCase() && ('checkbox' === t || 'radio' === t);
        }
        function $(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var t = W(e) ? 'checked' : 'value',
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                r = '' + e[t];
              if (
                !e.hasOwnProperty(t) &&
                'undefined' !== typeof n &&
                'function' === typeof n.get &&
                'function' === typeof n.set
              ) {
                var o = n.get,
                  a = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return o.call(this);
                    },
                    set: function (e) {
                      (r = '' + e), a.call(this, e);
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = '' + e;
                    },
                    stopTracking: function () {
                      (e._valueTracker = null), delete e[t];
                    },
                  }
                );
              }
            })(e));
        }
        function G(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = '';
          return e && (r = W(e) ? (e.checked ? 'true' : 'false') : e.value), (e = r) !== n && (t.setValue(e), !0);
        }
        function K(e) {
          if ('undefined' === typeof (e = e || ('undefined' !== typeof document ? document : void 0))) return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        function Q(e, t) {
          var n = t.checked;
          return M({}, t, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: null != n ? n : e._wrapperState.initialChecked,
          });
        }
        function Y(e, t) {
          var n = null == t.defaultValue ? '' : t.defaultValue,
            r = null != t.checked ? t.checked : t.defaultChecked;
          (n = q(null != t.value ? t.value : n)),
            (e._wrapperState = {
              initialChecked: r,
              initialValue: n,
              controlled: 'checkbox' === t.type || 'radio' === t.type ? null != t.checked : null != t.value,
            });
        }
        function X(e, t) {
          null != (t = t.checked) && y(e, 'checked', t, !1);
        }
        function J(e, t) {
          X(e, t);
          var n = q(t.value),
            r = t.type;
          if (null != n)
            'number' === r
              ? ((0 === n && '' === e.value) || e.value != n) && (e.value = '' + n)
              : e.value !== '' + n && (e.value = '' + n);
          else if ('submit' === r || 'reset' === r) return void e.removeAttribute('value');
          t.hasOwnProperty('value')
            ? ee(e, t.type, n)
            : t.hasOwnProperty('defaultValue') && ee(e, t.type, q(t.defaultValue)),
            null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
        }
        function Z(e, t, n) {
          if (t.hasOwnProperty('value') || t.hasOwnProperty('defaultValue')) {
            var r = t.type;
            if (!(('submit' !== r && 'reset' !== r) || (void 0 !== t.value && null !== t.value))) return;
            (t = '' + e._wrapperState.initialValue), n || t === e.value || (e.value = t), (e.defaultValue = t);
          }
          '' !== (n = e.name) && (e.name = ''),
            (e.defaultChecked = !!e._wrapperState.initialChecked),
            '' !== n && (e.name = n);
        }
        function ee(e, t, n) {
          ('number' === t && K(e.ownerDocument) === e) ||
            (null == n
              ? (e.defaultValue = '' + e._wrapperState.initialValue)
              : e.defaultValue !== '' + n && (e.defaultValue = '' + n));
        }
        var te = Array.isArray;
        function ne(e, t, n, r) {
          if (((e = e.options), t)) {
            t = {};
            for (var o = 0; o < n.length; o++) t['$' + n[o]] = !0;
            for (n = 0; n < e.length; n++)
              (o = t.hasOwnProperty('$' + e[n].value)),
                e[n].selected !== o && (e[n].selected = o),
                o && r && (e[n].defaultSelected = !0);
          } else {
            for (n = '' + q(n), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === n) return (e[o].selected = !0), void (r && (e[o].defaultSelected = !0));
              null !== t || e[o].disabled || (t = e[o]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function re(e, t) {
          if (null != t.dangerouslySetInnerHTML) throw Error(a(91));
          return M({}, t, { value: void 0, defaultValue: void 0, children: '' + e._wrapperState.initialValue });
        }
        function oe(e, t) {
          var n = t.value;
          if (null == n) {
            if (((n = t.children), (t = t.defaultValue), null != n)) {
              if (null != t) throw Error(a(92));
              if (te(n)) {
                if (1 < n.length) throw Error(a(93));
                n = n[0];
              }
              t = n;
            }
            null == t && (t = ''), (n = t);
          }
          e._wrapperState = { initialValue: q(n) };
        }
        function ae(e, t) {
          var n = q(t.value),
            r = q(t.defaultValue);
          null != n &&
            ((n = '' + n) !== e.value && (e.value = n),
            null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)),
            null != r && (e.defaultValue = '' + r);
        }
        function ie(e) {
          var t = e.textContent;
          t === e._wrapperState.initialValue && '' !== t && null !== t && (e.value = t);
        }
        function le(e) {
          switch (e) {
            case 'svg':
              return 'http://www.w3.org/2000/svg';
            case 'math':
              return 'http://www.w3.org/1998/Math/MathML';
            default:
              return 'http://www.w3.org/1999/xhtml';
          }
        }
        function ue(e, t) {
          return null == e || 'http://www.w3.org/1999/xhtml' === e
            ? le(t)
            : 'http://www.w3.org/2000/svg' === e && 'foreignObject' === t
            ? 'http://www.w3.org/1999/xhtml'
            : e;
        }
        var se,
          ce,
          fe =
            ((ce = function (e, t) {
              if ('http://www.w3.org/2000/svg' !== e.namespaceURI || 'innerHTML' in e) e.innerHTML = t;
              else {
                for (
                  (se = se || document.createElement('div')).innerHTML = '<svg>' + t.valueOf().toString() + '</svg>',
                    t = se.firstChild;
                  e.firstChild;

                )
                  e.removeChild(e.firstChild);
                for (; t.firstChild; ) e.appendChild(t.firstChild);
              }
            }),
            'undefined' !== typeof MSApp && MSApp.execUnsafeLocalFunction
              ? function (e, t, n, r) {
                  MSApp.execUnsafeLocalFunction(function () {
                    return ce(e, t);
                  });
                }
              : ce);
        function de(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var pe = {
            animationIterationCount: !0,
            aspectRatio: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridArea: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0,
          },
          he = ['Webkit', 'ms', 'Moz', 'O'];
        function ve(e, t, n) {
          return null == t || 'boolean' === typeof t || '' === t
            ? ''
            : n || 'number' !== typeof t || 0 === t || (pe.hasOwnProperty(e) && pe[e])
            ? ('' + t).trim()
            : t + 'px';
        }
        function me(e, t) {
          for (var n in ((e = e.style), t))
            if (t.hasOwnProperty(n)) {
              var r = 0 === n.indexOf('--'),
                o = ve(n, t[n], r);
              'float' === n && (n = 'cssFloat'), r ? e.setProperty(n, o) : (e[n] = o);
            }
        }
        Object.keys(pe).forEach(function (e) {
          he.forEach(function (t) {
            (t = t + e.charAt(0).toUpperCase() + e.substring(1)), (pe[t] = pe[e]);
          });
        });
        var ge = M(
          { menuitem: !0 },
          {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            embed: !0,
            hr: !0,
            img: !0,
            input: !0,
            keygen: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0,
          }
        );
        function we(e, t) {
          if (t) {
            if (ge[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(a(137, e));
            if (null != t.dangerouslySetInnerHTML) {
              if (null != t.children) throw Error(a(60));
              if ('object' !== typeof t.dangerouslySetInnerHTML || !('__html' in t.dangerouslySetInnerHTML))
                throw Error(a(61));
            }
            if (null != t.style && 'object' !== typeof t.style) throw Error(a(62));
          }
        }
        function ye(e, t) {
          if (-1 === e.indexOf('-')) return 'string' === typeof t.is;
          switch (e) {
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return !1;
            default:
              return !0;
          }
        }
        var be = null;
        function xe(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var ke = null,
          Se = null,
          _e = null;
        function Ee(e) {
          if ((e = bo(e))) {
            if ('function' !== typeof ke) throw Error(a(280));
            var t = e.stateNode;
            t && ((t = ko(t)), ke(e.stateNode, e.type, t));
          }
        }
        function Ce(e) {
          Se ? (_e ? _e.push(e) : (_e = [e])) : (Se = e);
        }
        function Te() {
          if (Se) {
            var e = Se,
              t = _e;
            if (((_e = Se = null), Ee(e), t)) for (e = 0; e < t.length; e++) Ee(t[e]);
          }
        }
        function Ne(e, t) {
          return e(t);
        }
        function je() {}
        var Le = !1;
        function Ae(e, t, n) {
          if (Le) return e(t, n);
          Le = !0;
          try {
            return Ne(e, t, n);
          } finally {
            (Le = !1), (null !== Se || null !== _e) && (je(), Te());
          }
        }
        function Re(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = ko(n);
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
              (r = !r.disabled) ||
                (r = !('button' === (e = e.type) || 'input' === e || 'select' === e || 'textarea' === e)),
                (e = !r);
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && 'function' !== typeof n) throw Error(a(231, t, typeof n));
          return n;
        }
        var Pe = !1;
        if (c)
          try {
            var Oe = {};
            Object.defineProperty(Oe, 'passive', {
              get: function () {
                Pe = !0;
              },
            }),
              window.addEventListener('test', Oe, Oe),
              window.removeEventListener('test', Oe, Oe);
          } catch (ce) {
            Pe = !1;
          }
        function De(e, t, n, r, o, a, i, l, u) {
          var s = Array.prototype.slice.call(arguments, 3);
          try {
            t.apply(n, s);
          } catch (c) {
            this.onError(c);
          }
        }
        var Ie = !1,
          Me = null,
          ze = !1,
          Ve = null,
          Be = {
            onError: function (e) {
              (Ie = !0), (Me = e);
            },
          };
        function Fe(e, t, n, r, o, a, i, l, u) {
          (Ie = !1), (Me = null), De.apply(Be, arguments);
        }
        function Ue(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do {
              0 !== (4098 & (t = e).flags) && (n = t.return), (e = t.return);
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function He(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if ((null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t)) return t.dehydrated;
          }
          return null;
        }
        function qe(e) {
          if (Ue(e) !== e) throw Error(a(188));
        }
        function We(e) {
          return null !==
            (e = (function (e) {
              var t = e.alternate;
              if (!t) {
                if (null === (t = Ue(e))) throw Error(a(188));
                return t !== e ? null : e;
              }
              for (var n = e, r = t; ; ) {
                var o = n.return;
                if (null === o) break;
                var i = o.alternate;
                if (null === i) {
                  if (null !== (r = o.return)) {
                    n = r;
                    continue;
                  }
                  break;
                }
                if (o.child === i.child) {
                  for (i = o.child; i; ) {
                    if (i === n) return qe(o), e;
                    if (i === r) return qe(o), t;
                    i = i.sibling;
                  }
                  throw Error(a(188));
                }
                if (n.return !== r.return) (n = o), (r = i);
                else {
                  for (var l = !1, u = o.child; u; ) {
                    if (u === n) {
                      (l = !0), (n = o), (r = i);
                      break;
                    }
                    if (u === r) {
                      (l = !0), (r = o), (n = i);
                      break;
                    }
                    u = u.sibling;
                  }
                  if (!l) {
                    for (u = i.child; u; ) {
                      if (u === n) {
                        (l = !0), (n = i), (r = o);
                        break;
                      }
                      if (u === r) {
                        (l = !0), (r = i), (n = o);
                        break;
                      }
                      u = u.sibling;
                    }
                    if (!l) throw Error(a(189));
                  }
                }
                if (n.alternate !== r) throw Error(a(190));
              }
              if (3 !== n.tag) throw Error(a(188));
              return n.stateNode.current === n ? e : t;
            })(e))
            ? $e(e)
            : null;
        }
        function $e(e) {
          if (5 === e.tag || 6 === e.tag) return e;
          for (e = e.child; null !== e; ) {
            var t = $e(e);
            if (null !== t) return t;
            e = e.sibling;
          }
          return null;
        }
        var Ge = o.unstable_scheduleCallback,
          Ke = o.unstable_cancelCallback,
          Qe = o.unstable_shouldYield,
          Ye = o.unstable_requestPaint,
          Xe = o.unstable_now,
          Je = o.unstable_getCurrentPriorityLevel,
          Ze = o.unstable_ImmediatePriority,
          et = o.unstable_UserBlockingPriority,
          tt = o.unstable_NormalPriority,
          nt = o.unstable_LowPriority,
          rt = o.unstable_IdlePriority,
          ot = null,
          at = null;
        var it = Math.clz32
            ? Math.clz32
            : function (e) {
                return (e >>>= 0), 0 === e ? 32 : (31 - ((lt(e) / ut) | 0)) | 0;
              },
          lt = Math.log,
          ut = Math.LN2;
        var st = 64,
          ct = 4194304;
        function ft(e) {
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return 4194240 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return 130023424 & e;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 1073741824;
            default:
              return e;
          }
        }
        function dt(e, t) {
          var n = e.pendingLanes;
          if (0 === n) return 0;
          var r = 0,
            o = e.suspendedLanes,
            a = e.pingedLanes,
            i = 268435455 & n;
          if (0 !== i) {
            var l = i & ~o;
            0 !== l ? (r = ft(l)) : 0 !== (a &= i) && (r = ft(a));
          } else 0 !== (i = n & ~o) ? (r = ft(i)) : 0 !== a && (r = ft(a));
          if (0 === r) return 0;
          if (
            0 !== t &&
            t !== r &&
            0 === (t & o) &&
            ((o = r & -r) >= (a = t & -t) || (16 === o && 0 !== (4194240 & a)))
          )
            return t;
          if ((0 !== (4 & r) && (r |= 16 & n), 0 !== (t = e.entangledLanes)))
            for (e = e.entanglements, t &= r; 0 < t; ) (o = 1 << (n = 31 - it(t))), (r |= e[n]), (t &= ~o);
          return r;
        }
        function pt(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
              return t + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            default:
              return -1;
          }
        }
        function ht(e) {
          return 0 !== (e = -1073741825 & e.pendingLanes) ? e : 1073741824 & e ? 1073741824 : 0;
        }
        function vt() {
          var e = st;
          return 0 === (4194240 & (st <<= 1)) && (st = 64), e;
        }
        function mt(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function gt(e, t, n) {
          (e.pendingLanes |= t),
            536870912 !== t && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
            ((e = e.eventTimes)[(t = 31 - it(t))] = n);
        }
        function wt(e, t) {
          var n = (e.entangledLanes |= t);
          for (e = e.entanglements; n; ) {
            var r = 31 - it(n),
              o = 1 << r;
            (o & t) | (e[r] & t) && (e[r] |= t), (n &= ~o);
          }
        }
        var yt = 0;
        function bt(e) {
          return 1 < (e &= -e) ? (4 < e ? (0 !== (268435455 & e) ? 16 : 536870912) : 4) : 1;
        }
        var xt,
          kt,
          St,
          _t,
          Et,
          Ct = !1,
          Tt = [],
          Nt = null,
          jt = null,
          Lt = null,
          At = new Map(),
          Rt = new Map(),
          Pt = [],
          Ot =
            'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit'.split(
              ' '
            );
        function Dt(e, t) {
          switch (e) {
            case 'focusin':
            case 'focusout':
              Nt = null;
              break;
            case 'dragenter':
            case 'dragleave':
              jt = null;
              break;
            case 'mouseover':
            case 'mouseout':
              Lt = null;
              break;
            case 'pointerover':
            case 'pointerout':
              At.delete(t.pointerId);
              break;
            case 'gotpointercapture':
            case 'lostpointercapture':
              Rt.delete(t.pointerId);
          }
        }
        function It(e, t, n, r, o, a) {
          return null === e || e.nativeEvent !== a
            ? ((e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: a, targetContainers: [o] }),
              null !== t && null !== (t = bo(t)) && kt(t),
              e)
            : ((e.eventSystemFlags |= r), (t = e.targetContainers), null !== o && -1 === t.indexOf(o) && t.push(o), e);
        }
        function Mt(e) {
          var t = yo(e.target);
          if (null !== t) {
            var n = Ue(t);
            if (null !== n)
              if (13 === (t = n.tag)) {
                if (null !== (t = He(n)))
                  return (
                    (e.blockedOn = t),
                    void Et(e.priority, function () {
                      St(n);
                    })
                  );
              } else if (3 === t && n.stateNode.current.memoizedState.isDehydrated)
                return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function zt(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var n = Qt(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
            if (null !== n) return null !== (t = bo(n)) && kt(t), (e.blockedOn = n), !1;
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            (be = r), n.target.dispatchEvent(r), (be = null), t.shift();
          }
          return !0;
        }
        function Vt(e, t, n) {
          zt(e) && n.delete(t);
        }
        function Bt() {
          (Ct = !1),
            null !== Nt && zt(Nt) && (Nt = null),
            null !== jt && zt(jt) && (jt = null),
            null !== Lt && zt(Lt) && (Lt = null),
            At.forEach(Vt),
            Rt.forEach(Vt);
        }
        function Ft(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null), Ct || ((Ct = !0), o.unstable_scheduleCallback(o.unstable_NormalPriority, Bt)));
        }
        function Ut(e) {
          function t(t) {
            return Ft(t, e);
          }
          if (0 < Tt.length) {
            Ft(Tt[0], e);
            for (var n = 1; n < Tt.length; n++) {
              var r = Tt[n];
              r.blockedOn === e && (r.blockedOn = null);
            }
          }
          for (
            null !== Nt && Ft(Nt, e),
              null !== jt && Ft(jt, e),
              null !== Lt && Ft(Lt, e),
              At.forEach(t),
              Rt.forEach(t),
              n = 0;
            n < Pt.length;
            n++
          )
            (r = Pt[n]).blockedOn === e && (r.blockedOn = null);
          for (; 0 < Pt.length && null === (n = Pt[0]).blockedOn; ) Mt(n), null === n.blockedOn && Pt.shift();
        }
        var Ht = b.ReactCurrentBatchConfig,
          qt = !0;
        function Wt(e, t, n, r) {
          var o = yt,
            a = Ht.transition;
          Ht.transition = null;
          try {
            (yt = 1), Gt(e, t, n, r);
          } finally {
            (yt = o), (Ht.transition = a);
          }
        }
        function $t(e, t, n, r) {
          var o = yt,
            a = Ht.transition;
          Ht.transition = null;
          try {
            (yt = 4), Gt(e, t, n, r);
          } finally {
            (yt = o), (Ht.transition = a);
          }
        }
        function Gt(e, t, n, r) {
          if (qt) {
            var o = Qt(e, t, n, r);
            if (null === o) qr(e, t, r, Kt, n), Dt(e, r);
            else if (
              (function (e, t, n, r, o) {
                switch (t) {
                  case 'focusin':
                    return (Nt = It(Nt, e, t, n, r, o)), !0;
                  case 'dragenter':
                    return (jt = It(jt, e, t, n, r, o)), !0;
                  case 'mouseover':
                    return (Lt = It(Lt, e, t, n, r, o)), !0;
                  case 'pointerover':
                    var a = o.pointerId;
                    return At.set(a, It(At.get(a) || null, e, t, n, r, o)), !0;
                  case 'gotpointercapture':
                    return (a = o.pointerId), Rt.set(a, It(Rt.get(a) || null, e, t, n, r, o)), !0;
                }
                return !1;
              })(o, e, t, n, r)
            )
              r.stopPropagation();
            else if ((Dt(e, r), 4 & t && -1 < Ot.indexOf(e))) {
              for (; null !== o; ) {
                var a = bo(o);
                if ((null !== a && xt(a), null === (a = Qt(e, t, n, r)) && qr(e, t, r, Kt, n), a === o)) break;
                o = a;
              }
              null !== o && r.stopPropagation();
            } else qr(e, t, r, null, n);
          }
        }
        var Kt = null;
        function Qt(e, t, n, r) {
          if (((Kt = null), null !== (e = yo((e = xe(r))))))
            if (null === (t = Ue(e))) e = null;
            else if (13 === (n = t.tag)) {
              if (null !== (e = He(t))) return e;
              e = null;
            } else if (3 === n) {
              if (t.stateNode.current.memoizedState.isDehydrated) return 3 === t.tag ? t.stateNode.containerInfo : null;
              e = null;
            } else t !== e && (e = null);
          return (Kt = e), null;
        }
        function Yt(e) {
          switch (e) {
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            case 'beforeblur':
            case 'afterblur':
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
              return 1;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'toggle':
            case 'touchmove':
            case 'wheel':
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
              return 4;
            case 'message':
              switch (Je()) {
                case Ze:
                  return 1;
                case et:
                  return 4;
                case tt:
                case nt:
                  return 16;
                case rt:
                  return 536870912;
                default:
                  return 16;
              }
            default:
              return 16;
          }
        }
        var Xt = null,
          Jt = null,
          Zt = null;
        function en() {
          if (Zt) return Zt;
          var e,
            t,
            n = Jt,
            r = n.length,
            o = 'value' in Xt ? Xt.value : Xt.textContent,
            a = o.length;
          for (e = 0; e < r && n[e] === o[e]; e++);
          var i = r - e;
          for (t = 1; t <= i && n[r - t] === o[a - t]; t++);
          return (Zt = o.slice(e, 1 < t ? 1 - t : void 0));
        }
        function tn(e) {
          var t = e.keyCode;
          return (
            'charCode' in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : (e = t),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function nn() {
          return !0;
        }
        function rn() {
          return !1;
        }
        function on(e) {
          function t(t, n, r, o, a) {
            for (var i in ((this._reactName = t),
            (this._targetInst = r),
            (this.type = n),
            (this.nativeEvent = o),
            (this.target = a),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(o) : o[i]));
            return (
              (this.isDefaultPrevented = (null != o.defaultPrevented ? o.defaultPrevented : !1 === o.returnValue)
                ? nn
                : rn),
              (this.isPropagationStopped = rn),
              this
            );
          }
          return (
            M(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault ? e.preventDefault() : 'unknown' !== typeof e.returnValue && (e.returnValue = !1),
                  (this.isDefaultPrevented = nn));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : 'unknown' !== typeof e.cancelBubble && (e.cancelBubble = !0),
                  (this.isPropagationStopped = nn));
              },
              persist: function () {},
              isPersistent: nn,
            }),
            t
          );
        }
        var an,
          ln,
          un,
          sn = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          cn = on(sn),
          fn = M({}, sn, { view: 0, detail: 0 }),
          dn = on(fn),
          pn = M({}, fn, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: En,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return 'movementX' in e
                ? e.movementX
                : (e !== un &&
                    (un && 'mousemove' === e.type
                      ? ((an = e.screenX - un.screenX), (ln = e.screenY - un.screenY))
                      : (ln = an = 0),
                    (un = e)),
                  an);
            },
            movementY: function (e) {
              return 'movementY' in e ? e.movementY : ln;
            },
          }),
          hn = on(pn),
          vn = on(M({}, pn, { dataTransfer: 0 })),
          mn = on(M({}, fn, { relatedTarget: 0 })),
          gn = on(M({}, sn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })),
          wn = M({}, sn, {
            clipboardData: function (e) {
              return 'clipboardData' in e ? e.clipboardData : window.clipboardData;
            },
          }),
          yn = on(wn),
          bn = on(M({}, sn, { data: 0 })),
          xn = {
            Esc: 'Escape',
            Spacebar: ' ',
            Left: 'ArrowLeft',
            Up: 'ArrowUp',
            Right: 'ArrowRight',
            Down: 'ArrowDown',
            Del: 'Delete',
            Win: 'OS',
            Menu: 'ContextMenu',
            Apps: 'ContextMenu',
            Scroll: 'ScrollLock',
            MozPrintableKey: 'Unidentified',
          },
          kn = {
            8: 'Backspace',
            9: 'Tab',
            12: 'Clear',
            13: 'Enter',
            16: 'Shift',
            17: 'Control',
            18: 'Alt',
            19: 'Pause',
            20: 'CapsLock',
            27: 'Escape',
            32: ' ',
            33: 'PageUp',
            34: 'PageDown',
            35: 'End',
            36: 'Home',
            37: 'ArrowLeft',
            38: 'ArrowUp',
            39: 'ArrowRight',
            40: 'ArrowDown',
            45: 'Insert',
            46: 'Delete',
            112: 'F1',
            113: 'F2',
            114: 'F3',
            115: 'F4',
            116: 'F5',
            117: 'F6',
            118: 'F7',
            119: 'F8',
            120: 'F9',
            121: 'F10',
            122: 'F11',
            123: 'F12',
            144: 'NumLock',
            145: 'ScrollLock',
            224: 'Meta',
          },
          Sn = { Alt: 'altKey', Control: 'ctrlKey', Meta: 'metaKey', Shift: 'shiftKey' };
        function _n(e) {
          var t = this.nativeEvent;
          return t.getModifierState ? t.getModifierState(e) : !!(e = Sn[e]) && !!t[e];
        }
        function En() {
          return _n;
        }
        var Cn = M({}, fn, {
            key: function (e) {
              if (e.key) {
                var t = xn[e.key] || e.key;
                if ('Unidentified' !== t) return t;
              }
              return 'keypress' === e.type
                ? 13 === (e = tn(e))
                  ? 'Enter'
                  : String.fromCharCode(e)
                : 'keydown' === e.type || 'keyup' === e.type
                ? kn[e.keyCode] || 'Unidentified'
                : '';
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: En,
            charCode: function (e) {
              return 'keypress' === e.type ? tn(e) : 0;
            },
            keyCode: function (e) {
              return 'keydown' === e.type || 'keyup' === e.type ? e.keyCode : 0;
            },
            which: function (e) {
              return 'keypress' === e.type ? tn(e) : 'keydown' === e.type || 'keyup' === e.type ? e.keyCode : 0;
            },
          }),
          Tn = on(Cn),
          Nn = on(
            M({}, pn, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            })
          ),
          jn = on(
            M({}, fn, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: En,
            })
          ),
          Ln = on(M({}, sn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })),
          An = M({}, pn, {
            deltaX: function (e) {
              return 'deltaX' in e ? e.deltaX : 'wheelDeltaX' in e ? -e.wheelDeltaX : 0;
            },
            deltaY: function (e) {
              return 'deltaY' in e
                ? e.deltaY
                : 'wheelDeltaY' in e
                ? -e.wheelDeltaY
                : 'wheelDelta' in e
                ? -e.wheelDelta
                : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          Rn = on(An),
          Pn = [9, 13, 27, 32],
          On = c && 'CompositionEvent' in window,
          Dn = null;
        c && 'documentMode' in document && (Dn = document.documentMode);
        var In = c && 'TextEvent' in window && !Dn,
          Mn = c && (!On || (Dn && 8 < Dn && 11 >= Dn)),
          zn = String.fromCharCode(32),
          Vn = !1;
        function Bn(e, t) {
          switch (e) {
            case 'keyup':
              return -1 !== Pn.indexOf(t.keyCode);
            case 'keydown':
              return 229 !== t.keyCode;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
              return !0;
            default:
              return !1;
          }
        }
        function Fn(e) {
          return 'object' === typeof (e = e.detail) && 'data' in e ? e.data : null;
        }
        var Un = !1;
        var Hn = {
          color: !0,
          date: !0,
          datetime: !0,
          'datetime-local': !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function qn(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return 'input' === t ? !!Hn[e.type] : 'textarea' === t;
        }
        function Wn(e, t, n, r) {
          Ce(r),
            0 < (t = $r(t, 'onChange')).length &&
              ((n = new cn('onChange', 'change', null, n, r)), e.push({ event: n, listeners: t }));
        }
        var $n = null,
          Gn = null;
        function Kn(e) {
          zr(e, 0);
        }
        function Qn(e) {
          if (G(xo(e))) return e;
        }
        function Yn(e, t) {
          if ('change' === e) return t;
        }
        var Xn = !1;
        if (c) {
          var Jn;
          if (c) {
            var Zn = 'oninput' in document;
            if (!Zn) {
              var er = document.createElement('div');
              er.setAttribute('oninput', 'return;'), (Zn = 'function' === typeof er.oninput);
            }
            Jn = Zn;
          } else Jn = !1;
          Xn = Jn && (!document.documentMode || 9 < document.documentMode);
        }
        function tr() {
          $n && ($n.detachEvent('onpropertychange', nr), (Gn = $n = null));
        }
        function nr(e) {
          if ('value' === e.propertyName && Qn(Gn)) {
            var t = [];
            Wn(t, Gn, e, xe(e)), Ae(Kn, t);
          }
        }
        function rr(e, t, n) {
          'focusin' === e ? (tr(), (Gn = n), ($n = t).attachEvent('onpropertychange', nr)) : 'focusout' === e && tr();
        }
        function or(e) {
          if ('selectionchange' === e || 'keyup' === e || 'keydown' === e) return Qn(Gn);
        }
        function ar(e, t) {
          if ('click' === e) return Qn(t);
        }
        function ir(e, t) {
          if ('input' === e || 'change' === e) return Qn(t);
        }
        var lr =
          'function' === typeof Object.is
            ? Object.is
            : function (e, t) {
                return (e === t && (0 !== e || 1 / e === 1 / t)) || (e !== e && t !== t);
              };
        function ur(e, t) {
          if (lr(e, t)) return !0;
          if ('object' !== typeof e || null === e || 'object' !== typeof t || null === t) return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) {
            var o = n[r];
            if (!f.call(t, o) || !lr(e[o], t[o])) return !1;
          }
          return !0;
        }
        function sr(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function cr(e, t) {
          var n,
            r = sr(e);
          for (e = 0; r; ) {
            if (3 === r.nodeType) {
              if (((n = e + r.textContent.length), e <= t && n >= t)) return { node: r, offset: t - e };
              e = n;
            }
            e: {
              for (; r; ) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = sr(r);
          }
        }
        function fr(e, t) {
          return (
            !(!e || !t) &&
            (e === t ||
              ((!e || 3 !== e.nodeType) &&
                (t && 3 === t.nodeType
                  ? fr(e, t.parentNode)
                  : 'contains' in e
                  ? e.contains(t)
                  : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(t)))))
          );
        }
        function dr() {
          for (var e = window, t = K(); t instanceof e.HTMLIFrameElement; ) {
            try {
              var n = 'string' === typeof t.contentWindow.location.href;
            } catch (r) {
              n = !1;
            }
            if (!n) break;
            t = K((e = t.contentWindow).document);
          }
          return t;
        }
        function pr(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            (('input' === t &&
              ('text' === e.type ||
                'search' === e.type ||
                'tel' === e.type ||
                'url' === e.type ||
                'password' === e.type)) ||
              'textarea' === t ||
              'true' === e.contentEditable)
          );
        }
        function hr(e) {
          var t = dr(),
            n = e.focusedElem,
            r = e.selectionRange;
          if (t !== n && n && n.ownerDocument && fr(n.ownerDocument.documentElement, n)) {
            if (null !== r && pr(n))
              if (((t = r.start), void 0 === (e = r.end) && (e = t), 'selectionStart' in n))
                (n.selectionStart = t), (n.selectionEnd = Math.min(e, n.value.length));
              else if ((e = ((t = n.ownerDocument || document) && t.defaultView) || window).getSelection) {
                e = e.getSelection();
                var o = n.textContent.length,
                  a = Math.min(r.start, o);
                (r = void 0 === r.end ? a : Math.min(r.end, o)),
                  !e.extend && a > r && ((o = r), (r = a), (a = o)),
                  (o = cr(n, a));
                var i = cr(n, r);
                o &&
                  i &&
                  (1 !== e.rangeCount ||
                    e.anchorNode !== o.node ||
                    e.anchorOffset !== o.offset ||
                    e.focusNode !== i.node ||
                    e.focusOffset !== i.offset) &&
                  ((t = t.createRange()).setStart(o.node, o.offset),
                  e.removeAllRanges(),
                  a > r ? (e.addRange(t), e.extend(i.node, i.offset)) : (t.setEnd(i.node, i.offset), e.addRange(t)));
              }
            for (t = [], e = n; (e = e.parentNode); )
              1 === e.nodeType && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
            for ('function' === typeof n.focus && n.focus(), n = 0; n < t.length; n++)
              ((e = t[n]).element.scrollLeft = e.left), (e.element.scrollTop = e.top);
          }
        }
        var vr = c && 'documentMode' in document && 11 >= document.documentMode,
          mr = null,
          gr = null,
          wr = null,
          yr = !1;
        function br(e, t, n) {
          var r = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
          yr ||
            null == mr ||
            mr !== K(r) ||
            ('selectionStart' in (r = mr) && pr(r)
              ? (r = { start: r.selectionStart, end: r.selectionEnd })
              : (r = {
                  anchorNode: (r = ((r.ownerDocument && r.ownerDocument.defaultView) || window).getSelection())
                    .anchorNode,
                  anchorOffset: r.anchorOffset,
                  focusNode: r.focusNode,
                  focusOffset: r.focusOffset,
                }),
            (wr && ur(wr, r)) ||
              ((wr = r),
              0 < (r = $r(gr, 'onSelect')).length &&
                ((t = new cn('onSelect', 'select', null, t, n)), e.push({ event: t, listeners: r }), (t.target = mr))));
        }
        function xr(e, t) {
          var n = {};
          return (
            (n[e.toLowerCase()] = t.toLowerCase()), (n['Webkit' + e] = 'webkit' + t), (n['Moz' + e] = 'moz' + t), n
          );
        }
        var kr = {
            animationend: xr('Animation', 'AnimationEnd'),
            animationiteration: xr('Animation', 'AnimationIteration'),
            animationstart: xr('Animation', 'AnimationStart'),
            transitionend: xr('Transition', 'TransitionEnd'),
          },
          Sr = {},
          _r = {};
        function Er(e) {
          if (Sr[e]) return Sr[e];
          if (!kr[e]) return e;
          var t,
            n = kr[e];
          for (t in n) if (n.hasOwnProperty(t) && t in _r) return (Sr[e] = n[t]);
          return e;
        }
        c &&
          ((_r = document.createElement('div').style),
          'AnimationEvent' in window ||
            (delete kr.animationend.animation,
            delete kr.animationiteration.animation,
            delete kr.animationstart.animation),
          'TransitionEvent' in window || delete kr.transitionend.transition);
        var Cr = Er('animationend'),
          Tr = Er('animationiteration'),
          Nr = Er('animationstart'),
          jr = Er('transitionend'),
          Lr = new Map(),
          Ar =
            'abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
              ' '
            );
        function Rr(e, t) {
          Lr.set(e, t), u(t, [e]);
        }
        for (var Pr = 0; Pr < Ar.length; Pr++) {
          var Or = Ar[Pr];
          Rr(Or.toLowerCase(), 'on' + (Or[0].toUpperCase() + Or.slice(1)));
        }
        Rr(Cr, 'onAnimationEnd'),
          Rr(Tr, 'onAnimationIteration'),
          Rr(Nr, 'onAnimationStart'),
          Rr('dblclick', 'onDoubleClick'),
          Rr('focusin', 'onFocus'),
          Rr('focusout', 'onBlur'),
          Rr(jr, 'onTransitionEnd'),
          s('onMouseEnter', ['mouseout', 'mouseover']),
          s('onMouseLeave', ['mouseout', 'mouseover']),
          s('onPointerEnter', ['pointerout', 'pointerover']),
          s('onPointerLeave', ['pointerout', 'pointerover']),
          u('onChange', 'change click focusin focusout input keydown keyup selectionchange'.split(' ')),
          u(
            'onSelect',
            'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(' ')
          ),
          u('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']),
          u('onCompositionEnd', 'compositionend focusout keydown keypress keyup mousedown'.split(' ')),
          u('onCompositionStart', 'compositionstart focusout keydown keypress keyup mousedown'.split(' ')),
          u('onCompositionUpdate', 'compositionupdate focusout keydown keypress keyup mousedown'.split(' '));
        var Dr =
            'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
              ' '
            ),
          Ir = new Set('cancel close invalid load scroll toggle'.split(' ').concat(Dr));
        function Mr(e, t, n) {
          var r = e.type || 'unknown-event';
          (e.currentTarget = n),
            (function (e, t, n, r, o, i, l, u, s) {
              if ((Fe.apply(this, arguments), Ie)) {
                if (!Ie) throw Error(a(198));
                var c = Me;
                (Ie = !1), (Me = null), ze || ((ze = !0), (Ve = c));
              }
            })(r, t, void 0, e),
            (e.currentTarget = null);
        }
        function zr(e, t) {
          t = 0 !== (4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              o = r.event;
            r = r.listeners;
            e: {
              var a = void 0;
              if (t)
                for (var i = r.length - 1; 0 <= i; i--) {
                  var l = r[i],
                    u = l.instance,
                    s = l.currentTarget;
                  if (((l = l.listener), u !== a && o.isPropagationStopped())) break e;
                  Mr(o, l, s), (a = u);
                }
              else
                for (i = 0; i < r.length; i++) {
                  if (
                    ((u = (l = r[i]).instance),
                    (s = l.currentTarget),
                    (l = l.listener),
                    u !== a && o.isPropagationStopped())
                  )
                    break e;
                  Mr(o, l, s), (a = u);
                }
            }
          }
          if (ze) throw ((e = Ve), (ze = !1), (Ve = null), e);
        }
        function Vr(e, t) {
          var n = t[mo];
          void 0 === n && (n = t[mo] = new Set());
          var r = e + '__bubble';
          n.has(r) || (Hr(t, e, 2, !1), n.add(r));
        }
        function Br(e, t, n) {
          var r = 0;
          t && (r |= 4), Hr(n, e, r, t);
        }
        var Fr = '_reactListening' + Math.random().toString(36).slice(2);
        function Ur(e) {
          if (!e[Fr]) {
            (e[Fr] = !0),
              i.forEach(function (t) {
                'selectionchange' !== t && (Ir.has(t) || Br(t, !1, e), Br(t, !0, e));
              });
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Fr] || ((t[Fr] = !0), Br('selectionchange', !1, t));
          }
        }
        function Hr(e, t, n, r) {
          switch (Yt(t)) {
            case 1:
              var o = Wt;
              break;
            case 4:
              o = $t;
              break;
            default:
              o = Gt;
          }
          (n = o.bind(null, t, n, e)),
            (o = void 0),
            !Pe || ('touchstart' !== t && 'touchmove' !== t && 'wheel' !== t) || (o = !0),
            r
              ? void 0 !== o
                ? e.addEventListener(t, n, { capture: !0, passive: o })
                : e.addEventListener(t, n, !0)
              : void 0 !== o
              ? e.addEventListener(t, n, { passive: o })
              : e.addEventListener(t, n, !1);
        }
        function qr(e, t, n, r, o) {
          var a = r;
          if (0 === (1 & t) && 0 === (2 & t) && null !== r)
            e: for (;;) {
              if (null === r) return;
              var i = r.tag;
              if (3 === i || 4 === i) {
                var l = r.stateNode.containerInfo;
                if (l === o || (8 === l.nodeType && l.parentNode === o)) break;
                if (4 === i)
                  for (i = r.return; null !== i; ) {
                    var u = i.tag;
                    if (
                      (3 === u || 4 === u) &&
                      ((u = i.stateNode.containerInfo) === o || (8 === u.nodeType && u.parentNode === o))
                    )
                      return;
                    i = i.return;
                  }
                for (; null !== l; ) {
                  if (null === (i = yo(l))) return;
                  if (5 === (u = i.tag) || 6 === u) {
                    r = a = i;
                    continue e;
                  }
                  l = l.parentNode;
                }
              }
              r = r.return;
            }
          Ae(function () {
            var r = a,
              o = xe(n),
              i = [];
            e: {
              var l = Lr.get(e);
              if (void 0 !== l) {
                var u = cn,
                  s = e;
                switch (e) {
                  case 'keypress':
                    if (0 === tn(n)) break e;
                  case 'keydown':
                  case 'keyup':
                    u = Tn;
                    break;
                  case 'focusin':
                    (s = 'focus'), (u = mn);
                    break;
                  case 'focusout':
                    (s = 'blur'), (u = mn);
                    break;
                  case 'beforeblur':
                  case 'afterblur':
                    u = mn;
                    break;
                  case 'click':
                    if (2 === n.button) break e;
                  case 'auxclick':
                  case 'dblclick':
                  case 'mousedown':
                  case 'mousemove':
                  case 'mouseup':
                  case 'mouseout':
                  case 'mouseover':
                  case 'contextmenu':
                    u = hn;
                    break;
                  case 'drag':
                  case 'dragend':
                  case 'dragenter':
                  case 'dragexit':
                  case 'dragleave':
                  case 'dragover':
                  case 'dragstart':
                  case 'drop':
                    u = vn;
                    break;
                  case 'touchcancel':
                  case 'touchend':
                  case 'touchmove':
                  case 'touchstart':
                    u = jn;
                    break;
                  case Cr:
                  case Tr:
                  case Nr:
                    u = gn;
                    break;
                  case jr:
                    u = Ln;
                    break;
                  case 'scroll':
                    u = dn;
                    break;
                  case 'wheel':
                    u = Rn;
                    break;
                  case 'copy':
                  case 'cut':
                  case 'paste':
                    u = yn;
                    break;
                  case 'gotpointercapture':
                  case 'lostpointercapture':
                  case 'pointercancel':
                  case 'pointerdown':
                  case 'pointermove':
                  case 'pointerout':
                  case 'pointerover':
                  case 'pointerup':
                    u = Nn;
                }
                var c = 0 !== (4 & t),
                  f = !c && 'scroll' === e,
                  d = c ? (null !== l ? l + 'Capture' : null) : l;
                c = [];
                for (var p, h = r; null !== h; ) {
                  var v = (p = h).stateNode;
                  if (
                    (5 === p.tag &&
                      null !== v &&
                      ((p = v), null !== d && null != (v = Re(h, d)) && c.push(Wr(h, v, p))),
                    f)
                  )
                    break;
                  h = h.return;
                }
                0 < c.length && ((l = new u(l, s, null, n, o)), i.push({ event: l, listeners: c }));
              }
            }
            if (0 === (7 & t)) {
              if (
                ((u = 'mouseout' === e || 'pointerout' === e),
                (!(l = 'mouseover' === e || 'pointerover' === e) ||
                  n === be ||
                  !(s = n.relatedTarget || n.fromElement) ||
                  (!yo(s) && !s[vo])) &&
                  (u || l) &&
                  ((l = o.window === o ? o : (l = o.ownerDocument) ? l.defaultView || l.parentWindow : window),
                  u
                    ? ((u = r),
                      null !== (s = (s = n.relatedTarget || n.toElement) ? yo(s) : null) &&
                        (s !== (f = Ue(s)) || (5 !== s.tag && 6 !== s.tag)) &&
                        (s = null))
                    : ((u = null), (s = r)),
                  u !== s))
              ) {
                if (
                  ((c = hn),
                  (v = 'onMouseLeave'),
                  (d = 'onMouseEnter'),
                  (h = 'mouse'),
                  ('pointerout' !== e && 'pointerover' !== e) ||
                    ((c = Nn), (v = 'onPointerLeave'), (d = 'onPointerEnter'), (h = 'pointer')),
                  (f = null == u ? l : xo(u)),
                  (p = null == s ? l : xo(s)),
                  ((l = new c(v, h + 'leave', u, n, o)).target = f),
                  (l.relatedTarget = p),
                  (v = null),
                  yo(o) === r && (((c = new c(d, h + 'enter', s, n, o)).target = p), (c.relatedTarget = f), (v = c)),
                  (f = v),
                  u && s)
                )
                  e: {
                    for (d = s, h = 0, p = c = u; p; p = Gr(p)) h++;
                    for (p = 0, v = d; v; v = Gr(v)) p++;
                    for (; 0 < h - p; ) (c = Gr(c)), h--;
                    for (; 0 < p - h; ) (d = Gr(d)), p--;
                    for (; h--; ) {
                      if (c === d || (null !== d && c === d.alternate)) break e;
                      (c = Gr(c)), (d = Gr(d));
                    }
                    c = null;
                  }
                else c = null;
                null !== u && Kr(i, l, u, c, !1), null !== s && null !== f && Kr(i, f, s, c, !0);
              }
              if (
                'select' === (u = (l = r ? xo(r) : window).nodeName && l.nodeName.toLowerCase()) ||
                ('input' === u && 'file' === l.type)
              )
                var m = Yn;
              else if (qn(l))
                if (Xn) m = ir;
                else {
                  m = or;
                  var g = rr;
                }
              else
                (u = l.nodeName) &&
                  'input' === u.toLowerCase() &&
                  ('checkbox' === l.type || 'radio' === l.type) &&
                  (m = ar);
              switch (
                (m && (m = m(e, r))
                  ? Wn(i, m, n, o)
                  : (g && g(e, l, r),
                    'focusout' === e &&
                      (g = l._wrapperState) &&
                      g.controlled &&
                      'number' === l.type &&
                      ee(l, 'number', l.value)),
                (g = r ? xo(r) : window),
                e)
              ) {
                case 'focusin':
                  (qn(g) || 'true' === g.contentEditable) && ((mr = g), (gr = r), (wr = null));
                  break;
                case 'focusout':
                  wr = gr = mr = null;
                  break;
                case 'mousedown':
                  yr = !0;
                  break;
                case 'contextmenu':
                case 'mouseup':
                case 'dragend':
                  (yr = !1), br(i, n, o);
                  break;
                case 'selectionchange':
                  if (vr) break;
                case 'keydown':
                case 'keyup':
                  br(i, n, o);
              }
              var w;
              if (On)
                e: {
                  switch (e) {
                    case 'compositionstart':
                      var y = 'onCompositionStart';
                      break e;
                    case 'compositionend':
                      y = 'onCompositionEnd';
                      break e;
                    case 'compositionupdate':
                      y = 'onCompositionUpdate';
                      break e;
                  }
                  y = void 0;
                }
              else
                Un
                  ? Bn(e, n) && (y = 'onCompositionEnd')
                  : 'keydown' === e && 229 === n.keyCode && (y = 'onCompositionStart');
              y &&
                (Mn &&
                  'ko' !== n.locale &&
                  (Un || 'onCompositionStart' !== y
                    ? 'onCompositionEnd' === y && Un && (w = en())
                    : ((Jt = 'value' in (Xt = o) ? Xt.value : Xt.textContent), (Un = !0))),
                0 < (g = $r(r, y)).length &&
                  ((y = new bn(y, e, null, n, o)),
                  i.push({ event: y, listeners: g }),
                  w ? (y.data = w) : null !== (w = Fn(n)) && (y.data = w))),
                (w = In
                  ? (function (e, t) {
                      switch (e) {
                        case 'compositionend':
                          return Fn(t);
                        case 'keypress':
                          return 32 !== t.which ? null : ((Vn = !0), zn);
                        case 'textInput':
                          return (e = t.data) === zn && Vn ? null : e;
                        default:
                          return null;
                      }
                    })(e, n)
                  : (function (e, t) {
                      if (Un)
                        return 'compositionend' === e || (!On && Bn(e, t))
                          ? ((e = en()), (Zt = Jt = Xt = null), (Un = !1), e)
                          : null;
                      switch (e) {
                        case 'paste':
                        default:
                          return null;
                        case 'keypress':
                          if (!(t.ctrlKey || t.altKey || t.metaKey) || (t.ctrlKey && t.altKey)) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case 'compositionend':
                          return Mn && 'ko' !== t.locale ? null : t.data;
                      }
                    })(e, n)) &&
                  0 < (r = $r(r, 'onBeforeInput')).length &&
                  ((o = new bn('onBeforeInput', 'beforeinput', null, n, o)),
                  i.push({ event: o, listeners: r }),
                  (o.data = w));
            }
            zr(i, t);
          });
        }
        function Wr(e, t, n) {
          return { instance: e, listener: t, currentTarget: n };
        }
        function $r(e, t) {
          for (var n = t + 'Capture', r = []; null !== e; ) {
            var o = e,
              a = o.stateNode;
            5 === o.tag &&
              null !== a &&
              ((o = a),
              null != (a = Re(e, n)) && r.unshift(Wr(e, a, o)),
              null != (a = Re(e, t)) && r.push(Wr(e, a, o))),
              (e = e.return);
          }
          return r;
        }
        function Gr(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag);
          return e || null;
        }
        function Kr(e, t, n, r, o) {
          for (var a = t._reactName, i = []; null !== n && n !== r; ) {
            var l = n,
              u = l.alternate,
              s = l.stateNode;
            if (null !== u && u === r) break;
            5 === l.tag &&
              null !== s &&
              ((l = s),
              o
                ? null != (u = Re(n, a)) && i.unshift(Wr(n, u, l))
                : o || (null != (u = Re(n, a)) && i.push(Wr(n, u, l)))),
              (n = n.return);
          }
          0 !== i.length && e.push({ event: t, listeners: i });
        }
        var Qr = /\r\n?/g,
          Yr = /\u0000|\uFFFD/g;
        function Xr(e) {
          return ('string' === typeof e ? e : '' + e).replace(Qr, '\n').replace(Yr, '');
        }
        function Jr(e, t, n) {
          if (((t = Xr(t)), Xr(e) !== t && n)) throw Error(a(425));
        }
        function Zr() {}
        var eo = null,
          to = null;
        function no(e, t) {
          return (
            'textarea' === e ||
            'noscript' === e ||
            'string' === typeof t.children ||
            'number' === typeof t.children ||
            ('object' === typeof t.dangerouslySetInnerHTML &&
              null !== t.dangerouslySetInnerHTML &&
              null != t.dangerouslySetInnerHTML.__html)
          );
        }
        var ro = 'function' === typeof setTimeout ? setTimeout : void 0,
          oo = 'function' === typeof clearTimeout ? clearTimeout : void 0,
          ao = 'function' === typeof Promise ? Promise : void 0,
          io =
            'function' === typeof queueMicrotask
              ? queueMicrotask
              : 'undefined' !== typeof ao
              ? function (e) {
                  return ao.resolve(null).then(e).catch(lo);
                }
              : ro;
        function lo(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function uo(e, t) {
          var n = t,
            r = 0;
          do {
            var o = n.nextSibling;
            if ((e.removeChild(n), o && 8 === o.nodeType))
              if ('/$' === (n = o.data)) {
                if (0 === r) return e.removeChild(o), void Ut(t);
                r--;
              } else ('$' !== n && '$?' !== n && '$!' !== n) || r++;
            n = o;
          } while (n);
          Ut(t);
        }
        function so(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
              if ('$' === (t = e.data) || '$!' === t || '$?' === t) break;
              if ('/$' === t) return null;
            }
          }
          return e;
        }
        function co(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ('$' === n || '$!' === n || '$?' === n) {
                if (0 === t) return e;
                t--;
              } else '/$' === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        var fo = Math.random().toString(36).slice(2),
          po = '__reactFiber$' + fo,
          ho = '__reactProps$' + fo,
          vo = '__reactContainer$' + fo,
          mo = '__reactEvents$' + fo,
          go = '__reactListeners$' + fo,
          wo = '__reactHandles$' + fo;
        function yo(e) {
          var t = e[po];
          if (t) return t;
          for (var n = e.parentNode; n; ) {
            if ((t = n[vo] || n[po])) {
              if (((n = t.alternate), null !== t.child || (null !== n && null !== n.child)))
                for (e = co(e); null !== e; ) {
                  if ((n = e[po])) return n;
                  e = co(e);
                }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function bo(e) {
          return !(e = e[po] || e[vo]) || (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag) ? null : e;
        }
        function xo(e) {
          if (5 === e.tag || 6 === e.tag) return e.stateNode;
          throw Error(a(33));
        }
        function ko(e) {
          return e[ho] || null;
        }
        var So = [],
          _o = -1;
        function Eo(e) {
          return { current: e };
        }
        function Co(e) {
          0 > _o || ((e.current = So[_o]), (So[_o] = null), _o--);
        }
        function To(e, t) {
          _o++, (So[_o] = e.current), (e.current = t);
        }
        var No = {},
          jo = Eo(No),
          Lo = Eo(!1),
          Ao = No;
        function Ro(e, t) {
          var n = e.type.contextTypes;
          if (!n) return No;
          var r = e.stateNode;
          if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
            return r.__reactInternalMemoizedMaskedChildContext;
          var o,
            a = {};
          for (o in n) a[o] = t[o];
          return (
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t),
              (e.__reactInternalMemoizedMaskedChildContext = a)),
            a
          );
        }
        function Po(e) {
          return null !== (e = e.childContextTypes) && void 0 !== e;
        }
        function Oo() {
          Co(Lo), Co(jo);
        }
        function Do(e, t, n) {
          if (jo.current !== No) throw Error(a(168));
          To(jo, t), To(Lo, n);
        }
        function Io(e, t, n) {
          var r = e.stateNode;
          if (((t = t.childContextTypes), 'function' !== typeof r.getChildContext)) return n;
          for (var o in (r = r.getChildContext())) if (!(o in t)) throw Error(a(108, H(e) || 'Unknown', o));
          return M({}, n, r);
        }
        function Mo(e) {
          return (
            (e = ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || No),
            (Ao = jo.current),
            To(jo, e),
            To(Lo, Lo.current),
            !0
          );
        }
        function zo(e, t, n) {
          var r = e.stateNode;
          if (!r) throw Error(a(169));
          n
            ? ((e = Io(e, t, Ao)), (r.__reactInternalMemoizedMergedChildContext = e), Co(Lo), Co(jo), To(jo, e))
            : Co(Lo),
            To(Lo, n);
        }
        var Vo = null,
          Bo = !1,
          Fo = !1;
        function Uo(e) {
          null === Vo ? (Vo = [e]) : Vo.push(e);
        }
        function Ho() {
          if (!Fo && null !== Vo) {
            Fo = !0;
            var e = 0,
              t = yt;
            try {
              var n = Vo;
              for (yt = 1; e < n.length; e++) {
                var r = n[e];
                do {
                  r = r(!0);
                } while (null !== r);
              }
              (Vo = null), (Bo = !1);
            } catch (o) {
              throw (null !== Vo && (Vo = Vo.slice(e + 1)), Ge(Ze, Ho), o);
            } finally {
              (yt = t), (Fo = !1);
            }
          }
          return null;
        }
        var qo = [],
          Wo = 0,
          $o = null,
          Go = 0,
          Ko = [],
          Qo = 0,
          Yo = null,
          Xo = 1,
          Jo = '';
        function Zo(e, t) {
          (qo[Wo++] = Go), (qo[Wo++] = $o), ($o = e), (Go = t);
        }
        function ea(e, t, n) {
          (Ko[Qo++] = Xo), (Ko[Qo++] = Jo), (Ko[Qo++] = Yo), (Yo = e);
          var r = Xo;
          e = Jo;
          var o = 32 - it(r) - 1;
          (r &= ~(1 << o)), (n += 1);
          var a = 32 - it(t) + o;
          if (30 < a) {
            var i = o - (o % 5);
            (a = (r & ((1 << i) - 1)).toString(32)),
              (r >>= i),
              (o -= i),
              (Xo = (1 << (32 - it(t) + o)) | (n << o) | r),
              (Jo = a + e);
          } else (Xo = (1 << a) | (n << o) | r), (Jo = e);
        }
        function ta(e) {
          null !== e.return && (Zo(e, 1), ea(e, 1, 0));
        }
        function na(e) {
          for (; e === $o; ) ($o = qo[--Wo]), (qo[Wo] = null), (Go = qo[--Wo]), (qo[Wo] = null);
          for (; e === Yo; )
            (Yo = Ko[--Qo]), (Ko[Qo] = null), (Jo = Ko[--Qo]), (Ko[Qo] = null), (Xo = Ko[--Qo]), (Ko[Qo] = null);
        }
        var ra = null,
          oa = null,
          aa = !1,
          ia = null;
        function la(e, t) {
          var n = As(5, null, null, 0);
          (n.elementType = 'DELETED'),
            (n.stateNode = t),
            (n.return = e),
            null === (t = e.deletions) ? ((e.deletions = [n]), (e.flags |= 16)) : t.push(n);
        }
        function ua(e, t) {
          switch (e.tag) {
            case 5:
              var n = e.type;
              return (
                null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) &&
                ((e.stateNode = t), (ra = e), (oa = so(t.firstChild)), !0)
              );
            case 6:
              return (
                null !== (t = '' === e.pendingProps || 3 !== t.nodeType ? null : t) &&
                ((e.stateNode = t), (ra = e), (oa = null), !0)
              );
            case 13:
              return (
                null !== (t = 8 !== t.nodeType ? null : t) &&
                ((n = null !== Yo ? { id: Xo, overflow: Jo } : null),
                (e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }),
                ((n = As(18, null, null, 0)).stateNode = t),
                (n.return = e),
                (e.child = n),
                (ra = e),
                (oa = null),
                !0)
              );
            default:
              return !1;
          }
        }
        function sa(e) {
          return 0 !== (1 & e.mode) && 0 === (128 & e.flags);
        }
        function ca(e) {
          if (aa) {
            var t = oa;
            if (t) {
              var n = t;
              if (!ua(e, t)) {
                if (sa(e)) throw Error(a(418));
                t = so(n.nextSibling);
                var r = ra;
                t && ua(e, t) ? la(r, n) : ((e.flags = (-4097 & e.flags) | 2), (aa = !1), (ra = e));
              }
            } else {
              if (sa(e)) throw Error(a(418));
              (e.flags = (-4097 & e.flags) | 2), (aa = !1), (ra = e);
            }
          }
        }
        function fa(e) {
          for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag; ) e = e.return;
          ra = e;
        }
        function da(e) {
          if (e !== ra) return !1;
          if (!aa) return fa(e), (aa = !0), !1;
          var t;
          if (
            ((t = 3 !== e.tag) &&
              !(t = 5 !== e.tag) &&
              (t = 'head' !== (t = e.type) && 'body' !== t && !no(e.type, e.memoizedProps)),
            t && (t = oa))
          ) {
            if (sa(e)) throw (pa(), Error(a(418)));
            for (; t; ) la(e, t), (t = so(t.nextSibling));
          }
          if ((fa(e), 13 === e.tag)) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(a(317));
            e: {
              for (e = e.nextSibling, t = 0; e; ) {
                if (8 === e.nodeType) {
                  var n = e.data;
                  if ('/$' === n) {
                    if (0 === t) {
                      oa = so(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else ('$' !== n && '$!' !== n && '$?' !== n) || t++;
                }
                e = e.nextSibling;
              }
              oa = null;
            }
          } else oa = ra ? so(e.stateNode.nextSibling) : null;
          return !0;
        }
        function pa() {
          for (var e = oa; e; ) e = so(e.nextSibling);
        }
        function ha() {
          (oa = ra = null), (aa = !1);
        }
        function va(e) {
          null === ia ? (ia = [e]) : ia.push(e);
        }
        var ma = b.ReactCurrentBatchConfig;
        function ga(e, t) {
          if (e && e.defaultProps) {
            for (var n in ((t = M({}, t)), (e = e.defaultProps))) void 0 === t[n] && (t[n] = e[n]);
            return t;
          }
          return t;
        }
        var wa = Eo(null),
          ya = null,
          ba = null,
          xa = null;
        function ka() {
          xa = ba = ya = null;
        }
        function Sa(e) {
          var t = wa.current;
          Co(wa), (e._currentValue = t);
        }
        function _a(e, t, n) {
          for (; null !== e; ) {
            var r = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
                : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
              e === n)
            )
              break;
            e = e.return;
          }
        }
        function Ea(e, t) {
          (ya = e),
            (xa = ba = null),
            null !== (e = e.dependencies) &&
              null !== e.firstContext &&
              (0 !== (e.lanes & t) && (bl = !0), (e.firstContext = null));
        }
        function Ca(e) {
          var t = e._currentValue;
          if (xa !== e)
            if (((e = { context: e, memoizedValue: t, next: null }), null === ba)) {
              if (null === ya) throw Error(a(308));
              (ba = e), (ya.dependencies = { lanes: 0, firstContext: e });
            } else ba = ba.next = e;
          return t;
        }
        var Ta = null;
        function Na(e) {
          null === Ta ? (Ta = [e]) : Ta.push(e);
        }
        function ja(e, t, n, r) {
          var o = t.interleaved;
          return null === o ? ((n.next = n), Na(t)) : ((n.next = o.next), (o.next = n)), (t.interleaved = n), La(e, r);
        }
        function La(e, t) {
          e.lanes |= t;
          var n = e.alternate;
          for (null !== n && (n.lanes |= t), n = e, e = e.return; null !== e; )
            (e.childLanes |= t), null !== (n = e.alternate) && (n.childLanes |= t), (n = e), (e = e.return);
          return 3 === n.tag ? n.stateNode : null;
        }
        var Aa = !1;
        function Ra(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, interleaved: null, lanes: 0 },
            effects: null,
          };
        }
        function Pa(e, t) {
          (e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                effects: e.effects,
              });
        }
        function Oa(e, t) {
          return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
        }
        function Da(e, t, n) {
          var r = e.updateQueue;
          if (null === r) return null;
          if (((r = r.shared), 0 !== (2 & Nu))) {
            var o = r.pending;
            return null === o ? (t.next = t) : ((t.next = o.next), (o.next = t)), (r.pending = t), La(e, n);
          }
          return (
            null === (o = r.interleaved) ? ((t.next = t), Na(r)) : ((t.next = o.next), (o.next = t)),
            (r.interleaved = t),
            La(e, n)
          );
        }
        function Ia(e, t, n) {
          if (null !== (t = t.updateQueue) && ((t = t.shared), 0 !== (4194240 & n))) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), wt(e, n);
          }
        }
        function Ma(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var o = null,
              a = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var i = {
                  eventTime: n.eventTime,
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: n.callback,
                  next: null,
                };
                null === a ? (o = a = i) : (a = a.next = i), (n = n.next);
              } while (null !== n);
              null === a ? (o = a = t) : (a = a.next = t);
            } else o = a = t;
            return (
              (n = {
                baseState: r.baseState,
                firstBaseUpdate: o,
                lastBaseUpdate: a,
                shared: r.shared,
                effects: r.effects,
              }),
              void (e.updateQueue = n)
            );
          }
          null === (e = n.lastBaseUpdate) ? (n.firstBaseUpdate = t) : (e.next = t), (n.lastBaseUpdate = t);
        }
        function za(e, t, n, r) {
          var o = e.updateQueue;
          Aa = !1;
          var a = o.firstBaseUpdate,
            i = o.lastBaseUpdate,
            l = o.shared.pending;
          if (null !== l) {
            o.shared.pending = null;
            var u = l,
              s = u.next;
            (u.next = null), null === i ? (a = s) : (i.next = s), (i = u);
            var c = e.alternate;
            null !== c &&
              (l = (c = c.updateQueue).lastBaseUpdate) !== i &&
              (null === l ? (c.firstBaseUpdate = s) : (l.next = s), (c.lastBaseUpdate = u));
          }
          if (null !== a) {
            var f = o.baseState;
            for (i = 0, c = s = u = null, l = a; ; ) {
              var d = l.lane,
                p = l.eventTime;
              if ((r & d) === d) {
                null !== c &&
                  (c = c.next =
                    { eventTime: p, lane: 0, tag: l.tag, payload: l.payload, callback: l.callback, next: null });
                e: {
                  var h = e,
                    v = l;
                  switch (((d = t), (p = n), v.tag)) {
                    case 1:
                      if ('function' === typeof (h = v.payload)) {
                        f = h.call(p, f, d);
                        break e;
                      }
                      f = h;
                      break e;
                    case 3:
                      h.flags = (-65537 & h.flags) | 128;
                    case 0:
                      if (null === (d = 'function' === typeof (h = v.payload) ? h.call(p, f, d) : h) || void 0 === d)
                        break e;
                      f = M({}, f, d);
                      break e;
                    case 2:
                      Aa = !0;
                  }
                }
                null !== l.callback &&
                  0 !== l.lane &&
                  ((e.flags |= 64), null === (d = o.effects) ? (o.effects = [l]) : d.push(l));
              } else
                (p = { eventTime: p, lane: d, tag: l.tag, payload: l.payload, callback: l.callback, next: null }),
                  null === c ? ((s = c = p), (u = f)) : (c = c.next = p),
                  (i |= d);
              if (null === (l = l.next)) {
                if (null === (l = o.shared.pending)) break;
                (l = (d = l).next), (d.next = null), (o.lastBaseUpdate = d), (o.shared.pending = null);
              }
            }
            if (
              (null === c && (u = f),
              (o.baseState = u),
              (o.firstBaseUpdate = s),
              (o.lastBaseUpdate = c),
              null !== (t = o.shared.interleaved))
            ) {
              o = t;
              do {
                (i |= o.lane), (o = o.next);
              } while (o !== t);
            } else null === a && (o.shared.lanes = 0);
            (Iu |= i), (e.lanes = i), (e.memoizedState = f);
          }
        }
        function Va(e, t, n) {
          if (((e = t.effects), (t.effects = null), null !== e))
            for (t = 0; t < e.length; t++) {
              var r = e[t],
                o = r.callback;
              if (null !== o) {
                if (((r.callback = null), (r = n), 'function' !== typeof o)) throw Error(a(191, o));
                o.call(r);
              }
            }
        }
        var Ba = new r.Component().refs;
        function Fa(e, t, n, r) {
          (n = null === (n = n(r, (t = e.memoizedState))) || void 0 === n ? t : M({}, t, n)),
            (e.memoizedState = n),
            0 === e.lanes && (e.updateQueue.baseState = n);
        }
        var Ua = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && Ue(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = es(),
              o = ts(e),
              a = Oa(r, o);
            (a.payload = t),
              void 0 !== n && null !== n && (a.callback = n),
              null !== (t = Da(e, a, o)) && (ns(t, e, o, r), Ia(t, e, o));
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = es(),
              o = ts(e),
              a = Oa(r, o);
            (a.tag = 1),
              (a.payload = t),
              void 0 !== n && null !== n && (a.callback = n),
              null !== (t = Da(e, a, o)) && (ns(t, e, o, r), Ia(t, e, o));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = es(),
              r = ts(e),
              o = Oa(n, r);
            (o.tag = 2),
              void 0 !== t && null !== t && (o.callback = t),
              null !== (t = Da(e, o, r)) && (ns(t, e, r, n), Ia(t, e, r));
          },
        };
        function Ha(e, t, n, r, o, a, i) {
          return 'function' === typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, a, i)
            : !t.prototype || !t.prototype.isPureReactComponent || !ur(n, r) || !ur(o, a);
        }
        function qa(e, t, n) {
          var r = !1,
            o = No,
            a = t.contextType;
          return (
            'object' === typeof a && null !== a
              ? (a = Ca(a))
              : ((o = Po(t) ? Ao : jo.current),
                (a = (r = null !== (r = t.contextTypes) && void 0 !== r) ? Ro(e, o) : No)),
            (t = new t(n, a)),
            (e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null),
            (t.updater = Ua),
            (e.stateNode = t),
            (t._reactInternals = e),
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = o),
              (e.__reactInternalMemoizedMaskedChildContext = a)),
            t
          );
        }
        function Wa(e, t, n, r) {
          (e = t.state),
            'function' === typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r),
            'function' === typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r),
            t.state !== e && Ua.enqueueReplaceState(t, t.state, null);
        }
        function $a(e, t, n, r) {
          var o = e.stateNode;
          (o.props = n), (o.state = e.memoizedState), (o.refs = Ba), Ra(e);
          var a = t.contextType;
          'object' === typeof a && null !== a
            ? (o.context = Ca(a))
            : ((a = Po(t) ? Ao : jo.current), (o.context = Ro(e, a))),
            (o.state = e.memoizedState),
            'function' === typeof (a = t.getDerivedStateFromProps) && (Fa(e, t, a, n), (o.state = e.memoizedState)),
            'function' === typeof t.getDerivedStateFromProps ||
              'function' === typeof o.getSnapshotBeforeUpdate ||
              ('function' !== typeof o.UNSAFE_componentWillMount && 'function' !== typeof o.componentWillMount) ||
              ((t = o.state),
              'function' === typeof o.componentWillMount && o.componentWillMount(),
              'function' === typeof o.UNSAFE_componentWillMount && o.UNSAFE_componentWillMount(),
              t !== o.state && Ua.enqueueReplaceState(o, o.state, null),
              za(e, n, o, r),
              (o.state = e.memoizedState)),
            'function' === typeof o.componentDidMount && (e.flags |= 4194308);
        }
        function Ga(e, t, n) {
          if (null !== (e = n.ref) && 'function' !== typeof e && 'object' !== typeof e) {
            if (n._owner) {
              if ((n = n._owner)) {
                if (1 !== n.tag) throw Error(a(309));
                var r = n.stateNode;
              }
              if (!r) throw Error(a(147, e));
              var o = r,
                i = '' + e;
              return null !== t && null !== t.ref && 'function' === typeof t.ref && t.ref._stringRef === i
                ? t.ref
                : ((t = function (e) {
                    var t = o.refs;
                    t === Ba && (t = o.refs = {}), null === e ? delete t[i] : (t[i] = e);
                  }),
                  (t._stringRef = i),
                  t);
            }
            if ('string' !== typeof e) throw Error(a(284));
            if (!n._owner) throw Error(a(290, e));
          }
          return e;
        }
        function Ka(e, t) {
          throw (
            ((e = Object.prototype.toString.call(t)),
            Error(a(31, '[object Object]' === e ? 'object with keys {' + Object.keys(t).join(', ') + '}' : e)))
          );
        }
        function Qa(e) {
          return (0, e._init)(e._payload);
        }
        function Ya(e) {
          function t(t, n) {
            if (e) {
              var r = t.deletions;
              null === r ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n);
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r; ) t(n, r), (r = r.sibling);
            return null;
          }
          function r(e, t) {
            for (e = new Map(); null !== t; ) null !== t.key ? e.set(t.key, t) : e.set(t.index, t), (t = t.sibling);
            return e;
          }
          function o(e, t) {
            return ((e = Ps(e, t)).index = 0), (e.sibling = null), e;
          }
          function i(t, n, r) {
            return (
              (t.index = r),
              e
                ? null !== (r = t.alternate)
                  ? (r = r.index) < n
                    ? ((t.flags |= 2), n)
                    : r
                  : ((t.flags |= 2), n)
                : ((t.flags |= 1048576), n)
            );
          }
          function l(t) {
            return e && null === t.alternate && (t.flags |= 2), t;
          }
          function u(e, t, n, r) {
            return null === t || 6 !== t.tag
              ? (((t = Ms(n, e.mode, r)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function s(e, t, n, r) {
            var a = n.type;
            return a === S
              ? f(e, t, n.props.children, r, n.key)
              : null !== t &&
                (t.elementType === a || ('object' === typeof a && null !== a && a.$$typeof === R && Qa(a) === t.type))
              ? (((r = o(t, n.props)).ref = Ga(e, t, n)), (r.return = e), r)
              : (((r = Os(n.type, n.key, n.props, null, e.mode, r)).ref = Ga(e, t, n)), (r.return = e), r);
          }
          function c(e, t, n, r) {
            return null === t ||
              4 !== t.tag ||
              t.stateNode.containerInfo !== n.containerInfo ||
              t.stateNode.implementation !== n.implementation
              ? (((t = zs(n, e.mode, r)).return = e), t)
              : (((t = o(t, n.children || [])).return = e), t);
          }
          function f(e, t, n, r, a) {
            return null === t || 7 !== t.tag
              ? (((t = Ds(n, e.mode, r, a)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function d(e, t, n) {
            if (('string' === typeof t && '' !== t) || 'number' === typeof t)
              return ((t = Ms('' + t, e.mode, n)).return = e), t;
            if ('object' === typeof t && null !== t) {
              switch (t.$$typeof) {
                case x:
                  return ((n = Os(t.type, t.key, t.props, null, e.mode, n)).ref = Ga(e, null, t)), (n.return = e), n;
                case k:
                  return ((t = zs(t, e.mode, n)).return = e), t;
                case R:
                  return d(e, (0, t._init)(t._payload), n);
              }
              if (te(t) || D(t)) return ((t = Ds(t, e.mode, n, null)).return = e), t;
              Ka(e, t);
            }
            return null;
          }
          function p(e, t, n, r) {
            var o = null !== t ? t.key : null;
            if (('string' === typeof n && '' !== n) || 'number' === typeof n)
              return null !== o ? null : u(e, t, '' + n, r);
            if ('object' === typeof n && null !== n) {
              switch (n.$$typeof) {
                case x:
                  return n.key === o ? s(e, t, n, r) : null;
                case k:
                  return n.key === o ? c(e, t, n, r) : null;
                case R:
                  return p(e, t, (o = n._init)(n._payload), r);
              }
              if (te(n) || D(n)) return null !== o ? null : f(e, t, n, r, null);
              Ka(e, n);
            }
            return null;
          }
          function h(e, t, n, r, o) {
            if (('string' === typeof r && '' !== r) || 'number' === typeof r)
              return u(t, (e = e.get(n) || null), '' + r, o);
            if ('object' === typeof r && null !== r) {
              switch (r.$$typeof) {
                case x:
                  return s(t, (e = e.get(null === r.key ? n : r.key) || null), r, o);
                case k:
                  return c(t, (e = e.get(null === r.key ? n : r.key) || null), r, o);
                case R:
                  return h(e, t, n, (0, r._init)(r._payload), o);
              }
              if (te(r) || D(r)) return f(t, (e = e.get(n) || null), r, o, null);
              Ka(t, r);
            }
            return null;
          }
          function v(o, a, l, u) {
            for (var s = null, c = null, f = a, v = (a = 0), m = null; null !== f && v < l.length; v++) {
              f.index > v ? ((m = f), (f = null)) : (m = f.sibling);
              var g = p(o, f, l[v], u);
              if (null === g) {
                null === f && (f = m);
                break;
              }
              e && f && null === g.alternate && t(o, f),
                (a = i(g, a, v)),
                null === c ? (s = g) : (c.sibling = g),
                (c = g),
                (f = m);
            }
            if (v === l.length) return n(o, f), aa && Zo(o, v), s;
            if (null === f) {
              for (; v < l.length; v++)
                null !== (f = d(o, l[v], u)) && ((a = i(f, a, v)), null === c ? (s = f) : (c.sibling = f), (c = f));
              return aa && Zo(o, v), s;
            }
            for (f = r(o, f); v < l.length; v++)
              null !== (m = h(f, o, v, l[v], u)) &&
                (e && null !== m.alternate && f.delete(null === m.key ? v : m.key),
                (a = i(m, a, v)),
                null === c ? (s = m) : (c.sibling = m),
                (c = m));
            return (
              e &&
                f.forEach(function (e) {
                  return t(o, e);
                }),
              aa && Zo(o, v),
              s
            );
          }
          function m(o, l, u, s) {
            var c = D(u);
            if ('function' !== typeof c) throw Error(a(150));
            if (null == (u = c.call(u))) throw Error(a(151));
            for (
              var f = (c = null), v = l, m = (l = 0), g = null, w = u.next();
              null !== v && !w.done;
              m++, w = u.next()
            ) {
              v.index > m ? ((g = v), (v = null)) : (g = v.sibling);
              var y = p(o, v, w.value, s);
              if (null === y) {
                null === v && (v = g);
                break;
              }
              e && v && null === y.alternate && t(o, v),
                (l = i(y, l, m)),
                null === f ? (c = y) : (f.sibling = y),
                (f = y),
                (v = g);
            }
            if (w.done) return n(o, v), aa && Zo(o, m), c;
            if (null === v) {
              for (; !w.done; m++, w = u.next())
                null !== (w = d(o, w.value, s)) && ((l = i(w, l, m)), null === f ? (c = w) : (f.sibling = w), (f = w));
              return aa && Zo(o, m), c;
            }
            for (v = r(o, v); !w.done; m++, w = u.next())
              null !== (w = h(v, o, m, w.value, s)) &&
                (e && null !== w.alternate && v.delete(null === w.key ? m : w.key),
                (l = i(w, l, m)),
                null === f ? (c = w) : (f.sibling = w),
                (f = w));
            return (
              e &&
                v.forEach(function (e) {
                  return t(o, e);
                }),
              aa && Zo(o, m),
              c
            );
          }
          return function e(r, a, i, u) {
            if (
              ('object' === typeof i && null !== i && i.type === S && null === i.key && (i = i.props.children),
              'object' === typeof i && null !== i)
            ) {
              switch (i.$$typeof) {
                case x:
                  e: {
                    for (var s = i.key, c = a; null !== c; ) {
                      if (c.key === s) {
                        if ((s = i.type) === S) {
                          if (7 === c.tag) {
                            n(r, c.sibling), ((a = o(c, i.props.children)).return = r), (r = a);
                            break e;
                          }
                        } else if (
                          c.elementType === s ||
                          ('object' === typeof s && null !== s && s.$$typeof === R && Qa(s) === c.type)
                        ) {
                          n(r, c.sibling), ((a = o(c, i.props)).ref = Ga(r, c, i)), (a.return = r), (r = a);
                          break e;
                        }
                        n(r, c);
                        break;
                      }
                      t(r, c), (c = c.sibling);
                    }
                    i.type === S
                      ? (((a = Ds(i.props.children, r.mode, u, i.key)).return = r), (r = a))
                      : (((u = Os(i.type, i.key, i.props, null, r.mode, u)).ref = Ga(r, a, i)),
                        (u.return = r),
                        (r = u));
                  }
                  return l(r);
                case k:
                  e: {
                    for (c = i.key; null !== a; ) {
                      if (a.key === c) {
                        if (
                          4 === a.tag &&
                          a.stateNode.containerInfo === i.containerInfo &&
                          a.stateNode.implementation === i.implementation
                        ) {
                          n(r, a.sibling), ((a = o(a, i.children || [])).return = r), (r = a);
                          break e;
                        }
                        n(r, a);
                        break;
                      }
                      t(r, a), (a = a.sibling);
                    }
                    ((a = zs(i, r.mode, u)).return = r), (r = a);
                  }
                  return l(r);
                case R:
                  return e(r, a, (c = i._init)(i._payload), u);
              }
              if (te(i)) return v(r, a, i, u);
              if (D(i)) return m(r, a, i, u);
              Ka(r, i);
            }
            return ('string' === typeof i && '' !== i) || 'number' === typeof i
              ? ((i = '' + i),
                null !== a && 6 === a.tag
                  ? (n(r, a.sibling), ((a = o(a, i)).return = r), (r = a))
                  : (n(r, a), ((a = Ms(i, r.mode, u)).return = r), (r = a)),
                l(r))
              : n(r, a);
          };
        }
        var Xa = Ya(!0),
          Ja = Ya(!1),
          Za = {},
          ei = Eo(Za),
          ti = Eo(Za),
          ni = Eo(Za);
        function ri(e) {
          if (e === Za) throw Error(a(174));
          return e;
        }
        function oi(e, t) {
          switch ((To(ni, t), To(ti, e), To(ei, Za), (e = t.nodeType))) {
            case 9:
            case 11:
              t = (t = t.documentElement) ? t.namespaceURI : ue(null, '');
              break;
            default:
              t = ue((t = (e = 8 === e ? t.parentNode : t).namespaceURI || null), (e = e.tagName));
          }
          Co(ei), To(ei, t);
        }
        function ai() {
          Co(ei), Co(ti), Co(ni);
        }
        function ii(e) {
          ri(ni.current);
          var t = ri(ei.current),
            n = ue(t, e.type);
          t !== n && (To(ti, e), To(ei, n));
        }
        function li(e) {
          ti.current === e && (Co(ei), Co(ti));
        }
        var ui = Eo(0);
        function si(e) {
          for (var t = e; null !== t; ) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (null !== n && (null === (n = n.dehydrated) || '$?' === n.data || '$!' === n.data)) return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (0 !== (128 & t.flags)) return t;
            } else if (null !== t.child) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
          return null;
        }
        var ci = [];
        function fi() {
          for (var e = 0; e < ci.length; e++) ci[e]._workInProgressVersionPrimary = null;
          ci.length = 0;
        }
        var di = b.ReactCurrentDispatcher,
          pi = b.ReactCurrentBatchConfig,
          hi = 0,
          vi = null,
          mi = null,
          gi = null,
          wi = !1,
          yi = !1,
          bi = 0,
          xi = 0;
        function ki() {
          throw Error(a(321));
        }
        function Si(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++) if (!lr(e[n], t[n])) return !1;
          return !0;
        }
        function _i(e, t, n, r, o, i) {
          if (
            ((hi = i),
            (vi = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (di.current = null === e || null === e.memoizedState ? ll : ul),
            (e = n(r, o)),
            yi)
          ) {
            i = 0;
            do {
              if (((yi = !1), (bi = 0), 25 <= i)) throw Error(a(301));
              (i += 1), (gi = mi = null), (t.updateQueue = null), (di.current = sl), (e = n(r, o));
            } while (yi);
          }
          if (((di.current = il), (t = null !== mi && null !== mi.next), (hi = 0), (gi = mi = vi = null), (wi = !1), t))
            throw Error(a(300));
          return e;
        }
        function Ei() {
          var e = 0 !== bi;
          return (bi = 0), e;
        }
        function Ci() {
          var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
          return null === gi ? (vi.memoizedState = gi = e) : (gi = gi.next = e), gi;
        }
        function Ti() {
          if (null === mi) {
            var e = vi.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = mi.next;
          var t = null === gi ? vi.memoizedState : gi.next;
          if (null !== t) (gi = t), (mi = e);
          else {
            if (null === e) throw Error(a(310));
            (e = {
              memoizedState: (mi = e).memoizedState,
              baseState: mi.baseState,
              baseQueue: mi.baseQueue,
              queue: mi.queue,
              next: null,
            }),
              null === gi ? (vi.memoizedState = gi = e) : (gi = gi.next = e);
          }
          return gi;
        }
        function Ni(e, t) {
          return 'function' === typeof t ? t(e) : t;
        }
        function ji(e) {
          var t = Ti(),
            n = t.queue;
          if (null === n) throw Error(a(311));
          n.lastRenderedReducer = e;
          var r = mi,
            o = r.baseQueue,
            i = n.pending;
          if (null !== i) {
            if (null !== o) {
              var l = o.next;
              (o.next = i.next), (i.next = l);
            }
            (r.baseQueue = o = i), (n.pending = null);
          }
          if (null !== o) {
            (i = o.next), (r = r.baseState);
            var u = (l = null),
              s = null,
              c = i;
            do {
              var f = c.lane;
              if ((hi & f) === f)
                null !== s &&
                  (s = s.next =
                    {
                      lane: 0,
                      action: c.action,
                      hasEagerState: c.hasEagerState,
                      eagerState: c.eagerState,
                      next: null,
                    }),
                  (r = c.hasEagerState ? c.eagerState : e(r, c.action));
              else {
                var d = {
                  lane: f,
                  action: c.action,
                  hasEagerState: c.hasEagerState,
                  eagerState: c.eagerState,
                  next: null,
                };
                null === s ? ((u = s = d), (l = r)) : (s = s.next = d), (vi.lanes |= f), (Iu |= f);
              }
              c = c.next;
            } while (null !== c && c !== i);
            null === s ? (l = r) : (s.next = u),
              lr(r, t.memoizedState) || (bl = !0),
              (t.memoizedState = r),
              (t.baseState = l),
              (t.baseQueue = s),
              (n.lastRenderedState = r);
          }
          if (null !== (e = n.interleaved)) {
            o = e;
            do {
              (i = o.lane), (vi.lanes |= i), (Iu |= i), (o = o.next);
            } while (o !== e);
          } else null === o && (n.lanes = 0);
          return [t.memoizedState, n.dispatch];
        }
        function Li(e) {
          var t = Ti(),
            n = t.queue;
          if (null === n) throw Error(a(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            o = n.pending,
            i = t.memoizedState;
          if (null !== o) {
            n.pending = null;
            var l = (o = o.next);
            do {
              (i = e(i, l.action)), (l = l.next);
            } while (l !== o);
            lr(i, t.memoizedState) || (bl = !0),
              (t.memoizedState = i),
              null === t.baseQueue && (t.baseState = i),
              (n.lastRenderedState = i);
          }
          return [i, r];
        }
        function Ai() {}
        function Ri(e, t) {
          var n = vi,
            r = Ti(),
            o = t(),
            i = !lr(r.memoizedState, o);
          if (
            (i && ((r.memoizedState = o), (bl = !0)),
            (r = r.queue),
            qi(Di.bind(null, n, r, e), [e]),
            r.getSnapshot !== t || i || (null !== gi && 1 & gi.memoizedState.tag))
          ) {
            if (((n.flags |= 2048), Vi(9, Oi.bind(null, n, r, o, t), void 0, null), null === ju)) throw Error(a(349));
            0 !== (30 & hi) || Pi(n, t, o);
          }
          return o;
        }
        function Pi(e, t, n) {
          (e.flags |= 16384),
            (e = { getSnapshot: t, value: n }),
            null === (t = vi.updateQueue)
              ? ((t = { lastEffect: null, stores: null }), (vi.updateQueue = t), (t.stores = [e]))
              : null === (n = t.stores)
              ? (t.stores = [e])
              : n.push(e);
        }
        function Oi(e, t, n, r) {
          (t.value = n), (t.getSnapshot = r), Ii(t) && Mi(e);
        }
        function Di(e, t, n) {
          return n(function () {
            Ii(t) && Mi(e);
          });
        }
        function Ii(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !lr(e, n);
          } catch (r) {
            return !0;
          }
        }
        function Mi(e) {
          var t = La(e, 1);
          null !== t && ns(t, e, 1, -1);
        }
        function zi(e) {
          var t = Ci();
          return (
            'function' === typeof e && (e = e()),
            (t.memoizedState = t.baseState = e),
            (e = {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ni,
              lastRenderedState: e,
            }),
            (t.queue = e),
            (e = e.dispatch = nl.bind(null, vi, e)),
            [t.memoizedState, e]
          );
        }
        function Vi(e, t, n, r) {
          return (
            (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
            null === (t = vi.updateQueue)
              ? ((t = { lastEffect: null, stores: null }), (vi.updateQueue = t), (t.lastEffect = e.next = e))
              : null === (n = t.lastEffect)
              ? (t.lastEffect = e.next = e)
              : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e)),
            e
          );
        }
        function Bi() {
          return Ti().memoizedState;
        }
        function Fi(e, t, n, r) {
          var o = Ci();
          (vi.flags |= e), (o.memoizedState = Vi(1 | t, n, void 0, void 0 === r ? null : r));
        }
        function Ui(e, t, n, r) {
          var o = Ti();
          r = void 0 === r ? null : r;
          var a = void 0;
          if (null !== mi) {
            var i = mi.memoizedState;
            if (((a = i.destroy), null !== r && Si(r, i.deps))) return void (o.memoizedState = Vi(t, n, a, r));
          }
          (vi.flags |= e), (o.memoizedState = Vi(1 | t, n, a, r));
        }
        function Hi(e, t) {
          return Fi(8390656, 8, e, t);
        }
        function qi(e, t) {
          return Ui(2048, 8, e, t);
        }
        function Wi(e, t) {
          return Ui(4, 2, e, t);
        }
        function $i(e, t) {
          return Ui(4, 4, e, t);
        }
        function Gi(e, t) {
          return 'function' === typeof t
            ? ((e = e()),
              t(e),
              function () {
                t(null);
              })
            : null !== t && void 0 !== t
            ? ((e = e()),
              (t.current = e),
              function () {
                t.current = null;
              })
            : void 0;
        }
        function Ki(e, t, n) {
          return (n = null !== n && void 0 !== n ? n.concat([e]) : null), Ui(4, 4, Gi.bind(null, t, e), n);
        }
        function Qi() {}
        function Yi(e, t) {
          var n = Ti();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && Si(t, r[1]) ? r[0] : ((n.memoizedState = [e, t]), e);
        }
        function Xi(e, t) {
          var n = Ti();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && Si(t, r[1]) ? r[0] : ((e = e()), (n.memoizedState = [e, t]), e);
        }
        function Ji(e, t, n) {
          return 0 === (21 & hi)
            ? (e.baseState && ((e.baseState = !1), (bl = !0)), (e.memoizedState = n))
            : (lr(n, t) || ((n = vt()), (vi.lanes |= n), (Iu |= n), (e.baseState = !0)), t);
        }
        function Zi(e, t) {
          var n = yt;
          (yt = 0 !== n && 4 > n ? n : 4), e(!0);
          var r = pi.transition;
          pi.transition = {};
          try {
            e(!1), t();
          } finally {
            (yt = n), (pi.transition = r);
          }
        }
        function el() {
          return Ti().memoizedState;
        }
        function tl(e, t, n) {
          var r = ts(e);
          if (((n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }), rl(e))) ol(t, n);
          else if (null !== (n = ja(e, t, n, r))) {
            ns(n, e, r, es()), al(n, t, r);
          }
        }
        function nl(e, t, n) {
          var r = ts(e),
            o = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
          if (rl(e)) ol(t, o);
          else {
            var a = e.alternate;
            if (0 === e.lanes && (null === a || 0 === a.lanes) && null !== (a = t.lastRenderedReducer))
              try {
                var i = t.lastRenderedState,
                  l = a(i, n);
                if (((o.hasEagerState = !0), (o.eagerState = l), lr(l, i))) {
                  var u = t.interleaved;
                  return (
                    null === u ? ((o.next = o), Na(t)) : ((o.next = u.next), (u.next = o)), void (t.interleaved = o)
                  );
                }
              } catch (s) {}
            null !== (n = ja(e, t, o, r)) && (ns(n, e, r, (o = es())), al(n, t, r));
          }
        }
        function rl(e) {
          var t = e.alternate;
          return e === vi || (null !== t && t === vi);
        }
        function ol(e, t) {
          yi = wi = !0;
          var n = e.pending;
          null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)), (e.pending = t);
        }
        function al(e, t, n) {
          if (0 !== (4194240 & n)) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), wt(e, n);
          }
        }
        var il = {
            readContext: Ca,
            useCallback: ki,
            useContext: ki,
            useEffect: ki,
            useImperativeHandle: ki,
            useInsertionEffect: ki,
            useLayoutEffect: ki,
            useMemo: ki,
            useReducer: ki,
            useRef: ki,
            useState: ki,
            useDebugValue: ki,
            useDeferredValue: ki,
            useTransition: ki,
            useMutableSource: ki,
            useSyncExternalStore: ki,
            useId: ki,
            unstable_isNewReconciler: !1,
          },
          ll = {
            readContext: Ca,
            useCallback: function (e, t) {
              return (Ci().memoizedState = [e, void 0 === t ? null : t]), e;
            },
            useContext: Ca,
            useEffect: Hi,
            useImperativeHandle: function (e, t, n) {
              return (n = null !== n && void 0 !== n ? n.concat([e]) : null), Fi(4194308, 4, Gi.bind(null, t, e), n);
            },
            useLayoutEffect: function (e, t) {
              return Fi(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              return Fi(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var n = Ci();
              return (t = void 0 === t ? null : t), (e = e()), (n.memoizedState = [e, t]), e;
            },
            useReducer: function (e, t, n) {
              var r = Ci();
              return (
                (t = void 0 !== n ? n(t) : t),
                (r.memoizedState = r.baseState = t),
                (e = {
                  pending: null,
                  interleaved: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: t,
                }),
                (r.queue = e),
                (e = e.dispatch = tl.bind(null, vi, e)),
                [r.memoizedState, e]
              );
            },
            useRef: function (e) {
              return (e = { current: e }), (Ci().memoizedState = e);
            },
            useState: zi,
            useDebugValue: Qi,
            useDeferredValue: function (e) {
              return (Ci().memoizedState = e);
            },
            useTransition: function () {
              var e = zi(!1),
                t = e[0];
              return (e = Zi.bind(null, e[1])), (Ci().memoizedState = e), [t, e];
            },
            useMutableSource: function () {},
            useSyncExternalStore: function (e, t, n) {
              var r = vi,
                o = Ci();
              if (aa) {
                if (void 0 === n) throw Error(a(407));
                n = n();
              } else {
                if (((n = t()), null === ju)) throw Error(a(349));
                0 !== (30 & hi) || Pi(r, t, n);
              }
              o.memoizedState = n;
              var i = { value: n, getSnapshot: t };
              return (
                (o.queue = i),
                Hi(Di.bind(null, r, i, e), [e]),
                (r.flags |= 2048),
                Vi(9, Oi.bind(null, r, i, n, t), void 0, null),
                n
              );
            },
            useId: function () {
              var e = Ci(),
                t = ju.identifierPrefix;
              if (aa) {
                var n = Jo;
                (t = ':' + t + 'R' + (n = (Xo & ~(1 << (32 - it(Xo) - 1))).toString(32) + n)),
                  0 < (n = bi++) && (t += 'H' + n.toString(32)),
                  (t += ':');
              } else t = ':' + t + 'r' + (n = xi++).toString(32) + ':';
              return (e.memoizedState = t);
            },
            unstable_isNewReconciler: !1,
          },
          ul = {
            readContext: Ca,
            useCallback: Yi,
            useContext: Ca,
            useEffect: qi,
            useImperativeHandle: Ki,
            useInsertionEffect: Wi,
            useLayoutEffect: $i,
            useMemo: Xi,
            useReducer: ji,
            useRef: Bi,
            useState: function () {
              return ji(Ni);
            },
            useDebugValue: Qi,
            useDeferredValue: function (e) {
              return Ji(Ti(), mi.memoizedState, e);
            },
            useTransition: function () {
              return [ji(Ni)[0], Ti().memoizedState];
            },
            useMutableSource: Ai,
            useSyncExternalStore: Ri,
            useId: el,
            unstable_isNewReconciler: !1,
          },
          sl = {
            readContext: Ca,
            useCallback: Yi,
            useContext: Ca,
            useEffect: qi,
            useImperativeHandle: Ki,
            useInsertionEffect: Wi,
            useLayoutEffect: $i,
            useMemo: Xi,
            useReducer: Li,
            useRef: Bi,
            useState: function () {
              return Li(Ni);
            },
            useDebugValue: Qi,
            useDeferredValue: function (e) {
              var t = Ti();
              return null === mi ? (t.memoizedState = e) : Ji(t, mi.memoizedState, e);
            },
            useTransition: function () {
              return [Li(Ni)[0], Ti().memoizedState];
            },
            useMutableSource: Ai,
            useSyncExternalStore: Ri,
            useId: el,
            unstable_isNewReconciler: !1,
          };
        function cl(e, t) {
          try {
            var n = '',
              r = t;
            do {
              (n += F(r)), (r = r.return);
            } while (r);
            var o = n;
          } catch (a) {
            o = '\nError generating stack: ' + a.message + '\n' + a.stack;
          }
          return { value: e, source: t, stack: o, digest: null };
        }
        function fl(e, t, n) {
          return { value: e, source: null, stack: null != n ? n : null, digest: null != t ? t : null };
        }
        function dl(e, t) {
          try {
            console.error(t.value);
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        var pl = 'function' === typeof WeakMap ? WeakMap : Map;
        function hl(e, t, n) {
          ((n = Oa(-1, n)).tag = 3), (n.payload = { element: null });
          var r = t.value;
          return (
            (n.callback = function () {
              qu || ((qu = !0), (Wu = r)), dl(0, t);
            }),
            n
          );
        }
        function vl(e, t, n) {
          (n = Oa(-1, n)).tag = 3;
          var r = e.type.getDerivedStateFromError;
          if ('function' === typeof r) {
            var o = t.value;
            (n.payload = function () {
              return r(o);
            }),
              (n.callback = function () {
                dl(0, t);
              });
          }
          var a = e.stateNode;
          return (
            null !== a &&
              'function' === typeof a.componentDidCatch &&
              (n.callback = function () {
                dl(0, t), 'function' !== typeof r && (null === $u ? ($u = new Set([this])) : $u.add(this));
                var e = t.stack;
                this.componentDidCatch(t.value, { componentStack: null !== e ? e : '' });
              }),
            n
          );
        }
        function ml(e, t, n) {
          var r = e.pingCache;
          if (null === r) {
            r = e.pingCache = new pl();
            var o = new Set();
            r.set(t, o);
          } else void 0 === (o = r.get(t)) && ((o = new Set()), r.set(t, o));
          o.has(n) || (o.add(n), (e = Es.bind(null, e, t, n)), t.then(e, e));
        }
        function gl(e) {
          do {
            var t;
            if (((t = 13 === e.tag) && (t = null === (t = e.memoizedState) || null !== t.dehydrated), t)) return e;
            e = e.return;
          } while (null !== e);
          return null;
        }
        function wl(e, t, n, r, o) {
          return 0 === (1 & e.mode)
            ? (e === t
                ? (e.flags |= 65536)
                : ((e.flags |= 128),
                  (n.flags |= 131072),
                  (n.flags &= -52805),
                  1 === n.tag && (null === n.alternate ? (n.tag = 17) : (((t = Oa(-1, 1)).tag = 2), Da(n, t, 1))),
                  (n.lanes |= 1)),
              e)
            : ((e.flags |= 65536), (e.lanes = o), e);
        }
        var yl = b.ReactCurrentOwner,
          bl = !1;
        function xl(e, t, n, r) {
          t.child = null === e ? Ja(t, null, n, r) : Xa(t, e.child, n, r);
        }
        function kl(e, t, n, r, o) {
          n = n.render;
          var a = t.ref;
          return (
            Ea(t, o),
            (r = _i(e, t, n, r, a, o)),
            (n = Ei()),
            null === e || bl
              ? (aa && n && ta(t), (t.flags |= 1), xl(e, t, r, o), t.child)
              : ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~o), ql(e, t, o))
          );
        }
        function Sl(e, t, n, r, o) {
          if (null === e) {
            var a = n.type;
            return 'function' !== typeof a ||
              Rs(a) ||
              void 0 !== a.defaultProps ||
              null !== n.compare ||
              void 0 !== n.defaultProps
              ? (((e = Os(n.type, null, r, t, t.mode, o)).ref = t.ref), (e.return = t), (t.child = e))
              : ((t.tag = 15), (t.type = a), _l(e, t, a, r, o));
          }
          if (((a = e.child), 0 === (e.lanes & o))) {
            var i = a.memoizedProps;
            if ((n = null !== (n = n.compare) ? n : ur)(i, r) && e.ref === t.ref) return ql(e, t, o);
          }
          return (t.flags |= 1), ((e = Ps(a, r)).ref = t.ref), (e.return = t), (t.child = e);
        }
        function _l(e, t, n, r, o) {
          if (null !== e) {
            var a = e.memoizedProps;
            if (ur(a, r) && e.ref === t.ref) {
              if (((bl = !1), (t.pendingProps = r = a), 0 === (e.lanes & o))) return (t.lanes = e.lanes), ql(e, t, o);
              0 !== (131072 & e.flags) && (bl = !0);
            }
          }
          return Tl(e, t, n, r, o);
        }
        function El(e, t, n) {
          var r = t.pendingProps,
            o = r.children,
            a = null !== e ? e.memoizedState : null;
          if ('hidden' === r.mode)
            if (0 === (1 & t.mode))
              (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }), To(Pu, Ru), (Ru |= n);
            else {
              if (0 === (1073741824 & n))
                return (
                  (e = null !== a ? a.baseLanes | n : n),
                  (t.lanes = t.childLanes = 1073741824),
                  (t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }),
                  (t.updateQueue = null),
                  To(Pu, Ru),
                  (Ru |= e),
                  null
                );
              (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
                (r = null !== a ? a.baseLanes : n),
                To(Pu, Ru),
                (Ru |= r);
            }
          else null !== a ? ((r = a.baseLanes | n), (t.memoizedState = null)) : (r = n), To(Pu, Ru), (Ru |= r);
          return xl(e, t, o, n), t.child;
        }
        function Cl(e, t) {
          var n = t.ref;
          ((null === e && null !== n) || (null !== e && e.ref !== n)) && ((t.flags |= 512), (t.flags |= 2097152));
        }
        function Tl(e, t, n, r, o) {
          var a = Po(n) ? Ao : jo.current;
          return (
            (a = Ro(t, a)),
            Ea(t, o),
            (n = _i(e, t, n, r, a, o)),
            (r = Ei()),
            null === e || bl
              ? (aa && r && ta(t), (t.flags |= 1), xl(e, t, n, o), t.child)
              : ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~o), ql(e, t, o))
          );
        }
        function Nl(e, t, n, r, o) {
          if (Po(n)) {
            var a = !0;
            Mo(t);
          } else a = !1;
          if ((Ea(t, o), null === t.stateNode)) Hl(e, t), qa(t, n, r), $a(t, n, r, o), (r = !0);
          else if (null === e) {
            var i = t.stateNode,
              l = t.memoizedProps;
            i.props = l;
            var u = i.context,
              s = n.contextType;
            'object' === typeof s && null !== s ? (s = Ca(s)) : (s = Ro(t, (s = Po(n) ? Ao : jo.current)));
            var c = n.getDerivedStateFromProps,
              f = 'function' === typeof c || 'function' === typeof i.getSnapshotBeforeUpdate;
            f ||
              ('function' !== typeof i.UNSAFE_componentWillReceiveProps &&
                'function' !== typeof i.componentWillReceiveProps) ||
              ((l !== r || u !== s) && Wa(t, i, r, s)),
              (Aa = !1);
            var d = t.memoizedState;
            (i.state = d),
              za(t, r, i, o),
              (u = t.memoizedState),
              l !== r || d !== u || Lo.current || Aa
                ? ('function' === typeof c && (Fa(t, n, c, r), (u = t.memoizedState)),
                  (l = Aa || Ha(t, n, l, r, d, u, s))
                    ? (f ||
                        ('function' !== typeof i.UNSAFE_componentWillMount &&
                          'function' !== typeof i.componentWillMount) ||
                        ('function' === typeof i.componentWillMount && i.componentWillMount(),
                        'function' === typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount()),
                      'function' === typeof i.componentDidMount && (t.flags |= 4194308))
                    : ('function' === typeof i.componentDidMount && (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = u)),
                  (i.props = r),
                  (i.state = u),
                  (i.context = s),
                  (r = l))
                : ('function' === typeof i.componentDidMount && (t.flags |= 4194308), (r = !1));
          } else {
            (i = t.stateNode),
              Pa(e, t),
              (l = t.memoizedProps),
              (s = t.type === t.elementType ? l : ga(t.type, l)),
              (i.props = s),
              (f = t.pendingProps),
              (d = i.context),
              'object' === typeof (u = n.contextType) && null !== u
                ? (u = Ca(u))
                : (u = Ro(t, (u = Po(n) ? Ao : jo.current)));
            var p = n.getDerivedStateFromProps;
            (c = 'function' === typeof p || 'function' === typeof i.getSnapshotBeforeUpdate) ||
              ('function' !== typeof i.UNSAFE_componentWillReceiveProps &&
                'function' !== typeof i.componentWillReceiveProps) ||
              ((l !== f || d !== u) && Wa(t, i, r, u)),
              (Aa = !1),
              (d = t.memoizedState),
              (i.state = d),
              za(t, r, i, o);
            var h = t.memoizedState;
            l !== f || d !== h || Lo.current || Aa
              ? ('function' === typeof p && (Fa(t, n, p, r), (h = t.memoizedState)),
                (s = Aa || Ha(t, n, s, r, d, h, u) || !1)
                  ? (c ||
                      ('function' !== typeof i.UNSAFE_componentWillUpdate &&
                        'function' !== typeof i.componentWillUpdate) ||
                      ('function' === typeof i.componentWillUpdate && i.componentWillUpdate(r, h, u),
                      'function' === typeof i.UNSAFE_componentWillUpdate && i.UNSAFE_componentWillUpdate(r, h, u)),
                    'function' === typeof i.componentDidUpdate && (t.flags |= 4),
                    'function' === typeof i.getSnapshotBeforeUpdate && (t.flags |= 1024))
                  : ('function' !== typeof i.componentDidUpdate ||
                      (l === e.memoizedProps && d === e.memoizedState) ||
                      (t.flags |= 4),
                    'function' !== typeof i.getSnapshotBeforeUpdate ||
                      (l === e.memoizedProps && d === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = h)),
                (i.props = r),
                (i.state = h),
                (i.context = u),
                (r = s))
              : ('function' !== typeof i.componentDidUpdate ||
                  (l === e.memoizedProps && d === e.memoizedState) ||
                  (t.flags |= 4),
                'function' !== typeof i.getSnapshotBeforeUpdate ||
                  (l === e.memoizedProps && d === e.memoizedState) ||
                  (t.flags |= 1024),
                (r = !1));
          }
          return jl(e, t, n, r, a, o);
        }
        function jl(e, t, n, r, o, a) {
          Cl(e, t);
          var i = 0 !== (128 & t.flags);
          if (!r && !i) return o && zo(t, n, !1), ql(e, t, a);
          (r = t.stateNode), (yl.current = t);
          var l = i && 'function' !== typeof n.getDerivedStateFromError ? null : r.render();
          return (
            (t.flags |= 1),
            null !== e && i ? ((t.child = Xa(t, e.child, null, a)), (t.child = Xa(t, null, l, a))) : xl(e, t, l, a),
            (t.memoizedState = r.state),
            o && zo(t, n, !0),
            t.child
          );
        }
        function Ll(e) {
          var t = e.stateNode;
          t.pendingContext
            ? Do(0, t.pendingContext, t.pendingContext !== t.context)
            : t.context && Do(0, t.context, !1),
            oi(e, t.containerInfo);
        }
        function Al(e, t, n, r, o) {
          return ha(), va(o), (t.flags |= 256), xl(e, t, n, r), t.child;
        }
        var Rl,
          Pl,
          Ol,
          Dl = { dehydrated: null, treeContext: null, retryLane: 0 };
        function Il(e) {
          return { baseLanes: e, cachePool: null, transitions: null };
        }
        function Ml(e, t, n) {
          var r,
            o = t.pendingProps,
            i = ui.current,
            l = !1,
            u = 0 !== (128 & t.flags);
          if (
            ((r = u) || (r = (null === e || null !== e.memoizedState) && 0 !== (2 & i)),
            r ? ((l = !0), (t.flags &= -129)) : (null !== e && null === e.memoizedState) || (i |= 1),
            To(ui, 1 & i),
            null === e)
          )
            return (
              ca(t),
              null !== (e = t.memoizedState) && null !== (e = e.dehydrated)
                ? (0 === (1 & t.mode) ? (t.lanes = 1) : '$!' === e.data ? (t.lanes = 8) : (t.lanes = 1073741824), null)
                : ((u = o.children),
                  (e = o.fallback),
                  l
                    ? ((o = t.mode),
                      (l = t.child),
                      (u = { mode: 'hidden', children: u }),
                      0 === (1 & o) && null !== l
                        ? ((l.childLanes = 0), (l.pendingProps = u))
                        : (l = Is(u, o, 0, null)),
                      (e = Ds(e, o, n, null)),
                      (l.return = t),
                      (e.return = t),
                      (l.sibling = e),
                      (t.child = l),
                      (t.child.memoizedState = Il(n)),
                      (t.memoizedState = Dl),
                      e)
                    : zl(t, u))
            );
          if (null !== (i = e.memoizedState) && null !== (r = i.dehydrated))
            return (function (e, t, n, r, o, i, l) {
              if (n)
                return 256 & t.flags
                  ? ((t.flags &= -257), Vl(e, t, l, (r = fl(Error(a(422))))))
                  : null !== t.memoizedState
                  ? ((t.child = e.child), (t.flags |= 128), null)
                  : ((i = r.fallback),
                    (o = t.mode),
                    (r = Is({ mode: 'visible', children: r.children }, o, 0, null)),
                    ((i = Ds(i, o, l, null)).flags |= 2),
                    (r.return = t),
                    (i.return = t),
                    (r.sibling = i),
                    (t.child = r),
                    0 !== (1 & t.mode) && Xa(t, e.child, null, l),
                    (t.child.memoizedState = Il(l)),
                    (t.memoizedState = Dl),
                    i);
              if (0 === (1 & t.mode)) return Vl(e, t, l, null);
              if ('$!' === o.data) {
                if ((r = o.nextSibling && o.nextSibling.dataset)) var u = r.dgst;
                return (r = u), Vl(e, t, l, (r = fl((i = Error(a(419))), r, void 0)));
              }
              if (((u = 0 !== (l & e.childLanes)), bl || u)) {
                if (null !== (r = ju)) {
                  switch (l & -l) {
                    case 4:
                      o = 2;
                      break;
                    case 16:
                      o = 8;
                      break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                      o = 32;
                      break;
                    case 536870912:
                      o = 268435456;
                      break;
                    default:
                      o = 0;
                  }
                  0 !== (o = 0 !== (o & (r.suspendedLanes | l)) ? 0 : o) &&
                    o !== i.retryLane &&
                    ((i.retryLane = o), La(e, o), ns(r, e, o, -1));
                }
                return vs(), Vl(e, t, l, (r = fl(Error(a(421)))));
              }
              return '$?' === o.data
                ? ((t.flags |= 128), (t.child = e.child), (t = Ts.bind(null, e)), (o._reactRetry = t), null)
                : ((e = i.treeContext),
                  (oa = so(o.nextSibling)),
                  (ra = t),
                  (aa = !0),
                  (ia = null),
                  null !== e &&
                    ((Ko[Qo++] = Xo), (Ko[Qo++] = Jo), (Ko[Qo++] = Yo), (Xo = e.id), (Jo = e.overflow), (Yo = t)),
                  (t = zl(t, r.children)),
                  (t.flags |= 4096),
                  t);
            })(e, t, u, o, r, i, n);
          if (l) {
            (l = o.fallback), (u = t.mode), (r = (i = e.child).sibling);
            var s = { mode: 'hidden', children: o.children };
            return (
              0 === (1 & u) && t.child !== i
                ? (((o = t.child).childLanes = 0), (o.pendingProps = s), (t.deletions = null))
                : ((o = Ps(i, s)).subtreeFlags = 14680064 & i.subtreeFlags),
              null !== r ? (l = Ps(r, l)) : ((l = Ds(l, u, n, null)).flags |= 2),
              (l.return = t),
              (o.return = t),
              (o.sibling = l),
              (t.child = o),
              (o = l),
              (l = t.child),
              (u =
                null === (u = e.child.memoizedState)
                  ? Il(n)
                  : { baseLanes: u.baseLanes | n, cachePool: null, transitions: u.transitions }),
              (l.memoizedState = u),
              (l.childLanes = e.childLanes & ~n),
              (t.memoizedState = Dl),
              o
            );
          }
          return (
            (e = (l = e.child).sibling),
            (o = Ps(l, { mode: 'visible', children: o.children })),
            0 === (1 & t.mode) && (o.lanes = n),
            (o.return = t),
            (o.sibling = null),
            null !== e && (null === (n = t.deletions) ? ((t.deletions = [e]), (t.flags |= 16)) : n.push(e)),
            (t.child = o),
            (t.memoizedState = null),
            o
          );
        }
        function zl(e, t) {
          return ((t = Is({ mode: 'visible', children: t }, e.mode, 0, null)).return = e), (e.child = t);
        }
        function Vl(e, t, n, r) {
          return (
            null !== r && va(r),
            Xa(t, e.child, null, n),
            ((e = zl(t, t.pendingProps.children)).flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function Bl(e, t, n) {
          e.lanes |= t;
          var r = e.alternate;
          null !== r && (r.lanes |= t), _a(e.return, t, n);
        }
        function Fl(e, t, n, r, o) {
          var a = e.memoizedState;
          null === a
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: o,
              })
            : ((a.isBackwards = t),
              (a.rendering = null),
              (a.renderingStartTime = 0),
              (a.last = r),
              (a.tail = n),
              (a.tailMode = o));
        }
        function Ul(e, t, n) {
          var r = t.pendingProps,
            o = r.revealOrder,
            a = r.tail;
          if ((xl(e, t, r.children, n), 0 !== (2 & (r = ui.current)))) (r = (1 & r) | 2), (t.flags |= 128);
          else {
            if (null !== e && 0 !== (128 & e.flags))
              e: for (e = t.child; null !== e; ) {
                if (13 === e.tag) null !== e.memoizedState && Bl(e, n, t);
                else if (19 === e.tag) Bl(e, n, t);
                else if (null !== e.child) {
                  (e.child.return = e), (e = e.child);
                  continue;
                }
                if (e === t) break e;
                for (; null === e.sibling; ) {
                  if (null === e.return || e.return === t) break e;
                  e = e.return;
                }
                (e.sibling.return = e.return), (e = e.sibling);
              }
            r &= 1;
          }
          if ((To(ui, r), 0 === (1 & t.mode))) t.memoizedState = null;
          else
            switch (o) {
              case 'forwards':
                for (n = t.child, o = null; null !== n; )
                  null !== (e = n.alternate) && null === si(e) && (o = n), (n = n.sibling);
                null === (n = o) ? ((o = t.child), (t.child = null)) : ((o = n.sibling), (n.sibling = null)),
                  Fl(t, !1, o, n, a);
                break;
              case 'backwards':
                for (n = null, o = t.child, t.child = null; null !== o; ) {
                  if (null !== (e = o.alternate) && null === si(e)) {
                    t.child = o;
                    break;
                  }
                  (e = o.sibling), (o.sibling = n), (n = o), (o = e);
                }
                Fl(t, !0, n, null, a);
                break;
              case 'together':
                Fl(t, !1, null, null, void 0);
                break;
              default:
                t.memoizedState = null;
            }
          return t.child;
        }
        function Hl(e, t) {
          0 === (1 & t.mode) && null !== e && ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
        }
        function ql(e, t, n) {
          if ((null !== e && (t.dependencies = e.dependencies), (Iu |= t.lanes), 0 === (n & t.childLanes))) return null;
          if (null !== e && t.child !== e.child) throw Error(a(153));
          if (null !== t.child) {
            for (n = Ps((e = t.child), e.pendingProps), t.child = n, n.return = t; null !== e.sibling; )
              (e = e.sibling), ((n = n.sibling = Ps(e, e.pendingProps)).return = t);
            n.sibling = null;
          }
          return t.child;
        }
        function Wl(e, t) {
          if (!aa)
            switch (e.tailMode) {
              case 'hidden':
                t = e.tail;
                for (var n = null; null !== t; ) null !== t.alternate && (n = t), (t = t.sibling);
                null === n ? (e.tail = null) : (n.sibling = null);
                break;
              case 'collapsed':
                n = e.tail;
                for (var r = null; null !== n; ) null !== n.alternate && (r = n), (n = n.sibling);
                null === r ? (t || null === e.tail ? (e.tail = null) : (e.tail.sibling = null)) : (r.sibling = null);
            }
        }
        function $l(e) {
          var t = null !== e.alternate && e.alternate.child === e.child,
            n = 0,
            r = 0;
          if (t)
            for (var o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= 14680064 & o.subtreeFlags),
                (r |= 14680064 & o.flags),
                (o.return = e),
                (o = o.sibling);
          else
            for (o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes), (r |= o.subtreeFlags), (r |= o.flags), (o.return = e), (o = o.sibling);
          return (e.subtreeFlags |= r), (e.childLanes = n), t;
        }
        function Gl(e, t, n) {
          var r = t.pendingProps;
          switch ((na(t), t.tag)) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return $l(t), null;
            case 1:
            case 17:
              return Po(t.type) && Oo(), $l(t), null;
            case 3:
              return (
                (r = t.stateNode),
                ai(),
                Co(Lo),
                Co(jo),
                fi(),
                r.pendingContext && ((r.context = r.pendingContext), (r.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (da(t)
                    ? (t.flags |= 4)
                    : null === e ||
                      (e.memoizedState.isDehydrated && 0 === (256 & t.flags)) ||
                      ((t.flags |= 1024), null !== ia && (is(ia), (ia = null)))),
                $l(t),
                null
              );
            case 5:
              li(t);
              var o = ri(ni.current);
              if (((n = t.type), null !== e && null != t.stateNode))
                Pl(e, t, n, r), e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(a(166));
                  return $l(t), null;
                }
                if (((e = ri(ei.current)), da(t))) {
                  (r = t.stateNode), (n = t.type);
                  var i = t.memoizedProps;
                  switch (((r[po] = t), (r[ho] = i), (e = 0 !== (1 & t.mode)), n)) {
                    case 'dialog':
                      Vr('cancel', r), Vr('close', r);
                      break;
                    case 'iframe':
                    case 'object':
                    case 'embed':
                      Vr('load', r);
                      break;
                    case 'video':
                    case 'audio':
                      for (o = 0; o < Dr.length; o++) Vr(Dr[o], r);
                      break;
                    case 'source':
                      Vr('error', r);
                      break;
                    case 'img':
                    case 'image':
                    case 'link':
                      Vr('error', r), Vr('load', r);
                      break;
                    case 'details':
                      Vr('toggle', r);
                      break;
                    case 'input':
                      Y(r, i), Vr('invalid', r);
                      break;
                    case 'select':
                      (r._wrapperState = { wasMultiple: !!i.multiple }), Vr('invalid', r);
                      break;
                    case 'textarea':
                      oe(r, i), Vr('invalid', r);
                  }
                  for (var u in (we(n, i), (o = null), i))
                    if (i.hasOwnProperty(u)) {
                      var s = i[u];
                      'children' === u
                        ? 'string' === typeof s
                          ? r.textContent !== s &&
                            (!0 !== i.suppressHydrationWarning && Jr(r.textContent, s, e), (o = ['children', s]))
                          : 'number' === typeof s &&
                            r.textContent !== '' + s &&
                            (!0 !== i.suppressHydrationWarning && Jr(r.textContent, s, e), (o = ['children', '' + s]))
                        : l.hasOwnProperty(u) && null != s && 'onScroll' === u && Vr('scroll', r);
                    }
                  switch (n) {
                    case 'input':
                      $(r), Z(r, i, !0);
                      break;
                    case 'textarea':
                      $(r), ie(r);
                      break;
                    case 'select':
                    case 'option':
                      break;
                    default:
                      'function' === typeof i.onClick && (r.onclick = Zr);
                  }
                  (r = o), (t.updateQueue = r), null !== r && (t.flags |= 4);
                } else {
                  (u = 9 === o.nodeType ? o : o.ownerDocument),
                    'http://www.w3.org/1999/xhtml' === e && (e = le(n)),
                    'http://www.w3.org/1999/xhtml' === e
                      ? 'script' === n
                        ? (((e = u.createElement('div')).innerHTML = '<script></script>'),
                          (e = e.removeChild(e.firstChild)))
                        : 'string' === typeof r.is
                        ? (e = u.createElement(n, { is: r.is }))
                        : ((e = u.createElement(n)),
                          'select' === n && ((u = e), r.multiple ? (u.multiple = !0) : r.size && (u.size = r.size)))
                      : (e = u.createElementNS(e, n)),
                    (e[po] = t),
                    (e[ho] = r),
                    Rl(e, t),
                    (t.stateNode = e);
                  e: {
                    switch (((u = ye(n, r)), n)) {
                      case 'dialog':
                        Vr('cancel', e), Vr('close', e), (o = r);
                        break;
                      case 'iframe':
                      case 'object':
                      case 'embed':
                        Vr('load', e), (o = r);
                        break;
                      case 'video':
                      case 'audio':
                        for (o = 0; o < Dr.length; o++) Vr(Dr[o], e);
                        o = r;
                        break;
                      case 'source':
                        Vr('error', e), (o = r);
                        break;
                      case 'img':
                      case 'image':
                      case 'link':
                        Vr('error', e), Vr('load', e), (o = r);
                        break;
                      case 'details':
                        Vr('toggle', e), (o = r);
                        break;
                      case 'input':
                        Y(e, r), (o = Q(e, r)), Vr('invalid', e);
                        break;
                      case 'option':
                      default:
                        o = r;
                        break;
                      case 'select':
                        (e._wrapperState = { wasMultiple: !!r.multiple }),
                          (o = M({}, r, { value: void 0 })),
                          Vr('invalid', e);
                        break;
                      case 'textarea':
                        oe(e, r), (o = re(e, r)), Vr('invalid', e);
                    }
                    for (i in (we(n, o), (s = o)))
                      if (s.hasOwnProperty(i)) {
                        var c = s[i];
                        'style' === i
                          ? me(e, c)
                          : 'dangerouslySetInnerHTML' === i
                          ? null != (c = c ? c.__html : void 0) && fe(e, c)
                          : 'children' === i
                          ? 'string' === typeof c
                            ? ('textarea' !== n || '' !== c) && de(e, c)
                            : 'number' === typeof c && de(e, '' + c)
                          : 'suppressContentEditableWarning' !== i &&
                            'suppressHydrationWarning' !== i &&
                            'autoFocus' !== i &&
                            (l.hasOwnProperty(i)
                              ? null != c && 'onScroll' === i && Vr('scroll', e)
                              : null != c && y(e, i, c, u));
                      }
                    switch (n) {
                      case 'input':
                        $(e), Z(e, r, !1);
                        break;
                      case 'textarea':
                        $(e), ie(e);
                        break;
                      case 'option':
                        null != r.value && e.setAttribute('value', '' + q(r.value));
                        break;
                      case 'select':
                        (e.multiple = !!r.multiple),
                          null != (i = r.value)
                            ? ne(e, !!r.multiple, i, !1)
                            : null != r.defaultValue && ne(e, !!r.multiple, r.defaultValue, !0);
                        break;
                      default:
                        'function' === typeof o.onClick && (e.onclick = Zr);
                    }
                    switch (n) {
                      case 'button':
                      case 'input':
                      case 'select':
                      case 'textarea':
                        r = !!r.autoFocus;
                        break e;
                      case 'img':
                        r = !0;
                        break e;
                      default:
                        r = !1;
                    }
                  }
                  r && (t.flags |= 4);
                }
                null !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              }
              return $l(t), null;
            case 6:
              if (e && null != t.stateNode) Ol(0, t, e.memoizedProps, r);
              else {
                if ('string' !== typeof r && null === t.stateNode) throw Error(a(166));
                if (((n = ri(ni.current)), ri(ei.current), da(t))) {
                  if (
                    ((r = t.stateNode),
                    (n = t.memoizedProps),
                    (r[po] = t),
                    (i = r.nodeValue !== n) && null !== (e = ra))
                  )
                    switch (e.tag) {
                      case 3:
                        Jr(r.nodeValue, n, 0 !== (1 & e.mode));
                        break;
                      case 5:
                        !0 !== e.memoizedProps.suppressHydrationWarning && Jr(r.nodeValue, n, 0 !== (1 & e.mode));
                    }
                  i && (t.flags |= 4);
                } else ((r = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(r))[po] = t), (t.stateNode = r);
              }
              return $l(t), null;
            case 13:
              if (
                (Co(ui),
                (r = t.memoizedState),
                null === e || (null !== e.memoizedState && null !== e.memoizedState.dehydrated))
              ) {
                if (aa && null !== oa && 0 !== (1 & t.mode) && 0 === (128 & t.flags))
                  pa(), ha(), (t.flags |= 98560), (i = !1);
                else if (((i = da(t)), null !== r && null !== r.dehydrated)) {
                  if (null === e) {
                    if (!i) throw Error(a(318));
                    if (!(i = null !== (i = t.memoizedState) ? i.dehydrated : null)) throw Error(a(317));
                    i[po] = t;
                  } else ha(), 0 === (128 & t.flags) && (t.memoizedState = null), (t.flags |= 4);
                  $l(t), (i = !1);
                } else null !== ia && (is(ia), (ia = null)), (i = !0);
                if (!i) return 65536 & t.flags ? t : null;
              }
              return 0 !== (128 & t.flags)
                ? ((t.lanes = n), t)
                : ((r = null !== r) !== (null !== e && null !== e.memoizedState) &&
                    r &&
                    ((t.child.flags |= 8192),
                    0 !== (1 & t.mode) && (null === e || 0 !== (1 & ui.current) ? 0 === Ou && (Ou = 3) : vs())),
                  null !== t.updateQueue && (t.flags |= 4),
                  $l(t),
                  null);
            case 4:
              return ai(), null === e && Ur(t.stateNode.containerInfo), $l(t), null;
            case 10:
              return Sa(t.type._context), $l(t), null;
            case 19:
              if ((Co(ui), null === (i = t.memoizedState))) return $l(t), null;
              if (((r = 0 !== (128 & t.flags)), null === (u = i.rendering)))
                if (r) Wl(i, !1);
                else {
                  if (0 !== Ou || (null !== e && 0 !== (128 & e.flags)))
                    for (e = t.child; null !== e; ) {
                      if (null !== (u = si(e))) {
                        for (
                          t.flags |= 128,
                            Wl(i, !1),
                            null !== (r = u.updateQueue) && ((t.updateQueue = r), (t.flags |= 4)),
                            t.subtreeFlags = 0,
                            r = n,
                            n = t.child;
                          null !== n;

                        )
                          (e = r),
                            ((i = n).flags &= 14680066),
                            null === (u = i.alternate)
                              ? ((i.childLanes = 0),
                                (i.lanes = e),
                                (i.child = null),
                                (i.subtreeFlags = 0),
                                (i.memoizedProps = null),
                                (i.memoizedState = null),
                                (i.updateQueue = null),
                                (i.dependencies = null),
                                (i.stateNode = null))
                              : ((i.childLanes = u.childLanes),
                                (i.lanes = u.lanes),
                                (i.child = u.child),
                                (i.subtreeFlags = 0),
                                (i.deletions = null),
                                (i.memoizedProps = u.memoizedProps),
                                (i.memoizedState = u.memoizedState),
                                (i.updateQueue = u.updateQueue),
                                (i.type = u.type),
                                (e = u.dependencies),
                                (i.dependencies =
                                  null === e ? null : { lanes: e.lanes, firstContext: e.firstContext })),
                            (n = n.sibling);
                        return To(ui, (1 & ui.current) | 2), t.child;
                      }
                      e = e.sibling;
                    }
                  null !== i.tail && Xe() > Uu && ((t.flags |= 128), (r = !0), Wl(i, !1), (t.lanes = 4194304));
                }
              else {
                if (!r)
                  if (null !== (e = si(u))) {
                    if (
                      ((t.flags |= 128),
                      (r = !0),
                      null !== (n = e.updateQueue) && ((t.updateQueue = n), (t.flags |= 4)),
                      Wl(i, !0),
                      null === i.tail && 'hidden' === i.tailMode && !u.alternate && !aa)
                    )
                      return $l(t), null;
                  } else
                    2 * Xe() - i.renderingStartTime > Uu &&
                      1073741824 !== n &&
                      ((t.flags |= 128), (r = !0), Wl(i, !1), (t.lanes = 4194304));
                i.isBackwards
                  ? ((u.sibling = t.child), (t.child = u))
                  : (null !== (n = i.last) ? (n.sibling = u) : (t.child = u), (i.last = u));
              }
              return null !== i.tail
                ? ((t = i.tail),
                  (i.rendering = t),
                  (i.tail = t.sibling),
                  (i.renderingStartTime = Xe()),
                  (t.sibling = null),
                  (n = ui.current),
                  To(ui, r ? (1 & n) | 2 : 1 & n),
                  t)
                : ($l(t), null);
            case 22:
            case 23:
              return (
                fs(),
                (r = null !== t.memoizedState),
                null !== e && (null !== e.memoizedState) !== r && (t.flags |= 8192),
                r && 0 !== (1 & t.mode)
                  ? 0 !== (1073741824 & Ru) && ($l(t), 6 & t.subtreeFlags && (t.flags |= 8192))
                  : $l(t),
                null
              );
            case 24:
            case 25:
              return null;
          }
          throw Error(a(156, t.tag));
        }
        function Kl(e, t) {
          switch ((na(t), t.tag)) {
            case 1:
              return Po(t.type) && Oo(), 65536 & (e = t.flags) ? ((t.flags = (-65537 & e) | 128), t) : null;
            case 3:
              return (
                ai(),
                Co(Lo),
                Co(jo),
                fi(),
                0 !== (65536 & (e = t.flags)) && 0 === (128 & e) ? ((t.flags = (-65537 & e) | 128), t) : null
              );
            case 5:
              return li(t), null;
            case 13:
              if ((Co(ui), null !== (e = t.memoizedState) && null !== e.dehydrated)) {
                if (null === t.alternate) throw Error(a(340));
                ha();
              }
              return 65536 & (e = t.flags) ? ((t.flags = (-65537 & e) | 128), t) : null;
            case 19:
              return Co(ui), null;
            case 4:
              return ai(), null;
            case 10:
              return Sa(t.type._context), null;
            case 22:
            case 23:
              return fs(), null;
            default:
              return null;
          }
        }
        (Rl = function (e, t) {
          for (var n = t.child; null !== n; ) {
            if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
            else if (4 !== n.tag && null !== n.child) {
              (n.child.return = n), (n = n.child);
              continue;
            }
            if (n === t) break;
            for (; null === n.sibling; ) {
              if (null === n.return || n.return === t) return;
              n = n.return;
            }
            (n.sibling.return = n.return), (n = n.sibling);
          }
        }),
          (Pl = function (e, t, n, r) {
            var o = e.memoizedProps;
            if (o !== r) {
              (e = t.stateNode), ri(ei.current);
              var a,
                i = null;
              switch (n) {
                case 'input':
                  (o = Q(e, o)), (r = Q(e, r)), (i = []);
                  break;
                case 'select':
                  (o = M({}, o, { value: void 0 })), (r = M({}, r, { value: void 0 })), (i = []);
                  break;
                case 'textarea':
                  (o = re(e, o)), (r = re(e, r)), (i = []);
                  break;
                default:
                  'function' !== typeof o.onClick && 'function' === typeof r.onClick && (e.onclick = Zr);
              }
              for (c in (we(n, r), (n = null), o))
                if (!r.hasOwnProperty(c) && o.hasOwnProperty(c) && null != o[c])
                  if ('style' === c) {
                    var u = o[c];
                    for (a in u) u.hasOwnProperty(a) && (n || (n = {}), (n[a] = ''));
                  } else
                    'dangerouslySetInnerHTML' !== c &&
                      'children' !== c &&
                      'suppressContentEditableWarning' !== c &&
                      'suppressHydrationWarning' !== c &&
                      'autoFocus' !== c &&
                      (l.hasOwnProperty(c) ? i || (i = []) : (i = i || []).push(c, null));
              for (c in r) {
                var s = r[c];
                if (((u = null != o ? o[c] : void 0), r.hasOwnProperty(c) && s !== u && (null != s || null != u)))
                  if ('style' === c)
                    if (u) {
                      for (a in u) !u.hasOwnProperty(a) || (s && s.hasOwnProperty(a)) || (n || (n = {}), (n[a] = ''));
                      for (a in s) s.hasOwnProperty(a) && u[a] !== s[a] && (n || (n = {}), (n[a] = s[a]));
                    } else n || (i || (i = []), i.push(c, n)), (n = s);
                  else
                    'dangerouslySetInnerHTML' === c
                      ? ((s = s ? s.__html : void 0),
                        (u = u ? u.__html : void 0),
                        null != s && u !== s && (i = i || []).push(c, s))
                      : 'children' === c
                      ? ('string' !== typeof s && 'number' !== typeof s) || (i = i || []).push(c, '' + s)
                      : 'suppressContentEditableWarning' !== c &&
                        'suppressHydrationWarning' !== c &&
                        (l.hasOwnProperty(c)
                          ? (null != s && 'onScroll' === c && Vr('scroll', e), i || u === s || (i = []))
                          : (i = i || []).push(c, s));
              }
              n && (i = i || []).push('style', n);
              var c = i;
              (t.updateQueue = c) && (t.flags |= 4);
            }
          }),
          (Ol = function (e, t, n, r) {
            n !== r && (t.flags |= 4);
          });
        var Ql = !1,
          Yl = !1,
          Xl = 'function' === typeof WeakSet ? WeakSet : Set,
          Jl = null;
        function Zl(e, t) {
          var n = e.ref;
          if (null !== n)
            if ('function' === typeof n)
              try {
                n(null);
              } catch (r) {
                _s(e, t, r);
              }
            else n.current = null;
        }
        function eu(e, t, n) {
          try {
            n();
          } catch (r) {
            _s(e, t, r);
          }
        }
        var tu = !1;
        function nu(e, t, n) {
          var r = t.updateQueue;
          if (null !== (r = null !== r ? r.lastEffect : null)) {
            var o = (r = r.next);
            do {
              if ((o.tag & e) === e) {
                var a = o.destroy;
                (o.destroy = void 0), void 0 !== a && eu(t, n, a);
              }
              o = o.next;
            } while (o !== r);
          }
        }
        function ru(e, t) {
          if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
            var n = (t = t.next);
            do {
              if ((n.tag & e) === e) {
                var r = n.create;
                n.destroy = r();
              }
              n = n.next;
            } while (n !== t);
          }
        }
        function ou(e) {
          var t = e.ref;
          if (null !== t) {
            var n = e.stateNode;
            e.tag, (e = n), 'function' === typeof t ? t(e) : (t.current = e);
          }
        }
        function au(e) {
          var t = e.alternate;
          null !== t && ((e.alternate = null), au(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            5 === e.tag &&
              null !== (t = e.stateNode) &&
              (delete t[po], delete t[ho], delete t[mo], delete t[go], delete t[wo]),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null);
        }
        function iu(e) {
          return 5 === e.tag || 3 === e.tag || 4 === e.tag;
        }
        function lu(e) {
          e: for (;;) {
            for (; null === e.sibling; ) {
              if (null === e.return || iu(e.return)) return null;
              e = e.return;
            }
            for (e.sibling.return = e.return, e = e.sibling; 5 !== e.tag && 6 !== e.tag && 18 !== e.tag; ) {
              if (2 & e.flags) continue e;
              if (null === e.child || 4 === e.tag) continue e;
              (e.child.return = e), (e = e.child);
            }
            if (!(2 & e.flags)) return e.stateNode;
          }
        }
        function uu(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode),
              t
                ? 8 === n.nodeType
                  ? n.parentNode.insertBefore(e, t)
                  : n.insertBefore(e, t)
                : (8 === n.nodeType ? (t = n.parentNode).insertBefore(e, n) : (t = n).appendChild(e),
                  (null !== (n = n._reactRootContainer) && void 0 !== n) || null !== t.onclick || (t.onclick = Zr));
          else if (4 !== r && null !== (e = e.child))
            for (uu(e, t, n), e = e.sibling; null !== e; ) uu(e, t, n), (e = e.sibling);
        }
        function su(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r) (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
          else if (4 !== r && null !== (e = e.child))
            for (su(e, t, n), e = e.sibling; null !== e; ) su(e, t, n), (e = e.sibling);
        }
        var cu = null,
          fu = !1;
        function du(e, t, n) {
          for (n = n.child; null !== n; ) pu(e, t, n), (n = n.sibling);
        }
        function pu(e, t, n) {
          if (at && 'function' === typeof at.onCommitFiberUnmount)
            try {
              at.onCommitFiberUnmount(ot, n);
            } catch (l) {}
          switch (n.tag) {
            case 5:
              Yl || Zl(n, t);
            case 6:
              var r = cu,
                o = fu;
              (cu = null),
                du(e, t, n),
                (fu = o),
                null !== (cu = r) &&
                  (fu
                    ? ((e = cu), (n = n.stateNode), 8 === e.nodeType ? e.parentNode.removeChild(n) : e.removeChild(n))
                    : cu.removeChild(n.stateNode));
              break;
            case 18:
              null !== cu &&
                (fu
                  ? ((e = cu),
                    (n = n.stateNode),
                    8 === e.nodeType ? uo(e.parentNode, n) : 1 === e.nodeType && uo(e, n),
                    Ut(e))
                  : uo(cu, n.stateNode));
              break;
            case 4:
              (r = cu), (o = fu), (cu = n.stateNode.containerInfo), (fu = !0), du(e, t, n), (cu = r), (fu = o);
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              if (!Yl && null !== (r = n.updateQueue) && null !== (r = r.lastEffect)) {
                o = r = r.next;
                do {
                  var a = o,
                    i = a.destroy;
                  (a = a.tag), void 0 !== i && (0 !== (2 & a) || 0 !== (4 & a)) && eu(n, t, i), (o = o.next);
                } while (o !== r);
              }
              du(e, t, n);
              break;
            case 1:
              if (!Yl && (Zl(n, t), 'function' === typeof (r = n.stateNode).componentWillUnmount))
                try {
                  (r.props = n.memoizedProps), (r.state = n.memoizedState), r.componentWillUnmount();
                } catch (l) {
                  _s(n, t, l);
                }
              du(e, t, n);
              break;
            case 21:
              du(e, t, n);
              break;
            case 22:
              1 & n.mode ? ((Yl = (r = Yl) || null !== n.memoizedState), du(e, t, n), (Yl = r)) : du(e, t, n);
              break;
            default:
              du(e, t, n);
          }
        }
        function hu(e) {
          var t = e.updateQueue;
          if (null !== t) {
            e.updateQueue = null;
            var n = e.stateNode;
            null === n && (n = e.stateNode = new Xl()),
              t.forEach(function (t) {
                var r = Ns.bind(null, e, t);
                n.has(t) || (n.add(t), t.then(r, r));
              });
          }
        }
        function vu(e, t) {
          var n = t.deletions;
          if (null !== n)
            for (var r = 0; r < n.length; r++) {
              var o = n[r];
              try {
                var i = e,
                  l = t,
                  u = l;
                e: for (; null !== u; ) {
                  switch (u.tag) {
                    case 5:
                      (cu = u.stateNode), (fu = !1);
                      break e;
                    case 3:
                    case 4:
                      (cu = u.stateNode.containerInfo), (fu = !0);
                      break e;
                  }
                  u = u.return;
                }
                if (null === cu) throw Error(a(160));
                pu(i, l, o), (cu = null), (fu = !1);
                var s = o.alternate;
                null !== s && (s.return = null), (o.return = null);
              } catch (c) {
                _s(o, t, c);
              }
            }
          if (12854 & t.subtreeFlags) for (t = t.child; null !== t; ) mu(t, e), (t = t.sibling);
        }
        function mu(e, t) {
          var n = e.alternate,
            r = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              if ((vu(t, e), gu(e), 4 & r)) {
                try {
                  nu(3, e, e.return), ru(3, e);
                } catch (m) {
                  _s(e, e.return, m);
                }
                try {
                  nu(5, e, e.return);
                } catch (m) {
                  _s(e, e.return, m);
                }
              }
              break;
            case 1:
              vu(t, e), gu(e), 512 & r && null !== n && Zl(n, n.return);
              break;
            case 5:
              if ((vu(t, e), gu(e), 512 & r && null !== n && Zl(n, n.return), 32 & e.flags)) {
                var o = e.stateNode;
                try {
                  de(o, '');
                } catch (m) {
                  _s(e, e.return, m);
                }
              }
              if (4 & r && null != (o = e.stateNode)) {
                var i = e.memoizedProps,
                  l = null !== n ? n.memoizedProps : i,
                  u = e.type,
                  s = e.updateQueue;
                if (((e.updateQueue = null), null !== s))
                  try {
                    'input' === u && 'radio' === i.type && null != i.name && X(o, i), ye(u, l);
                    var c = ye(u, i);
                    for (l = 0; l < s.length; l += 2) {
                      var f = s[l],
                        d = s[l + 1];
                      'style' === f
                        ? me(o, d)
                        : 'dangerouslySetInnerHTML' === f
                        ? fe(o, d)
                        : 'children' === f
                        ? de(o, d)
                        : y(o, f, d, c);
                    }
                    switch (u) {
                      case 'input':
                        J(o, i);
                        break;
                      case 'textarea':
                        ae(o, i);
                        break;
                      case 'select':
                        var p = o._wrapperState.wasMultiple;
                        o._wrapperState.wasMultiple = !!i.multiple;
                        var h = i.value;
                        null != h
                          ? ne(o, !!i.multiple, h, !1)
                          : p !== !!i.multiple &&
                            (null != i.defaultValue
                              ? ne(o, !!i.multiple, i.defaultValue, !0)
                              : ne(o, !!i.multiple, i.multiple ? [] : '', !1));
                    }
                    o[ho] = i;
                  } catch (m) {
                    _s(e, e.return, m);
                  }
              }
              break;
            case 6:
              if ((vu(t, e), gu(e), 4 & r)) {
                if (null === e.stateNode) throw Error(a(162));
                (o = e.stateNode), (i = e.memoizedProps);
                try {
                  o.nodeValue = i;
                } catch (m) {
                  _s(e, e.return, m);
                }
              }
              break;
            case 3:
              if ((vu(t, e), gu(e), 4 & r && null !== n && n.memoizedState.isDehydrated))
                try {
                  Ut(t.containerInfo);
                } catch (m) {
                  _s(e, e.return, m);
                }
              break;
            case 4:
            default:
              vu(t, e), gu(e);
              break;
            case 13:
              vu(t, e),
                gu(e),
                8192 & (o = e.child).flags &&
                  ((i = null !== o.memoizedState),
                  (o.stateNode.isHidden = i),
                  !i || (null !== o.alternate && null !== o.alternate.memoizedState) || (Fu = Xe())),
                4 & r && hu(e);
              break;
            case 22:
              if (
                ((f = null !== n && null !== n.memoizedState),
                1 & e.mode ? ((Yl = (c = Yl) || f), vu(t, e), (Yl = c)) : vu(t, e),
                gu(e),
                8192 & r)
              ) {
                if (((c = null !== e.memoizedState), (e.stateNode.isHidden = c) && !f && 0 !== (1 & e.mode)))
                  for (Jl = e, f = e.child; null !== f; ) {
                    for (d = Jl = f; null !== Jl; ) {
                      switch (((h = (p = Jl).child), p.tag)) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                          nu(4, p, p.return);
                          break;
                        case 1:
                          Zl(p, p.return);
                          var v = p.stateNode;
                          if ('function' === typeof v.componentWillUnmount) {
                            (r = p), (n = p.return);
                            try {
                              (t = r),
                                (v.props = t.memoizedProps),
                                (v.state = t.memoizedState),
                                v.componentWillUnmount();
                            } catch (m) {
                              _s(r, n, m);
                            }
                          }
                          break;
                        case 5:
                          Zl(p, p.return);
                          break;
                        case 22:
                          if (null !== p.memoizedState) {
                            xu(d);
                            continue;
                          }
                      }
                      null !== h ? ((h.return = p), (Jl = h)) : xu(d);
                    }
                    f = f.sibling;
                  }
                e: for (f = null, d = e; ; ) {
                  if (5 === d.tag) {
                    if (null === f) {
                      f = d;
                      try {
                        (o = d.stateNode),
                          c
                            ? 'function' === typeof (i = o.style).setProperty
                              ? i.setProperty('display', 'none', 'important')
                              : (i.display = 'none')
                            : ((u = d.stateNode),
                              (l =
                                void 0 !== (s = d.memoizedProps.style) && null !== s && s.hasOwnProperty('display')
                                  ? s.display
                                  : null),
                              (u.style.display = ve('display', l)));
                      } catch (m) {
                        _s(e, e.return, m);
                      }
                    }
                  } else if (6 === d.tag) {
                    if (null === f)
                      try {
                        d.stateNode.nodeValue = c ? '' : d.memoizedProps;
                      } catch (m) {
                        _s(e, e.return, m);
                      }
                  } else if (
                    ((22 !== d.tag && 23 !== d.tag) || null === d.memoizedState || d === e) &&
                    null !== d.child
                  ) {
                    (d.child.return = d), (d = d.child);
                    continue;
                  }
                  if (d === e) break e;
                  for (; null === d.sibling; ) {
                    if (null === d.return || d.return === e) break e;
                    f === d && (f = null), (d = d.return);
                  }
                  f === d && (f = null), (d.sibling.return = d.return), (d = d.sibling);
                }
              }
              break;
            case 19:
              vu(t, e), gu(e), 4 & r && hu(e);
            case 21:
          }
        }
        function gu(e) {
          var t = e.flags;
          if (2 & t) {
            try {
              e: {
                for (var n = e.return; null !== n; ) {
                  if (iu(n)) {
                    var r = n;
                    break e;
                  }
                  n = n.return;
                }
                throw Error(a(160));
              }
              switch (r.tag) {
                case 5:
                  var o = r.stateNode;
                  32 & r.flags && (de(o, ''), (r.flags &= -33)), su(e, lu(e), o);
                  break;
                case 3:
                case 4:
                  var i = r.stateNode.containerInfo;
                  uu(e, lu(e), i);
                  break;
                default:
                  throw Error(a(161));
              }
            } catch (l) {
              _s(e, e.return, l);
            }
            e.flags &= -3;
          }
          4096 & t && (e.flags &= -4097);
        }
        function wu(e, t, n) {
          (Jl = e), yu(e, t, n);
        }
        function yu(e, t, n) {
          for (var r = 0 !== (1 & e.mode); null !== Jl; ) {
            var o = Jl,
              a = o.child;
            if (22 === o.tag && r) {
              var i = null !== o.memoizedState || Ql;
              if (!i) {
                var l = o.alternate,
                  u = (null !== l && null !== l.memoizedState) || Yl;
                l = Ql;
                var s = Yl;
                if (((Ql = i), (Yl = u) && !s))
                  for (Jl = o; null !== Jl; )
                    (u = (i = Jl).child),
                      22 === i.tag && null !== i.memoizedState
                        ? ku(o)
                        : null !== u
                        ? ((u.return = i), (Jl = u))
                        : ku(o);
                for (; null !== a; ) (Jl = a), yu(a, t, n), (a = a.sibling);
                (Jl = o), (Ql = l), (Yl = s);
              }
              bu(e);
            } else 0 !== (8772 & o.subtreeFlags) && null !== a ? ((a.return = o), (Jl = a)) : bu(e);
          }
        }
        function bu(e) {
          for (; null !== Jl; ) {
            var t = Jl;
            if (0 !== (8772 & t.flags)) {
              var n = t.alternate;
              try {
                if (0 !== (8772 & t.flags))
                  switch (t.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Yl || ru(5, t);
                      break;
                    case 1:
                      var r = t.stateNode;
                      if (4 & t.flags && !Yl)
                        if (null === n) r.componentDidMount();
                        else {
                          var o = t.elementType === t.type ? n.memoizedProps : ga(t.type, n.memoizedProps);
                          r.componentDidUpdate(o, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
                        }
                      var i = t.updateQueue;
                      null !== i && Va(t, i, r);
                      break;
                    case 3:
                      var l = t.updateQueue;
                      if (null !== l) {
                        if (((n = null), null !== t.child))
                          switch (t.child.tag) {
                            case 5:
                            case 1:
                              n = t.child.stateNode;
                          }
                        Va(t, l, n);
                      }
                      break;
                    case 5:
                      var u = t.stateNode;
                      if (null === n && 4 & t.flags) {
                        n = u;
                        var s = t.memoizedProps;
                        switch (t.type) {
                          case 'button':
                          case 'input':
                          case 'select':
                          case 'textarea':
                            s.autoFocus && n.focus();
                            break;
                          case 'img':
                            s.src && (n.src = s.src);
                        }
                      }
                      break;
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                      break;
                    case 13:
                      if (null === t.memoizedState) {
                        var c = t.alternate;
                        if (null !== c) {
                          var f = c.memoizedState;
                          if (null !== f) {
                            var d = f.dehydrated;
                            null !== d && Ut(d);
                          }
                        }
                      }
                      break;
                    default:
                      throw Error(a(163));
                  }
                Yl || (512 & t.flags && ou(t));
              } catch (p) {
                _s(t, t.return, p);
              }
            }
            if (t === e) {
              Jl = null;
              break;
            }
            if (null !== (n = t.sibling)) {
              (n.return = t.return), (Jl = n);
              break;
            }
            Jl = t.return;
          }
        }
        function xu(e) {
          for (; null !== Jl; ) {
            var t = Jl;
            if (t === e) {
              Jl = null;
              break;
            }
            var n = t.sibling;
            if (null !== n) {
              (n.return = t.return), (Jl = n);
              break;
            }
            Jl = t.return;
          }
        }
        function ku(e) {
          for (; null !== Jl; ) {
            var t = Jl;
            try {
              switch (t.tag) {
                case 0:
                case 11:
                case 15:
                  var n = t.return;
                  try {
                    ru(4, t);
                  } catch (u) {
                    _s(t, n, u);
                  }
                  break;
                case 1:
                  var r = t.stateNode;
                  if ('function' === typeof r.componentDidMount) {
                    var o = t.return;
                    try {
                      r.componentDidMount();
                    } catch (u) {
                      _s(t, o, u);
                    }
                  }
                  var a = t.return;
                  try {
                    ou(t);
                  } catch (u) {
                    _s(t, a, u);
                  }
                  break;
                case 5:
                  var i = t.return;
                  try {
                    ou(t);
                  } catch (u) {
                    _s(t, i, u);
                  }
              }
            } catch (u) {
              _s(t, t.return, u);
            }
            if (t === e) {
              Jl = null;
              break;
            }
            var l = t.sibling;
            if (null !== l) {
              (l.return = t.return), (Jl = l);
              break;
            }
            Jl = t.return;
          }
        }
        var Su,
          _u = Math.ceil,
          Eu = b.ReactCurrentDispatcher,
          Cu = b.ReactCurrentOwner,
          Tu = b.ReactCurrentBatchConfig,
          Nu = 0,
          ju = null,
          Lu = null,
          Au = 0,
          Ru = 0,
          Pu = Eo(0),
          Ou = 0,
          Du = null,
          Iu = 0,
          Mu = 0,
          zu = 0,
          Vu = null,
          Bu = null,
          Fu = 0,
          Uu = 1 / 0,
          Hu = null,
          qu = !1,
          Wu = null,
          $u = null,
          Gu = !1,
          Ku = null,
          Qu = 0,
          Yu = 0,
          Xu = null,
          Ju = -1,
          Zu = 0;
        function es() {
          return 0 !== (6 & Nu) ? Xe() : -1 !== Ju ? Ju : (Ju = Xe());
        }
        function ts(e) {
          return 0 === (1 & e.mode)
            ? 1
            : 0 !== (2 & Nu) && 0 !== Au
            ? Au & -Au
            : null !== ma.transition
            ? (0 === Zu && (Zu = vt()), Zu)
            : 0 !== (e = yt)
            ? e
            : (e = void 0 === (e = window.event) ? 16 : Yt(e.type));
        }
        function ns(e, t, n, r) {
          if (50 < Yu) throw ((Yu = 0), (Xu = null), Error(a(185)));
          gt(e, n, r),
            (0 !== (2 & Nu) && e === ju) ||
              (e === ju && (0 === (2 & Nu) && (Mu |= n), 4 === Ou && ls(e, Au)),
              rs(e, r),
              1 === n && 0 === Nu && 0 === (1 & t.mode) && ((Uu = Xe() + 500), Bo && Ho()));
        }
        function rs(e, t) {
          var n = e.callbackNode;
          !(function (e, t) {
            for (var n = e.suspendedLanes, r = e.pingedLanes, o = e.expirationTimes, a = e.pendingLanes; 0 < a; ) {
              var i = 31 - it(a),
                l = 1 << i,
                u = o[i];
              -1 === u ? (0 !== (l & n) && 0 === (l & r)) || (o[i] = pt(l, t)) : u <= t && (e.expiredLanes |= l),
                (a &= ~l);
            }
          })(e, t);
          var r = dt(e, e === ju ? Au : 0);
          if (0 === r) null !== n && Ke(n), (e.callbackNode = null), (e.callbackPriority = 0);
          else if (((t = r & -r), e.callbackPriority !== t)) {
            if ((null != n && Ke(n), 1 === t))
              0 === e.tag
                ? (function (e) {
                    (Bo = !0), Uo(e);
                  })(us.bind(null, e))
                : Uo(us.bind(null, e)),
                io(function () {
                  0 === (6 & Nu) && Ho();
                }),
                (n = null);
            else {
              switch (bt(r)) {
                case 1:
                  n = Ze;
                  break;
                case 4:
                  n = et;
                  break;
                case 16:
                default:
                  n = tt;
                  break;
                case 536870912:
                  n = rt;
              }
              n = js(n, os.bind(null, e));
            }
            (e.callbackPriority = t), (e.callbackNode = n);
          }
        }
        function os(e, t) {
          if (((Ju = -1), (Zu = 0), 0 !== (6 & Nu))) throw Error(a(327));
          var n = e.callbackNode;
          if (ks() && e.callbackNode !== n) return null;
          var r = dt(e, e === ju ? Au : 0);
          if (0 === r) return null;
          if (0 !== (30 & r) || 0 !== (r & e.expiredLanes) || t) t = ms(e, r);
          else {
            t = r;
            var o = Nu;
            Nu |= 2;
            var i = hs();
            for ((ju === e && Au === t) || ((Hu = null), (Uu = Xe() + 500), ds(e, t)); ; )
              try {
                ws();
                break;
              } catch (u) {
                ps(e, u);
              }
            ka(), (Eu.current = i), (Nu = o), null !== Lu ? (t = 0) : ((ju = null), (Au = 0), (t = Ou));
          }
          if (0 !== t) {
            if ((2 === t && 0 !== (o = ht(e)) && ((r = o), (t = as(e, o))), 1 === t))
              throw ((n = Du), ds(e, 0), ls(e, r), rs(e, Xe()), n);
            if (6 === t) ls(e, r);
            else {
              if (
                ((o = e.current.alternate),
                0 === (30 & r) &&
                  !(function (e) {
                    for (var t = e; ; ) {
                      if (16384 & t.flags) {
                        var n = t.updateQueue;
                        if (null !== n && null !== (n = n.stores))
                          for (var r = 0; r < n.length; r++) {
                            var o = n[r],
                              a = o.getSnapshot;
                            o = o.value;
                            try {
                              if (!lr(a(), o)) return !1;
                            } catch (l) {
                              return !1;
                            }
                          }
                      }
                      if (((n = t.child), 16384 & t.subtreeFlags && null !== n)) (n.return = t), (t = n);
                      else {
                        if (t === e) break;
                        for (; null === t.sibling; ) {
                          if (null === t.return || t.return === e) return !0;
                          t = t.return;
                        }
                        (t.sibling.return = t.return), (t = t.sibling);
                      }
                    }
                    return !0;
                  })(o) &&
                  (2 === (t = ms(e, r)) && 0 !== (i = ht(e)) && ((r = i), (t = as(e, i))), 1 === t))
              )
                throw ((n = Du), ds(e, 0), ls(e, r), rs(e, Xe()), n);
              switch (((e.finishedWork = o), (e.finishedLanes = r), t)) {
                case 0:
                case 1:
                  throw Error(a(345));
                case 2:
                case 5:
                  xs(e, Bu, Hu);
                  break;
                case 3:
                  if ((ls(e, r), (130023424 & r) === r && 10 < (t = Fu + 500 - Xe()))) {
                    if (0 !== dt(e, 0)) break;
                    if (((o = e.suspendedLanes) & r) !== r) {
                      es(), (e.pingedLanes |= e.suspendedLanes & o);
                      break;
                    }
                    e.timeoutHandle = ro(xs.bind(null, e, Bu, Hu), t);
                    break;
                  }
                  xs(e, Bu, Hu);
                  break;
                case 4:
                  if ((ls(e, r), (4194240 & r) === r)) break;
                  for (t = e.eventTimes, o = -1; 0 < r; ) {
                    var l = 31 - it(r);
                    (i = 1 << l), (l = t[l]) > o && (o = l), (r &= ~i);
                  }
                  if (
                    ((r = o),
                    10 <
                      (r =
                        (120 > (r = Xe() - r)
                          ? 120
                          : 480 > r
                          ? 480
                          : 1080 > r
                          ? 1080
                          : 1920 > r
                          ? 1920
                          : 3e3 > r
                          ? 3e3
                          : 4320 > r
                          ? 4320
                          : 1960 * _u(r / 1960)) - r))
                  ) {
                    e.timeoutHandle = ro(xs.bind(null, e, Bu, Hu), r);
                    break;
                  }
                  xs(e, Bu, Hu);
                  break;
                default:
                  throw Error(a(329));
              }
            }
          }
          return rs(e, Xe()), e.callbackNode === n ? os.bind(null, e) : null;
        }
        function as(e, t) {
          var n = Vu;
          return (
            e.current.memoizedState.isDehydrated && (ds(e, t).flags |= 256),
            2 !== (e = ms(e, t)) && ((t = Bu), (Bu = n), null !== t && is(t)),
            e
          );
        }
        function is(e) {
          null === Bu ? (Bu = e) : Bu.push.apply(Bu, e);
        }
        function ls(e, t) {
          for (t &= ~zu, t &= ~Mu, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
            var n = 31 - it(t),
              r = 1 << n;
            (e[n] = -1), (t &= ~r);
          }
        }
        function us(e) {
          if (0 !== (6 & Nu)) throw Error(a(327));
          ks();
          var t = dt(e, 0);
          if (0 === (1 & t)) return rs(e, Xe()), null;
          var n = ms(e, t);
          if (0 !== e.tag && 2 === n) {
            var r = ht(e);
            0 !== r && ((t = r), (n = as(e, r)));
          }
          if (1 === n) throw ((n = Du), ds(e, 0), ls(e, t), rs(e, Xe()), n);
          if (6 === n) throw Error(a(345));
          return (e.finishedWork = e.current.alternate), (e.finishedLanes = t), xs(e, Bu, Hu), rs(e, Xe()), null;
        }
        function ss(e, t) {
          var n = Nu;
          Nu |= 1;
          try {
            return e(t);
          } finally {
            0 === (Nu = n) && ((Uu = Xe() + 500), Bo && Ho());
          }
        }
        function cs(e) {
          null !== Ku && 0 === Ku.tag && 0 === (6 & Nu) && ks();
          var t = Nu;
          Nu |= 1;
          var n = Tu.transition,
            r = yt;
          try {
            if (((Tu.transition = null), (yt = 1), e)) return e();
          } finally {
            (yt = r), (Tu.transition = n), 0 === (6 & (Nu = t)) && Ho();
          }
        }
        function fs() {
          (Ru = Pu.current), Co(Pu);
        }
        function ds(e, t) {
          (e.finishedWork = null), (e.finishedLanes = 0);
          var n = e.timeoutHandle;
          if ((-1 !== n && ((e.timeoutHandle = -1), oo(n)), null !== Lu))
            for (n = Lu.return; null !== n; ) {
              var r = n;
              switch ((na(r), r.tag)) {
                case 1:
                  null !== (r = r.type.childContextTypes) && void 0 !== r && Oo();
                  break;
                case 3:
                  ai(), Co(Lo), Co(jo), fi();
                  break;
                case 5:
                  li(r);
                  break;
                case 4:
                  ai();
                  break;
                case 13:
                case 19:
                  Co(ui);
                  break;
                case 10:
                  Sa(r.type._context);
                  break;
                case 22:
                case 23:
                  fs();
              }
              n = n.return;
            }
          if (
            ((ju = e),
            (Lu = e = Ps(e.current, null)),
            (Au = Ru = t),
            (Ou = 0),
            (Du = null),
            (zu = Mu = Iu = 0),
            (Bu = Vu = null),
            null !== Ta)
          ) {
            for (t = 0; t < Ta.length; t++)
              if (null !== (r = (n = Ta[t]).interleaved)) {
                n.interleaved = null;
                var o = r.next,
                  a = n.pending;
                if (null !== a) {
                  var i = a.next;
                  (a.next = o), (r.next = i);
                }
                n.pending = r;
              }
            Ta = null;
          }
          return e;
        }
        function ps(e, t) {
          for (;;) {
            var n = Lu;
            try {
              if ((ka(), (di.current = il), wi)) {
                for (var r = vi.memoizedState; null !== r; ) {
                  var o = r.queue;
                  null !== o && (o.pending = null), (r = r.next);
                }
                wi = !1;
              }
              if (
                ((hi = 0),
                (gi = mi = vi = null),
                (yi = !1),
                (bi = 0),
                (Cu.current = null),
                null === n || null === n.return)
              ) {
                (Ou = 1), (Du = t), (Lu = null);
                break;
              }
              e: {
                var i = e,
                  l = n.return,
                  u = n,
                  s = t;
                if (
                  ((t = Au), (u.flags |= 32768), null !== s && 'object' === typeof s && 'function' === typeof s.then)
                ) {
                  var c = s,
                    f = u,
                    d = f.tag;
                  if (0 === (1 & f.mode) && (0 === d || 11 === d || 15 === d)) {
                    var p = f.alternate;
                    p
                      ? ((f.updateQueue = p.updateQueue), (f.memoizedState = p.memoizedState), (f.lanes = p.lanes))
                      : ((f.updateQueue = null), (f.memoizedState = null));
                  }
                  var h = gl(l);
                  if (null !== h) {
                    (h.flags &= -257), wl(h, l, u, 0, t), 1 & h.mode && ml(i, c, t), (s = c);
                    var v = (t = h).updateQueue;
                    if (null === v) {
                      var m = new Set();
                      m.add(s), (t.updateQueue = m);
                    } else v.add(s);
                    break e;
                  }
                  if (0 === (1 & t)) {
                    ml(i, c, t), vs();
                    break e;
                  }
                  s = Error(a(426));
                } else if (aa && 1 & u.mode) {
                  var g = gl(l);
                  if (null !== g) {
                    0 === (65536 & g.flags) && (g.flags |= 256), wl(g, l, u, 0, t), va(cl(s, u));
                    break e;
                  }
                }
                (i = s = cl(s, u)), 4 !== Ou && (Ou = 2), null === Vu ? (Vu = [i]) : Vu.push(i), (i = l);
                do {
                  switch (i.tag) {
                    case 3:
                      (i.flags |= 65536), (t &= -t), (i.lanes |= t), Ma(i, hl(0, s, t));
                      break e;
                    case 1:
                      u = s;
                      var w = i.type,
                        y = i.stateNode;
                      if (
                        0 === (128 & i.flags) &&
                        ('function' === typeof w.getDerivedStateFromError ||
                          (null !== y && 'function' === typeof y.componentDidCatch && (null === $u || !$u.has(y))))
                      ) {
                        (i.flags |= 65536), (t &= -t), (i.lanes |= t), Ma(i, vl(i, u, t));
                        break e;
                      }
                  }
                  i = i.return;
                } while (null !== i);
              }
              bs(n);
            } catch (b) {
              (t = b), Lu === n && null !== n && (Lu = n = n.return);
              continue;
            }
            break;
          }
        }
        function hs() {
          var e = Eu.current;
          return (Eu.current = il), null === e ? il : e;
        }
        function vs() {
          (0 !== Ou && 3 !== Ou && 2 !== Ou) || (Ou = 4),
            null === ju || (0 === (268435455 & Iu) && 0 === (268435455 & Mu)) || ls(ju, Au);
        }
        function ms(e, t) {
          var n = Nu;
          Nu |= 2;
          var r = hs();
          for ((ju === e && Au === t) || ((Hu = null), ds(e, t)); ; )
            try {
              gs();
              break;
            } catch (o) {
              ps(e, o);
            }
          if ((ka(), (Nu = n), (Eu.current = r), null !== Lu)) throw Error(a(261));
          return (ju = null), (Au = 0), Ou;
        }
        function gs() {
          for (; null !== Lu; ) ys(Lu);
        }
        function ws() {
          for (; null !== Lu && !Qe(); ) ys(Lu);
        }
        function ys(e) {
          var t = Su(e.alternate, e, Ru);
          (e.memoizedProps = e.pendingProps), null === t ? bs(e) : (Lu = t), (Cu.current = null);
        }
        function bs(e) {
          var t = e;
          do {
            var n = t.alternate;
            if (((e = t.return), 0 === (32768 & t.flags))) {
              if (null !== (n = Gl(n, t, Ru))) return void (Lu = n);
            } else {
              if (null !== (n = Kl(n, t))) return (n.flags &= 32767), void (Lu = n);
              if (null === e) return (Ou = 6), void (Lu = null);
              (e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null);
            }
            if (null !== (t = t.sibling)) return void (Lu = t);
            Lu = t = e;
          } while (null !== t);
          0 === Ou && (Ou = 5);
        }
        function xs(e, t, n) {
          var r = yt,
            o = Tu.transition;
          try {
            (Tu.transition = null),
              (yt = 1),
              (function (e, t, n, r) {
                do {
                  ks();
                } while (null !== Ku);
                if (0 !== (6 & Nu)) throw Error(a(327));
                n = e.finishedWork;
                var o = e.finishedLanes;
                if (null === n) return null;
                if (((e.finishedWork = null), (e.finishedLanes = 0), n === e.current)) throw Error(a(177));
                (e.callbackNode = null), (e.callbackPriority = 0);
                var i = n.lanes | n.childLanes;
                if (
                  ((function (e, t) {
                    var n = e.pendingLanes & ~t;
                    (e.pendingLanes = t),
                      (e.suspendedLanes = 0),
                      (e.pingedLanes = 0),
                      (e.expiredLanes &= t),
                      (e.mutableReadLanes &= t),
                      (e.entangledLanes &= t),
                      (t = e.entanglements);
                    var r = e.eventTimes;
                    for (e = e.expirationTimes; 0 < n; ) {
                      var o = 31 - it(n),
                        a = 1 << o;
                      (t[o] = 0), (r[o] = -1), (e[o] = -1), (n &= ~a);
                    }
                  })(e, i),
                  e === ju && ((Lu = ju = null), (Au = 0)),
                  (0 === (2064 & n.subtreeFlags) && 0 === (2064 & n.flags)) ||
                    Gu ||
                    ((Gu = !0),
                    js(tt, function () {
                      return ks(), null;
                    })),
                  (i = 0 !== (15990 & n.flags)),
                  0 !== (15990 & n.subtreeFlags) || i)
                ) {
                  (i = Tu.transition), (Tu.transition = null);
                  var l = yt;
                  yt = 1;
                  var u = Nu;
                  (Nu |= 4),
                    (Cu.current = null),
                    (function (e, t) {
                      if (((eo = qt), pr((e = dr())))) {
                        if ('selectionStart' in e) var n = { start: e.selectionStart, end: e.selectionEnd };
                        else
                          e: {
                            var r =
                              (n = ((n = e.ownerDocument) && n.defaultView) || window).getSelection && n.getSelection();
                            if (r && 0 !== r.rangeCount) {
                              n = r.anchorNode;
                              var o = r.anchorOffset,
                                i = r.focusNode;
                              r = r.focusOffset;
                              try {
                                n.nodeType, i.nodeType;
                              } catch (x) {
                                n = null;
                                break e;
                              }
                              var l = 0,
                                u = -1,
                                s = -1,
                                c = 0,
                                f = 0,
                                d = e,
                                p = null;
                              t: for (;;) {
                                for (
                                  var h;
                                  d !== n || (0 !== o && 3 !== d.nodeType) || (u = l + o),
                                    d !== i || (0 !== r && 3 !== d.nodeType) || (s = l + r),
                                    3 === d.nodeType && (l += d.nodeValue.length),
                                    null !== (h = d.firstChild);

                                )
                                  (p = d), (d = h);
                                for (;;) {
                                  if (d === e) break t;
                                  if (
                                    (p === n && ++c === o && (u = l),
                                    p === i && ++f === r && (s = l),
                                    null !== (h = d.nextSibling))
                                  )
                                    break;
                                  p = (d = p).parentNode;
                                }
                                d = h;
                              }
                              n = -1 === u || -1 === s ? null : { start: u, end: s };
                            } else n = null;
                          }
                        n = n || { start: 0, end: 0 };
                      } else n = null;
                      for (to = { focusedElem: e, selectionRange: n }, qt = !1, Jl = t; null !== Jl; )
                        if (((e = (t = Jl).child), 0 !== (1028 & t.subtreeFlags) && null !== e))
                          (e.return = t), (Jl = e);
                        else
                          for (; null !== Jl; ) {
                            t = Jl;
                            try {
                              var v = t.alternate;
                              if (0 !== (1024 & t.flags))
                                switch (t.tag) {
                                  case 0:
                                  case 11:
                                  case 15:
                                  case 5:
                                  case 6:
                                  case 4:
                                  case 17:
                                    break;
                                  case 1:
                                    if (null !== v) {
                                      var m = v.memoizedProps,
                                        g = v.memoizedState,
                                        w = t.stateNode,
                                        y = w.getSnapshotBeforeUpdate(t.elementType === t.type ? m : ga(t.type, m), g);
                                      w.__reactInternalSnapshotBeforeUpdate = y;
                                    }
                                    break;
                                  case 3:
                                    var b = t.stateNode.containerInfo;
                                    1 === b.nodeType
                                      ? (b.textContent = '')
                                      : 9 === b.nodeType && b.documentElement && b.removeChild(b.documentElement);
                                    break;
                                  default:
                                    throw Error(a(163));
                                }
                            } catch (x) {
                              _s(t, t.return, x);
                            }
                            if (null !== (e = t.sibling)) {
                              (e.return = t.return), (Jl = e);
                              break;
                            }
                            Jl = t.return;
                          }
                      (v = tu), (tu = !1);
                    })(e, n),
                    mu(n, e),
                    hr(to),
                    (qt = !!eo),
                    (to = eo = null),
                    (e.current = n),
                    wu(n, e, o),
                    Ye(),
                    (Nu = u),
                    (yt = l),
                    (Tu.transition = i);
                } else e.current = n;
                if (
                  (Gu && ((Gu = !1), (Ku = e), (Qu = o)),
                  (i = e.pendingLanes),
                  0 === i && ($u = null),
                  (function (e) {
                    if (at && 'function' === typeof at.onCommitFiberRoot)
                      try {
                        at.onCommitFiberRoot(ot, e, void 0, 128 === (128 & e.current.flags));
                      } catch (t) {}
                  })(n.stateNode),
                  rs(e, Xe()),
                  null !== t)
                )
                  for (r = e.onRecoverableError, n = 0; n < t.length; n++)
                    r((o = t[n]).value, { componentStack: o.stack, digest: o.digest });
                if (qu) throw ((qu = !1), (e = Wu), (Wu = null), e);
                0 !== (1 & Qu) && 0 !== e.tag && ks(),
                  (i = e.pendingLanes),
                  0 !== (1 & i) ? (e === Xu ? Yu++ : ((Yu = 0), (Xu = e))) : (Yu = 0),
                  Ho();
              })(e, t, n, r);
          } finally {
            (Tu.transition = o), (yt = r);
          }
          return null;
        }
        function ks() {
          if (null !== Ku) {
            var e = bt(Qu),
              t = Tu.transition,
              n = yt;
            try {
              if (((Tu.transition = null), (yt = 16 > e ? 16 : e), null === Ku)) var r = !1;
              else {
                if (((e = Ku), (Ku = null), (Qu = 0), 0 !== (6 & Nu))) throw Error(a(331));
                var o = Nu;
                for (Nu |= 4, Jl = e.current; null !== Jl; ) {
                  var i = Jl,
                    l = i.child;
                  if (0 !== (16 & Jl.flags)) {
                    var u = i.deletions;
                    if (null !== u) {
                      for (var s = 0; s < u.length; s++) {
                        var c = u[s];
                        for (Jl = c; null !== Jl; ) {
                          var f = Jl;
                          switch (f.tag) {
                            case 0:
                            case 11:
                            case 15:
                              nu(8, f, i);
                          }
                          var d = f.child;
                          if (null !== d) (d.return = f), (Jl = d);
                          else
                            for (; null !== Jl; ) {
                              var p = (f = Jl).sibling,
                                h = f.return;
                              if ((au(f), f === c)) {
                                Jl = null;
                                break;
                              }
                              if (null !== p) {
                                (p.return = h), (Jl = p);
                                break;
                              }
                              Jl = h;
                            }
                        }
                      }
                      var v = i.alternate;
                      if (null !== v) {
                        var m = v.child;
                        if (null !== m) {
                          v.child = null;
                          do {
                            var g = m.sibling;
                            (m.sibling = null), (m = g);
                          } while (null !== m);
                        }
                      }
                      Jl = i;
                    }
                  }
                  if (0 !== (2064 & i.subtreeFlags) && null !== l) (l.return = i), (Jl = l);
                  else
                    e: for (; null !== Jl; ) {
                      if (0 !== (2048 & (i = Jl).flags))
                        switch (i.tag) {
                          case 0:
                          case 11:
                          case 15:
                            nu(9, i, i.return);
                        }
                      var w = i.sibling;
                      if (null !== w) {
                        (w.return = i.return), (Jl = w);
                        break e;
                      }
                      Jl = i.return;
                    }
                }
                var y = e.current;
                for (Jl = y; null !== Jl; ) {
                  var b = (l = Jl).child;
                  if (0 !== (2064 & l.subtreeFlags) && null !== b) (b.return = l), (Jl = b);
                  else
                    e: for (l = y; null !== Jl; ) {
                      if (0 !== (2048 & (u = Jl).flags))
                        try {
                          switch (u.tag) {
                            case 0:
                            case 11:
                            case 15:
                              ru(9, u);
                          }
                        } catch (k) {
                          _s(u, u.return, k);
                        }
                      if (u === l) {
                        Jl = null;
                        break e;
                      }
                      var x = u.sibling;
                      if (null !== x) {
                        (x.return = u.return), (Jl = x);
                        break e;
                      }
                      Jl = u.return;
                    }
                }
                if (((Nu = o), Ho(), at && 'function' === typeof at.onPostCommitFiberRoot))
                  try {
                    at.onPostCommitFiberRoot(ot, e);
                  } catch (k) {}
                r = !0;
              }
              return r;
            } finally {
              (yt = n), (Tu.transition = t);
            }
          }
          return !1;
        }
        function Ss(e, t, n) {
          (e = Da(e, (t = hl(0, (t = cl(n, t)), 1)), 1)), (t = es()), null !== e && (gt(e, 1, t), rs(e, t));
        }
        function _s(e, t, n) {
          if (3 === e.tag) Ss(e, e, n);
          else
            for (; null !== t; ) {
              if (3 === t.tag) {
                Ss(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  'function' === typeof t.type.getDerivedStateFromError ||
                  ('function' === typeof r.componentDidCatch && (null === $u || !$u.has(r)))
                ) {
                  (t = Da(t, (e = vl(t, (e = cl(n, e)), 1)), 1)), (e = es()), null !== t && (gt(t, 1, e), rs(t, e));
                  break;
                }
              }
              t = t.return;
            }
        }
        function Es(e, t, n) {
          var r = e.pingCache;
          null !== r && r.delete(t),
            (t = es()),
            (e.pingedLanes |= e.suspendedLanes & n),
            ju === e &&
              (Au & n) === n &&
              (4 === Ou || (3 === Ou && (130023424 & Au) === Au && 500 > Xe() - Fu) ? ds(e, 0) : (zu |= n)),
            rs(e, t);
        }
        function Cs(e, t) {
          0 === t && (0 === (1 & e.mode) ? (t = 1) : ((t = ct), 0 === (130023424 & (ct <<= 1)) && (ct = 4194304)));
          var n = es();
          null !== (e = La(e, t)) && (gt(e, t, n), rs(e, n));
        }
        function Ts(e) {
          var t = e.memoizedState,
            n = 0;
          null !== t && (n = t.retryLane), Cs(e, n);
        }
        function Ns(e, t) {
          var n = 0;
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                o = e.memoizedState;
              null !== o && (n = o.retryLane);
              break;
            case 19:
              r = e.stateNode;
              break;
            default:
              throw Error(a(314));
          }
          null !== r && r.delete(t), Cs(e, n);
        }
        function js(e, t) {
          return Ge(e, t);
        }
        function Ls(e, t, n, r) {
          (this.tag = e),
            (this.key = n),
            (this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null),
            (this.index = 0),
            (this.ref = null),
            (this.pendingProps = t),
            (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
            (this.mode = r),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null);
        }
        function As(e, t, n, r) {
          return new Ls(e, t, n, r);
        }
        function Rs(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Ps(e, t) {
          var n = e.alternate;
          return (
            null === n
              ? (((n = As(e.tag, t, e.key, e.mode)).elementType = e.elementType),
                (n.type = e.type),
                (n.stateNode = e.stateNode),
                (n.alternate = e),
                (e.alternate = n))
              : ((n.pendingProps = t), (n.type = e.type), (n.flags = 0), (n.subtreeFlags = 0), (n.deletions = null)),
            (n.flags = 14680064 & e.flags),
            (n.childLanes = e.childLanes),
            (n.lanes = e.lanes),
            (n.child = e.child),
            (n.memoizedProps = e.memoizedProps),
            (n.memoizedState = e.memoizedState),
            (n.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (n.dependencies = null === t ? null : { lanes: t.lanes, firstContext: t.firstContext }),
            (n.sibling = e.sibling),
            (n.index = e.index),
            (n.ref = e.ref),
            n
          );
        }
        function Os(e, t, n, r, o, i) {
          var l = 2;
          if (((r = e), 'function' === typeof e)) Rs(e) && (l = 1);
          else if ('string' === typeof e) l = 5;
          else
            e: switch (e) {
              case S:
                return Ds(n.children, o, i, t);
              case _:
                (l = 8), (o |= 8);
                break;
              case E:
                return ((e = As(12, n, t, 2 | o)).elementType = E), (e.lanes = i), e;
              case j:
                return ((e = As(13, n, t, o)).elementType = j), (e.lanes = i), e;
              case L:
                return ((e = As(19, n, t, o)).elementType = L), (e.lanes = i), e;
              case P:
                return Is(n, o, i, t);
              default:
                if ('object' === typeof e && null !== e)
                  switch (e.$$typeof) {
                    case C:
                      l = 10;
                      break e;
                    case T:
                      l = 9;
                      break e;
                    case N:
                      l = 11;
                      break e;
                    case A:
                      l = 14;
                      break e;
                    case R:
                      (l = 16), (r = null);
                      break e;
                  }
                throw Error(a(130, null == e ? e : typeof e, ''));
            }
          return ((t = As(l, n, t, o)).elementType = e), (t.type = r), (t.lanes = i), t;
        }
        function Ds(e, t, n, r) {
          return ((e = As(7, e, r, t)).lanes = n), e;
        }
        function Is(e, t, n, r) {
          return ((e = As(22, e, r, t)).elementType = P), (e.lanes = n), (e.stateNode = { isHidden: !1 }), e;
        }
        function Ms(e, t, n) {
          return ((e = As(6, e, null, t)).lanes = n), e;
        }
        function zs(e, t, n) {
          return (
            ((t = As(4, null !== e.children ? e.children : [], e.key, t)).lanes = n),
            (t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }),
            t
          );
        }
        function Vs(e, t, n, r, o) {
          (this.tag = t),
            (this.containerInfo = e),
            (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
            (this.timeoutHandle = -1),
            (this.callbackNode = this.pendingContext = this.context = null),
            (this.callbackPriority = 0),
            (this.eventTimes = mt(0)),
            (this.expirationTimes = mt(-1)),
            (this.entangledLanes =
              this.finishedLanes =
              this.mutableReadLanes =
              this.expiredLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = mt(0)),
            (this.identifierPrefix = r),
            (this.onRecoverableError = o),
            (this.mutableSourceEagerHydrationData = null);
        }
        function Bs(e, t, n, r, o, a, i, l, u) {
          return (
            (e = new Vs(e, t, n, l, u)),
            1 === t ? ((t = 1), !0 === a && (t |= 8)) : (t = 0),
            (a = As(3, null, null, t)),
            (e.current = a),
            (a.stateNode = e),
            (a.memoizedState = {
              element: r,
              isDehydrated: n,
              cache: null,
              transitions: null,
              pendingSuspenseBoundaries: null,
            }),
            Ra(a),
            e
          );
        }
        function Fs(e, t, n) {
          var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
          return { $$typeof: k, key: null == r ? null : '' + r, children: e, containerInfo: t, implementation: n };
        }
        function Us(e) {
          if (!e) return No;
          e: {
            if (Ue((e = e._reactInternals)) !== e || 1 !== e.tag) throw Error(a(170));
            var t = e;
            do {
              switch (t.tag) {
                case 3:
                  t = t.stateNode.context;
                  break e;
                case 1:
                  if (Po(t.type)) {
                    t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                    break e;
                  }
              }
              t = t.return;
            } while (null !== t);
            throw Error(a(171));
          }
          if (1 === e.tag) {
            var n = e.type;
            if (Po(n)) return Io(e, n, t);
          }
          return t;
        }
        function Hs(e, t, n, r, o, a, i, l, u) {
          return (
            ((e = Bs(n, r, !0, e, 0, a, 0, l, u)).context = Us(null)),
            (n = e.current),
            ((a = Oa((r = es()), (o = ts(n)))).callback = void 0 !== t && null !== t ? t : null),
            Da(n, a, o),
            (e.current.lanes = o),
            gt(e, o, r),
            rs(e, r),
            e
          );
        }
        function qs(e, t, n, r) {
          var o = t.current,
            a = es(),
            i = ts(o);
          return (
            (n = Us(n)),
            null === t.context ? (t.context = n) : (t.pendingContext = n),
            ((t = Oa(a, i)).payload = { element: e }),
            null !== (r = void 0 === r ? null : r) && (t.callback = r),
            null !== (e = Da(o, t, i)) && (ns(e, o, i, a), Ia(e, o, i)),
            i
          );
        }
        function Ws(e) {
          return (e = e.current).child ? (e.child.tag, e.child.stateNode) : null;
        }
        function $s(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function Gs(e, t) {
          $s(e, t), (e = e.alternate) && $s(e, t);
        }
        Su = function (e, t, n) {
          if (null !== e)
            if (e.memoizedProps !== t.pendingProps || Lo.current) bl = !0;
            else {
              if (0 === (e.lanes & n) && 0 === (128 & t.flags))
                return (
                  (bl = !1),
                  (function (e, t, n) {
                    switch (t.tag) {
                      case 3:
                        Ll(t), ha();
                        break;
                      case 5:
                        ii(t);
                        break;
                      case 1:
                        Po(t.type) && Mo(t);
                        break;
                      case 4:
                        oi(t, t.stateNode.containerInfo);
                        break;
                      case 10:
                        var r = t.type._context,
                          o = t.memoizedProps.value;
                        To(wa, r._currentValue), (r._currentValue = o);
                        break;
                      case 13:
                        if (null !== (r = t.memoizedState))
                          return null !== r.dehydrated
                            ? (To(ui, 1 & ui.current), (t.flags |= 128), null)
                            : 0 !== (n & t.child.childLanes)
                            ? Ml(e, t, n)
                            : (To(ui, 1 & ui.current), null !== (e = ql(e, t, n)) ? e.sibling : null);
                        To(ui, 1 & ui.current);
                        break;
                      case 19:
                        if (((r = 0 !== (n & t.childLanes)), 0 !== (128 & e.flags))) {
                          if (r) return Ul(e, t, n);
                          t.flags |= 128;
                        }
                        if (
                          (null !== (o = t.memoizedState) &&
                            ((o.rendering = null), (o.tail = null), (o.lastEffect = null)),
                          To(ui, ui.current),
                          r)
                        )
                          break;
                        return null;
                      case 22:
                      case 23:
                        return (t.lanes = 0), El(e, t, n);
                    }
                    return ql(e, t, n);
                  })(e, t, n)
                );
              bl = 0 !== (131072 & e.flags);
            }
          else (bl = !1), aa && 0 !== (1048576 & t.flags) && ea(t, Go, t.index);
          switch (((t.lanes = 0), t.tag)) {
            case 2:
              var r = t.type;
              Hl(e, t), (e = t.pendingProps);
              var o = Ro(t, jo.current);
              Ea(t, n), (o = _i(null, t, r, e, o, n));
              var i = Ei();
              return (
                (t.flags |= 1),
                'object' === typeof o && null !== o && 'function' === typeof o.render && void 0 === o.$$typeof
                  ? ((t.tag = 1),
                    (t.memoizedState = null),
                    (t.updateQueue = null),
                    Po(r) ? ((i = !0), Mo(t)) : (i = !1),
                    (t.memoizedState = null !== o.state && void 0 !== o.state ? o.state : null),
                    Ra(t),
                    (o.updater = Ua),
                    (t.stateNode = o),
                    (o._reactInternals = t),
                    $a(t, r, e, n),
                    (t = jl(null, t, r, !0, i, n)))
                  : ((t.tag = 0), aa && i && ta(t), xl(null, t, o, n), (t = t.child)),
                t
              );
            case 16:
              r = t.elementType;
              e: {
                switch (
                  (Hl(e, t),
                  (e = t.pendingProps),
                  (r = (o = r._init)(r._payload)),
                  (t.type = r),
                  (o = t.tag =
                    (function (e) {
                      if ('function' === typeof e) return Rs(e) ? 1 : 0;
                      if (void 0 !== e && null !== e) {
                        if ((e = e.$$typeof) === N) return 11;
                        if (e === A) return 14;
                      }
                      return 2;
                    })(r)),
                  (e = ga(r, e)),
                  o)
                ) {
                  case 0:
                    t = Tl(null, t, r, e, n);
                    break e;
                  case 1:
                    t = Nl(null, t, r, e, n);
                    break e;
                  case 11:
                    t = kl(null, t, r, e, n);
                    break e;
                  case 14:
                    t = Sl(null, t, r, ga(r.type, e), n);
                    break e;
                }
                throw Error(a(306, r, ''));
              }
              return t;
            case 0:
              return (r = t.type), (o = t.pendingProps), Tl(e, t, r, (o = t.elementType === r ? o : ga(r, o)), n);
            case 1:
              return (r = t.type), (o = t.pendingProps), Nl(e, t, r, (o = t.elementType === r ? o : ga(r, o)), n);
            case 3:
              e: {
                if ((Ll(t), null === e)) throw Error(a(387));
                (r = t.pendingProps), (o = (i = t.memoizedState).element), Pa(e, t), za(t, r, null, n);
                var l = t.memoizedState;
                if (((r = l.element), i.isDehydrated)) {
                  if (
                    ((i = {
                      element: r,
                      isDehydrated: !1,
                      cache: l.cache,
                      pendingSuspenseBoundaries: l.pendingSuspenseBoundaries,
                      transitions: l.transitions,
                    }),
                    (t.updateQueue.baseState = i),
                    (t.memoizedState = i),
                    256 & t.flags)
                  ) {
                    t = Al(e, t, r, n, (o = cl(Error(a(423)), t)));
                    break e;
                  }
                  if (r !== o) {
                    t = Al(e, t, r, n, (o = cl(Error(a(424)), t)));
                    break e;
                  }
                  for (
                    oa = so(t.stateNode.containerInfo.firstChild),
                      ra = t,
                      aa = !0,
                      ia = null,
                      n = Ja(t, null, r, n),
                      t.child = n;
                    n;

                  )
                    (n.flags = (-3 & n.flags) | 4096), (n = n.sibling);
                } else {
                  if ((ha(), r === o)) {
                    t = ql(e, t, n);
                    break e;
                  }
                  xl(e, t, r, n);
                }
                t = t.child;
              }
              return t;
            case 5:
              return (
                ii(t),
                null === e && ca(t),
                (r = t.type),
                (o = t.pendingProps),
                (i = null !== e ? e.memoizedProps : null),
                (l = o.children),
                no(r, o) ? (l = null) : null !== i && no(r, i) && (t.flags |= 32),
                Cl(e, t),
                xl(e, t, l, n),
                t.child
              );
            case 6:
              return null === e && ca(t), null;
            case 13:
              return Ml(e, t, n);
            case 4:
              return (
                oi(t, t.stateNode.containerInfo),
                (r = t.pendingProps),
                null === e ? (t.child = Xa(t, null, r, n)) : xl(e, t, r, n),
                t.child
              );
            case 11:
              return (r = t.type), (o = t.pendingProps), kl(e, t, r, (o = t.elementType === r ? o : ga(r, o)), n);
            case 7:
              return xl(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return xl(e, t, t.pendingProps.children, n), t.child;
            case 10:
              e: {
                if (
                  ((r = t.type._context),
                  (o = t.pendingProps),
                  (i = t.memoizedProps),
                  (l = o.value),
                  To(wa, r._currentValue),
                  (r._currentValue = l),
                  null !== i)
                )
                  if (lr(i.value, l)) {
                    if (i.children === o.children && !Lo.current) {
                      t = ql(e, t, n);
                      break e;
                    }
                  } else
                    for (null !== (i = t.child) && (i.return = t); null !== i; ) {
                      var u = i.dependencies;
                      if (null !== u) {
                        l = i.child;
                        for (var s = u.firstContext; null !== s; ) {
                          if (s.context === r) {
                            if (1 === i.tag) {
                              (s = Oa(-1, n & -n)).tag = 2;
                              var c = i.updateQueue;
                              if (null !== c) {
                                var f = (c = c.shared).pending;
                                null === f ? (s.next = s) : ((s.next = f.next), (f.next = s)), (c.pending = s);
                              }
                            }
                            (i.lanes |= n),
                              null !== (s = i.alternate) && (s.lanes |= n),
                              _a(i.return, n, t),
                              (u.lanes |= n);
                            break;
                          }
                          s = s.next;
                        }
                      } else if (10 === i.tag) l = i.type === t.type ? null : i.child;
                      else if (18 === i.tag) {
                        if (null === (l = i.return)) throw Error(a(341));
                        (l.lanes |= n), null !== (u = l.alternate) && (u.lanes |= n), _a(l, n, t), (l = i.sibling);
                      } else l = i.child;
                      if (null !== l) l.return = i;
                      else
                        for (l = i; null !== l; ) {
                          if (l === t) {
                            l = null;
                            break;
                          }
                          if (null !== (i = l.sibling)) {
                            (i.return = l.return), (l = i);
                            break;
                          }
                          l = l.return;
                        }
                      i = l;
                    }
                xl(e, t, o.children, n), (t = t.child);
              }
              return t;
            case 9:
              return (
                (o = t.type),
                (r = t.pendingProps.children),
                Ea(t, n),
                (r = r((o = Ca(o)))),
                (t.flags |= 1),
                xl(e, t, r, n),
                t.child
              );
            case 14:
              return (o = ga((r = t.type), t.pendingProps)), Sl(e, t, r, (o = ga(r.type, o)), n);
            case 15:
              return _l(e, t, t.type, t.pendingProps, n);
            case 17:
              return (
                (r = t.type),
                (o = t.pendingProps),
                (o = t.elementType === r ? o : ga(r, o)),
                Hl(e, t),
                (t.tag = 1),
                Po(r) ? ((e = !0), Mo(t)) : (e = !1),
                Ea(t, n),
                qa(t, r, o),
                $a(t, r, o, n),
                jl(null, t, r, !0, e, n)
              );
            case 19:
              return Ul(e, t, n);
            case 22:
              return El(e, t, n);
          }
          throw Error(a(156, t.tag));
        };
        var Ks =
          'function' === typeof reportError
            ? reportError
            : function (e) {
                console.error(e);
              };
        function Qs(e) {
          this._internalRoot = e;
        }
        function Ys(e) {
          this._internalRoot = e;
        }
        function Xs(e) {
          return !(!e || (1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType));
        }
        function Js(e) {
          return !(
            !e ||
            (1 !== e.nodeType &&
              9 !== e.nodeType &&
              11 !== e.nodeType &&
              (8 !== e.nodeType || ' react-mount-point-unstable ' !== e.nodeValue))
          );
        }
        function Zs() {}
        function ec(e, t, n, r, o) {
          var a = n._reactRootContainer;
          if (a) {
            var i = a;
            if ('function' === typeof o) {
              var l = o;
              o = function () {
                var e = Ws(i);
                l.call(e);
              };
            }
            qs(t, i, e, o);
          } else
            i = (function (e, t, n, r, o) {
              if (o) {
                if ('function' === typeof r) {
                  var a = r;
                  r = function () {
                    var e = Ws(i);
                    a.call(e);
                  };
                }
                var i = Hs(t, r, e, 0, null, !1, 0, '', Zs);
                return (
                  (e._reactRootContainer = i), (e[vo] = i.current), Ur(8 === e.nodeType ? e.parentNode : e), cs(), i
                );
              }
              for (; (o = e.lastChild); ) e.removeChild(o);
              if ('function' === typeof r) {
                var l = r;
                r = function () {
                  var e = Ws(u);
                  l.call(e);
                };
              }
              var u = Bs(e, 0, !1, null, 0, !1, 0, '', Zs);
              return (
                (e._reactRootContainer = u),
                (e[vo] = u.current),
                Ur(8 === e.nodeType ? e.parentNode : e),
                cs(function () {
                  qs(t, u, n, r);
                }),
                u
              );
            })(n, t, e, o, r);
          return Ws(i);
        }
        (Ys.prototype.render = Qs.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (null === t) throw Error(a(409));
            qs(e, t, null, null);
          }),
          (Ys.prototype.unmount = Qs.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (null !== e) {
                this._internalRoot = null;
                var t = e.containerInfo;
                cs(function () {
                  qs(null, e, null, null);
                }),
                  (t[vo] = null);
              }
            }),
          (Ys.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
              var t = _t();
              e = { blockedOn: null, target: e, priority: t };
              for (var n = 0; n < Pt.length && 0 !== t && t < Pt[n].priority; n++);
              Pt.splice(n, 0, e), 0 === n && Mt(e);
            }
          }),
          (xt = function (e) {
            switch (e.tag) {
              case 3:
                var t = e.stateNode;
                if (t.current.memoizedState.isDehydrated) {
                  var n = ft(t.pendingLanes);
                  0 !== n && (wt(t, 1 | n), rs(t, Xe()), 0 === (6 & Nu) && ((Uu = Xe() + 500), Ho()));
                }
                break;
              case 13:
                cs(function () {
                  var t = La(e, 1);
                  if (null !== t) {
                    var n = es();
                    ns(t, e, 1, n);
                  }
                }),
                  Gs(e, 1);
            }
          }),
          (kt = function (e) {
            if (13 === e.tag) {
              var t = La(e, 134217728);
              if (null !== t) ns(t, e, 134217728, es());
              Gs(e, 134217728);
            }
          }),
          (St = function (e) {
            if (13 === e.tag) {
              var t = ts(e),
                n = La(e, t);
              if (null !== n) ns(n, e, t, es());
              Gs(e, t);
            }
          }),
          (_t = function () {
            return yt;
          }),
          (Et = function (e, t) {
            var n = yt;
            try {
              return (yt = e), t();
            } finally {
              yt = n;
            }
          }),
          (ke = function (e, t, n) {
            switch (t) {
              case 'input':
                if ((J(e, n), (t = n.name), 'radio' === n.type && null != t)) {
                  for (n = e; n.parentNode; ) n = n.parentNode;
                  for (
                    n = n.querySelectorAll('input[name=' + JSON.stringify('' + t) + '][type="radio"]'), t = 0;
                    t < n.length;
                    t++
                  ) {
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                      var o = ko(r);
                      if (!o) throw Error(a(90));
                      G(r), J(r, o);
                    }
                  }
                }
                break;
              case 'textarea':
                ae(e, n);
                break;
              case 'select':
                null != (t = n.value) && ne(e, !!n.multiple, t, !1);
            }
          }),
          (Ne = ss),
          (je = cs);
        var tc = { usingClientEntryPoint: !1, Events: [bo, xo, ko, Ce, Te, ss] },
          nc = { findFiberByHostInstance: yo, bundleType: 0, version: '18.2.0', rendererPackageName: 'react-dom' },
          rc = {
            bundleType: nc.bundleType,
            version: nc.version,
            rendererPackageName: nc.rendererPackageName,
            rendererConfig: nc.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: b.ReactCurrentDispatcher,
            findHostInstanceByFiber: function (e) {
              return null === (e = We(e)) ? null : e.stateNode;
            },
            findFiberByHostInstance:
              nc.findFiberByHostInstance ||
              function () {
                return null;
              },
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: '18.2.0-next-9e3b772b8-20220608',
          };
        if ('undefined' !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var oc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!oc.isDisabled && oc.supportsFiber)
            try {
              (ot = oc.inject(rc)), (at = oc);
            } catch (ce) {}
        }
        (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tc),
          (t.createPortal = function (e, t) {
            var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
            if (!Xs(t)) throw Error(a(200));
            return Fs(e, t, null, n);
          }),
          (t.createRoot = function (e, t) {
            if (!Xs(e)) throw Error(a(299));
            var n = !1,
              r = '',
              o = Ks;
            return (
              null !== t &&
                void 0 !== t &&
                (!0 === t.unstable_strictMode && (n = !0),
                void 0 !== t.identifierPrefix && (r = t.identifierPrefix),
                void 0 !== t.onRecoverableError && (o = t.onRecoverableError)),
              (t = Bs(e, 1, !1, null, 0, n, 0, r, o)),
              (e[vo] = t.current),
              Ur(8 === e.nodeType ? e.parentNode : e),
              new Qs(t)
            );
          }),
          (t.findDOMNode = function (e) {
            if (null == e) return null;
            if (1 === e.nodeType) return e;
            var t = e._reactInternals;
            if (void 0 === t) {
              if ('function' === typeof e.render) throw Error(a(188));
              throw ((e = Object.keys(e).join(',')), Error(a(268, e)));
            }
            return (e = null === (e = We(t)) ? null : e.stateNode);
          }),
          (t.flushSync = function (e) {
            return cs(e);
          }),
          (t.hydrate = function (e, t, n) {
            if (!Js(t)) throw Error(a(200));
            return ec(null, e, t, !0, n);
          }),
          (t.hydrateRoot = function (e, t, n) {
            if (!Xs(e)) throw Error(a(405));
            var r = (null != n && n.hydratedSources) || null,
              o = !1,
              i = '',
              l = Ks;
            if (
              (null !== n &&
                void 0 !== n &&
                (!0 === n.unstable_strictMode && (o = !0),
                void 0 !== n.identifierPrefix && (i = n.identifierPrefix),
                void 0 !== n.onRecoverableError && (l = n.onRecoverableError)),
              (t = Hs(t, null, e, 1, null != n ? n : null, o, 0, i, l)),
              (e[vo] = t.current),
              Ur(e),
              r)
            )
              for (e = 0; e < r.length; e++)
                (o = (o = (n = r[e])._getVersion)(n._source)),
                  null == t.mutableSourceEagerHydrationData
                    ? (t.mutableSourceEagerHydrationData = [n, o])
                    : t.mutableSourceEagerHydrationData.push(n, o);
            return new Ys(t);
          }),
          (t.render = function (e, t, n) {
            if (!Js(t)) throw Error(a(200));
            return ec(null, e, t, !1, n);
          }),
          (t.unmountComponentAtNode = function (e) {
            if (!Js(e)) throw Error(a(40));
            return (
              !!e._reactRootContainer &&
              (cs(function () {
                ec(null, null, e, !1, function () {
                  (e._reactRootContainer = null), (e[vo] = null);
                });
              }),
              !0)
            );
          }),
          (t.unstable_batchedUpdates = ss),
          (t.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
            if (!Js(n)) throw Error(a(200));
            if (null == e || void 0 === e._reactInternals) throw Error(a(38));
            return ec(e, t, n, !1, r);
          }),
          (t.version = '18.2.0-next-9e3b772b8-20220608');
      },
      250: function (e, t, n) {
        'use strict';
        var r = n(164);
        (t.createRoot = r.createRoot), (t.hydrateRoot = r.hydrateRoot);
      },
      164: function (e, t, n) {
        'use strict';
        !(function e() {
          if (
            'undefined' !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            'function' === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (t) {
              console.error(t);
            }
        })(),
          (e.exports = n(463));
      },
      374: function (e, t, n) {
        'use strict';
        var r = n(791),
          o = Symbol.for('react.element'),
          a = Symbol.for('react.fragment'),
          i = Object.prototype.hasOwnProperty,
          l = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
          u = { key: !0, ref: !0, __self: !0, __source: !0 };
        function s(e, t, n) {
          var r,
            a = {},
            s = null,
            c = null;
          for (r in (void 0 !== n && (s = '' + n),
          void 0 !== t.key && (s = '' + t.key),
          void 0 !== t.ref && (c = t.ref),
          t))
            i.call(t, r) && !u.hasOwnProperty(r) && (a[r] = t[r]);
          if (e && e.defaultProps) for (r in (t = e.defaultProps)) void 0 === a[r] && (a[r] = t[r]);
          return { $$typeof: o, type: e, key: s, ref: c, props: a, _owner: l.current };
        }
        (t.Fragment = a), (t.jsx = s), (t.jsxs = s);
      },
      117: function (e, t) {
        'use strict';
        var n = Symbol.for('react.element'),
          r = Symbol.for('react.portal'),
          o = Symbol.for('react.fragment'),
          a = Symbol.for('react.strict_mode'),
          i = Symbol.for('react.profiler'),
          l = Symbol.for('react.provider'),
          u = Symbol.for('react.context'),
          s = Symbol.for('react.forward_ref'),
          c = Symbol.for('react.suspense'),
          f = Symbol.for('react.memo'),
          d = Symbol.for('react.lazy'),
          p = Symbol.iterator;
        var h = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          v = Object.assign,
          m = {};
        function g(e, t, n) {
          (this.props = e), (this.context = t), (this.refs = m), (this.updater = n || h);
        }
        function w() {}
        function y(e, t, n) {
          (this.props = e), (this.context = t), (this.refs = m), (this.updater = n || h);
        }
        (g.prototype.isReactComponent = {}),
          (g.prototype.setState = function (e, t) {
            if ('object' !== typeof e && 'function' !== typeof e && null != e)
              throw Error(
                'setState(...): takes an object of state variables to update or a function which returns an object of state variables.'
              );
            this.updater.enqueueSetState(this, e, t, 'setState');
          }),
          (g.prototype.forceUpdate = function (e) {
            this.updater.enqueueForceUpdate(this, e, 'forceUpdate');
          }),
          (w.prototype = g.prototype);
        var b = (y.prototype = new w());
        (b.constructor = y), v(b, g.prototype), (b.isPureReactComponent = !0);
        var x = Array.isArray,
          k = Object.prototype.hasOwnProperty,
          S = { current: null },
          _ = { key: !0, ref: !0, __self: !0, __source: !0 };
        function E(e, t, r) {
          var o,
            a = {},
            i = null,
            l = null;
          if (null != t)
            for (o in (void 0 !== t.ref && (l = t.ref), void 0 !== t.key && (i = '' + t.key), t))
              k.call(t, o) && !_.hasOwnProperty(o) && (a[o] = t[o]);
          var u = arguments.length - 2;
          if (1 === u) a.children = r;
          else if (1 < u) {
            for (var s = Array(u), c = 0; c < u; c++) s[c] = arguments[c + 2];
            a.children = s;
          }
          if (e && e.defaultProps) for (o in (u = e.defaultProps)) void 0 === a[o] && (a[o] = u[o]);
          return { $$typeof: n, type: e, key: i, ref: l, props: a, _owner: S.current };
        }
        function C(e) {
          return 'object' === typeof e && null !== e && e.$$typeof === n;
        }
        var T = /\/+/g;
        function N(e, t) {
          return 'object' === typeof e && null !== e && null != e.key
            ? (function (e) {
                var t = { '=': '=0', ':': '=2' };
                return (
                  '$' +
                  e.replace(/[=:]/g, function (e) {
                    return t[e];
                  })
                );
              })('' + e.key)
            : t.toString(36);
        }
        function j(e, t, o, a, i) {
          var l = typeof e;
          ('undefined' !== l && 'boolean' !== l) || (e = null);
          var u = !1;
          if (null === e) u = !0;
          else
            switch (l) {
              case 'string':
              case 'number':
                u = !0;
                break;
              case 'object':
                switch (e.$$typeof) {
                  case n:
                  case r:
                    u = !0;
                }
            }
          if (u)
            return (
              (i = i((u = e))),
              (e = '' === a ? '.' + N(u, 0) : a),
              x(i)
                ? ((o = ''),
                  null != e && (o = e.replace(T, '$&/') + '/'),
                  j(i, t, o, '', function (e) {
                    return e;
                  }))
                : null != i &&
                  (C(i) &&
                    (i = (function (e, t) {
                      return { $$typeof: n, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
                    })(i, o + (!i.key || (u && u.key === i.key) ? '' : ('' + i.key).replace(T, '$&/') + '/') + e)),
                  t.push(i)),
              1
            );
          if (((u = 0), (a = '' === a ? '.' : a + ':'), x(e)))
            for (var s = 0; s < e.length; s++) {
              var c = a + N((l = e[s]), s);
              u += j(l, t, o, c, i);
            }
          else if (
            ((c = (function (e) {
              return null === e || 'object' !== typeof e
                ? null
                : 'function' === typeof (e = (p && e[p]) || e['@@iterator'])
                ? e
                : null;
            })(e)),
            'function' === typeof c)
          )
            for (e = c.call(e), s = 0; !(l = e.next()).done; ) u += j((l = l.value), t, o, (c = a + N(l, s++)), i);
          else if ('object' === l)
            throw (
              ((t = String(e)),
              Error(
                'Objects are not valid as a React child (found: ' +
                  ('[object Object]' === t ? 'object with keys {' + Object.keys(e).join(', ') + '}' : t) +
                  '). If you meant to render a collection of children, use an array instead.'
              ))
            );
          return u;
        }
        function L(e, t, n) {
          if (null == e) return e;
          var r = [],
            o = 0;
          return (
            j(e, r, '', '', function (e) {
              return t.call(n, e, o++);
            }),
            r
          );
        }
        function A(e) {
          if (-1 === e._status) {
            var t = e._result;
            (t = t()).then(
              function (t) {
                (0 !== e._status && -1 !== e._status) || ((e._status = 1), (e._result = t));
              },
              function (t) {
                (0 !== e._status && -1 !== e._status) || ((e._status = 2), (e._result = t));
              }
            ),
              -1 === e._status && ((e._status = 0), (e._result = t));
          }
          if (1 === e._status) return e._result.default;
          throw e._result;
        }
        var R = { current: null },
          P = { transition: null },
          O = { ReactCurrentDispatcher: R, ReactCurrentBatchConfig: P, ReactCurrentOwner: S };
        (t.Children = {
          map: L,
          forEach: function (e, t, n) {
            L(
              e,
              function () {
                t.apply(this, arguments);
              },
              n
            );
          },
          count: function (e) {
            var t = 0;
            return (
              L(e, function () {
                t++;
              }),
              t
            );
          },
          toArray: function (e) {
            return (
              L(e, function (e) {
                return e;
              }) || []
            );
          },
          only: function (e) {
            if (!C(e)) throw Error('React.Children.only expected to receive a single React element child.');
            return e;
          },
        }),
          (t.Component = g),
          (t.Fragment = o),
          (t.Profiler = i),
          (t.PureComponent = y),
          (t.StrictMode = a),
          (t.Suspense = c),
          (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = O),
          (t.cloneElement = function (e, t, r) {
            if (null === e || void 0 === e)
              throw Error('React.cloneElement(...): The argument must be a React element, but you passed ' + e + '.');
            var o = v({}, e.props),
              a = e.key,
              i = e.ref,
              l = e._owner;
            if (null != t) {
              if (
                (void 0 !== t.ref && ((i = t.ref), (l = S.current)),
                void 0 !== t.key && (a = '' + t.key),
                e.type && e.type.defaultProps)
              )
                var u = e.type.defaultProps;
              for (s in t)
                k.call(t, s) && !_.hasOwnProperty(s) && (o[s] = void 0 === t[s] && void 0 !== u ? u[s] : t[s]);
            }
            var s = arguments.length - 2;
            if (1 === s) o.children = r;
            else if (1 < s) {
              u = Array(s);
              for (var c = 0; c < s; c++) u[c] = arguments[c + 2];
              o.children = u;
            }
            return { $$typeof: n, type: e.type, key: a, ref: i, props: o, _owner: l };
          }),
          (t.createContext = function (e) {
            return (
              ((e = {
                $$typeof: u,
                _currentValue: e,
                _currentValue2: e,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
                _defaultValue: null,
                _globalName: null,
              }).Provider = { $$typeof: l, _context: e }),
              (e.Consumer = e)
            );
          }),
          (t.createElement = E),
          (t.createFactory = function (e) {
            var t = E.bind(null, e);
            return (t.type = e), t;
          }),
          (t.createRef = function () {
            return { current: null };
          }),
          (t.forwardRef = function (e) {
            return { $$typeof: s, render: e };
          }),
          (t.isValidElement = C),
          (t.lazy = function (e) {
            return { $$typeof: d, _payload: { _status: -1, _result: e }, _init: A };
          }),
          (t.memo = function (e, t) {
            return { $$typeof: f, type: e, compare: void 0 === t ? null : t };
          }),
          (t.startTransition = function (e) {
            var t = P.transition;
            P.transition = {};
            try {
              e();
            } finally {
              P.transition = t;
            }
          }),
          (t.unstable_act = function () {
            throw Error('act(...) is not supported in production builds of React.');
          }),
          (t.useCallback = function (e, t) {
            return R.current.useCallback(e, t);
          }),
          (t.useContext = function (e) {
            return R.current.useContext(e);
          }),
          (t.useDebugValue = function () {}),
          (t.useDeferredValue = function (e) {
            return R.current.useDeferredValue(e);
          }),
          (t.useEffect = function (e, t) {
            return R.current.useEffect(e, t);
          }),
          (t.useId = function () {
            return R.current.useId();
          }),
          (t.useImperativeHandle = function (e, t, n) {
            return R.current.useImperativeHandle(e, t, n);
          }),
          (t.useInsertionEffect = function (e, t) {
            return R.current.useInsertionEffect(e, t);
          }),
          (t.useLayoutEffect = function (e, t) {
            return R.current.useLayoutEffect(e, t);
          }),
          (t.useMemo = function (e, t) {
            return R.current.useMemo(e, t);
          }),
          (t.useReducer = function (e, t, n) {
            return R.current.useReducer(e, t, n);
          }),
          (t.useRef = function (e) {
            return R.current.useRef(e);
          }),
          (t.useState = function (e) {
            return R.current.useState(e);
          }),
          (t.useSyncExternalStore = function (e, t, n) {
            return R.current.useSyncExternalStore(e, t, n);
          }),
          (t.useTransition = function () {
            return R.current.useTransition();
          }),
          (t.version = '18.2.0');
      },
      791: function (e, t, n) {
        'use strict';
        e.exports = n(117);
      },
      184: function (e, t, n) {
        'use strict';
        e.exports = n(374);
      },
      813: function (e, t) {
        'use strict';
        function n(e, t) {
          var n = e.length;
          e.push(t);
          e: for (; 0 < n; ) {
            var r = (n - 1) >>> 1,
              o = e[r];
            if (!(0 < a(o, t))) break e;
            (e[r] = t), (e[n] = o), (n = r);
          }
        }
        function r(e) {
          return 0 === e.length ? null : e[0];
        }
        function o(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, o = e.length, i = o >>> 1; r < i; ) {
              var l = 2 * (r + 1) - 1,
                u = e[l],
                s = l + 1,
                c = e[s];
              if (0 > a(u, n))
                s < o && 0 > a(c, u) ? ((e[r] = c), (e[s] = n), (r = s)) : ((e[r] = u), (e[l] = n), (r = l));
              else {
                if (!(s < o && 0 > a(c, n))) break e;
                (e[r] = c), (e[s] = n), (r = s);
              }
            }
          }
          return t;
        }
        function a(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if ('object' === typeof performance && 'function' === typeof performance.now) {
          var i = performance;
          t.unstable_now = function () {
            return i.now();
          };
        } else {
          var l = Date,
            u = l.now();
          t.unstable_now = function () {
            return l.now() - u;
          };
        }
        var s = [],
          c = [],
          f = 1,
          d = null,
          p = 3,
          h = !1,
          v = !1,
          m = !1,
          g = 'function' === typeof setTimeout ? setTimeout : null,
          w = 'function' === typeof clearTimeout ? clearTimeout : null,
          y = 'undefined' !== typeof setImmediate ? setImmediate : null;
        function b(e) {
          for (var t = r(c); null !== t; ) {
            if (null === t.callback) o(c);
            else {
              if (!(t.startTime <= e)) break;
              o(c), (t.sortIndex = t.expirationTime), n(s, t);
            }
            t = r(c);
          }
        }
        function x(e) {
          if (((m = !1), b(e), !v))
            if (null !== r(s)) (v = !0), P(k);
            else {
              var t = r(c);
              null !== t && O(x, t.startTime - e);
            }
        }
        function k(e, n) {
          (v = !1), m && ((m = !1), w(C), (C = -1)), (h = !0);
          var a = p;
          try {
            for (b(n), d = r(s); null !== d && (!(d.expirationTime > n) || (e && !j())); ) {
              var i = d.callback;
              if ('function' === typeof i) {
                (d.callback = null), (p = d.priorityLevel);
                var l = i(d.expirationTime <= n);
                (n = t.unstable_now()), 'function' === typeof l ? (d.callback = l) : d === r(s) && o(s), b(n);
              } else o(s);
              d = r(s);
            }
            if (null !== d) var u = !0;
            else {
              var f = r(c);
              null !== f && O(x, f.startTime - n), (u = !1);
            }
            return u;
          } finally {
            (d = null), (p = a), (h = !1);
          }
        }
        'undefined' !== typeof navigator &&
          void 0 !== navigator.scheduling &&
          void 0 !== navigator.scheduling.isInputPending &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling);
        var S,
          _ = !1,
          E = null,
          C = -1,
          T = 5,
          N = -1;
        function j() {
          return !(t.unstable_now() - N < T);
        }
        function L() {
          if (null !== E) {
            var e = t.unstable_now();
            N = e;
            var n = !0;
            try {
              n = E(!0, e);
            } finally {
              n ? S() : ((_ = !1), (E = null));
            }
          } else _ = !1;
        }
        if ('function' === typeof y)
          S = function () {
            y(L);
          };
        else if ('undefined' !== typeof MessageChannel) {
          var A = new MessageChannel(),
            R = A.port2;
          (A.port1.onmessage = L),
            (S = function () {
              R.postMessage(null);
            });
        } else
          S = function () {
            g(L, 0);
          };
        function P(e) {
          (E = e), _ || ((_ = !0), S());
        }
        function O(e, n) {
          C = g(function () {
            e(t.unstable_now());
          }, n);
        }
        (t.unstable_IdlePriority = 5),
          (t.unstable_ImmediatePriority = 1),
          (t.unstable_LowPriority = 4),
          (t.unstable_NormalPriority = 3),
          (t.unstable_Profiling = null),
          (t.unstable_UserBlockingPriority = 2),
          (t.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (t.unstable_continueExecution = function () {
            v || h || ((v = !0), P(k));
          }),
          (t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
                )
              : (T = 0 < e ? Math.floor(1e3 / e) : 5);
          }),
          (t.unstable_getCurrentPriorityLevel = function () {
            return p;
          }),
          (t.unstable_getFirstCallbackNode = function () {
            return r(s);
          }),
          (t.unstable_next = function (e) {
            switch (p) {
              case 1:
              case 2:
              case 3:
                var t = 3;
                break;
              default:
                t = p;
            }
            var n = p;
            p = t;
            try {
              return e();
            } finally {
              p = n;
            }
          }),
          (t.unstable_pauseExecution = function () {}),
          (t.unstable_requestPaint = function () {}),
          (t.unstable_runWithPriority = function (e, t) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var n = p;
            p = e;
            try {
              return t();
            } finally {
              p = n;
            }
          }),
          (t.unstable_scheduleCallback = function (e, o, a) {
            var i = t.unstable_now();
            switch (
              ('object' === typeof a && null !== a
                ? (a = 'number' === typeof (a = a.delay) && 0 < a ? i + a : i)
                : (a = i),
              e)
            ) {
              case 1:
                var l = -1;
                break;
              case 2:
                l = 250;
                break;
              case 5:
                l = 1073741823;
                break;
              case 4:
                l = 1e4;
                break;
              default:
                l = 5e3;
            }
            return (
              (e = {
                id: f++,
                callback: o,
                priorityLevel: e,
                startTime: a,
                expirationTime: (l = a + l),
                sortIndex: -1,
              }),
              a > i
                ? ((e.sortIndex = a),
                  n(c, e),
                  null === r(s) && e === r(c) && (m ? (w(C), (C = -1)) : (m = !0), O(x, a - i)))
                : ((e.sortIndex = l), n(s, e), v || h || ((v = !0), P(k))),
              e
            );
          }),
          (t.unstable_shouldYield = j),
          (t.unstable_wrapCallback = function (e) {
            var t = p;
            return function () {
              var n = p;
              p = t;
              try {
                return e.apply(this, arguments);
              } finally {
                p = n;
              }
            };
          });
      },
      296: function (e, t, n) {
        'use strict';
        e.exports = n(813);
      },
      110: function (e, t) {
        var n;
        !(function (t, n) {
          'use strict';
          'object' === typeof e.exports
            ? (e.exports = t.document
                ? n(t, !0)
                : function (e) {
                    if (!e.document) throw new Error('jQuery requires a window with a document');
                    return n(e);
                  })
            : n(t);
        })('undefined' !== typeof window ? window : this, function (r, o) {
          'use strict';
          var a = [],
            i = Object.getPrototypeOf,
            l = a.slice,
            u = a.flat
              ? function (e) {
                  return a.flat.call(e);
                }
              : function (e) {
                  return a.concat.apply([], e);
                },
            s = a.push,
            c = a.indexOf,
            f = {},
            d = f.toString,
            p = f.hasOwnProperty,
            h = p.toString,
            v = h.call(Object),
            m = {},
            g = function (e) {
              return 'function' === typeof e && 'number' !== typeof e.nodeType && 'function' !== typeof e.item;
            },
            w = function (e) {
              return null != e && e === e.window;
            },
            y = r.document,
            b = { type: !0, src: !0, nonce: !0, noModule: !0 };
          function x(e, t, n) {
            var r,
              o,
              a = (n = n || y).createElement('script');
            if (((a.text = e), t))
              for (r in b) (o = t[r] || (t.getAttribute && t.getAttribute(r))) && a.setAttribute(r, o);
            n.head.appendChild(a).parentNode.removeChild(a);
          }
          function k(e) {
            return null == e
              ? e + ''
              : 'object' === typeof e || 'function' === typeof e
              ? f[d.call(e)] || 'object'
              : typeof e;
          }
          var S = '3.7.1',
            _ = /HTML$/i,
            E = function e(t, n) {
              return new e.fn.init(t, n);
            };
          function C(e) {
            var t = !!e && 'length' in e && e.length,
              n = k(e);
            return !g(e) && !w(e) && ('array' === n || 0 === t || ('number' === typeof t && t > 0 && t - 1 in e));
          }
          function T(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
          }
          (E.fn = E.prototype =
            {
              jquery: S,
              constructor: E,
              length: 0,
              toArray: function () {
                return l.call(this);
              },
              get: function (e) {
                return null == e ? l.call(this) : e < 0 ? this[e + this.length] : this[e];
              },
              pushStack: function (e) {
                var t = E.merge(this.constructor(), e);
                return (t.prevObject = this), t;
              },
              each: function (e) {
                return E.each(this, e);
              },
              map: function (e) {
                return this.pushStack(
                  E.map(this, function (t, n) {
                    return e.call(t, n, t);
                  })
                );
              },
              slice: function () {
                return this.pushStack(l.apply(this, arguments));
              },
              first: function () {
                return this.eq(0);
              },
              last: function () {
                return this.eq(-1);
              },
              even: function () {
                return this.pushStack(
                  E.grep(this, function (e, t) {
                    return (t + 1) % 2;
                  })
                );
              },
              odd: function () {
                return this.pushStack(
                  E.grep(this, function (e, t) {
                    return t % 2;
                  })
                );
              },
              eq: function (e) {
                var t = this.length,
                  n = +e + (e < 0 ? t : 0);
                return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
              },
              end: function () {
                return this.prevObject || this.constructor();
              },
              push: s,
              sort: a.sort,
              splice: a.splice,
            }),
            (E.extend = E.fn.extend =
              function () {
                var e,
                  t,
                  n,
                  r,
                  o,
                  a,
                  i = arguments[0] || {},
                  l = 1,
                  u = arguments.length,
                  s = !1;
                for (
                  'boolean' === typeof i && ((s = i), (i = arguments[l] || {}), l++),
                    'object' === typeof i || g(i) || (i = {}),
                    l === u && ((i = this), l--);
                  l < u;
                  l++
                )
                  if (null != (e = arguments[l]))
                    for (t in e)
                      (r = e[t]),
                        '__proto__' !== t &&
                          i !== r &&
                          (s && r && (E.isPlainObject(r) || (o = Array.isArray(r)))
                            ? ((n = i[t]),
                              (a = o && !Array.isArray(n) ? [] : o || E.isPlainObject(n) ? n : {}),
                              (o = !1),
                              (i[t] = E.extend(s, a, r)))
                            : void 0 !== r && (i[t] = r));
                return i;
              }),
            E.extend({
              expando: 'jQuery' + (S + Math.random()).replace(/\D/g, ''),
              isReady: !0,
              error: function (e) {
                throw new Error(e);
              },
              noop: function () {},
              isPlainObject: function (e) {
                var t, n;
                return (
                  !(!e || '[object Object]' !== d.call(e)) &&
                  (!(t = i(e)) ||
                    ('function' === typeof (n = p.call(t, 'constructor') && t.constructor) && h.call(n) === v))
                );
              },
              isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
              },
              globalEval: function (e, t, n) {
                x(e, { nonce: t && t.nonce }, n);
              },
              each: function (e, t) {
                var n,
                  r = 0;
                if (C(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);
                else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
                return e;
              },
              text: function (e) {
                var t,
                  n = '',
                  r = 0,
                  o = e.nodeType;
                if (!o) for (; (t = e[r++]); ) n += E.text(t);
                return 1 === o || 11 === o
                  ? e.textContent
                  : 9 === o
                  ? e.documentElement.textContent
                  : 3 === o || 4 === o
                  ? e.nodeValue
                  : n;
              },
              makeArray: function (e, t) {
                var n = t || [];
                return null != e && (C(Object(e)) ? E.merge(n, 'string' === typeof e ? [e] : e) : s.call(n, e)), n;
              },
              inArray: function (e, t, n) {
                return null == t ? -1 : c.call(t, e, n);
              },
              isXMLDoc: function (e) {
                var t = e && e.namespaceURI,
                  n = e && (e.ownerDocument || e).documentElement;
                return !_.test(t || (n && n.nodeName) || 'HTML');
              },
              merge: function (e, t) {
                for (var n = +t.length, r = 0, o = e.length; r < n; r++) e[o++] = t[r];
                return (e.length = o), e;
              },
              grep: function (e, t, n) {
                for (var r = [], o = 0, a = e.length, i = !n; o < a; o++) !t(e[o], o) !== i && r.push(e[o]);
                return r;
              },
              map: function (e, t, n) {
                var r,
                  o,
                  a = 0,
                  i = [];
                if (C(e)) for (r = e.length; a < r; a++) null != (o = t(e[a], a, n)) && i.push(o);
                else for (a in e) null != (o = t(e[a], a, n)) && i.push(o);
                return u(i);
              },
              guid: 1,
              support: m,
            }),
            'function' === typeof Symbol && (E.fn[Symbol.iterator] = a[Symbol.iterator]),
            E.each('Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '), function (e, t) {
              f['[object ' + t + ']'] = t.toLowerCase();
            });
          var N = a.pop,
            j = a.sort,
            L = a.splice,
            A = '[\\x20\\t\\r\\n\\f]',
            R = new RegExp('^' + A + '+|((?:^|[^\\\\])(?:\\\\.)*)' + A + '+$', 'g');
          E.contains = function (e, t) {
            var n = t && t.parentNode;
            return (
              e === n ||
              !(
                !n ||
                1 !== n.nodeType ||
                !(e.contains ? e.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n))
              )
            );
          };
          var P = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
          function O(e, t) {
            return t
              ? '\0' === e
                ? '\ufffd'
                : e.slice(0, -1) + '\\' + e.charCodeAt(e.length - 1).toString(16) + ' '
              : '\\' + e;
          }
          E.escapeSelector = function (e) {
            return (e + '').replace(P, O);
          };
          var D = y,
            I = s;
          !(function () {
            var e,
              t,
              n,
              o,
              i,
              u,
              s,
              f,
              d,
              h,
              v = I,
              g = E.expando,
              w = 0,
              y = 0,
              b = ee(),
              x = ee(),
              k = ee(),
              S = ee(),
              _ = function (e, t) {
                return e === t && (i = !0), 0;
              },
              C =
                'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
              P = '(?:\\\\[\\da-fA-F]{1,6}' + A + '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
              O =
                '\\[' +
                A +
                '*(' +
                P +
                ')(?:' +
                A +
                '*([*^$|!~]?=)' +
                A +
                '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
                P +
                '))|)' +
                A +
                '*\\]',
              M =
                ':(' +
                P +
                ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
                O +
                ')*)|.*)\\)|)',
              z = new RegExp(A + '+', 'g'),
              V = new RegExp('^' + A + '*,' + A + '*'),
              B = new RegExp('^' + A + '*([>+~]|' + A + ')' + A + '*'),
              F = new RegExp(A + '|>'),
              U = new RegExp(M),
              H = new RegExp('^' + P + '$'),
              q = {
                ID: new RegExp('^#(' + P + ')'),
                CLASS: new RegExp('^\\.(' + P + ')'),
                TAG: new RegExp('^(' + P + '|[*])'),
                ATTR: new RegExp('^' + O),
                PSEUDO: new RegExp('^' + M),
                CHILD: new RegExp(
                  '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
                    A +
                    '*(even|odd|(([+-]|)(\\d*)n|)' +
                    A +
                    '*(?:([+-]|)' +
                    A +
                    '*(\\d+)|))' +
                    A +
                    '*\\)|)',
                  'i'
                ),
                bool: new RegExp('^(?:' + C + ')$', 'i'),
                needsContext: new RegExp(
                  '^' +
                    A +
                    '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
                    A +
                    '*((?:-\\d)?\\d*)' +
                    A +
                    '*\\)|)(?=[^-]|$)',
                  'i'
                ),
              },
              W = /^(?:input|select|textarea|button)$/i,
              $ = /^h\d$/i,
              G = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
              K = /[+~]/,
              Q = new RegExp('\\\\[\\da-fA-F]{1,6}' + A + '?|\\\\([^\\r\\n\\f])', 'g'),
              Y = function (e, t) {
                var n = '0x' + e.slice(1) - 65536;
                return (
                  t ||
                  (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
                );
              },
              X = function () {
                ue();
              },
              J = de(
                function (e) {
                  return !0 === e.disabled && T(e, 'fieldset');
                },
                { dir: 'parentNode', next: 'legend' }
              );
            try {
              v.apply((a = l.call(D.childNodes)), D.childNodes), a[D.childNodes.length].nodeType;
            } catch (ye) {
              v = {
                apply: function (e, t) {
                  I.apply(e, l.call(t));
                },
                call: function (e) {
                  I.apply(e, l.call(arguments, 1));
                },
              };
            }
            function Z(e, t, n, r) {
              var o,
                a,
                i,
                l,
                s,
                c,
                p,
                h = t && t.ownerDocument,
                w = t ? t.nodeType : 9;
              if (((n = n || []), 'string' !== typeof e || !e || (1 !== w && 9 !== w && 11 !== w))) return n;
              if (!r && (ue(t), (t = t || u), f)) {
                if (11 !== w && (s = G.exec(e)))
                  if ((o = s[1])) {
                    if (9 === w) {
                      if (!(i = t.getElementById(o))) return n;
                      if (i.id === o) return v.call(n, i), n;
                    } else if (h && (i = h.getElementById(o)) && Z.contains(t, i) && i.id === o) return v.call(n, i), n;
                  } else {
                    if (s[2]) return v.apply(n, t.getElementsByTagName(e)), n;
                    if ((o = s[3]) && t.getElementsByClassName) return v.apply(n, t.getElementsByClassName(o)), n;
                  }
                if (!S[e + ' '] && (!d || !d.test(e))) {
                  if (((p = e), (h = t), 1 === w && (F.test(e) || B.test(e)))) {
                    for (
                      ((h = (K.test(e) && le(t.parentNode)) || t) == t && m.scope) ||
                        ((l = t.getAttribute('id')) ? (l = E.escapeSelector(l)) : t.setAttribute('id', (l = g))),
                        a = (c = ce(e)).length;
                      a--;

                    )
                      c[a] = (l ? '#' + l : ':scope') + ' ' + fe(c[a]);
                    p = c.join(',');
                  }
                  try {
                    return v.apply(n, h.querySelectorAll(p)), n;
                  } catch (y) {
                    S(e, !0);
                  } finally {
                    l === g && t.removeAttribute('id');
                  }
                }
              }
              return we(e.replace(R, '$1'), t, n, r);
            }
            function ee() {
              var e = [];
              return function n(r, o) {
                return e.push(r + ' ') > t.cacheLength && delete n[e.shift()], (n[r + ' '] = o);
              };
            }
            function te(e) {
              return (e[g] = !0), e;
            }
            function ne(e) {
              var t = u.createElement('fieldset');
              try {
                return !!e(t);
              } catch (ye) {
                return !1;
              } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
              }
            }
            function re(e) {
              return function (t) {
                return T(t, 'input') && t.type === e;
              };
            }
            function oe(e) {
              return function (t) {
                return (T(t, 'input') || T(t, 'button')) && t.type === e;
              };
            }
            function ae(e) {
              return function (t) {
                return 'form' in t
                  ? t.parentNode && !1 === t.disabled
                    ? 'label' in t
                      ? 'label' in t.parentNode
                        ? t.parentNode.disabled === e
                        : t.disabled === e
                      : t.isDisabled === e || (t.isDisabled !== !e && J(t) === e)
                    : t.disabled === e
                  : 'label' in t && t.disabled === e;
              };
            }
            function ie(e) {
              return te(function (t) {
                return (
                  (t = +t),
                  te(function (n, r) {
                    for (var o, a = e([], n.length, t), i = a.length; i--; ) n[(o = a[i])] && (n[o] = !(r[o] = n[o]));
                  })
                );
              });
            }
            function le(e) {
              return e && 'undefined' !== typeof e.getElementsByTagName && e;
            }
            function ue(e) {
              var n,
                r = e ? e.ownerDocument || e : D;
              return r != u && 9 === r.nodeType && r.documentElement
                ? ((s = (u = r).documentElement),
                  (f = !E.isXMLDoc(u)),
                  (h = s.matches || s.webkitMatchesSelector || s.msMatchesSelector),
                  s.msMatchesSelector &&
                    D != u &&
                    (n = u.defaultView) &&
                    n.top !== n &&
                    n.addEventListener('unload', X),
                  (m.getById = ne(function (e) {
                    return (
                      (s.appendChild(e).id = E.expando), !u.getElementsByName || !u.getElementsByName(E.expando).length
                    );
                  })),
                  (m.disconnectedMatch = ne(function (e) {
                    return h.call(e, '*');
                  })),
                  (m.scope = ne(function () {
                    return u.querySelectorAll(':scope');
                  })),
                  (m.cssHas = ne(function () {
                    try {
                      return u.querySelector(':has(*,:jqfake)'), !1;
                    } catch (ye) {
                      return !0;
                    }
                  })),
                  m.getById
                    ? ((t.filter.ID = function (e) {
                        var t = e.replace(Q, Y);
                        return function (e) {
                          return e.getAttribute('id') === t;
                        };
                      }),
                      (t.find.ID = function (e, t) {
                        if ('undefined' !== typeof t.getElementById && f) {
                          var n = t.getElementById(e);
                          return n ? [n] : [];
                        }
                      }))
                    : ((t.filter.ID = function (e) {
                        var t = e.replace(Q, Y);
                        return function (e) {
                          var n = 'undefined' !== typeof e.getAttributeNode && e.getAttributeNode('id');
                          return n && n.value === t;
                        };
                      }),
                      (t.find.ID = function (e, t) {
                        if ('undefined' !== typeof t.getElementById && f) {
                          var n,
                            r,
                            o,
                            a = t.getElementById(e);
                          if (a) {
                            if ((n = a.getAttributeNode('id')) && n.value === e) return [a];
                            for (o = t.getElementsByName(e), r = 0; (a = o[r++]); )
                              if ((n = a.getAttributeNode('id')) && n.value === e) return [a];
                          }
                          return [];
                        }
                      })),
                  (t.find.TAG = function (e, t) {
                    return 'undefined' !== typeof t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : t.querySelectorAll(e);
                  }),
                  (t.find.CLASS = function (e, t) {
                    if ('undefined' !== typeof t.getElementsByClassName && f) return t.getElementsByClassName(e);
                  }),
                  (d = []),
                  ne(function (e) {
                    var t;
                    (s.appendChild(e).innerHTML =
                      "<a id='" +
                      g +
                      "' href='' disabled='disabled'></a><select id='" +
                      g +
                      "-\r\\' disabled='disabled'><option selected=''></option></select>"),
                      e.querySelectorAll('[selected]').length || d.push('\\[' + A + '*(?:value|' + C + ')'),
                      e.querySelectorAll('[id~=' + g + '-]').length || d.push('~='),
                      e.querySelectorAll('a#' + g + '+*').length || d.push('.#.+[+~]'),
                      e.querySelectorAll(':checked').length || d.push(':checked'),
                      (t = u.createElement('input')).setAttribute('type', 'hidden'),
                      e.appendChild(t).setAttribute('name', 'D'),
                      (s.appendChild(e).disabled = !0),
                      2 !== e.querySelectorAll(':disabled').length && d.push(':enabled', ':disabled'),
                      (t = u.createElement('input')).setAttribute('name', ''),
                      e.appendChild(t),
                      e.querySelectorAll("[name='']").length ||
                        d.push('\\[' + A + '*name' + A + '*=' + A + '*(?:\'\'|"")');
                  }),
                  m.cssHas || d.push(':has'),
                  (d = d.length && new RegExp(d.join('|'))),
                  (_ = function (e, t) {
                    if (e === t) return (i = !0), 0;
                    var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return (
                      n ||
                      (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) ||
                      (!m.sortDetached && t.compareDocumentPosition(e) === n)
                        ? e === u || (e.ownerDocument == D && Z.contains(D, e))
                          ? -1
                          : t === u || (t.ownerDocument == D && Z.contains(D, t))
                          ? 1
                          : o
                          ? c.call(o, e) - c.call(o, t)
                          : 0
                        : 4 & n
                        ? -1
                        : 1)
                    );
                  }),
                  u)
                : u;
            }
            for (e in ((Z.matches = function (e, t) {
              return Z(e, null, null, t);
            }),
            (Z.matchesSelector = function (e, t) {
              if ((ue(e), f && !S[t + ' '] && (!d || !d.test(t))))
                try {
                  var n = h.call(e, t);
                  if (n || m.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return n;
                } catch (ye) {
                  S(t, !0);
                }
              return Z(t, u, null, [e]).length > 0;
            }),
            (Z.contains = function (e, t) {
              return (e.ownerDocument || e) != u && ue(e), E.contains(e, t);
            }),
            (Z.attr = function (e, n) {
              (e.ownerDocument || e) != u && ue(e);
              var r = t.attrHandle[n.toLowerCase()],
                o = r && p.call(t.attrHandle, n.toLowerCase()) ? r(e, n, !f) : void 0;
              return void 0 !== o ? o : e.getAttribute(n);
            }),
            (Z.error = function (e) {
              throw new Error('Syntax error, unrecognized expression: ' + e);
            }),
            (E.uniqueSort = function (e) {
              var t,
                n = [],
                r = 0,
                a = 0;
              if (((i = !m.sortStable), (o = !m.sortStable && l.call(e, 0)), j.call(e, _), i)) {
                for (; (t = e[a++]); ) t === e[a] && (r = n.push(a));
                for (; r--; ) L.call(e, n[r], 1);
              }
              return (o = null), e;
            }),
            (E.fn.uniqueSort = function () {
              return this.pushStack(E.uniqueSort(l.apply(this)));
            }),
            (t = E.expr =
              {
                cacheLength: 50,
                createPseudo: te,
                match: q,
                attrHandle: {},
                find: {},
                relative: {
                  '>': { dir: 'parentNode', first: !0 },
                  ' ': { dir: 'parentNode' },
                  '+': { dir: 'previousSibling', first: !0 },
                  '~': { dir: 'previousSibling' },
                },
                preFilter: {
                  ATTR: function (e) {
                    return (
                      (e[1] = e[1].replace(Q, Y)),
                      (e[3] = (e[3] || e[4] || e[5] || '').replace(Q, Y)),
                      '~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
                      e.slice(0, 4)
                    );
                  },
                  CHILD: function (e) {
                    return (
                      (e[1] = e[1].toLowerCase()),
                      'nth' === e[1].slice(0, 3)
                        ? (e[3] || Z.error(e[0]),
                          (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ('even' === e[3] || 'odd' === e[3]))),
                          (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
                        : e[3] && Z.error(e[0]),
                      e
                    );
                  },
                  PSEUDO: function (e) {
                    var t,
                      n = !e[6] && e[2];
                    return q.CHILD.test(e[0])
                      ? null
                      : (e[3]
                          ? (e[2] = e[4] || e[5] || '')
                          : n &&
                            U.test(n) &&
                            (t = ce(n, !0)) &&
                            (t = n.indexOf(')', n.length - t) - n.length) &&
                            ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                        e.slice(0, 3));
                  },
                },
                filter: {
                  TAG: function (e) {
                    var t = e.replace(Q, Y).toLowerCase();
                    return '*' === e
                      ? function () {
                          return !0;
                        }
                      : function (e) {
                          return T(e, t);
                        };
                  },
                  CLASS: function (e) {
                    var t = b[e + ' '];
                    return (
                      t ||
                      ((t = new RegExp('(^|' + A + ')' + e + '(' + A + '|$)')) &&
                        b(e, function (e) {
                          return t.test(
                            ('string' === typeof e.className && e.className) ||
                              ('undefined' !== typeof e.getAttribute && e.getAttribute('class')) ||
                              ''
                          );
                        }))
                    );
                  },
                  ATTR: function (e, t, n) {
                    return function (r) {
                      var o = Z.attr(r, e);
                      return null == o
                        ? '!=' === t
                        : !t ||
                            ((o += ''),
                            '=' === t
                              ? o === n
                              : '!=' === t
                              ? o !== n
                              : '^=' === t
                              ? n && 0 === o.indexOf(n)
                              : '*=' === t
                              ? n && o.indexOf(n) > -1
                              : '$=' === t
                              ? n && o.slice(-n.length) === n
                              : '~=' === t
                              ? (' ' + o.replace(z, ' ') + ' ').indexOf(n) > -1
                              : '|=' === t && (o === n || o.slice(0, n.length + 1) === n + '-'));
                    };
                  },
                  CHILD: function (e, t, n, r, o) {
                    var a = 'nth' !== e.slice(0, 3),
                      i = 'last' !== e.slice(-4),
                      l = 'of-type' === t;
                    return 1 === r && 0 === o
                      ? function (e) {
                          return !!e.parentNode;
                        }
                      : function (t, n, u) {
                          var s,
                            c,
                            f,
                            d,
                            p,
                            h = a !== i ? 'nextSibling' : 'previousSibling',
                            v = t.parentNode,
                            m = l && t.nodeName.toLowerCase(),
                            y = !u && !l,
                            b = !1;
                          if (v) {
                            if (a) {
                              for (; h; ) {
                                for (f = t; (f = f[h]); ) if (l ? T(f, m) : 1 === f.nodeType) return !1;
                                p = h = 'only' === e && !p && 'nextSibling';
                              }
                              return !0;
                            }
                            if (((p = [i ? v.firstChild : v.lastChild]), i && y)) {
                              for (
                                b = (d = (s = (c = v[g] || (v[g] = {}))[e] || [])[0] === w && s[1]) && s[2],
                                  f = d && v.childNodes[d];
                                (f = (++d && f && f[h]) || (b = d = 0) || p.pop());

                              )
                                if (1 === f.nodeType && ++b && f === t) {
                                  c[e] = [w, d, b];
                                  break;
                                }
                            } else if (
                              (y && (b = d = (s = (c = t[g] || (t[g] = {}))[e] || [])[0] === w && s[1]), !1 === b)
                            )
                              for (
                                ;
                                (f = (++d && f && f[h]) || (b = d = 0) || p.pop()) &&
                                (!(l ? T(f, m) : 1 === f.nodeType) ||
                                  !++b ||
                                  (y && ((c = f[g] || (f[g] = {}))[e] = [w, b]), f !== t));

                              );
                            return (b -= o) === r || (b % r === 0 && b / r >= 0);
                          }
                        };
                  },
                  PSEUDO: function (e, n) {
                    var r,
                      o = t.pseudos[e] || t.setFilters[e.toLowerCase()] || Z.error('unsupported pseudo: ' + e);
                    return o[g]
                      ? o(n)
                      : o.length > 1
                      ? ((r = [e, e, '', n]),
                        t.setFilters.hasOwnProperty(e.toLowerCase())
                          ? te(function (e, t) {
                              for (var r, a = o(e, n), i = a.length; i--; ) e[(r = c.call(e, a[i]))] = !(t[r] = a[i]);
                            })
                          : function (e) {
                              return o(e, 0, r);
                            })
                      : o;
                  },
                },
                pseudos: {
                  not: te(function (e) {
                    var t = [],
                      n = [],
                      r = ge(e.replace(R, '$1'));
                    return r[g]
                      ? te(function (e, t, n, o) {
                          for (var a, i = r(e, null, o, []), l = e.length; l--; ) (a = i[l]) && (e[l] = !(t[l] = a));
                        })
                      : function (e, o, a) {
                          return (t[0] = e), r(t, null, a, n), (t[0] = null), !n.pop();
                        };
                  }),
                  has: te(function (e) {
                    return function (t) {
                      return Z(e, t).length > 0;
                    };
                  }),
                  contains: te(function (e) {
                    return (
                      (e = e.replace(Q, Y)),
                      function (t) {
                        return (t.textContent || E.text(t)).indexOf(e) > -1;
                      }
                    );
                  }),
                  lang: te(function (e) {
                    return (
                      H.test(e || '') || Z.error('unsupported lang: ' + e),
                      (e = e.replace(Q, Y).toLowerCase()),
                      function (t) {
                        var n;
                        do {
                          if ((n = f ? t.lang : t.getAttribute('xml:lang') || t.getAttribute('lang')))
                            return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + '-');
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1;
                      }
                    );
                  }),
                  target: function (e) {
                    var t = r.location && r.location.hash;
                    return t && t.slice(1) === e.id;
                  },
                  root: function (e) {
                    return e === s;
                  },
                  focus: function (e) {
                    return (
                      e ===
                        (function () {
                          try {
                            return u.activeElement;
                          } catch (e) {}
                        })() &&
                      u.hasFocus() &&
                      !!(e.type || e.href || ~e.tabIndex)
                    );
                  },
                  enabled: ae(!1),
                  disabled: ae(!0),
                  checked: function (e) {
                    return (T(e, 'input') && !!e.checked) || (T(e, 'option') && !!e.selected);
                  },
                  selected: function (e) {
                    return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                  },
                  empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                    return !0;
                  },
                  parent: function (e) {
                    return !t.pseudos.empty(e);
                  },
                  header: function (e) {
                    return $.test(e.nodeName);
                  },
                  input: function (e) {
                    return W.test(e.nodeName);
                  },
                  button: function (e) {
                    return (T(e, 'input') && 'button' === e.type) || T(e, 'button');
                  },
                  text: function (e) {
                    var t;
                    return (
                      T(e, 'input') &&
                      'text' === e.type &&
                      (null == (t = e.getAttribute('type')) || 'text' === t.toLowerCase())
                    );
                  },
                  first: ie(function () {
                    return [0];
                  }),
                  last: ie(function (e, t) {
                    return [t - 1];
                  }),
                  eq: ie(function (e, t, n) {
                    return [n < 0 ? n + t : n];
                  }),
                  even: ie(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                  }),
                  odd: ie(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                  }),
                  lt: ie(function (e, t, n) {
                    var r;
                    for (r = n < 0 ? n + t : n > t ? t : n; --r >= 0; ) e.push(r);
                    return e;
                  }),
                  gt: ie(function (e, t, n) {
                    for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
                    return e;
                  }),
                },
              }),
            (t.pseudos.nth = t.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
              t.pseudos[e] = re(e);
            for (e in { submit: !0, reset: !0 }) t.pseudos[e] = oe(e);
            function se() {}
            function ce(e, n) {
              var r,
                o,
                a,
                i,
                l,
                u,
                s,
                c = x[e + ' '];
              if (c) return n ? 0 : c.slice(0);
              for (l = e, u = [], s = t.preFilter; l; ) {
                for (i in ((r && !(o = V.exec(l))) || (o && (l = l.slice(o[0].length) || l), u.push((a = []))),
                (r = !1),
                (o = B.exec(l)) &&
                  ((r = o.shift()), a.push({ value: r, type: o[0].replace(R, ' ') }), (l = l.slice(r.length))),
                t.filter))
                  !(o = q[i].exec(l)) ||
                    (s[i] && !(o = s[i](o))) ||
                    ((r = o.shift()), a.push({ value: r, type: i, matches: o }), (l = l.slice(r.length)));
                if (!r) break;
              }
              return n ? l.length : l ? Z.error(e) : x(e, u).slice(0);
            }
            function fe(e) {
              for (var t = 0, n = e.length, r = ''; t < n; t++) r += e[t].value;
              return r;
            }
            function de(e, t, n) {
              var r = t.dir,
                o = t.next,
                a = o || r,
                i = n && 'parentNode' === a,
                l = y++;
              return t.first
                ? function (t, n, o) {
                    for (; (t = t[r]); ) if (1 === t.nodeType || i) return e(t, n, o);
                    return !1;
                  }
                : function (t, n, u) {
                    var s,
                      c,
                      f = [w, l];
                    if (u) {
                      for (; (t = t[r]); ) if ((1 === t.nodeType || i) && e(t, n, u)) return !0;
                    } else
                      for (; (t = t[r]); )
                        if (1 === t.nodeType || i)
                          if (((c = t[g] || (t[g] = {})), o && T(t, o))) t = t[r] || t;
                          else {
                            if ((s = c[a]) && s[0] === w && s[1] === l) return (f[2] = s[2]);
                            if (((c[a] = f), (f[2] = e(t, n, u)))) return !0;
                          }
                    return !1;
                  };
            }
            function pe(e) {
              return e.length > 1
                ? function (t, n, r) {
                    for (var o = e.length; o--; ) if (!e[o](t, n, r)) return !1;
                    return !0;
                  }
                : e[0];
            }
            function he(e, t, n, r, o) {
              for (var a, i = [], l = 0, u = e.length, s = null != t; l < u; l++)
                (a = e[l]) && ((n && !n(a, r, o)) || (i.push(a), s && t.push(l)));
              return i;
            }
            function ve(e, t, n, r, o, a) {
              return (
                r && !r[g] && (r = ve(r)),
                o && !o[g] && (o = ve(o, a)),
                te(function (a, i, l, u) {
                  var s,
                    f,
                    d,
                    p,
                    h = [],
                    m = [],
                    g = i.length,
                    w =
                      a ||
                      (function (e, t, n) {
                        for (var r = 0, o = t.length; r < o; r++) Z(e, t[r], n);
                        return n;
                      })(t || '*', l.nodeType ? [l] : l, []),
                    y = !e || (!a && t) ? w : he(w, h, e, l, u);
                  if ((n ? n(y, (p = o || (a ? e : g || r) ? [] : i), l, u) : (p = y), r))
                    for (s = he(p, m), r(s, [], l, u), f = s.length; f--; ) (d = s[f]) && (p[m[f]] = !(y[m[f]] = d));
                  if (a) {
                    if (o || e) {
                      if (o) {
                        for (s = [], f = p.length; f--; ) (d = p[f]) && s.push((y[f] = d));
                        o(null, (p = []), s, u);
                      }
                      for (f = p.length; f--; )
                        (d = p[f]) && (s = o ? c.call(a, d) : h[f]) > -1 && (a[s] = !(i[s] = d));
                    }
                  } else (p = he(p === i ? p.splice(g, p.length) : p)), o ? o(null, i, p, u) : v.apply(i, p);
                })
              );
            }
            function me(e) {
              for (
                var r,
                  o,
                  a,
                  i = e.length,
                  l = t.relative[e[0].type],
                  u = l || t.relative[' '],
                  s = l ? 1 : 0,
                  f = de(
                    function (e) {
                      return e === r;
                    },
                    u,
                    !0
                  ),
                  d = de(
                    function (e) {
                      return c.call(r, e) > -1;
                    },
                    u,
                    !0
                  ),
                  p = [
                    function (e, t, o) {
                      var a = (!l && (o || t != n)) || ((r = t).nodeType ? f(e, t, o) : d(e, t, o));
                      return (r = null), a;
                    },
                  ];
                s < i;
                s++
              )
                if ((o = t.relative[e[s].type])) p = [de(pe(p), o)];
                else {
                  if ((o = t.filter[e[s].type].apply(null, e[s].matches))[g]) {
                    for (a = ++s; a < i && !t.relative[e[a].type]; a++);
                    return ve(
                      s > 1 && pe(p),
                      s > 1 &&
                        fe(e.slice(0, s - 1).concat({ value: ' ' === e[s - 2].type ? '*' : '' })).replace(R, '$1'),
                      o,
                      s < a && me(e.slice(s, a)),
                      a < i && me((e = e.slice(a))),
                      a < i && fe(e)
                    );
                  }
                  p.push(o);
                }
              return pe(p);
            }
            function ge(e, r) {
              var o,
                a = [],
                i = [],
                l = k[e + ' '];
              if (!l) {
                for (r || (r = ce(e)), o = r.length; o--; ) (l = me(r[o]))[g] ? a.push(l) : i.push(l);
                (l = k(
                  e,
                  (function (e, r) {
                    var o = r.length > 0,
                      a = e.length > 0,
                      i = function (i, l, s, c, d) {
                        var p,
                          h,
                          m,
                          g = 0,
                          y = '0',
                          b = i && [],
                          x = [],
                          k = n,
                          S = i || (a && t.find.TAG('*', d)),
                          _ = (w += null == k ? 1 : Math.random() || 0.1),
                          C = S.length;
                        for (d && (n = l == u || l || d); y !== C && null != (p = S[y]); y++) {
                          if (a && p) {
                            for (h = 0, l || p.ownerDocument == u || (ue(p), (s = !f)); (m = e[h++]); )
                              if (m(p, l || u, s)) {
                                v.call(c, p);
                                break;
                              }
                            d && (w = _);
                          }
                          o && ((p = !m && p) && g--, i && b.push(p));
                        }
                        if (((g += y), o && y !== g)) {
                          for (h = 0; (m = r[h++]); ) m(b, x, l, s);
                          if (i) {
                            if (g > 0) for (; y--; ) b[y] || x[y] || (x[y] = N.call(c));
                            x = he(x);
                          }
                          v.apply(c, x), d && !i && x.length > 0 && g + r.length > 1 && E.uniqueSort(c);
                        }
                        return d && ((w = _), (n = k)), b;
                      };
                    return o ? te(i) : i;
                  })(i, a)
                )),
                  (l.selector = e);
              }
              return l;
            }
            function we(e, n, r, o) {
              var a,
                i,
                l,
                u,
                s,
                c = 'function' === typeof e && e,
                d = !o && ce((e = c.selector || e));
              if (((r = r || []), 1 === d.length)) {
                if (
                  (i = d[0] = d[0].slice(0)).length > 2 &&
                  'ID' === (l = i[0]).type &&
                  9 === n.nodeType &&
                  f &&
                  t.relative[i[1].type]
                ) {
                  if (!(n = (t.find.ID(l.matches[0].replace(Q, Y), n) || [])[0])) return r;
                  c && (n = n.parentNode), (e = e.slice(i.shift().value.length));
                }
                for (a = q.needsContext.test(e) ? 0 : i.length; a-- && ((l = i[a]), !t.relative[(u = l.type)]); )
                  if (
                    (s = t.find[u]) &&
                    (o = s(l.matches[0].replace(Q, Y), (K.test(i[0].type) && le(n.parentNode)) || n))
                  ) {
                    if ((i.splice(a, 1), !(e = o.length && fe(i)))) return v.apply(r, o), r;
                    break;
                  }
              }
              return (c || ge(e, d))(o, n, !f, r, !n || (K.test(e) && le(n.parentNode)) || n), r;
            }
            (se.prototype = t.filters = t.pseudos),
              (t.setFilters = new se()),
              (m.sortStable = g.split('').sort(_).join('') === g),
              ue(),
              (m.sortDetached = ne(function (e) {
                return 1 & e.compareDocumentPosition(u.createElement('fieldset'));
              })),
              (E.find = Z),
              (E.expr[':'] = E.expr.pseudos),
              (E.unique = E.uniqueSort),
              (Z.compile = ge),
              (Z.select = we),
              (Z.setDocument = ue),
              (Z.tokenize = ce),
              (Z.escape = E.escapeSelector),
              (Z.getText = E.text),
              (Z.isXML = E.isXMLDoc),
              (Z.selectors = E.expr),
              (Z.support = E.support),
              (Z.uniqueSort = E.uniqueSort);
          })();
          var M = function (e, t, n) {
              for (var r = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                if (1 === e.nodeType) {
                  if (o && E(e).is(n)) break;
                  r.push(e);
                }
              return r;
            },
            z = function (e, t) {
              for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
              return n;
            },
            V = E.expr.match.needsContext,
            B = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function F(e, t, n) {
            return g(t)
              ? E.grep(e, function (e, r) {
                  return !!t.call(e, r, e) !== n;
                })
              : t.nodeType
              ? E.grep(e, function (e) {
                  return (e === t) !== n;
                })
              : 'string' !== typeof t
              ? E.grep(e, function (e) {
                  return c.call(t, e) > -1 !== n;
                })
              : E.filter(t, e, n);
          }
          (E.filter = function (e, t, n) {
            var r = t[0];
            return (
              n && (e = ':not(' + e + ')'),
              1 === t.length && 1 === r.nodeType
                ? E.find.matchesSelector(r, e)
                  ? [r]
                  : []
                : E.find.matches(
                    e,
                    E.grep(t, function (e) {
                      return 1 === e.nodeType;
                    })
                  )
            );
          }),
            E.fn.extend({
              find: function (e) {
                var t,
                  n,
                  r = this.length,
                  o = this;
                if ('string' !== typeof e)
                  return this.pushStack(
                    E(e).filter(function () {
                      for (t = 0; t < r; t++) if (E.contains(o[t], this)) return !0;
                    })
                  );
                for (n = this.pushStack([]), t = 0; t < r; t++) E.find(e, o[t], n);
                return r > 1 ? E.uniqueSort(n) : n;
              },
              filter: function (e) {
                return this.pushStack(F(this, e || [], !1));
              },
              not: function (e) {
                return this.pushStack(F(this, e || [], !0));
              },
              is: function (e) {
                return !!F(this, 'string' === typeof e && V.test(e) ? E(e) : e || [], !1).length;
              },
            });
          var U,
            H = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          ((E.fn.init = function (e, t, n) {
            var r, o;
            if (!e) return this;
            if (((n = n || U), 'string' === typeof e)) {
              if (
                !(r = '<' === e[0] && '>' === e[e.length - 1] && e.length >= 3 ? [null, e, null] : H.exec(e)) ||
                (!r[1] && t)
              )
                return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
              if (r[1]) {
                if (
                  ((t = t instanceof E ? t[0] : t),
                  E.merge(this, E.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : y, !0)),
                  B.test(r[1]) && E.isPlainObject(t))
                )
                  for (r in t) g(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                return this;
              }
              return (o = y.getElementById(r[2])) && ((this[0] = o), (this.length = 1)), this;
            }
            return e.nodeType
              ? ((this[0] = e), (this.length = 1), this)
              : g(e)
              ? void 0 !== n.ready
                ? n.ready(e)
                : e(E)
              : E.makeArray(e, this);
          }).prototype = E.fn),
            (U = E(y));
          var q = /^(?:parents|prev(?:Until|All))/,
            W = { children: !0, contents: !0, next: !0, prev: !0 };
          function $(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
          }
          E.fn.extend({
            has: function (e) {
              var t = E(e, this),
                n = t.length;
              return this.filter(function () {
                for (var e = 0; e < n; e++) if (E.contains(this, t[e])) return !0;
              });
            },
            closest: function (e, t) {
              var n,
                r = 0,
                o = this.length,
                a = [],
                i = 'string' !== typeof e && E(e);
              if (!V.test(e))
                for (; r < o; r++)
                  for (n = this[r]; n && n !== t; n = n.parentNode)
                    if (n.nodeType < 11 && (i ? i.index(n) > -1 : 1 === n.nodeType && E.find.matchesSelector(n, e))) {
                      a.push(n);
                      break;
                    }
              return this.pushStack(a.length > 1 ? E.uniqueSort(a) : a);
            },
            index: function (e) {
              return e
                ? 'string' === typeof e
                  ? c.call(E(e), this[0])
                  : c.call(this, e.jquery ? e[0] : e)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
            },
            add: function (e, t) {
              return this.pushStack(E.uniqueSort(E.merge(this.get(), E(e, t))));
            },
            addBack: function (e) {
              return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            },
          }),
            E.each(
              {
                parent: function (e) {
                  var t = e.parentNode;
                  return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                  return M(e, 'parentNode');
                },
                parentsUntil: function (e, t, n) {
                  return M(e, 'parentNode', n);
                },
                next: function (e) {
                  return $(e, 'nextSibling');
                },
                prev: function (e) {
                  return $(e, 'previousSibling');
                },
                nextAll: function (e) {
                  return M(e, 'nextSibling');
                },
                prevAll: function (e) {
                  return M(e, 'previousSibling');
                },
                nextUntil: function (e, t, n) {
                  return M(e, 'nextSibling', n);
                },
                prevUntil: function (e, t, n) {
                  return M(e, 'previousSibling', n);
                },
                siblings: function (e) {
                  return z((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                  return z(e.firstChild);
                },
                contents: function (e) {
                  return null != e.contentDocument && i(e.contentDocument)
                    ? e.contentDocument
                    : (T(e, 'template') && (e = e.content || e), E.merge([], e.childNodes));
                },
              },
              function (e, t) {
                E.fn[e] = function (n, r) {
                  var o = E.map(this, t, n);
                  return (
                    'Until' !== e.slice(-5) && (r = n),
                    r && 'string' === typeof r && (o = E.filter(r, o)),
                    this.length > 1 && (W[e] || E.uniqueSort(o), q.test(e) && o.reverse()),
                    this.pushStack(o)
                  );
                };
              }
            );
          var G = /[^\x20\t\r\n\f]+/g;
          function K(e) {
            return e;
          }
          function Q(e) {
            throw e;
          }
          function Y(e, t, n, r) {
            var o;
            try {
              e && g((o = e.promise))
                ? o.call(e).done(t).fail(n)
                : e && g((o = e.then))
                ? o.call(e, t, n)
                : t.apply(void 0, [e].slice(r));
            } catch (e) {
              n.apply(void 0, [e]);
            }
          }
          (E.Callbacks = function (e) {
            e =
              'string' === typeof e
                ? (function (e) {
                    var t = {};
                    return (
                      E.each(e.match(G) || [], function (e, n) {
                        t[n] = !0;
                      }),
                      t
                    );
                  })(e)
                : E.extend({}, e);
            var t,
              n,
              r,
              o,
              a = [],
              i = [],
              l = -1,
              u = function () {
                for (o = o || e.once, r = t = !0; i.length; l = -1)
                  for (n = i.shift(); ++l < a.length; )
                    !1 === a[l].apply(n[0], n[1]) && e.stopOnFalse && ((l = a.length), (n = !1));
                e.memory || (n = !1), (t = !1), o && (a = n ? [] : '');
              },
              s = {
                add: function () {
                  return (
                    a &&
                      (n && !t && ((l = a.length - 1), i.push(n)),
                      (function t(n) {
                        E.each(n, function (n, r) {
                          g(r) ? (e.unique && s.has(r)) || a.push(r) : r && r.length && 'string' !== k(r) && t(r);
                        });
                      })(arguments),
                      n && !t && u()),
                    this
                  );
                },
                remove: function () {
                  return (
                    E.each(arguments, function (e, t) {
                      for (var n; (n = E.inArray(t, a, n)) > -1; ) a.splice(n, 1), n <= l && l--;
                    }),
                    this
                  );
                },
                has: function (e) {
                  return e ? E.inArray(e, a) > -1 : a.length > 0;
                },
                empty: function () {
                  return a && (a = []), this;
                },
                disable: function () {
                  return (o = i = []), (a = n = ''), this;
                },
                disabled: function () {
                  return !a;
                },
                lock: function () {
                  return (o = i = []), n || t || (a = n = ''), this;
                },
                locked: function () {
                  return !!o;
                },
                fireWith: function (e, n) {
                  return o || ((n = [e, (n = n || []).slice ? n.slice() : n]), i.push(n), t || u()), this;
                },
                fire: function () {
                  return s.fireWith(this, arguments), this;
                },
                fired: function () {
                  return !!r;
                },
              };
            return s;
          }),
            E.extend({
              Deferred: function (e) {
                var t = [
                    ['notify', 'progress', E.Callbacks('memory'), E.Callbacks('memory'), 2],
                    ['resolve', 'done', E.Callbacks('once memory'), E.Callbacks('once memory'), 0, 'resolved'],
                    ['reject', 'fail', E.Callbacks('once memory'), E.Callbacks('once memory'), 1, 'rejected'],
                  ],
                  n = 'pending',
                  o = {
                    state: function () {
                      return n;
                    },
                    always: function () {
                      return a.done(arguments).fail(arguments), this;
                    },
                    catch: function (e) {
                      return o.then(null, e);
                    },
                    pipe: function () {
                      var e = arguments;
                      return E.Deferred(function (n) {
                        E.each(t, function (t, r) {
                          var o = g(e[r[4]]) && e[r[4]];
                          a[r[1]](function () {
                            var e = o && o.apply(this, arguments);
                            e && g(e.promise)
                              ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject)
                              : n[r[0] + 'With'](this, o ? [e] : arguments);
                          });
                        }),
                          (e = null);
                      }).promise();
                    },
                    then: function (e, n, o) {
                      var a = 0;
                      function i(e, t, n, o) {
                        return function () {
                          var l = this,
                            u = arguments,
                            s = function () {
                              var r, s;
                              if (!(e < a)) {
                                if ((r = n.apply(l, u)) === t.promise())
                                  throw new TypeError('Thenable self-resolution');
                                (s = r && ('object' === typeof r || 'function' === typeof r) && r.then),
                                  g(s)
                                    ? o
                                      ? s.call(r, i(a, t, K, o), i(a, t, Q, o))
                                      : (a++, s.call(r, i(a, t, K, o), i(a, t, Q, o), i(a, t, K, t.notifyWith)))
                                    : (n !== K && ((l = void 0), (u = [r])), (o || t.resolveWith)(l, u));
                              }
                            },
                            c = o
                              ? s
                              : function () {
                                  try {
                                    s();
                                  } catch (r) {
                                    E.Deferred.exceptionHook && E.Deferred.exceptionHook(r, c.error),
                                      e + 1 >= a && (n !== Q && ((l = void 0), (u = [r])), t.rejectWith(l, u));
                                  }
                                };
                          e
                            ? c()
                            : (E.Deferred.getErrorHook
                                ? (c.error = E.Deferred.getErrorHook())
                                : E.Deferred.getStackHook && (c.error = E.Deferred.getStackHook()),
                              r.setTimeout(c));
                        };
                      }
                      return E.Deferred(function (r) {
                        t[0][3].add(i(0, r, g(o) ? o : K, r.notifyWith)),
                          t[1][3].add(i(0, r, g(e) ? e : K)),
                          t[2][3].add(i(0, r, g(n) ? n : Q));
                      }).promise();
                    },
                    promise: function (e) {
                      return null != e ? E.extend(e, o) : o;
                    },
                  },
                  a = {};
                return (
                  E.each(t, function (e, r) {
                    var i = r[2],
                      l = r[5];
                    (o[r[1]] = i.add),
                      l &&
                        i.add(
                          function () {
                            n = l;
                          },
                          t[3 - e][2].disable,
                          t[3 - e][3].disable,
                          t[0][2].lock,
                          t[0][3].lock
                        ),
                      i.add(r[3].fire),
                      (a[r[0]] = function () {
                        return a[r[0] + 'With'](this === a ? void 0 : this, arguments), this;
                      }),
                      (a[r[0] + 'With'] = i.fireWith);
                  }),
                  o.promise(a),
                  e && e.call(a, a),
                  a
                );
              },
              when: function (e) {
                var t = arguments.length,
                  n = t,
                  r = Array(n),
                  o = l.call(arguments),
                  a = E.Deferred(),
                  i = function (e) {
                    return function (n) {
                      (r[e] = this), (o[e] = arguments.length > 1 ? l.call(arguments) : n), --t || a.resolveWith(r, o);
                    };
                  };
                if (
                  t <= 1 &&
                  (Y(e, a.done(i(n)).resolve, a.reject, !t), 'pending' === a.state() || g(o[n] && o[n].then))
                )
                  return a.then();
                for (; n--; ) Y(o[n], i(n), a.reject);
                return a.promise();
              },
            });
          var X = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          (E.Deferred.exceptionHook = function (e, t) {
            r.console &&
              r.console.warn &&
              e &&
              X.test(e.name) &&
              r.console.warn('jQuery.Deferred exception: ' + e.message, e.stack, t);
          }),
            (E.readyException = function (e) {
              r.setTimeout(function () {
                throw e;
              });
            });
          var J = E.Deferred();
          function Z() {
            y.removeEventListener('DOMContentLoaded', Z), r.removeEventListener('load', Z), E.ready();
          }
          (E.fn.ready = function (e) {
            return (
              J.then(e).catch(function (e) {
                E.readyException(e);
              }),
              this
            );
          }),
            E.extend({
              isReady: !1,
              readyWait: 1,
              ready: function (e) {
                (!0 === e ? --E.readyWait : E.isReady) ||
                  ((E.isReady = !0), (!0 !== e && --E.readyWait > 0) || J.resolveWith(y, [E]));
              },
            }),
            (E.ready.then = J.then),
            'complete' === y.readyState || ('loading' !== y.readyState && !y.documentElement.doScroll)
              ? r.setTimeout(E.ready)
              : (y.addEventListener('DOMContentLoaded', Z), r.addEventListener('load', Z));
          var ee = function e(t, n, r, o, a, i, l) {
              var u = 0,
                s = t.length,
                c = null == r;
              if ('object' === k(r)) for (u in ((a = !0), r)) e(t, n, u, r[u], !0, i, l);
              else if (
                void 0 !== o &&
                ((a = !0),
                g(o) || (l = !0),
                c &&
                  (l
                    ? (n.call(t, o), (n = null))
                    : ((c = n),
                      (n = function (e, t, n) {
                        return c.call(E(e), n);
                      }))),
                n)
              )
                for (; u < s; u++) n(t[u], r, l ? o : o.call(t[u], u, n(t[u], r)));
              return a ? t : c ? n.call(t) : s ? n(t[0], r) : i;
            },
            te = /^-ms-/,
            ne = /-([a-z])/g;
          function re(e, t) {
            return t.toUpperCase();
          }
          function oe(e) {
            return e.replace(te, 'ms-').replace(ne, re);
          }
          var ae = function (e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
          };
          function ie() {
            this.expando = E.expando + ie.uid++;
          }
          (ie.uid = 1),
            (ie.prototype = {
              cache: function (e) {
                var t = e[this.expando];
                return (
                  t ||
                    ((t = {}),
                    ae(e) &&
                      (e.nodeType
                        ? (e[this.expando] = t)
                        : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))),
                  t
                );
              },
              set: function (e, t, n) {
                var r,
                  o = this.cache(e);
                if ('string' === typeof t) o[oe(t)] = n;
                else for (r in t) o[oe(r)] = t[r];
                return o;
              },
              get: function (e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][oe(t)];
              },
              access: function (e, t, n) {
                return void 0 === t || (t && 'string' === typeof t && void 0 === n)
                  ? this.get(e, t)
                  : (this.set(e, t, n), void 0 !== n ? n : t);
              },
              remove: function (e, t) {
                var n,
                  r = e[this.expando];
                if (void 0 !== r) {
                  if (void 0 !== t) {
                    n = (t = Array.isArray(t) ? t.map(oe) : (t = oe(t)) in r ? [t] : t.match(G) || []).length;
                    for (; n--; ) delete r[t[n]];
                  }
                  (void 0 === t || E.isEmptyObject(r)) &&
                    (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
              },
              hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !E.isEmptyObject(t);
              },
            });
          var le = new ie(),
            ue = new ie(),
            se = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            ce = /[A-Z]/g;
          function fe(e, t, n) {
            var r;
            if (void 0 === n && 1 === e.nodeType)
              if (((r = 'data-' + t.replace(ce, '-$&').toLowerCase()), 'string' === typeof (n = e.getAttribute(r)))) {
                try {
                  n = (function (e) {
                    return (
                      'true' === e ||
                      ('false' !== e && ('null' === e ? null : e === +e + '' ? +e : se.test(e) ? JSON.parse(e) : e))
                    );
                  })(n);
                } catch (o) {}
                ue.set(e, t, n);
              } else n = void 0;
            return n;
          }
          E.extend({
            hasData: function (e) {
              return ue.hasData(e) || le.hasData(e);
            },
            data: function (e, t, n) {
              return ue.access(e, t, n);
            },
            removeData: function (e, t) {
              ue.remove(e, t);
            },
            _data: function (e, t, n) {
              return le.access(e, t, n);
            },
            _removeData: function (e, t) {
              le.remove(e, t);
            },
          }),
            E.fn.extend({
              data: function (e, t) {
                var n,
                  r,
                  o,
                  a = this[0],
                  i = a && a.attributes;
                if (void 0 === e) {
                  if (this.length && ((o = ue.get(a)), 1 === a.nodeType && !le.get(a, 'hasDataAttrs'))) {
                    for (n = i.length; n--; )
                      i[n] && 0 === (r = i[n].name).indexOf('data-') && ((r = oe(r.slice(5))), fe(a, r, o[r]));
                    le.set(a, 'hasDataAttrs', !0);
                  }
                  return o;
                }
                return 'object' === typeof e
                  ? this.each(function () {
                      ue.set(this, e);
                    })
                  : ee(
                      this,
                      function (t) {
                        var n;
                        if (a && void 0 === t)
                          return void 0 !== (n = ue.get(a, e)) || void 0 !== (n = fe(a, e)) ? n : void 0;
                        this.each(function () {
                          ue.set(this, e, t);
                        });
                      },
                      null,
                      t,
                      arguments.length > 1,
                      null,
                      !0
                    );
              },
              removeData: function (e) {
                return this.each(function () {
                  ue.remove(this, e);
                });
              },
            }),
            E.extend({
              queue: function (e, t, n) {
                var r;
                if (e)
                  return (
                    (t = (t || 'fx') + 'queue'),
                    (r = le.get(e, t)),
                    n && (!r || Array.isArray(n) ? (r = le.access(e, t, E.makeArray(n))) : r.push(n)),
                    r || []
                  );
              },
              dequeue: function (e, t) {
                var n = E.queue(e, (t = t || 'fx')),
                  r = n.length,
                  o = n.shift(),
                  a = E._queueHooks(e, t);
                'inprogress' === o && ((o = n.shift()), r--),
                  o &&
                    ('fx' === t && n.unshift('inprogress'),
                    delete a.stop,
                    o.call(
                      e,
                      function () {
                        E.dequeue(e, t);
                      },
                      a
                    )),
                  !r && a && a.empty.fire();
              },
              _queueHooks: function (e, t) {
                var n = t + 'queueHooks';
                return (
                  le.get(e, n) ||
                  le.access(e, n, {
                    empty: E.Callbacks('once memory').add(function () {
                      le.remove(e, [t + 'queue', n]);
                    }),
                  })
                );
              },
            }),
            E.fn.extend({
              queue: function (e, t) {
                var n = 2;
                return (
                  'string' !== typeof e && ((t = e), (e = 'fx'), n--),
                  arguments.length < n
                    ? E.queue(this[0], e)
                    : void 0 === t
                    ? this
                    : this.each(function () {
                        var n = E.queue(this, e, t);
                        E._queueHooks(this, e), 'fx' === e && 'inprogress' !== n[0] && E.dequeue(this, e);
                      })
                );
              },
              dequeue: function (e) {
                return this.each(function () {
                  E.dequeue(this, e);
                });
              },
              clearQueue: function (e) {
                return this.queue(e || 'fx', []);
              },
              promise: function (e, t) {
                var n,
                  r = 1,
                  o = E.Deferred(),
                  a = this,
                  i = this.length,
                  l = function () {
                    --r || o.resolveWith(a, [a]);
                  };
                for ('string' !== typeof e && ((t = e), (e = void 0)), e = e || 'fx'; i--; )
                  (n = le.get(a[i], e + 'queueHooks')) && n.empty && (r++, n.empty.add(l));
                return l(), o.promise(t);
              },
            });
          var de = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            pe = new RegExp('^(?:([+-])=|)(' + de + ')([a-z%]*)$', 'i'),
            he = ['Top', 'Right', 'Bottom', 'Left'],
            ve = y.documentElement,
            me = function (e) {
              return E.contains(e.ownerDocument, e);
            },
            ge = { composed: !0 };
          ve.getRootNode &&
            (me = function (e) {
              return E.contains(e.ownerDocument, e) || e.getRootNode(ge) === e.ownerDocument;
            });
          var we = function (e, t) {
            return (
              'none' === (e = t || e).style.display ||
              ('' === e.style.display && me(e) && 'none' === E.css(e, 'display'))
            );
          };
          function ye(e, t, n, r) {
            var o,
              a,
              i = 20,
              l = r
                ? function () {
                    return r.cur();
                  }
                : function () {
                    return E.css(e, t, '');
                  },
              u = l(),
              s = (n && n[3]) || (E.cssNumber[t] ? '' : 'px'),
              c = e.nodeType && (E.cssNumber[t] || ('px' !== s && +u)) && pe.exec(E.css(e, t));
            if (c && c[3] !== s) {
              for (u /= 2, s = s || c[3], c = +u || 1; i--; )
                E.style(e, t, c + s), (1 - a) * (1 - (a = l() / u || 0.5)) <= 0 && (i = 0), (c /= a);
              E.style(e, t, (c *= 2) + s), (n = n || []);
            }
            return (
              n &&
                ((c = +c || +u || 0),
                (o = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
                r && ((r.unit = s), (r.start = c), (r.end = o))),
              o
            );
          }
          var be = {};
          function xe(e) {
            var t,
              n = e.ownerDocument,
              r = e.nodeName,
              o = be[r];
            return (
              o ||
              ((t = n.body.appendChild(n.createElement(r))),
              (o = E.css(t, 'display')),
              t.parentNode.removeChild(t),
              'none' === o && (o = 'block'),
              (be[r] = o),
              o)
            );
          }
          function ke(e, t) {
            for (var n, r, o = [], a = 0, i = e.length; a < i; a++)
              (r = e[a]).style &&
                ((n = r.style.display),
                t
                  ? ('none' === n && ((o[a] = le.get(r, 'display') || null), o[a] || (r.style.display = '')),
                    '' === r.style.display && we(r) && (o[a] = xe(r)))
                  : 'none' !== n && ((o[a] = 'none'), le.set(r, 'display', n)));
            for (a = 0; a < i; a++) null != o[a] && (e[a].style.display = o[a]);
            return e;
          }
          E.fn.extend({
            show: function () {
              return ke(this, !0);
            },
            hide: function () {
              return ke(this);
            },
            toggle: function (e) {
              return 'boolean' === typeof e
                ? e
                  ? this.show()
                  : this.hide()
                : this.each(function () {
                    we(this) ? E(this).show() : E(this).hide();
                  });
            },
          });
          var Se = /^(?:checkbox|radio)$/i,
            _e = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            Ee = /^$|^module$|\/(?:java|ecma)script/i;
          !(function () {
            var e = y.createDocumentFragment().appendChild(y.createElement('div')),
              t = y.createElement('input');
            t.setAttribute('type', 'radio'),
              t.setAttribute('checked', 'checked'),
              t.setAttribute('name', 't'),
              e.appendChild(t),
              (m.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked),
              (e.innerHTML = '<textarea>x</textarea>'),
              (m.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue),
              (e.innerHTML = '<option></option>'),
              (m.option = !!e.lastChild);
          })();
          var Ce = {
            thead: [1, '<table>', '</table>'],
            col: [2, '<table><colgroup>', '</colgroup></table>'],
            tr: [2, '<table><tbody>', '</tbody></table>'],
            td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
            _default: [0, '', ''],
          };
          function Te(e, t) {
            var n;
            return (
              (n =
                'undefined' !== typeof e.getElementsByTagName
                  ? e.getElementsByTagName(t || '*')
                  : 'undefined' !== typeof e.querySelectorAll
                  ? e.querySelectorAll(t || '*')
                  : []),
              void 0 === t || (t && T(e, t)) ? E.merge([e], n) : n
            );
          }
          function Ne(e, t) {
            for (var n = 0, r = e.length; n < r; n++) le.set(e[n], 'globalEval', !t || le.get(t[n], 'globalEval'));
          }
          (Ce.tbody = Ce.tfoot = Ce.colgroup = Ce.caption = Ce.thead),
            (Ce.th = Ce.td),
            m.option || (Ce.optgroup = Ce.option = [1, "<select multiple='multiple'>", '</select>']);
          var je = /<|&#?\w+;/;
          function Le(e, t, n, r, o) {
            for (var a, i, l, u, s, c, f = t.createDocumentFragment(), d = [], p = 0, h = e.length; p < h; p++)
              if ((a = e[p]) || 0 === a)
                if ('object' === k(a)) E.merge(d, a.nodeType ? [a] : a);
                else if (je.test(a)) {
                  for (
                    i = i || f.appendChild(t.createElement('div')),
                      l = (_e.exec(a) || ['', ''])[1].toLowerCase(),
                      u = Ce[l] || Ce._default,
                      i.innerHTML = u[1] + E.htmlPrefilter(a) + u[2],
                      c = u[0];
                    c--;

                  )
                    i = i.lastChild;
                  E.merge(d, i.childNodes), ((i = f.firstChild).textContent = '');
                } else d.push(t.createTextNode(a));
            for (f.textContent = '', p = 0; (a = d[p++]); )
              if (r && E.inArray(a, r) > -1) o && o.push(a);
              else if (((s = me(a)), (i = Te(f.appendChild(a), 'script')), s && Ne(i), n))
                for (c = 0; (a = i[c++]); ) Ee.test(a.type || '') && n.push(a);
            return f;
          }
          var Ae = /^([^.]*)(?:\.(.+)|)/;
          function Re() {
            return !0;
          }
          function Pe() {
            return !1;
          }
          function Oe(e, t, n, r, o, a) {
            var i, l;
            if ('object' === typeof t) {
              for (l in ('string' !== typeof n && ((r = r || n), (n = void 0)), t)) Oe(e, l, n, r, t[l], a);
              return e;
            }
            if (
              (null == r && null == o
                ? ((o = n), (r = n = void 0))
                : null == o && ('string' === typeof n ? ((o = r), (r = void 0)) : ((o = r), (r = n), (n = void 0))),
              !1 === o)
            )
              o = Pe;
            else if (!o) return e;
            return (
              1 === a &&
                ((i = o),
                (o = function (e) {
                  return E().off(e), i.apply(this, arguments);
                }),
                (o.guid = i.guid || (i.guid = E.guid++))),
              e.each(function () {
                E.event.add(this, t, o, r, n);
              })
            );
          }
          function De(e, t, n) {
            n
              ? (le.set(e, t, !1),
                E.event.add(e, t, {
                  namespace: !1,
                  handler: function (e) {
                    var n,
                      r = le.get(this, t);
                    if (1 & e.isTrigger && this[t]) {
                      if (r) (E.event.special[t] || {}).delegateType && e.stopPropagation();
                      else if (
                        ((r = l.call(arguments)),
                        le.set(this, t, r),
                        this[t](),
                        (n = le.get(this, t)),
                        le.set(this, t, !1),
                        r !== n)
                      )
                        return e.stopImmediatePropagation(), e.preventDefault(), n;
                    } else
                      r &&
                        (le.set(this, t, E.event.trigger(r[0], r.slice(1), this)),
                        e.stopPropagation(),
                        (e.isImmediatePropagationStopped = Re));
                  },
                }))
              : void 0 === le.get(e, t) && E.event.add(e, t, Re);
          }
          (E.event = {
            global: {},
            add: function (e, t, n, r, o) {
              var a,
                i,
                l,
                u,
                s,
                c,
                f,
                d,
                p,
                h,
                v,
                m = le.get(e);
              if (ae(e))
                for (
                  n.handler && ((n = (a = n).handler), (o = a.selector)),
                    o && E.find.matchesSelector(ve, o),
                    n.guid || (n.guid = E.guid++),
                    (u = m.events) || (u = m.events = Object.create(null)),
                    (i = m.handle) ||
                      (i = m.handle =
                        function (t) {
                          return E.event.triggered !== t.type ? E.event.dispatch.apply(e, arguments) : void 0;
                        }),
                    s = (t = (t || '').match(G) || ['']).length;
                  s--;

                )
                  (p = v = (l = Ae.exec(t[s]) || [])[1]),
                    (h = (l[2] || '').split('.').sort()),
                    p &&
                      ((f = E.event.special[p] || {}),
                      (p = (o ? f.delegateType : f.bindType) || p),
                      (f = E.event.special[p] || {}),
                      (c = E.extend(
                        {
                          type: p,
                          origType: v,
                          data: r,
                          handler: n,
                          guid: n.guid,
                          selector: o,
                          needsContext: o && E.expr.match.needsContext.test(o),
                          namespace: h.join('.'),
                        },
                        a
                      )),
                      (d = u[p]) ||
                        (((d = u[p] = []).delegateCount = 0),
                        (f.setup && !1 !== f.setup.call(e, r, h, i)) ||
                          (e.addEventListener && e.addEventListener(p, i))),
                      f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
                      o ? d.splice(d.delegateCount++, 0, c) : d.push(c),
                      (E.event.global[p] = !0));
            },
            remove: function (e, t, n, r, o) {
              var a,
                i,
                l,
                u,
                s,
                c,
                f,
                d,
                p,
                h,
                v,
                m = le.hasData(e) && le.get(e);
              if (m && (u = m.events)) {
                for (s = (t = (t || '').match(G) || ['']).length; s--; )
                  if (((p = v = (l = Ae.exec(t[s]) || [])[1]), (h = (l[2] || '').split('.').sort()), p)) {
                    for (
                      f = E.event.special[p] || {},
                        d = u[(p = (r ? f.delegateType : f.bindType) || p)] || [],
                        l = l[2] && new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)'),
                        i = a = d.length;
                      a--;

                    )
                      (c = d[a]),
                        (!o && v !== c.origType) ||
                          (n && n.guid !== c.guid) ||
                          (l && !l.test(c.namespace)) ||
                          (r && r !== c.selector && ('**' !== r || !c.selector)) ||
                          (d.splice(a, 1), c.selector && d.delegateCount--, f.remove && f.remove.call(e, c));
                    i &&
                      !d.length &&
                      ((f.teardown && !1 !== f.teardown.call(e, h, m.handle)) || E.removeEvent(e, p, m.handle),
                      delete u[p]);
                  } else for (p in u) E.event.remove(e, p + t[s], n, r, !0);
                E.isEmptyObject(u) && le.remove(e, 'handle events');
              }
            },
            dispatch: function (e) {
              var t,
                n,
                r,
                o,
                a,
                i,
                l = new Array(arguments.length),
                u = E.event.fix(e),
                s = (le.get(this, 'events') || Object.create(null))[u.type] || [],
                c = E.event.special[u.type] || {};
              for (l[0] = u, t = 1; t < arguments.length; t++) l[t] = arguments[t];
              if (((u.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, u))) {
                for (i = E.event.handlers.call(this, u, s), t = 0; (o = i[t++]) && !u.isPropagationStopped(); )
                  for (u.currentTarget = o.elem, n = 0; (a = o.handlers[n++]) && !u.isImmediatePropagationStopped(); )
                    (u.rnamespace && !1 !== a.namespace && !u.rnamespace.test(a.namespace)) ||
                      ((u.handleObj = a),
                      (u.data = a.data),
                      void 0 !== (r = ((E.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, l)) &&
                        !1 === (u.result = r) &&
                        (u.preventDefault(), u.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, u), u.result;
              }
            },
            handlers: function (e, t) {
              var n,
                r,
                o,
                a,
                i,
                l = [],
                u = t.delegateCount,
                s = e.target;
              if (u && s.nodeType && !('click' === e.type && e.button >= 1))
                for (; s !== this; s = s.parentNode || this)
                  if (1 === s.nodeType && ('click' !== e.type || !0 !== s.disabled)) {
                    for (a = [], i = {}, n = 0; n < u; n++)
                      void 0 === i[(o = (r = t[n]).selector + ' ')] &&
                        (i[o] = r.needsContext ? E(o, this).index(s) > -1 : E.find(o, this, null, [s]).length),
                        i[o] && a.push(r);
                    a.length && l.push({ elem: s, handlers: a });
                  }
              return (s = this), u < t.length && l.push({ elem: s, handlers: t.slice(u) }), l;
            },
            addProp: function (e, t) {
              Object.defineProperty(E.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: g(t)
                  ? function () {
                      if (this.originalEvent) return t(this.originalEvent);
                    }
                  : function () {
                      if (this.originalEvent) return this.originalEvent[e];
                    },
                set: function (t) {
                  Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                },
              });
            },
            fix: function (e) {
              return e[E.expando] ? e : new E.Event(e);
            },
            special: {
              load: { noBubble: !0 },
              click: {
                setup: function (e) {
                  var t = this || e;
                  return Se.test(t.type) && t.click && T(t, 'input') && De(t, 'click', !0), !1;
                },
                trigger: function (e) {
                  var t = this || e;
                  return Se.test(t.type) && t.click && T(t, 'input') && De(t, 'click'), !0;
                },
                _default: function (e) {
                  var t = e.target;
                  return (Se.test(t.type) && t.click && T(t, 'input') && le.get(t, 'click')) || T(t, 'a');
                },
              },
              beforeunload: {
                postDispatch: function (e) {
                  void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
              },
            },
          }),
            (E.removeEvent = function (e, t, n) {
              e.removeEventListener && e.removeEventListener(t, n);
            }),
            ((E.Event = function (e, t) {
              if (!(this instanceof E.Event)) return new E.Event(e, t);
              e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented =
                    e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? Re : Pe),
                  (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && E.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[E.expando] = !0);
            }).prototype = {
              constructor: E.Event,
              isDefaultPrevented: Pe,
              isPropagationStopped: Pe,
              isImmediatePropagationStopped: Pe,
              isSimulated: !1,
              preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = Re), e && !this.isSimulated && e.preventDefault();
              },
              stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = Re), e && !this.isSimulated && e.stopPropagation();
              },
              stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = Re),
                  e && !this.isSimulated && e.stopImmediatePropagation(),
                  this.stopPropagation();
              },
            }),
            E.each(
              {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: !0,
              },
              E.event.addProp
            ),
            E.each({ focus: 'focusin', blur: 'focusout' }, function (e, t) {
              function n(e) {
                if (y.documentMode) {
                  var n = le.get(this, 'handle'),
                    r = E.event.fix(e);
                  (r.type = 'focusin' === e.type ? 'focus' : 'blur'),
                    (r.isSimulated = !0),
                    n(e),
                    r.target === r.currentTarget && n(r);
                } else E.event.simulate(t, e.target, E.event.fix(e));
              }
              (E.event.special[e] = {
                setup: function () {
                  var r;
                  if ((De(this, e, !0), !y.documentMode)) return !1;
                  (r = le.get(this, t)) || this.addEventListener(t, n), le.set(this, t, (r || 0) + 1);
                },
                trigger: function () {
                  return De(this, e), !0;
                },
                teardown: function () {
                  var e;
                  if (!y.documentMode) return !1;
                  (e = le.get(this, t) - 1) ? le.set(this, t, e) : (this.removeEventListener(t, n), le.remove(this, t));
                },
                _default: function (t) {
                  return le.get(t.target, e);
                },
                delegateType: t,
              }),
                (E.event.special[t] = {
                  setup: function () {
                    var r = this.ownerDocument || this.document || this,
                      o = y.documentMode ? this : r,
                      a = le.get(o, t);
                    a || (y.documentMode ? this.addEventListener(t, n) : r.addEventListener(e, n, !0)),
                      le.set(o, t, (a || 0) + 1);
                  },
                  teardown: function () {
                    var r = this.ownerDocument || this.document || this,
                      o = y.documentMode ? this : r,
                      a = le.get(o, t) - 1;
                    a
                      ? le.set(o, t, a)
                      : (y.documentMode ? this.removeEventListener(t, n) : r.removeEventListener(e, n, !0),
                        le.remove(o, t));
                  },
                });
            }),
            E.each(
              {
                mouseenter: 'mouseover',
                mouseleave: 'mouseout',
                pointerenter: 'pointerover',
                pointerleave: 'pointerout',
              },
              function (e, t) {
                E.event.special[e] = {
                  delegateType: t,
                  bindType: t,
                  handle: function (e) {
                    var n,
                      r = this,
                      o = e.relatedTarget,
                      a = e.handleObj;
                    return (
                      (o && (o === r || E.contains(r, o))) ||
                        ((e.type = a.origType), (n = a.handler.apply(this, arguments)), (e.type = t)),
                      n
                    );
                  },
                };
              }
            ),
            E.fn.extend({
              on: function (e, t, n, r) {
                return Oe(this, e, t, n, r);
              },
              one: function (e, t, n, r) {
                return Oe(this, e, t, n, r, 1);
              },
              off: function (e, t, n) {
                var r, o;
                if (e && e.preventDefault && e.handleObj)
                  return (
                    (r = e.handleObj),
                    E(e.delegateTarget).off(
                      r.namespace ? r.origType + '.' + r.namespace : r.origType,
                      r.selector,
                      r.handler
                    ),
                    this
                  );
                if ('object' === typeof e) {
                  for (o in e) this.off(o, t, e[o]);
                  return this;
                }
                return (
                  (!1 !== t && 'function' !== typeof t) || ((n = t), (t = void 0)),
                  !1 === n && (n = Pe),
                  this.each(function () {
                    E.event.remove(this, e, n, t);
                  })
                );
              },
            });
          var Ie = /<script|<style|<link/i,
            Me = /checked\s*(?:[^=]|=\s*.checked.)/i,
            ze = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
          function Ve(e, t) {
            return (T(e, 'table') && T(11 !== t.nodeType ? t : t.firstChild, 'tr') && E(e).children('tbody')[0]) || e;
          }
          function Be(e) {
            return (e.type = (null !== e.getAttribute('type')) + '/' + e.type), e;
          }
          function Fe(e) {
            return 'true/' === (e.type || '').slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute('type'), e;
          }
          function Ue(e, t) {
            var n, r, o, a, i, l;
            if (1 === t.nodeType) {
              if (le.hasData(e) && (l = le.get(e).events))
                for (o in (le.remove(t, 'handle events'), l))
                  for (n = 0, r = l[o].length; n < r; n++) E.event.add(t, o, l[o][n]);
              ue.hasData(e) && ((a = ue.access(e)), (i = E.extend({}, a)), ue.set(t, i));
            }
          }
          function He(e, t) {
            var n = t.nodeName.toLowerCase();
            'input' === n && Se.test(e.type)
              ? (t.checked = e.checked)
              : ('input' !== n && 'textarea' !== n) || (t.defaultValue = e.defaultValue);
          }
          function qe(e, t, n, r) {
            t = u(t);
            var o,
              a,
              i,
              l,
              s,
              c,
              f = 0,
              d = e.length,
              p = d - 1,
              h = t[0],
              v = g(h);
            if (v || (d > 1 && 'string' === typeof h && !m.checkClone && Me.test(h)))
              return e.each(function (o) {
                var a = e.eq(o);
                v && (t[0] = h.call(this, o, a.html())), qe(a, t, n, r);
              });
            if (
              d &&
              ((a = (o = Le(t, e[0].ownerDocument, !1, e, r)).firstChild), 1 === o.childNodes.length && (o = a), a || r)
            ) {
              for (l = (i = E.map(Te(o, 'script'), Be)).length; f < d; f++)
                (s = o), f !== p && ((s = E.clone(s, !0, !0)), l && E.merge(i, Te(s, 'script'))), n.call(e[f], s, f);
              if (l)
                for (c = i[i.length - 1].ownerDocument, E.map(i, Fe), f = 0; f < l; f++)
                  (s = i[f]),
                    Ee.test(s.type || '') &&
                      !le.access(s, 'globalEval') &&
                      E.contains(c, s) &&
                      (s.src && 'module' !== (s.type || '').toLowerCase()
                        ? E._evalUrl &&
                          !s.noModule &&
                          E._evalUrl(s.src, { nonce: s.nonce || s.getAttribute('nonce') }, c)
                        : x(s.textContent.replace(ze, ''), s, c));
            }
            return e;
          }
          function We(e, t, n) {
            for (var r, o = t ? E.filter(t, e) : e, a = 0; null != (r = o[a]); a++)
              n || 1 !== r.nodeType || E.cleanData(Te(r)),
                r.parentNode && (n && me(r) && Ne(Te(r, 'script')), r.parentNode.removeChild(r));
            return e;
          }
          E.extend({
            htmlPrefilter: function (e) {
              return e;
            },
            clone: function (e, t, n) {
              var r,
                o,
                a,
                i,
                l = e.cloneNode(!0),
                u = me(e);
              if (!m.noCloneChecked && (1 === e.nodeType || 11 === e.nodeType) && !E.isXMLDoc(e))
                for (i = Te(l), r = 0, o = (a = Te(e)).length; r < o; r++) He(a[r], i[r]);
              if (t)
                if (n) for (a = a || Te(e), i = i || Te(l), r = 0, o = a.length; r < o; r++) Ue(a[r], i[r]);
                else Ue(e, l);
              return (i = Te(l, 'script')).length > 0 && Ne(i, !u && Te(e, 'script')), l;
            },
            cleanData: function (e) {
              for (var t, n, r, o = E.event.special, a = 0; void 0 !== (n = e[a]); a++)
                if (ae(n)) {
                  if ((t = n[le.expando])) {
                    if (t.events) for (r in t.events) o[r] ? E.event.remove(n, r) : E.removeEvent(n, r, t.handle);
                    n[le.expando] = void 0;
                  }
                  n[ue.expando] && (n[ue.expando] = void 0);
                }
            },
          }),
            E.fn.extend({
              detach: function (e) {
                return We(this, e, !0);
              },
              remove: function (e) {
                return We(this, e);
              },
              text: function (e) {
                return ee(
                  this,
                  function (e) {
                    return void 0 === e
                      ? E.text(this)
                      : this.empty().each(function () {
                          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                            (this.textContent = e);
                        });
                  },
                  null,
                  e,
                  arguments.length
                );
              },
              append: function () {
                return qe(this, arguments, function (e) {
                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Ve(this, e).appendChild(e);
                });
              },
              prepend: function () {
                return qe(this, arguments, function (e) {
                  if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = Ve(this, e);
                    t.insertBefore(e, t.firstChild);
                  }
                });
              },
              before: function () {
                return qe(this, arguments, function (e) {
                  this.parentNode && this.parentNode.insertBefore(e, this);
                });
              },
              after: function () {
                return qe(this, arguments, function (e) {
                  this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
              },
              empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++)
                  1 === e.nodeType && (E.cleanData(Te(e, !1)), (e.textContent = ''));
                return this;
              },
              clone: function (e, t) {
                return (
                  (e = null != e && e),
                  (t = null == t ? e : t),
                  this.map(function () {
                    return E.clone(this, e, t);
                  })
                );
              },
              html: function (e) {
                return ee(
                  this,
                  function (e) {
                    var t = this[0] || {},
                      n = 0,
                      r = this.length;
                    if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                    if ('string' === typeof e && !Ie.test(e) && !Ce[(_e.exec(e) || ['', ''])[1].toLowerCase()]) {
                      e = E.htmlPrefilter(e);
                      try {
                        for (; n < r; n++)
                          1 === (t = this[n] || {}).nodeType && (E.cleanData(Te(t, !1)), (t.innerHTML = e));
                        t = 0;
                      } catch (o) {}
                    }
                    t && this.empty().append(e);
                  },
                  null,
                  e,
                  arguments.length
                );
              },
              replaceWith: function () {
                var e = [];
                return qe(
                  this,
                  arguments,
                  function (t) {
                    var n = this.parentNode;
                    E.inArray(this, e) < 0 && (E.cleanData(Te(this)), n && n.replaceChild(t, this));
                  },
                  e
                );
              },
            }),
            E.each(
              {
                appendTo: 'append',
                prependTo: 'prepend',
                insertBefore: 'before',
                insertAfter: 'after',
                replaceAll: 'replaceWith',
              },
              function (e, t) {
                E.fn[e] = function (e) {
                  for (var n, r = [], o = E(e), a = o.length - 1, i = 0; i <= a; i++)
                    (n = i === a ? this : this.clone(!0)), E(o[i])[t](n), s.apply(r, n.get());
                  return this.pushStack(r);
                };
              }
            );
          var $e = new RegExp('^(' + de + ')(?!px)[a-z%]+$', 'i'),
            Ge = /^--/,
            Ke = function (e) {
              var t = e.ownerDocument.defaultView;
              return (t && t.opener) || (t = r), t.getComputedStyle(e);
            },
            Qe = function (e, t, n) {
              var r,
                o,
                a = {};
              for (o in t) (a[o] = e.style[o]), (e.style[o] = t[o]);
              for (o in ((r = n.call(e)), t)) e.style[o] = a[o];
              return r;
            },
            Ye = new RegExp(he.join('|'), 'i');
          function Xe(e, t, n) {
            var r,
              o,
              a,
              i,
              l = Ge.test(t),
              u = e.style;
            return (
              (n = n || Ke(e)) &&
                ((i = n.getPropertyValue(t) || n[t]),
                l && i && (i = i.replace(R, '$1') || void 0),
                '' !== i || me(e) || (i = E.style(e, t)),
                !m.pixelBoxStyles() &&
                  $e.test(i) &&
                  Ye.test(t) &&
                  ((r = u.width),
                  (o = u.minWidth),
                  (a = u.maxWidth),
                  (u.minWidth = u.maxWidth = u.width = i),
                  (i = n.width),
                  (u.width = r),
                  (u.minWidth = o),
                  (u.maxWidth = a))),
              void 0 !== i ? i + '' : i
            );
          }
          function Je(e, t) {
            return {
              get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
              },
            };
          }
          !(function () {
            function e() {
              if (c) {
                (s.style.cssText = 'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
                  (c.style.cssText =
                    'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
                  ve.appendChild(s).appendChild(c);
                var e = r.getComputedStyle(c);
                (n = '1%' !== e.top),
                  (u = 12 === t(e.marginLeft)),
                  (c.style.right = '60%'),
                  (i = 36 === t(e.right)),
                  (o = 36 === t(e.width)),
                  (c.style.position = 'absolute'),
                  (a = 12 === t(c.offsetWidth / 3)),
                  ve.removeChild(s),
                  (c = null);
              }
            }
            function t(e) {
              return Math.round(parseFloat(e));
            }
            var n,
              o,
              a,
              i,
              l,
              u,
              s = y.createElement('div'),
              c = y.createElement('div');
            c.style &&
              ((c.style.backgroundClip = 'content-box'),
              (c.cloneNode(!0).style.backgroundClip = ''),
              (m.clearCloneStyle = 'content-box' === c.style.backgroundClip),
              E.extend(m, {
                boxSizingReliable: function () {
                  return e(), o;
                },
                pixelBoxStyles: function () {
                  return e(), i;
                },
                pixelPosition: function () {
                  return e(), n;
                },
                reliableMarginLeft: function () {
                  return e(), u;
                },
                scrollboxSize: function () {
                  return e(), a;
                },
                reliableTrDimensions: function () {
                  var e, t, n, o;
                  return (
                    null == l &&
                      ((e = y.createElement('table')),
                      (t = y.createElement('tr')),
                      (n = y.createElement('div')),
                      (e.style.cssText = 'position:absolute;left:-11111px;border-collapse:separate'),
                      (t.style.cssText = 'box-sizing:content-box;border:1px solid'),
                      (t.style.height = '1px'),
                      (n.style.height = '9px'),
                      (n.style.display = 'block'),
                      ve.appendChild(e).appendChild(t).appendChild(n),
                      (o = r.getComputedStyle(t)),
                      (l =
                        parseInt(o.height, 10) + parseInt(o.borderTopWidth, 10) + parseInt(o.borderBottomWidth, 10) ===
                        t.offsetHeight),
                      ve.removeChild(e)),
                    l
                  );
                },
              }));
          })();
          var Ze = ['Webkit', 'Moz', 'ms'],
            et = y.createElement('div').style,
            tt = {};
          function nt(e) {
            var t = E.cssProps[e] || tt[e];
            return (
              t ||
              (e in et
                ? e
                : (tt[e] =
                    (function (e) {
                      for (var t = e[0].toUpperCase() + e.slice(1), n = Ze.length; n--; )
                        if ((e = Ze[n] + t) in et) return e;
                    })(e) || e))
            );
          }
          var rt = /^(none|table(?!-c[ea]).+)/,
            ot = { position: 'absolute', visibility: 'hidden', display: 'block' },
            at = { letterSpacing: '0', fontWeight: '400' };
          function it(e, t, n) {
            var r = pe.exec(t);
            return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px') : t;
          }
          function lt(e, t, n, r, o, a) {
            var i = 'width' === t ? 1 : 0,
              l = 0,
              u = 0,
              s = 0;
            if (n === (r ? 'border' : 'content')) return 0;
            for (; i < 4; i += 2)
              'margin' === n && (s += E.css(e, n + he[i], !0, o)),
                r
                  ? ('content' === n && (u -= E.css(e, 'padding' + he[i], !0, o)),
                    'margin' !== n && (u -= E.css(e, 'border' + he[i] + 'Width', !0, o)))
                  : ((u += E.css(e, 'padding' + he[i], !0, o)),
                    'padding' !== n
                      ? (u += E.css(e, 'border' + he[i] + 'Width', !0, o))
                      : (l += E.css(e, 'border' + he[i] + 'Width', !0, o)));
            return (
              !r &&
                a >= 0 &&
                (u += Math.max(0, Math.ceil(e['offset' + t[0].toUpperCase() + t.slice(1)] - a - u - l - 0.5)) || 0),
              u + s
            );
          }
          function ut(e, t, n) {
            var r = Ke(e),
              o = (!m.boxSizingReliable() || n) && 'border-box' === E.css(e, 'boxSizing', !1, r),
              a = o,
              i = Xe(e, t, r),
              l = 'offset' + t[0].toUpperCase() + t.slice(1);
            if ($e.test(i)) {
              if (!n) return i;
              i = 'auto';
            }
            return (
              ((!m.boxSizingReliable() && o) ||
                (!m.reliableTrDimensions() && T(e, 'tr')) ||
                'auto' === i ||
                (!parseFloat(i) && 'inline' === E.css(e, 'display', !1, r))) &&
                e.getClientRects().length &&
                ((o = 'border-box' === E.css(e, 'boxSizing', !1, r)), (a = l in e) && (i = e[l])),
              (i = parseFloat(i) || 0) + lt(e, t, n || (o ? 'border' : 'content'), a, r, i) + 'px'
            );
          }
          function st(e, t, n, r, o) {
            return new st.prototype.init(e, t, n, r, o);
          }
          E.extend({
            cssHooks: {
              opacity: {
                get: function (e, t) {
                  if (t) {
                    var n = Xe(e, 'opacity');
                    return '' === n ? '1' : n;
                  }
                },
              },
            },
            cssNumber: {
              animationIterationCount: !0,
              aspectRatio: !0,
              borderImageSlice: !0,
              columnCount: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              scale: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
              fillOpacity: !0,
              floodOpacity: !0,
              stopOpacity: !0,
              strokeMiterlimit: !0,
              strokeOpacity: !0,
            },
            cssProps: {},
            style: function (e, t, n, r) {
              if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o,
                  a,
                  i,
                  l = oe(t),
                  u = Ge.test(t),
                  s = e.style;
                if ((u || (t = nt(l)), (i = E.cssHooks[t] || E.cssHooks[l]), void 0 === n))
                  return i && 'get' in i && void 0 !== (o = i.get(e, !1, r)) ? o : s[t];
                'string' === (a = typeof n) && (o = pe.exec(n)) && o[1] && ((n = ye(e, t, o)), (a = 'number')),
                  null != n &&
                    n === n &&
                    ('number' !== a || u || (n += (o && o[3]) || (E.cssNumber[l] ? '' : 'px')),
                    m.clearCloneStyle || '' !== n || 0 !== t.indexOf('background') || (s[t] = 'inherit'),
                    (i && 'set' in i && void 0 === (n = i.set(e, n, r))) || (u ? s.setProperty(t, n) : (s[t] = n)));
              }
            },
            css: function (e, t, n, r) {
              var o,
                a,
                i,
                l = oe(t);
              return (
                Ge.test(t) || (t = nt(l)),
                (i = E.cssHooks[t] || E.cssHooks[l]) && 'get' in i && (o = i.get(e, !0, n)),
                void 0 === o && (o = Xe(e, t, r)),
                'normal' === o && t in at && (o = at[t]),
                '' === n || n ? ((a = parseFloat(o)), !0 === n || isFinite(a) ? a || 0 : o) : o
              );
            },
          }),
            E.each(['height', 'width'], function (e, t) {
              E.cssHooks[t] = {
                get: function (e, n, r) {
                  if (n)
                    return !rt.test(E.css(e, 'display')) ||
                      (e.getClientRects().length && e.getBoundingClientRect().width)
                      ? ut(e, t, r)
                      : Qe(e, ot, function () {
                          return ut(e, t, r);
                        });
                },
                set: function (e, n, r) {
                  var o,
                    a = Ke(e),
                    i = !m.scrollboxSize() && 'absolute' === a.position,
                    l = (i || r) && 'border-box' === E.css(e, 'boxSizing', !1, a),
                    u = r ? lt(e, t, r, l, a) : 0;
                  return (
                    l &&
                      i &&
                      (u -= Math.ceil(
                        e['offset' + t[0].toUpperCase() + t.slice(1)] -
                          parseFloat(a[t]) -
                          lt(e, t, 'border', !1, a) -
                          0.5
                      )),
                    u && (o = pe.exec(n)) && 'px' !== (o[3] || 'px') && ((e.style[t] = n), (n = E.css(e, t))),
                    it(0, n, u)
                  );
                },
              };
            }),
            (E.cssHooks.marginLeft = Je(m.reliableMarginLeft, function (e, t) {
              if (t)
                return (
                  (parseFloat(Xe(e, 'marginLeft')) ||
                    e.getBoundingClientRect().left -
                      Qe(e, { marginLeft: 0 }, function () {
                        return e.getBoundingClientRect().left;
                      })) + 'px'
                );
            })),
            E.each({ margin: '', padding: '', border: 'Width' }, function (e, t) {
              (E.cssHooks[e + t] = {
                expand: function (n) {
                  for (var r = 0, o = {}, a = 'string' === typeof n ? n.split(' ') : [n]; r < 4; r++)
                    o[e + he[r] + t] = a[r] || a[r - 2] || a[0];
                  return o;
                },
              }),
                'margin' !== e && (E.cssHooks[e + t].set = it);
            }),
            E.fn.extend({
              css: function (e, t) {
                return ee(
                  this,
                  function (e, t, n) {
                    var r,
                      o,
                      a = {},
                      i = 0;
                    if (Array.isArray(t)) {
                      for (r = Ke(e), o = t.length; i < o; i++) a[t[i]] = E.css(e, t[i], !1, r);
                      return a;
                    }
                    return void 0 !== n ? E.style(e, t, n) : E.css(e, t);
                  },
                  e,
                  t,
                  arguments.length > 1
                );
              },
            }),
            (E.Tween = st),
            (st.prototype = {
              constructor: st,
              init: function (e, t, n, r, o, a) {
                (this.elem = e),
                  (this.prop = n),
                  (this.easing = o || E.easing._default),
                  (this.options = t),
                  (this.start = this.now = this.cur()),
                  (this.end = r),
                  (this.unit = a || (E.cssNumber[n] ? '' : 'px'));
              },
              cur: function () {
                var e = st.propHooks[this.prop];
                return e && e.get ? e.get(this) : st.propHooks._default.get(this);
              },
              run: function (e) {
                var t,
                  n = st.propHooks[this.prop];
                return (
                  this.options.duration
                    ? (this.pos = t = E.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
                    : (this.pos = t = e),
                  (this.now = (this.end - this.start) * t + this.start),
                  this.options.step && this.options.step.call(this.elem, this.now, this),
                  n && n.set ? n.set(this) : st.propHooks._default.set(this),
                  this
                );
              },
            }),
            (st.prototype.init.prototype = st.prototype),
            (st.propHooks = {
              _default: {
                get: function (e) {
                  var t;
                  return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                    ? e.elem[e.prop]
                    : (t = E.css(e.elem, e.prop, '')) && 'auto' !== t
                    ? t
                    : 0;
                },
                set: function (e) {
                  E.fx.step[e.prop]
                    ? E.fx.step[e.prop](e)
                    : 1 !== e.elem.nodeType || (!E.cssHooks[e.prop] && null == e.elem.style[nt(e.prop)])
                    ? (e.elem[e.prop] = e.now)
                    : E.style(e.elem, e.prop, e.now + e.unit);
                },
              },
            }),
            (st.propHooks.scrollTop = st.propHooks.scrollLeft =
              {
                set: function (e) {
                  e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                },
              }),
            (E.easing = {
              linear: function (e) {
                return e;
              },
              swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
              },
              _default: 'swing',
            }),
            ((E.fx = st.prototype.init).step = {});
          var ct,
            ft,
            dt = /^(?:toggle|show|hide)$/,
            pt = /queueHooks$/;
          function ht() {
            ft &&
              (!1 === y.hidden && r.requestAnimationFrame
                ? r.requestAnimationFrame(ht)
                : r.setTimeout(ht, E.fx.interval),
              E.fx.tick());
          }
          function vt() {
            return (
              r.setTimeout(function () {
                ct = void 0;
              }),
              (ct = Date.now())
            );
          }
          function mt(e, t) {
            var n,
              r = 0,
              o = { height: e };
            for (t = t ? 1 : 0; r < 4; r += 2 - t) o['margin' + (n = he[r])] = o['padding' + n] = e;
            return t && (o.opacity = o.width = e), o;
          }
          function gt(e, t, n) {
            for (var r, o = (wt.tweeners[t] || []).concat(wt.tweeners['*']), a = 0, i = o.length; a < i; a++)
              if ((r = o[a].call(n, t, e))) return r;
          }
          function wt(e, t, n) {
            var r,
              o,
              a = 0,
              i = wt.prefilters.length,
              l = E.Deferred().always(function () {
                delete u.elem;
              }),
              u = function () {
                if (o) return !1;
                for (
                  var t = ct || vt(),
                    n = Math.max(0, s.startTime + s.duration - t),
                    r = 1 - (n / s.duration || 0),
                    a = 0,
                    i = s.tweens.length;
                  a < i;
                  a++
                )
                  s.tweens[a].run(r);
                return (
                  l.notifyWith(e, [s, r, n]),
                  r < 1 && i ? n : (i || l.notifyWith(e, [s, 1, 0]), l.resolveWith(e, [s]), !1)
                );
              },
              s = l.promise({
                elem: e,
                props: E.extend({}, t),
                opts: E.extend(!0, { specialEasing: {}, easing: E.easing._default }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: ct || vt(),
                duration: n.duration,
                tweens: [],
                createTween: function (t, n) {
                  var r = E.Tween(e, s.opts, t, n, s.opts.specialEasing[t] || s.opts.easing);
                  return s.tweens.push(r), r;
                },
                stop: function (t) {
                  var n = 0,
                    r = t ? s.tweens.length : 0;
                  if (o) return this;
                  for (o = !0; n < r; n++) s.tweens[n].run(1);
                  return t ? (l.notifyWith(e, [s, 1, 0]), l.resolveWith(e, [s, t])) : l.rejectWith(e, [s, t]), this;
                },
              }),
              c = s.props;
            for (
              !(function (e, t) {
                var n, r, o, a, i;
                for (n in e)
                  if (
                    ((o = t[(r = oe(n))]),
                    (a = e[n]),
                    Array.isArray(a) && ((o = a[1]), (a = e[n] = a[0])),
                    n !== r && ((e[r] = a), delete e[n]),
                    (i = E.cssHooks[r]) && ('expand' in i))
                  )
                    for (n in ((a = i.expand(a)), delete e[r], a)) (n in e) || ((e[n] = a[n]), (t[n] = o));
                  else t[r] = o;
              })(c, s.opts.specialEasing);
              a < i;
              a++
            )
              if ((r = wt.prefilters[a].call(s, e, c, s.opts)))
                return g(r.stop) && (E._queueHooks(s.elem, s.opts.queue).stop = r.stop.bind(r)), r;
            return (
              E.map(c, gt, s),
              g(s.opts.start) && s.opts.start.call(e, s),
              s.progress(s.opts.progress).done(s.opts.done, s.opts.complete).fail(s.opts.fail).always(s.opts.always),
              E.fx.timer(E.extend(u, { elem: e, anim: s, queue: s.opts.queue })),
              s
            );
          }
          (E.Animation = E.extend(wt, {
            tweeners: {
              '*': [
                function (e, t) {
                  var n = this.createTween(e, t);
                  return ye(n.elem, e, pe.exec(t), n), n;
                },
              ],
            },
            tweener: function (e, t) {
              g(e) ? ((t = e), (e = ['*'])) : (e = e.match(G));
              for (var n, r = 0, o = e.length; r < o; r++)
                (n = e[r]), (wt.tweeners[n] = wt.tweeners[n] || []), wt.tweeners[n].unshift(t);
            },
            prefilters: [
              function (e, t, n) {
                var r,
                  o,
                  a,
                  i,
                  l,
                  u,
                  s,
                  c,
                  f = 'width' in t || 'height' in t,
                  d = this,
                  p = {},
                  h = e.style,
                  v = e.nodeType && we(e),
                  m = le.get(e, 'fxshow');
                for (r in (n.queue ||
                  (null == (i = E._queueHooks(e, 'fx')).unqueued &&
                    ((i.unqueued = 0),
                    (l = i.empty.fire),
                    (i.empty.fire = function () {
                      i.unqueued || l();
                    })),
                  i.unqueued++,
                  d.always(function () {
                    d.always(function () {
                      i.unqueued--, E.queue(e, 'fx').length || i.empty.fire();
                    });
                  })),
                t))
                  if (((o = t[r]), dt.test(o))) {
                    if ((delete t[r], (a = a || 'toggle' === o), o === (v ? 'hide' : 'show'))) {
                      if ('show' !== o || !m || void 0 === m[r]) continue;
                      v = !0;
                    }
                    p[r] = (m && m[r]) || E.style(e, r);
                  }
                if ((u = !E.isEmptyObject(t)) || !E.isEmptyObject(p))
                  for (r in (f &&
                    1 === e.nodeType &&
                    ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                    null == (s = m && m.display) && (s = le.get(e, 'display')),
                    'none' === (c = E.css(e, 'display')) &&
                      (s ? (c = s) : (ke([e], !0), (s = e.style.display || s), (c = E.css(e, 'display')), ke([e]))),
                    ('inline' === c || ('inline-block' === c && null != s)) &&
                      'none' === E.css(e, 'float') &&
                      (u ||
                        (d.done(function () {
                          h.display = s;
                        }),
                        null == s && ((c = h.display), (s = 'none' === c ? '' : c))),
                      (h.display = 'inline-block'))),
                  n.overflow &&
                    ((h.overflow = 'hidden'),
                    d.always(function () {
                      (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                    })),
                  (u = !1),
                  p))
                    u ||
                      (m ? 'hidden' in m && (v = m.hidden) : (m = le.access(e, 'fxshow', { display: s })),
                      a && (m.hidden = !v),
                      v && ke([e], !0),
                      d.done(function () {
                        for (r in (v || ke([e]), le.remove(e, 'fxshow'), p)) E.style(e, r, p[r]);
                      })),
                      (u = gt(v ? m[r] : 0, r, d)),
                      r in m || ((m[r] = u.start), v && ((u.end = u.start), (u.start = 0)));
              },
            ],
            prefilter: function (e, t) {
              t ? wt.prefilters.unshift(e) : wt.prefilters.push(e);
            },
          })),
            (E.speed = function (e, t, n) {
              var r =
                e && 'object' === typeof e
                  ? E.extend({}, e)
                  : { complete: n || (!n && t) || (g(e) && e), duration: e, easing: (n && t) || (t && !g(t) && t) };
              return (
                E.fx.off
                  ? (r.duration = 0)
                  : 'number' !== typeof r.duration &&
                    (r.duration in E.fx.speeds
                      ? (r.duration = E.fx.speeds[r.duration])
                      : (r.duration = E.fx.speeds._default)),
                (null != r.queue && !0 !== r.queue) || (r.queue = 'fx'),
                (r.old = r.complete),
                (r.complete = function () {
                  g(r.old) && r.old.call(this), r.queue && E.dequeue(this, r.queue);
                }),
                r
              );
            }),
            E.fn.extend({
              fadeTo: function (e, t, n, r) {
                return this.filter(we).css('opacity', 0).show().end().animate({ opacity: t }, e, n, r);
              },
              animate: function (e, t, n, r) {
                var o = E.isEmptyObject(e),
                  a = E.speed(t, n, r),
                  i = function () {
                    var t = wt(this, E.extend({}, e), a);
                    (o || le.get(this, 'finish')) && t.stop(!0);
                  };
                return (i.finish = i), o || !1 === a.queue ? this.each(i) : this.queue(a.queue, i);
              },
              stop: function (e, t, n) {
                var r = function (e) {
                  var t = e.stop;
                  delete e.stop, t(n);
                };
                return (
                  'string' !== typeof e && ((n = t), (t = e), (e = void 0)),
                  t && this.queue(e || 'fx', []),
                  this.each(function () {
                    var t = !0,
                      o = null != e && e + 'queueHooks',
                      a = E.timers,
                      i = le.get(this);
                    if (o) i[o] && i[o].stop && r(i[o]);
                    else for (o in i) i[o] && i[o].stop && pt.test(o) && r(i[o]);
                    for (o = a.length; o--; )
                      a[o].elem !== this ||
                        (null != e && a[o].queue !== e) ||
                        (a[o].anim.stop(n), (t = !1), a.splice(o, 1));
                    (!t && n) || E.dequeue(this, e);
                  })
                );
              },
              finish: function (e) {
                return (
                  !1 !== e && (e = e || 'fx'),
                  this.each(function () {
                    var t,
                      n = le.get(this),
                      r = n[e + 'queue'],
                      o = n[e + 'queueHooks'],
                      a = E.timers,
                      i = r ? r.length : 0;
                    for (n.finish = !0, E.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = a.length; t--; )
                      a[t].elem === this && a[t].queue === e && (a[t].anim.stop(!0), a.splice(t, 1));
                    for (t = 0; t < i; t++) r[t] && r[t].finish && r[t].finish.call(this);
                    delete n.finish;
                  })
                );
              },
            }),
            E.each(['toggle', 'show', 'hide'], function (e, t) {
              var n = E.fn[t];
              E.fn[t] = function (e, r, o) {
                return null == e || 'boolean' === typeof e
                  ? n.apply(this, arguments)
                  : this.animate(mt(t, !0), e, r, o);
              };
            }),
            E.each(
              {
                slideDown: mt('show'),
                slideUp: mt('hide'),
                slideToggle: mt('toggle'),
                fadeIn: { opacity: 'show' },
                fadeOut: { opacity: 'hide' },
                fadeToggle: { opacity: 'toggle' },
              },
              function (e, t) {
                E.fn[e] = function (e, n, r) {
                  return this.animate(t, e, n, r);
                };
              }
            ),
            (E.timers = []),
            (E.fx.tick = function () {
              var e,
                t = 0,
                n = E.timers;
              for (ct = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
              n.length || E.fx.stop(), (ct = void 0);
            }),
            (E.fx.timer = function (e) {
              E.timers.push(e), E.fx.start();
            }),
            (E.fx.interval = 13),
            (E.fx.start = function () {
              ft || ((ft = !0), ht());
            }),
            (E.fx.stop = function () {
              ft = null;
            }),
            (E.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (E.fn.delay = function (e, t) {
              return (
                (e = (E.fx && E.fx.speeds[e]) || e),
                (t = t || 'fx'),
                this.queue(t, function (t, n) {
                  var o = r.setTimeout(t, e);
                  n.stop = function () {
                    r.clearTimeout(o);
                  };
                })
              );
            }),
            (function () {
              var e = y.createElement('input'),
                t = y.createElement('select').appendChild(y.createElement('option'));
              (e.type = 'checkbox'),
                (m.checkOn = '' !== e.value),
                (m.optSelected = t.selected),
                ((e = y.createElement('input')).value = 't'),
                (e.type = 'radio'),
                (m.radioValue = 't' === e.value);
            })();
          var yt,
            bt = E.expr.attrHandle;
          E.fn.extend({
            attr: function (e, t) {
              return ee(this, E.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
              return this.each(function () {
                E.removeAttr(this, e);
              });
            },
          }),
            E.extend({
              attr: function (e, t, n) {
                var r,
                  o,
                  a = e.nodeType;
                if (3 !== a && 8 !== a && 2 !== a)
                  return 'undefined' === typeof e.getAttribute
                    ? E.prop(e, t, n)
                    : ((1 === a && E.isXMLDoc(e)) ||
                        (o = E.attrHooks[t.toLowerCase()] || (E.expr.match.bool.test(t) ? yt : void 0)),
                      void 0 !== n
                        ? null === n
                          ? void E.removeAttr(e, t)
                          : o && 'set' in o && void 0 !== (r = o.set(e, n, t))
                          ? r
                          : (e.setAttribute(t, n + ''), n)
                        : o && 'get' in o && null !== (r = o.get(e, t))
                        ? r
                        : null == (r = E.find.attr(e, t))
                        ? void 0
                        : r);
              },
              attrHooks: {
                type: {
                  set: function (e, t) {
                    if (!m.radioValue && 'radio' === t && T(e, 'input')) {
                      var n = e.value;
                      return e.setAttribute('type', t), n && (e.value = n), t;
                    }
                  },
                },
              },
              removeAttr: function (e, t) {
                var n,
                  r = 0,
                  o = t && t.match(G);
                if (o && 1 === e.nodeType) for (; (n = o[r++]); ) e.removeAttribute(n);
              },
            }),
            (yt = {
              set: function (e, t, n) {
                return !1 === t ? E.removeAttr(e, n) : e.setAttribute(n, n), n;
              },
            }),
            E.each(E.expr.match.bool.source.match(/\w+/g), function (e, t) {
              var n = bt[t] || E.find.attr;
              bt[t] = function (e, t, r) {
                var o,
                  a,
                  i = t.toLowerCase();
                return r || ((a = bt[i]), (bt[i] = o), (o = null != n(e, t, r) ? i : null), (bt[i] = a)), o;
              };
            });
          var xt = /^(?:input|select|textarea|button)$/i,
            kt = /^(?:a|area)$/i;
          function St(e) {
            return (e.match(G) || []).join(' ');
          }
          function _t(e) {
            return (e.getAttribute && e.getAttribute('class')) || '';
          }
          function Et(e) {
            return Array.isArray(e) ? e : ('string' === typeof e && e.match(G)) || [];
          }
          E.fn.extend({
            prop: function (e, t) {
              return ee(this, E.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
              return this.each(function () {
                delete this[E.propFix[e] || e];
              });
            },
          }),
            E.extend({
              prop: function (e, t, n) {
                var r,
                  o,
                  a = e.nodeType;
                if (3 !== a && 8 !== a && 2 !== a)
                  return (
                    (1 === a && E.isXMLDoc(e)) || ((t = E.propFix[t] || t), (o = E.propHooks[t])),
                    void 0 !== n
                      ? o && 'set' in o && void 0 !== (r = o.set(e, n, t))
                        ? r
                        : (e[t] = n)
                      : o && 'get' in o && null !== (r = o.get(e, t))
                      ? r
                      : e[t]
                  );
              },
              propHooks: {
                tabIndex: {
                  get: function (e) {
                    var t = E.find.attr(e, 'tabindex');
                    return t ? parseInt(t, 10) : xt.test(e.nodeName) || (kt.test(e.nodeName) && e.href) ? 0 : -1;
                  },
                },
              },
              propFix: { for: 'htmlFor', class: 'className' },
            }),
            m.optSelected ||
              (E.propHooks.selected = {
                get: function (e) {
                  var t = e.parentNode;
                  return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                  var t = e.parentNode;
                  t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
              }),
            E.each(
              [
                'tabIndex',
                'readOnly',
                'maxLength',
                'cellSpacing',
                'cellPadding',
                'rowSpan',
                'colSpan',
                'useMap',
                'frameBorder',
                'contentEditable',
              ],
              function () {
                E.propFix[this.toLowerCase()] = this;
              }
            ),
            E.fn.extend({
              addClass: function (e) {
                var t, n, r, o, a, i;
                return g(e)
                  ? this.each(function (t) {
                      E(this).addClass(e.call(this, t, _t(this)));
                    })
                  : (t = Et(e)).length
                  ? this.each(function () {
                      if (((r = _t(this)), (n = 1 === this.nodeType && ' ' + St(r) + ' '))) {
                        for (a = 0; a < t.length; a++) (o = t[a]), n.indexOf(' ' + o + ' ') < 0 && (n += o + ' ');
                        (i = St(n)), r !== i && this.setAttribute('class', i);
                      }
                    })
                  : this;
              },
              removeClass: function (e) {
                var t, n, r, o, a, i;
                return g(e)
                  ? this.each(function (t) {
                      E(this).removeClass(e.call(this, t, _t(this)));
                    })
                  : arguments.length
                  ? (t = Et(e)).length
                    ? this.each(function () {
                        if (((r = _t(this)), (n = 1 === this.nodeType && ' ' + St(r) + ' '))) {
                          for (a = 0; a < t.length; a++)
                            for (o = t[a]; n.indexOf(' ' + o + ' ') > -1; ) n = n.replace(' ' + o + ' ', ' ');
                          (i = St(n)), r !== i && this.setAttribute('class', i);
                        }
                      })
                    : this
                  : this.attr('class', '');
              },
              toggleClass: function (e, t) {
                var n,
                  r,
                  o,
                  a,
                  i = typeof e,
                  l = 'string' === i || Array.isArray(e);
                return g(e)
                  ? this.each(function (n) {
                      E(this).toggleClass(e.call(this, n, _t(this), t), t);
                    })
                  : 'boolean' === typeof t && l
                  ? t
                    ? this.addClass(e)
                    : this.removeClass(e)
                  : ((n = Et(e)),
                    this.each(function () {
                      if (l)
                        for (a = E(this), o = 0; o < n.length; o++)
                          (r = n[o]), a.hasClass(r) ? a.removeClass(r) : a.addClass(r);
                      else
                        (void 0 !== e && 'boolean' !== i) ||
                          ((r = _t(this)) && le.set(this, '__className__', r),
                          this.setAttribute &&
                            this.setAttribute('class', r || !1 === e ? '' : le.get(this, '__className__') || ''));
                    }));
              },
              hasClass: function (e) {
                var t,
                  n,
                  r = 0;
                for (t = ' ' + e + ' '; (n = this[r++]); )
                  if (1 === n.nodeType && (' ' + St(_t(n)) + ' ').indexOf(t) > -1) return !0;
                return !1;
              },
            });
          var Ct = /\r/g;
          E.fn.extend({
            val: function (e) {
              var t,
                n,
                r,
                o = this[0];
              return arguments.length
                ? ((r = g(e)),
                  this.each(function (n) {
                    var o;
                    1 === this.nodeType &&
                      (null == (o = r ? e.call(this, n, E(this).val()) : e)
                        ? (o = '')
                        : 'number' === typeof o
                        ? (o += '')
                        : Array.isArray(o) &&
                          (o = E.map(o, function (e) {
                            return null == e ? '' : e + '';
                          })),
                      ((t = E.valHooks[this.type] || E.valHooks[this.nodeName.toLowerCase()]) &&
                        'set' in t &&
                        void 0 !== t.set(this, o, 'value')) ||
                        (this.value = o));
                  }))
                : o
                ? (t = E.valHooks[o.type] || E.valHooks[o.nodeName.toLowerCase()]) &&
                  'get' in t &&
                  void 0 !== (n = t.get(o, 'value'))
                  ? n
                  : 'string' === typeof (n = o.value)
                  ? n.replace(Ct, '')
                  : null == n
                  ? ''
                  : n
                : void 0;
            },
          }),
            E.extend({
              valHooks: {
                option: {
                  get: function (e) {
                    var t = E.find.attr(e, 'value');
                    return null != t ? t : St(E.text(e));
                  },
                },
                select: {
                  get: function (e) {
                    var t,
                      n,
                      r,
                      o = e.options,
                      a = e.selectedIndex,
                      i = 'select-one' === e.type,
                      l = i ? null : [],
                      u = i ? a + 1 : o.length;
                    for (r = a < 0 ? u : i ? a : 0; r < u; r++)
                      if (
                        ((n = o[r]).selected || r === a) &&
                        !n.disabled &&
                        (!n.parentNode.disabled || !T(n.parentNode, 'optgroup'))
                      ) {
                        if (((t = E(n).val()), i)) return t;
                        l.push(t);
                      }
                    return l;
                  },
                  set: function (e, t) {
                    for (var n, r, o = e.options, a = E.makeArray(t), i = o.length; i--; )
                      ((r = o[i]).selected = E.inArray(E.valHooks.option.get(r), a) > -1) && (n = !0);
                    return n || (e.selectedIndex = -1), a;
                  },
                },
              },
            }),
            E.each(['radio', 'checkbox'], function () {
              (E.valHooks[this] = {
                set: function (e, t) {
                  if (Array.isArray(t)) return (e.checked = E.inArray(E(e).val(), t) > -1);
                },
              }),
                m.checkOn ||
                  (E.valHooks[this].get = function (e) {
                    return null === e.getAttribute('value') ? 'on' : e.value;
                  });
            });
          var Tt = r.location,
            Nt = { guid: Date.now() },
            jt = /\?/;
          E.parseXML = function (e) {
            var t, n;
            if (!e || 'string' !== typeof e) return null;
            try {
              t = new r.DOMParser().parseFromString(e, 'text/xml');
            } catch (o) {}
            return (
              (n = t && t.getElementsByTagName('parsererror')[0]),
              (t && !n) ||
                E.error(
                  'Invalid XML: ' +
                    (n
                      ? E.map(n.childNodes, function (e) {
                          return e.textContent;
                        }).join('\n')
                      : e)
                ),
              t
            );
          };
          var Lt = /^(?:focusinfocus|focusoutblur)$/,
            At = function (e) {
              e.stopPropagation();
            };
          E.extend(E.event, {
            trigger: function (e, t, n, o) {
              var a,
                i,
                l,
                u,
                s,
                c,
                f,
                d,
                h = [n || y],
                v = p.call(e, 'type') ? e.type : e,
                m = p.call(e, 'namespace') ? e.namespace.split('.') : [];
              if (
                ((i = d = l = n = n || y),
                3 !== n.nodeType &&
                  8 !== n.nodeType &&
                  !Lt.test(v + E.event.triggered) &&
                  (v.indexOf('.') > -1 && ((m = v.split('.')), (v = m.shift()), m.sort()),
                  (s = v.indexOf(':') < 0 && 'on' + v),
                  ((e = e[E.expando] ? e : new E.Event(v, 'object' === typeof e && e)).isTrigger = o ? 2 : 3),
                  (e.namespace = m.join('.')),
                  (e.rnamespace = e.namespace ? new RegExp('(^|\\.)' + m.join('\\.(?:.*\\.|)') + '(\\.|$)') : null),
                  (e.result = void 0),
                  e.target || (e.target = n),
                  (t = null == t ? [e] : E.makeArray(t, [e])),
                  (f = E.event.special[v] || {}),
                  o || !f.trigger || !1 !== f.trigger.apply(n, t)))
              ) {
                if (!o && !f.noBubble && !w(n)) {
                  for (u = f.delegateType || v, Lt.test(u + v) || (i = i.parentNode); i; i = i.parentNode)
                    h.push(i), (l = i);
                  l === (n.ownerDocument || y) && h.push(l.defaultView || l.parentWindow || r);
                }
                for (a = 0; (i = h[a++]) && !e.isPropagationStopped(); )
                  (d = i),
                    (e.type = a > 1 ? u : f.bindType || v),
                    (c = (le.get(i, 'events') || Object.create(null))[e.type] && le.get(i, 'handle')) && c.apply(i, t),
                    (c = s && i[s]) &&
                      c.apply &&
                      ae(i) &&
                      ((e.result = c.apply(i, t)), !1 === e.result && e.preventDefault());
                return (
                  (e.type = v),
                  o ||
                    e.isDefaultPrevented() ||
                    (f._default && !1 !== f._default.apply(h.pop(), t)) ||
                    !ae(n) ||
                    (s &&
                      g(n[v]) &&
                      !w(n) &&
                      ((l = n[s]) && (n[s] = null),
                      (E.event.triggered = v),
                      e.isPropagationStopped() && d.addEventListener(v, At),
                      n[v](),
                      e.isPropagationStopped() && d.removeEventListener(v, At),
                      (E.event.triggered = void 0),
                      l && (n[s] = l))),
                  e.result
                );
              }
            },
            simulate: function (e, t, n) {
              var r = E.extend(new E.Event(), n, { type: e, isSimulated: !0 });
              E.event.trigger(r, null, t);
            },
          }),
            E.fn.extend({
              trigger: function (e, t) {
                return this.each(function () {
                  E.event.trigger(e, t, this);
                });
              },
              triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return E.event.trigger(e, t, n, !0);
              },
            });
          var Rt = /\[\]$/,
            Pt = /\r?\n/g,
            Ot = /^(?:submit|button|image|reset|file)$/i,
            Dt = /^(?:input|select|textarea|keygen)/i;
          function It(e, t, n, r) {
            var o;
            if (Array.isArray(t))
              E.each(t, function (t, o) {
                n || Rt.test(e) ? r(e, o) : It(e + '[' + ('object' === typeof o && null != o ? t : '') + ']', o, n, r);
              });
            else if (n || 'object' !== k(t)) r(e, t);
            else for (o in t) It(e + '[' + o + ']', t[o], n, r);
          }
          (E.param = function (e, t) {
            var n,
              r = [],
              o = function (e, t) {
                var n = g(t) ? t() : t;
                r[r.length] = encodeURIComponent(e) + '=' + encodeURIComponent(null == n ? '' : n);
              };
            if (null == e) return '';
            if (Array.isArray(e) || (e.jquery && !E.isPlainObject(e)))
              E.each(e, function () {
                o(this.name, this.value);
              });
            else for (n in e) It(n, e[n], t, o);
            return r.join('&');
          }),
            E.fn.extend({
              serialize: function () {
                return E.param(this.serializeArray());
              },
              serializeArray: function () {
                return this.map(function () {
                  var e = E.prop(this, 'elements');
                  return e ? E.makeArray(e) : this;
                })
                  .filter(function () {
                    var e = this.type;
                    return (
                      this.name &&
                      !E(this).is(':disabled') &&
                      Dt.test(this.nodeName) &&
                      !Ot.test(e) &&
                      (this.checked || !Se.test(e))
                    );
                  })
                  .map(function (e, t) {
                    var n = E(this).val();
                    return null == n
                      ? null
                      : Array.isArray(n)
                      ? E.map(n, function (e) {
                          return { name: t.name, value: e.replace(Pt, '\r\n') };
                        })
                      : { name: t.name, value: n.replace(Pt, '\r\n') };
                  })
                  .get();
              },
            });
          var Mt = /%20/g,
            zt = /#.*$/,
            Vt = /([?&])_=[^&]*/,
            Bt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Ft = /^(?:GET|HEAD)$/,
            Ut = /^\/\//,
            Ht = {},
            qt = {},
            Wt = '*/'.concat('*'),
            $t = y.createElement('a');
          function Gt(e) {
            return function (t, n) {
              'string' !== typeof t && ((n = t), (t = '*'));
              var r,
                o = 0,
                a = t.toLowerCase().match(G) || [];
              if (g(n))
                for (; (r = a[o++]); )
                  '+' === r[0]
                    ? ((r = r.slice(1) || '*'), (e[r] = e[r] || []).unshift(n))
                    : (e[r] = e[r] || []).push(n);
            };
          }
          function Kt(e, t, n, r) {
            var o = {},
              a = e === qt;
            function i(l) {
              var u;
              return (
                (o[l] = !0),
                E.each(e[l] || [], function (e, l) {
                  var s = l(t, n, r);
                  return 'string' !== typeof s || a || o[s]
                    ? a
                      ? !(u = s)
                      : void 0
                    : (t.dataTypes.unshift(s), i(s), !1);
                }),
                u
              );
            }
            return i(t.dataTypes[0]) || (!o['*'] && i('*'));
          }
          function Qt(e, t) {
            var n,
              r,
              o = E.ajaxSettings.flatOptions || {};
            for (n in t) void 0 !== t[n] && ((o[n] ? e : r || (r = {}))[n] = t[n]);
            return r && E.extend(!0, e, r), e;
          }
          ($t.href = Tt.href),
            E.extend({
              active: 0,
              lastModified: {},
              etag: {},
              ajaxSettings: {
                url: Tt.href,
                type: 'GET',
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                accepts: {
                  '*': Wt,
                  text: 'text/plain',
                  html: 'text/html',
                  xml: 'application/xml, text/xml',
                  json: 'application/json, text/javascript',
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: 'responseXML', text: 'responseText', json: 'responseJSON' },
                converters: { '* text': String, 'text html': !0, 'text json': JSON.parse, 'text xml': E.parseXML },
                flatOptions: { url: !0, context: !0 },
              },
              ajaxSetup: function (e, t) {
                return t ? Qt(Qt(e, E.ajaxSettings), t) : Qt(E.ajaxSettings, e);
              },
              ajaxPrefilter: Gt(Ht),
              ajaxTransport: Gt(qt),
              ajax: function (e, t) {
                'object' === typeof e && ((t = e), (e = void 0));
                var n,
                  o,
                  a,
                  i,
                  l,
                  u,
                  s,
                  c,
                  f,
                  d,
                  p = E.ajaxSetup({}, (t = t || {})),
                  h = p.context || p,
                  v = p.context && (h.nodeType || h.jquery) ? E(h) : E.event,
                  m = E.Deferred(),
                  g = E.Callbacks('once memory'),
                  w = p.statusCode || {},
                  b = {},
                  x = {},
                  k = 'canceled',
                  S = {
                    readyState: 0,
                    getResponseHeader: function (e) {
                      var t;
                      if (s) {
                        if (!i)
                          for (i = {}; (t = Bt.exec(a)); )
                            i[t[1].toLowerCase() + ' '] = (i[t[1].toLowerCase() + ' '] || []).concat(t[2]);
                        t = i[e.toLowerCase() + ' '];
                      }
                      return null == t ? null : t.join(', ');
                    },
                    getAllResponseHeaders: function () {
                      return s ? a : null;
                    },
                    setRequestHeader: function (e, t) {
                      return null == s && ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e), (b[e] = t)), this;
                    },
                    overrideMimeType: function (e) {
                      return null == s && (p.mimeType = e), this;
                    },
                    statusCode: function (e) {
                      var t;
                      if (e)
                        if (s) S.always(e[S.status]);
                        else for (t in e) w[t] = [w[t], e[t]];
                      return this;
                    },
                    abort: function (e) {
                      var t = e || k;
                      return n && n.abort(t), _(0, t), this;
                    },
                  };
                if (
                  (m.promise(S),
                  (p.url = ((e || p.url || Tt.href) + '').replace(Ut, Tt.protocol + '//')),
                  (p.type = t.method || t.type || p.method || p.type),
                  (p.dataTypes = (p.dataType || '*').toLowerCase().match(G) || ['']),
                  null == p.crossDomain)
                ) {
                  u = y.createElement('a');
                  try {
                    (u.href = p.url),
                      (u.href = u.href),
                      (p.crossDomain = $t.protocol + '//' + $t.host !== u.protocol + '//' + u.host);
                  } catch (C) {
                    p.crossDomain = !0;
                  }
                }
                if (
                  (p.data && p.processData && 'string' !== typeof p.data && (p.data = E.param(p.data, p.traditional)),
                  Kt(Ht, p, t, S),
                  s)
                )
                  return S;
                for (f in ((c = E.event && p.global) && 0 === E.active++ && E.event.trigger('ajaxStart'),
                (p.type = p.type.toUpperCase()),
                (p.hasContent = !Ft.test(p.type)),
                (o = p.url.replace(zt, '')),
                p.hasContent
                  ? p.data &&
                    p.processData &&
                    0 === (p.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                    (p.data = p.data.replace(Mt, '+'))
                  : ((d = p.url.slice(o.length)),
                    p.data &&
                      (p.processData || 'string' === typeof p.data) &&
                      ((o += (jt.test(o) ? '&' : '?') + p.data), delete p.data),
                    !1 === p.cache &&
                      ((o = o.replace(Vt, '$1')), (d = (jt.test(o) ? '&' : '?') + '_=' + Nt.guid++ + d)),
                    (p.url = o + d)),
                p.ifModified &&
                  (E.lastModified[o] && S.setRequestHeader('If-Modified-Since', E.lastModified[o]),
                  E.etag[o] && S.setRequestHeader('If-None-Match', E.etag[o])),
                ((p.data && p.hasContent && !1 !== p.contentType) || t.contentType) &&
                  S.setRequestHeader('Content-Type', p.contentType),
                S.setRequestHeader(
                  'Accept',
                  p.dataTypes[0] && p.accepts[p.dataTypes[0]]
                    ? p.accepts[p.dataTypes[0]] + ('*' !== p.dataTypes[0] ? ', ' + Wt + '; q=0.01' : '')
                    : p.accepts['*']
                ),
                p.headers))
                  S.setRequestHeader(f, p.headers[f]);
                if (p.beforeSend && (!1 === p.beforeSend.call(h, S, p) || s)) return S.abort();
                if (((k = 'abort'), g.add(p.complete), S.done(p.success), S.fail(p.error), (n = Kt(qt, p, t, S)))) {
                  if (((S.readyState = 1), c && v.trigger('ajaxSend', [S, p]), s)) return S;
                  p.async &&
                    p.timeout > 0 &&
                    (l = r.setTimeout(function () {
                      S.abort('timeout');
                    }, p.timeout));
                  try {
                    (s = !1), n.send(b, _);
                  } catch (C) {
                    if (s) throw C;
                    _(-1, C);
                  }
                } else _(-1, 'No Transport');
                function _(e, t, i, u) {
                  var f,
                    d,
                    y,
                    b,
                    x,
                    k = t;
                  s ||
                    ((s = !0),
                    l && r.clearTimeout(l),
                    (n = void 0),
                    (a = u || ''),
                    (S.readyState = e > 0 ? 4 : 0),
                    (f = (e >= 200 && e < 300) || 304 === e),
                    i &&
                      (b = (function (e, t, n) {
                        for (var r, o, a, i, l = e.contents, u = e.dataTypes; '*' === u[0]; )
                          u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader('Content-Type'));
                        if (r)
                          for (o in l)
                            if (l[o] && l[o].test(r)) {
                              u.unshift(o);
                              break;
                            }
                        if (u[0] in n) a = u[0];
                        else {
                          for (o in n) {
                            if (!u[0] || e.converters[o + ' ' + u[0]]) {
                              a = o;
                              break;
                            }
                            i || (i = o);
                          }
                          a = a || i;
                        }
                        if (a) return a !== u[0] && u.unshift(a), n[a];
                      })(p, S, i)),
                    !f &&
                      E.inArray('script', p.dataTypes) > -1 &&
                      E.inArray('json', p.dataTypes) < 0 &&
                      (p.converters['text script'] = function () {}),
                    (b = (function (e, t, n, r) {
                      var o,
                        a,
                        i,
                        l,
                        u,
                        s = {},
                        c = e.dataTypes.slice();
                      if (c[1]) for (i in e.converters) s[i.toLowerCase()] = e.converters[i];
                      for (a = c.shift(); a; )
                        if (
                          (e.responseFields[a] && (n[e.responseFields[a]] = t),
                          !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                          (u = a),
                          (a = c.shift()))
                        )
                          if ('*' === a) a = u;
                          else if ('*' !== u && u !== a) {
                            if (!(i = s[u + ' ' + a] || s['* ' + a]))
                              for (o in s)
                                if ((l = o.split(' '))[1] === a && (i = s[u + ' ' + l[0]] || s['* ' + l[0]])) {
                                  !0 === i ? (i = s[o]) : !0 !== s[o] && ((a = l[0]), c.unshift(l[1]));
                                  break;
                                }
                            if (!0 !== i)
                              if (i && e.throws) t = i(t);
                              else
                                try {
                                  t = i(t);
                                } catch (C) {
                                  return {
                                    state: 'parsererror',
                                    error: i ? C : 'No conversion from ' + u + ' to ' + a,
                                  };
                                }
                          }
                      return { state: 'success', data: t };
                    })(p, b, S, f)),
                    f
                      ? (p.ifModified &&
                          ((x = S.getResponseHeader('Last-Modified')) && (E.lastModified[o] = x),
                          (x = S.getResponseHeader('etag')) && (E.etag[o] = x)),
                        204 === e || 'HEAD' === p.type
                          ? (k = 'nocontent')
                          : 304 === e
                          ? (k = 'notmodified')
                          : ((k = b.state), (d = b.data), (f = !(y = b.error))))
                      : ((y = k), (!e && k) || ((k = 'error'), e < 0 && (e = 0))),
                    (S.status = e),
                    (S.statusText = (t || k) + ''),
                    f ? m.resolveWith(h, [d, k, S]) : m.rejectWith(h, [S, k, y]),
                    S.statusCode(w),
                    (w = void 0),
                    c && v.trigger(f ? 'ajaxSuccess' : 'ajaxError', [S, p, f ? d : y]),
                    g.fireWith(h, [S, k]),
                    c && (v.trigger('ajaxComplete', [S, p]), --E.active || E.event.trigger('ajaxStop')));
                }
                return S;
              },
              getJSON: function (e, t, n) {
                return E.get(e, t, n, 'json');
              },
              getScript: function (e, t) {
                return E.get(e, void 0, t, 'script');
              },
            }),
            E.each(['get', 'post'], function (e, t) {
              E[t] = function (e, n, r, o) {
                return (
                  g(n) && ((o = o || r), (r = n), (n = void 0)),
                  E.ajax(E.extend({ url: e, type: t, dataType: o, data: n, success: r }, E.isPlainObject(e) && e))
                );
              };
            }),
            E.ajaxPrefilter(function (e) {
              var t;
              for (t in e.headers) 'content-type' === t.toLowerCase() && (e.contentType = e.headers[t] || '');
            }),
            (E._evalUrl = function (e, t, n) {
              return E.ajax({
                url: e,
                type: 'GET',
                dataType: 'script',
                cache: !0,
                async: !1,
                global: !1,
                converters: { 'text script': function () {} },
                dataFilter: function (e) {
                  E.globalEval(e, t, n);
                },
              });
            }),
            E.fn.extend({
              wrapAll: function (e) {
                var t;
                return (
                  this[0] &&
                    (g(e) && (e = e.call(this[0])),
                    (t = E(e, this[0].ownerDocument).eq(0).clone(!0)),
                    this[0].parentNode && t.insertBefore(this[0]),
                    t
                      .map(function () {
                        for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                        return e;
                      })
                      .append(this)),
                  this
                );
              },
              wrapInner: function (e) {
                return g(e)
                  ? this.each(function (t) {
                      E(this).wrapInner(e.call(this, t));
                    })
                  : this.each(function () {
                      var t = E(this),
                        n = t.contents();
                      n.length ? n.wrapAll(e) : t.append(e);
                    });
              },
              wrap: function (e) {
                var t = g(e);
                return this.each(function (n) {
                  E(this).wrapAll(t ? e.call(this, n) : e);
                });
              },
              unwrap: function (e) {
                return (
                  this.parent(e)
                    .not('body')
                    .each(function () {
                      E(this).replaceWith(this.childNodes);
                    }),
                  this
                );
              },
            }),
            (E.expr.pseudos.hidden = function (e) {
              return !E.expr.pseudos.visible(e);
            }),
            (E.expr.pseudos.visible = function (e) {
              return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
            }),
            (E.ajaxSettings.xhr = function () {
              try {
                return new r.XMLHttpRequest();
              } catch (e) {}
            });
          var Yt = { 0: 200, 1223: 204 },
            Xt = E.ajaxSettings.xhr();
          (m.cors = !!Xt && 'withCredentials' in Xt),
            (m.ajax = Xt = !!Xt),
            E.ajaxTransport(function (e) {
              var t, n;
              if (m.cors || (Xt && !e.crossDomain))
                return {
                  send: function (o, a) {
                    var i,
                      l = e.xhr();
                    if ((l.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields))
                      for (i in e.xhrFields) l[i] = e.xhrFields[i];
                    for (i in (e.mimeType && l.overrideMimeType && l.overrideMimeType(e.mimeType),
                    e.crossDomain || o['X-Requested-With'] || (o['X-Requested-With'] = 'XMLHttpRequest'),
                    o))
                      l.setRequestHeader(i, o[i]);
                    (t = function (e) {
                      return function () {
                        t &&
                          ((t = n = l.onload = l.onerror = l.onabort = l.ontimeout = l.onreadystatechange = null),
                          'abort' === e
                            ? l.abort()
                            : 'error' === e
                            ? 'number' !== typeof l.status
                              ? a(0, 'error')
                              : a(l.status, l.statusText)
                            : a(
                                Yt[l.status] || l.status,
                                l.statusText,
                                'text' !== (l.responseType || 'text') || 'string' !== typeof l.responseText
                                  ? { binary: l.response }
                                  : { text: l.responseText },
                                l.getAllResponseHeaders()
                              ));
                      };
                    }),
                      (l.onload = t()),
                      (n = l.onerror = l.ontimeout = t('error')),
                      void 0 !== l.onabort
                        ? (l.onabort = n)
                        : (l.onreadystatechange = function () {
                            4 === l.readyState &&
                              r.setTimeout(function () {
                                t && n();
                              });
                          }),
                      (t = t('abort'));
                    try {
                      l.send((e.hasContent && e.data) || null);
                    } catch (u) {
                      if (t) throw u;
                    }
                  },
                  abort: function () {
                    t && t();
                  },
                };
            }),
            E.ajaxPrefilter(function (e) {
              e.crossDomain && (e.contents.script = !1);
            }),
            E.ajaxSetup({
              accepts: {
                script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
              },
              contents: { script: /\b(?:java|ecma)script\b/ },
              converters: {
                'text script': function (e) {
                  return E.globalEval(e), e;
                },
              },
            }),
            E.ajaxPrefilter('script', function (e) {
              void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = 'GET');
            }),
            E.ajaxTransport('script', function (e) {
              var t, n;
              if (e.crossDomain || e.scriptAttrs)
                return {
                  send: function (r, o) {
                    (t = E('<script>')
                      .attr(e.scriptAttrs || {})
                      .prop({ charset: e.scriptCharset, src: e.url })
                      .on(
                        'load error',
                        (n = function (e) {
                          t.remove(), (n = null), e && o('error' === e.type ? 404 : 200, e.type);
                        })
                      )),
                      y.head.appendChild(t[0]);
                  },
                  abort: function () {
                    n && n();
                  },
                };
            });
          var Jt = [],
            Zt = /(=)\?(?=&|$)|\?\?/;
          E.ajaxSetup({
            jsonp: 'callback',
            jsonpCallback: function () {
              var e = Jt.pop() || E.expando + '_' + Nt.guid++;
              return (this[e] = !0), e;
            },
          }),
            E.ajaxPrefilter('json jsonp', function (e, t, n) {
              var o,
                a,
                i,
                l =
                  !1 !== e.jsonp &&
                  (Zt.test(e.url)
                    ? 'url'
                    : 'string' === typeof e.data &&
                      0 === (e.contentType || '').indexOf('application/x-www-form-urlencoded') &&
                      Zt.test(e.data) &&
                      'data');
              if (l || 'jsonp' === e.dataTypes[0])
                return (
                  (o = e.jsonpCallback = g(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                  l
                    ? (e[l] = e[l].replace(Zt, '$1' + o))
                    : !1 !== e.jsonp && (e.url += (jt.test(e.url) ? '&' : '?') + e.jsonp + '=' + o),
                  (e.converters['script json'] = function () {
                    return i || E.error(o + ' was not called'), i[0];
                  }),
                  (e.dataTypes[0] = 'json'),
                  (a = r[o]),
                  (r[o] = function () {
                    i = arguments;
                  }),
                  n.always(function () {
                    void 0 === a ? E(r).removeProp(o) : (r[o] = a),
                      e[o] && ((e.jsonpCallback = t.jsonpCallback), Jt.push(o)),
                      i && g(a) && a(i[0]),
                      (i = a = void 0);
                  }),
                  'script'
                );
            }),
            (m.createHTMLDocument = (function () {
              var e = y.implementation.createHTMLDocument('').body;
              return (e.innerHTML = '<form></form><form></form>'), 2 === e.childNodes.length;
            })()),
            (E.parseHTML = function (e, t, n) {
              return 'string' !== typeof e
                ? []
                : ('boolean' === typeof t && ((n = t), (t = !1)),
                  t ||
                    (m.createHTMLDocument
                      ? (((r = (t = y.implementation.createHTMLDocument('')).createElement('base')).href =
                          y.location.href),
                        t.head.appendChild(r))
                      : (t = y)),
                  (a = !n && []),
                  (o = B.exec(e))
                    ? [t.createElement(o[1])]
                    : ((o = Le([e], t, a)), a && a.length && E(a).remove(), E.merge([], o.childNodes)));
              var r, o, a;
            }),
            (E.fn.load = function (e, t, n) {
              var r,
                o,
                a,
                i = this,
                l = e.indexOf(' ');
              return (
                l > -1 && ((r = St(e.slice(l))), (e = e.slice(0, l))),
                g(t) ? ((n = t), (t = void 0)) : t && 'object' === typeof t && (o = 'POST'),
                i.length > 0 &&
                  E.ajax({ url: e, type: o || 'GET', dataType: 'html', data: t })
                    .done(function (e) {
                      (a = arguments), i.html(r ? E('<div>').append(E.parseHTML(e)).find(r) : e);
                    })
                    .always(
                      n &&
                        function (e, t) {
                          i.each(function () {
                            n.apply(this, a || [e.responseText, t, e]);
                          });
                        }
                    ),
                this
              );
            }),
            (E.expr.pseudos.animated = function (e) {
              return E.grep(E.timers, function (t) {
                return e === t.elem;
              }).length;
            }),
            (E.offset = {
              setOffset: function (e, t, n) {
                var r,
                  o,
                  a,
                  i,
                  l,
                  u,
                  s = E.css(e, 'position'),
                  c = E(e),
                  f = {};
                'static' === s && (e.style.position = 'relative'),
                  (l = c.offset()),
                  (a = E.css(e, 'top')),
                  (u = E.css(e, 'left')),
                  ('absolute' === s || 'fixed' === s) && (a + u).indexOf('auto') > -1
                    ? ((i = (r = c.position()).top), (o = r.left))
                    : ((i = parseFloat(a) || 0), (o = parseFloat(u) || 0)),
                  g(t) && (t = t.call(e, n, E.extend({}, l))),
                  null != t.top && (f.top = t.top - l.top + i),
                  null != t.left && (f.left = t.left - l.left + o),
                  'using' in t ? t.using.call(e, f) : c.css(f);
              },
            }),
            E.fn.extend({
              offset: function (e) {
                if (arguments.length)
                  return void 0 === e
                    ? this
                    : this.each(function (t) {
                        E.offset.setOffset(this, e, t);
                      });
                var t,
                  n,
                  r = this[0];
                return r
                  ? r.getClientRects().length
                    ? ((t = r.getBoundingClientRect()),
                      (n = r.ownerDocument.defaultView),
                      { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset })
                    : { top: 0, left: 0 }
                  : void 0;
              },
              position: function () {
                if (this[0]) {
                  var e,
                    t,
                    n,
                    r = this[0],
                    o = { top: 0, left: 0 };
                  if ('fixed' === E.css(r, 'position')) t = r.getBoundingClientRect();
                  else {
                    for (
                      t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement;
                      e && (e === n.body || e === n.documentElement) && 'static' === E.css(e, 'position');

                    )
                      e = e.parentNode;
                    e &&
                      e !== r &&
                      1 === e.nodeType &&
                      (((o = E(e).offset()).top += E.css(e, 'borderTopWidth', !0)),
                      (o.left += E.css(e, 'borderLeftWidth', !0)));
                  }
                  return {
                    top: t.top - o.top - E.css(r, 'marginTop', !0),
                    left: t.left - o.left - E.css(r, 'marginLeft', !0),
                  };
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (var e = this.offsetParent; e && 'static' === E.css(e, 'position'); ) e = e.offsetParent;
                  return e || ve;
                });
              },
            }),
            E.each({ scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' }, function (e, t) {
              var n = 'pageYOffset' === t;
              E.fn[e] = function (r) {
                return ee(
                  this,
                  function (e, r, o) {
                    var a;
                    if ((w(e) ? (a = e) : 9 === e.nodeType && (a = e.defaultView), void 0 === o))
                      return a ? a[t] : e[r];
                    a ? a.scrollTo(n ? a.pageXOffset : o, n ? o : a.pageYOffset) : (e[r] = o);
                  },
                  e,
                  r,
                  arguments.length
                );
              };
            }),
            E.each(['top', 'left'], function (e, t) {
              E.cssHooks[t] = Je(m.pixelPosition, function (e, n) {
                if (n) return (n = Xe(e, t)), $e.test(n) ? E(e).position()[t] + 'px' : n;
              });
            }),
            E.each({ Height: 'height', Width: 'width' }, function (e, t) {
              E.each({ padding: 'inner' + e, content: t, '': 'outer' + e }, function (n, r) {
                E.fn[r] = function (o, a) {
                  var i = arguments.length && (n || 'boolean' !== typeof o),
                    l = n || (!0 === o || !0 === a ? 'margin' : 'border');
                  return ee(
                    this,
                    function (t, n, o) {
                      var a;
                      return w(t)
                        ? 0 === r.indexOf('outer')
                          ? t['inner' + e]
                          : t.document.documentElement['client' + e]
                        : 9 === t.nodeType
                        ? ((a = t.documentElement),
                          Math.max(
                            t.body['scroll' + e],
                            a['scroll' + e],
                            t.body['offset' + e],
                            a['offset' + e],
                            a['client' + e]
                          ))
                        : void 0 === o
                        ? E.css(t, n, l)
                        : E.style(t, n, o, l);
                    },
                    t,
                    i ? o : void 0,
                    i
                  );
                };
              });
            }),
            E.each(['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'], function (e, t) {
              E.fn[t] = function (e) {
                return this.on(t, e);
              };
            }),
            E.fn.extend({
              bind: function (e, t, n) {
                return this.on(e, null, t, n);
              },
              unbind: function (e, t) {
                return this.off(e, null, t);
              },
              delegate: function (e, t, n, r) {
                return this.on(t, e, n, r);
              },
              undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, '**') : this.off(t, e || '**', n);
              },
              hover: function (e, t) {
                return this.on('mouseenter', e).on('mouseleave', t || e);
              },
            }),
            E.each(
              'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
                ' '
              ),
              function (e, t) {
                E.fn[t] = function (e, n) {
                  return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
                };
              }
            );
          var en = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
          (E.proxy = function (e, t) {
            var n, r, o;
            if (('string' === typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
              return (
                (r = l.call(arguments, 2)),
                (o = function () {
                  return e.apply(t || this, r.concat(l.call(arguments)));
                }),
                (o.guid = e.guid = e.guid || E.guid++),
                o
              );
          }),
            (E.holdReady = function (e) {
              e ? E.readyWait++ : E.ready(!0);
            }),
            (E.isArray = Array.isArray),
            (E.parseJSON = JSON.parse),
            (E.nodeName = T),
            (E.isFunction = g),
            (E.isWindow = w),
            (E.camelCase = oe),
            (E.type = k),
            (E.now = Date.now),
            (E.isNumeric = function (e) {
              var t = E.type(e);
              return ('number' === t || 'string' === t) && !isNaN(e - parseFloat(e));
            }),
            (E.trim = function (e) {
              return null == e ? '' : (e + '').replace(en, '$1');
            }),
            void 0 ===
              (n = function () {
                return E;
              }.apply(t, [])) || (e.exports = n);
          var tn = r.jQuery,
            nn = r.$;
          return (
            (E.noConflict = function (e) {
              return r.$ === E && (r.$ = nn), e && r.jQuery === E && (r.jQuery = tn), E;
            }),
            'undefined' === typeof o && (r.jQuery = r.$ = E),
            E
          );
        });
      },
    },
    t = {};
  function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var a = (t[r] = { exports: {} });
    return e[r].call(a.exports, a, a.exports, n), a.exports;
  }
  (n.m = e),
    (n.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return n.d(t, { a: t }), t;
    }),
    (function () {
      var e,
        t = Object.getPrototypeOf
          ? function (e) {
              return Object.getPrototypeOf(e);
            }
          : function (e) {
              return e.__proto__;
            };
      n.t = function (r, o) {
        if ((1 & o && (r = this(r)), 8 & o)) return r;
        if ('object' === typeof r && r) {
          if (4 & o && r.__esModule) return r;
          if (16 & o && 'function' === typeof r.then) return r;
        }
        var a = Object.create(null);
        n.r(a);
        var i = {};
        e = e || [null, t({}), t([]), t(t)];
        for (var l = 2 & o && r; 'object' == typeof l && !~e.indexOf(l); l = t(l))
          Object.getOwnPropertyNames(l).forEach(function (e) {
            i[e] = function () {
              return r[e];
            };
          });
        return (
          (i.default = function () {
            return r;
          }),
          n.d(a, i),
          a
        );
      };
    })(),
    (n.d = function (e, t) {
      for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.f = {}),
    (n.e = function (e) {
      return Promise.all(
        Object.keys(n.f).reduce(function (t, r) {
          return n.f[r](e, t), t;
        }, [])
      );
    }),
    (n.u = function (e) {
      return 'static/js/' + e + '.76c96522.chunk.js';
    }),
    (n.miniCssF = function (e) {}),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = {},
        t = 'bundler-app:';
      n.l = function (r, o, a, i) {
        if (e[r]) e[r].push(o);
        else {
          var l, u;
          if (void 0 !== a)
            for (var s = document.getElementsByTagName('script'), c = 0; c < s.length; c++) {
              var f = s[c];
              if (f.getAttribute('src') == r || f.getAttribute('data-webpack') == t + a) {
                l = f;
                break;
              }
            }
          l ||
            ((u = !0),
            ((l = document.createElement('script')).charset = 'utf-8'),
            (l.timeout = 120),
            n.nc && l.setAttribute('nonce', n.nc),
            l.setAttribute('data-webpack', t + a),
            (l.src = r)),
            (e[r] = [o]);
          var d = function (t, n) {
              (l.onerror = l.onload = null), clearTimeout(p);
              var o = e[r];
              if (
                (delete e[r],
                l.parentNode && l.parentNode.removeChild(l),
                o &&
                  o.forEach(function (e) {
                    return e(n);
                  }),
                t)
              )
                return t(n);
            },
            p = setTimeout(d.bind(null, void 0, { type: 'timeout', target: l }), 12e4);
          (l.onerror = d.bind(null, l.onerror)), (l.onload = d.bind(null, l.onload)), u && document.head.appendChild(l);
        }
      };
    })(),
    (n.r = function (e) {
      'undefined' !== typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(e, '__esModule', { value: !0 });
    }),
    (n.p = '/'),
    (function () {
      var e = { 179: 0 };
      n.f.j = function (t, r) {
        var o = n.o(e, t) ? e[t] : void 0;
        if (0 !== o)
          if (o) r.push(o[2]);
          else {
            var a = new Promise(function (n, r) {
              o = e[t] = [n, r];
            });
            r.push((o[2] = a));
            var i = n.p + n.u(t),
              l = new Error();
            n.l(
              i,
              function (r) {
                if (n.o(e, t) && (0 !== (o = e[t]) && (e[t] = void 0), o)) {
                  var a = r && ('load' === r.type ? 'missing' : r.type),
                    i = r && r.target && r.target.src;
                  (l.message = 'Loading chunk ' + t + ' failed.\n(' + a + ': ' + i + ')'),
                    (l.name = 'ChunkLoadError'),
                    (l.type = a),
                    (l.request = i),
                    o[1](l);
                }
              },
              'chunk-' + t,
              t
            );
          }
      };
      var t = function (t, r) {
          var o,
            a,
            i = r[0],
            l = r[1],
            u = r[2],
            s = 0;
          if (
            i.some(function (t) {
              return 0 !== e[t];
            })
          ) {
            for (o in l) n.o(l, o) && (n.m[o] = l[o]);
            if (u) u(n);
          }
          for (t && t(r); s < i.length; s++) (a = i[s]), n.o(e, a) && e[a] && e[a][0](), (e[a] = 0);
        },
        r = (self.webpackChunkbundler_app = self.webpackChunkbundler_app || []);
      r.forEach(t.bind(null, 0)), (r.push = t.bind(null, r.push.bind(r)));
    })(),
    (function () {
      'use strict';
      var e = n(791),
        t = n.t(e, 2),
        r = n(250);
      function o(e) {
        return (
          (o =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                    ? 'symbol'
                    : typeof e;
                }),
          o(e)
        );
      }
      function a() {
        a = function () {
          return e;
        };
        var e = {},
          t = Object.prototype,
          n = t.hasOwnProperty,
          r =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          i = 'function' == typeof Symbol ? Symbol : {},
          l = i.iterator || '@@iterator',
          u = i.asyncIterator || '@@asyncIterator',
          s = i.toStringTag || '@@toStringTag';
        function c(e, t, n) {
          return Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }), e[t];
        }
        try {
          c({}, '');
        } catch (L) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function f(e, t, n, o) {
          var a = t && t.prototype instanceof h ? t : h,
            i = Object.create(a.prototype),
            l = new T(o || []);
          return r(i, '_invoke', { value: S(e, n, l) }), i;
        }
        function d(e, t, n) {
          try {
            return { type: 'normal', arg: e.call(t, n) };
          } catch (L) {
            return { type: 'throw', arg: L };
          }
        }
        e.wrap = f;
        var p = {};
        function h() {}
        function v() {}
        function m() {}
        var g = {};
        c(g, l, function () {
          return this;
        });
        var w = Object.getPrototypeOf,
          y = w && w(w(N([])));
        y && y !== t && n.call(y, l) && (g = y);
        var b = (m.prototype = h.prototype = Object.create(g));
        function x(e) {
          ['next', 'throw', 'return'].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function k(e, t) {
          function a(r, i, l, u) {
            var s = d(e[r], e, i);
            if ('throw' !== s.type) {
              var c = s.arg,
                f = c.value;
              return f && 'object' == o(f) && n.call(f, '__await')
                ? t.resolve(f.__await).then(
                    function (e) {
                      a('next', e, l, u);
                    },
                    function (e) {
                      a('throw', e, l, u);
                    }
                  )
                : t.resolve(f).then(
                    function (e) {
                      (c.value = e), l(c);
                    },
                    function (e) {
                      return a('throw', e, l, u);
                    }
                  );
            }
            u(s.arg);
          }
          var i;
          r(this, '_invoke', {
            value: function (e, n) {
              function r() {
                return new t(function (t, r) {
                  a(e, n, t, r);
                });
              }
              return (i = i ? i.then(r, r) : r());
            },
          });
        }
        function S(e, t, n) {
          var r = 'suspendedStart';
          return function (o, a) {
            if ('executing' === r) throw new Error('Generator is already running');
            if ('completed' === r) {
              if ('throw' === o) throw a;
              return j();
            }
            for (n.method = o, n.arg = a; ; ) {
              var i = n.delegate;
              if (i) {
                var l = _(i, n);
                if (l) {
                  if (l === p) continue;
                  return l;
                }
              }
              if ('next' === n.method) n.sent = n._sent = n.arg;
              else if ('throw' === n.method) {
                if ('suspendedStart' === r) throw ((r = 'completed'), n.arg);
                n.dispatchException(n.arg);
              } else 'return' === n.method && n.abrupt('return', n.arg);
              r = 'executing';
              var u = d(e, t, n);
              if ('normal' === u.type) {
                if (((r = n.done ? 'completed' : 'suspendedYield'), u.arg === p)) continue;
                return { value: u.arg, done: n.done };
              }
              'throw' === u.type && ((r = 'completed'), (n.method = 'throw'), (n.arg = u.arg));
            }
          };
        }
        function _(e, t) {
          var n = t.method,
            r = e.iterator[n];
          if (void 0 === r)
            return (
              (t.delegate = null),
              ('throw' === n &&
                e.iterator.return &&
                ((t.method = 'return'), (t.arg = void 0), _(e, t), 'throw' === t.method)) ||
                ('return' !== n &&
                  ((t.method = 'throw'),
                  (t.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
              p
            );
          var o = d(r, e.iterator, t.arg);
          if ('throw' === o.type) return (t.method = 'throw'), (t.arg = o.arg), (t.delegate = null), p;
          var a = o.arg;
          return a
            ? a.done
              ? ((t[e.resultName] = a.value),
                (t.next = e.nextLoc),
                'return' !== t.method && ((t.method = 'next'), (t.arg = void 0)),
                (t.delegate = null),
                p)
              : a
            : ((t.method = 'throw'),
              (t.arg = new TypeError('iterator result is not an object')),
              (t.delegate = null),
              p);
        }
        function E(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function C(e) {
          var t = e.completion || {};
          (t.type = 'normal'), delete t.arg, (e.completion = t);
        }
        function T(e) {
          (this.tryEntries = [{ tryLoc: 'root' }]), e.forEach(E, this), this.reset(!0);
        }
        function N(e) {
          if (e) {
            var t = e[l];
            if (t) return t.call(e);
            if ('function' == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var r = -1,
                o = function t() {
                  for (; ++r < e.length; ) if (n.call(e, r)) return (t.value = e[r]), (t.done = !1), t;
                  return (t.value = void 0), (t.done = !0), t;
                };
              return (o.next = o);
            }
          }
          return { next: j };
        }
        function j() {
          return { value: void 0, done: !0 };
        }
        return (
          (v.prototype = m),
          r(b, 'constructor', { value: m, configurable: !0 }),
          r(m, 'constructor', { value: v, configurable: !0 }),
          (v.displayName = c(m, s, 'GeneratorFunction')),
          (e.isGeneratorFunction = function (e) {
            var t = 'function' == typeof e && e.constructor;
            return !!t && (t === v || 'GeneratorFunction' === (t.displayName || t.name));
          }),
          (e.mark = function (e) {
            return (
              Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : ((e.__proto__ = m), c(e, s, 'GeneratorFunction')),
              (e.prototype = Object.create(b)),
              e
            );
          }),
          (e.awrap = function (e) {
            return { __await: e };
          }),
          x(k.prototype),
          c(k.prototype, u, function () {
            return this;
          }),
          (e.AsyncIterator = k),
          (e.async = function (t, n, r, o, a) {
            void 0 === a && (a = Promise);
            var i = new k(f(t, n, r, o), a);
            return e.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          x(b),
          c(b, s, 'Generator'),
          c(b, l, function () {
            return this;
          }),
          c(b, 'toString', function () {
            return '[object Generator]';
          }),
          (e.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var r in t) n.push(r);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in t) return (e.value = r), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (e.values = N),
          (T.prototype = {
            constructor: T,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = void 0),
                (this.done = !1),
                (this.delegate = null),
                (this.method = 'next'),
                (this.arg = void 0),
                this.tryEntries.forEach(C),
                !e)
              )
                for (var t in this) 't' === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ('throw' === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var t = this;
              function r(n, r) {
                return (i.type = 'throw'), (i.arg = e), (t.next = n), r && ((t.method = 'next'), (t.arg = void 0)), !!r;
              }
              for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                var a = this.tryEntries[o],
                  i = a.completion;
                if ('root' === a.tryLoc) return r('end');
                if (a.tryLoc <= this.prev) {
                  var l = n.call(a, 'catchLoc'),
                    u = n.call(a, 'finallyLoc');
                  if (l && u) {
                    if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                  } else if (l) {
                    if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                  } else {
                    if (!u) throw new Error('try statement without catch or finally');
                    if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                  var a = o;
                  break;
                }
              }
              a && ('break' === e || 'continue' === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
              var i = a ? a.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                a ? ((this.method = 'next'), (this.next = a.finallyLoc), p) : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ('throw' === e.type) throw e.arg;
              return (
                'break' === e.type || 'continue' === e.type
                  ? (this.next = e.arg)
                  : 'return' === e.type
                  ? ((this.rval = this.arg = e.arg), (this.method = 'return'), (this.next = 'end'))
                  : 'normal' === e.type && t && (this.next = t),
                p
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), C(n), p;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var r = n.completion;
                  if ('throw' === r.type) {
                    var o = r.arg;
                    C(n);
                  }
                  return o;
                }
              }
              throw new Error('illegal catch attempt');
            },
            delegateYield: function (e, t, n) {
              return (
                (this.delegate = { iterator: N(e), resultName: t, nextLoc: n }),
                'next' === this.method && (this.arg = void 0),
                p
              );
            },
          }),
          e
        );
      }
      function i(e, t, n, r, o, a, i) {
        try {
          var l = e[a](i),
            u = l.value;
        } catch (s) {
          return void n(s);
        }
        l.done ? t(u) : Promise.resolve(u).then(r, o);
      }
      function l(e) {
        return function () {
          var t = this,
            n = arguments;
          return new Promise(function (r, o) {
            var a = e.apply(t, n);
            function l(e) {
              i(a, r, o, l, u, 'next', e);
            }
            function u(e) {
              i(a, r, o, l, u, 'throw', e);
            }
            l(void 0);
          });
        };
      }
      function u(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function s(e, t) {
        if (e) {
          if ('string' === typeof e) return u(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return (
            'Object' === n && e.constructor && (n = e.constructor.name),
            'Map' === n || 'Set' === n
              ? Array.from(e)
              : 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              ? u(e, t)
              : void 0
          );
        }
      }
      function c(e, t) {
        return (
          (function (e) {
            if (Array.isArray(e)) return e;
          })(e) ||
          (function (e, t) {
            var n = null == e ? null : ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
            if (null != n) {
              var r,
                o,
                a,
                i,
                l = [],
                u = !0,
                s = !1;
              try {
                if (((a = (n = n.call(e)).next), 0 === t)) {
                  if (Object(n) !== n) return;
                  u = !1;
                } else for (; !(u = (r = a.call(n)).done) && (l.push(r.value), l.length !== t); u = !0);
              } catch (c) {
                (s = !0), (o = c);
              } finally {
                try {
                  if (!u && null != n.return && ((i = n.return()), Object(i) !== i)) return;
                } finally {
                  if (s) throw o;
                }
              }
              return l;
            }
          })(e, t) ||
          s(e, t) ||
          (function () {
            throw new TypeError(
              'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          })()
        );
      }
      function f(e) {
        return (
          (function (e) {
            if (Array.isArray(e)) return u(e);
          })(e) ||
          (function (e) {
            if (('undefined' !== typeof Symbol && null != e[Symbol.iterator]) || null != e['@@iterator'])
              return Array.from(e);
          })(e) ||
          s(e) ||
          (function () {
            throw new TypeError(
              'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          })()
        );
      }
      function d(e, t) {
        if (null == e) return {};
        var n,
          r,
          o = {},
          a = Object.keys(e);
        for (r = 0; r < a.length; r++) (n = a[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o;
      }
      function p(e, t) {
        if (null == e) return {};
        var n,
          r,
          o = d(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (r = 0; r < a.length; r++)
            (n = a[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]));
        }
        return o;
      }
      function h(e) {
        return (
          (h = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (e) {
                return e.__proto__ || Object.getPrototypeOf(e);
              }),
          h(e)
        );
      }
      function v(e, t) {
        return (
          (v = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (e, t) {
                return (e.__proto__ = t), e;
              }),
          v(e, t)
        );
      }
      function m() {
        if ('undefined' === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ('function' === typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }
      function g(e, t, n) {
        return (
          (g = m()
            ? Reflect.construct.bind()
            : function (e, t, n) {
                var r = [null];
                r.push.apply(r, t);
                var o = new (Function.bind.apply(e, r))();
                return n && v(o, n.prototype), o;
              }),
          g.apply(null, arguments)
        );
      }
      function w(e) {
        var t = 'function' === typeof Map ? new Map() : void 0;
        return (
          (w = function (e) {
            if (null === e || ((n = e), -1 === Function.toString.call(n).indexOf('[native code]'))) return e;
            var n;
            if ('function' !== typeof e) throw new TypeError('Super expression must either be null or a function');
            if ('undefined' !== typeof t) {
              if (t.has(e)) return t.get(e);
              t.set(e, r);
            }
            function r() {
              return g(e, arguments, h(this).constructor);
            }
            return (
              (r.prototype = Object.create(e.prototype, {
                constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 },
              })),
              v(r, e)
            );
          }),
          w(e)
        );
      }
      function y(e, t) {
        var n = ('undefined' !== typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
        if (!n) {
          if (Array.isArray(e) || (n = s(e)) || (t && e && 'number' === typeof e.length)) {
            n && (e = n);
            var r = 0,
              o = function () {};
            return {
              s: o,
              n: function () {
                return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
              },
              e: function (e) {
                throw e;
              },
              f: o,
            };
          }
          throw new TypeError(
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          );
        }
        var a,
          i = !0,
          l = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (i = e.done), e;
          },
          e: function (e) {
            (l = !0), (a = e);
          },
          f: function () {
            try {
              i || null == n.return || n.return();
            } finally {
              if (l) throw a;
            }
          },
        };
      }
      function b(e) {
        var t = (function (e, t) {
          if ('object' !== o(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var r = n.call(e, t || 'default');
            if ('object' !== o(r)) return r;
            throw new TypeError('@@toPrimitive must return a primitive value.');
          }
          return ('string' === t ? String : Number)(e);
        })(e, 'string');
        return 'symbol' === o(t) ? t : String(t);
      }
      function x(e, t, n) {
        return (
          (t = b(t)) in e
            ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
            : (e[t] = n),
          e
        );
      }
      function k(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function S(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? k(Object(n), !0).forEach(function (t) {
                x(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : k(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
        }
        return e;
      }
      function _(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function E(e, t) {
        if ('function' !== typeof t && null !== t)
          throw new TypeError('Super expression must either be null or a function');
        (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
          Object.defineProperty(e, 'prototype', { writable: !1 }),
          t && v(e, t);
      }
      function C(e, t) {
        if (t && ('object' === o(t) || 'function' === typeof t)) return t;
        if (void 0 !== t) throw new TypeError('Derived constructors may only return object or undefined');
        return _(e);
      }
      function T(e) {
        var t = m();
        return function () {
          var n,
            r = h(e);
          if (t) {
            var o = h(this).constructor;
            n = Reflect.construct(r, arguments, o);
          } else n = r.apply(this, arguments);
          return C(this, n);
        };
      }
      function N(e, t) {
        if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
      }
      function j(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            'value' in r && (r.writable = !0),
            Object.defineProperty(e, b(r.key), r);
        }
      }
      function L(e, t, n) {
        return t && j(e.prototype, t), n && j(e, n), Object.defineProperty(e, 'prototype', { writable: !1 }), e;
      }
      var A = n(164),
        R = ['override'],
        P = ['cachePolicyForParams_UNSTABLE'],
        O = a().mark(ht),
        D = a().mark(Cn);
      var I = function (e) {
        var t = new Error(e);
        if (void 0 === t.stack)
          try {
            throw t;
          } catch (n) {}
        return t;
      };
      var M = function (e) {
        return !!e && 'function' === typeof e.then;
      };
      var z = function (e, t) {
        if (null != e) return e;
        throw I(null !== t && void 0 !== t ? t : 'Got unexpected null or undefined');
      };
      function V(e, t, n) {
        return (
          t in e
            ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
            : (e[t] = n),
          e
        );
      }
      var B = (function () {
          function e() {
            N(this, e);
          }
          return (
            L(e, [
              {
                key: 'getValue',
                value: function () {
                  throw I('BaseLoadable');
                },
              },
              {
                key: 'toPromise',
                value: function () {
                  throw I('BaseLoadable');
                },
              },
              {
                key: 'valueMaybe',
                value: function () {
                  throw I('BaseLoadable');
                },
              },
              {
                key: 'valueOrThrow',
                value: function () {
                  throw I('Loadable expected value, but in "'.concat(this.state, '" state'));
                },
              },
              {
                key: 'promiseMaybe',
                value: function () {
                  throw I('BaseLoadable');
                },
              },
              {
                key: 'promiseOrThrow',
                value: function () {
                  throw I('Loadable expected promise, but in "'.concat(this.state, '" state'));
                },
              },
              {
                key: 'errorMaybe',
                value: function () {
                  throw I('BaseLoadable');
                },
              },
              {
                key: 'errorOrThrow',
                value: function () {
                  throw I('Loadable expected error, but in "'.concat(this.state, '" state'));
                },
              },
              {
                key: 'is',
                value: function (e) {
                  return e.state === this.state && e.contents === this.contents;
                },
              },
              {
                key: 'map',
                value: function (e) {
                  throw I('BaseLoadable');
                },
              },
            ]),
            e
          );
        })(),
        F = (function (e) {
          E(n, e);
          var t = T(n);
          function n(e) {
            var r;
            return (
              N(this, n),
              V(_((r = t.call(this))), 'state', 'hasValue'),
              V(_(r), 'contents', void 0),
              (r.contents = e),
              r
            );
          }
          return (
            L(n, [
              {
                key: 'getValue',
                value: function () {
                  return this.contents;
                },
              },
              {
                key: 'toPromise',
                value: function () {
                  return Promise.resolve(this.contents);
                },
              },
              {
                key: 'valueMaybe',
                value: function () {
                  return this.contents;
                },
              },
              {
                key: 'valueOrThrow',
                value: function () {
                  return this.contents;
                },
              },
              { key: 'promiseMaybe', value: function () {} },
              { key: 'errorMaybe', value: function () {} },
              {
                key: 'map',
                value: function (e) {
                  var t = this;
                  try {
                    var n = e(this.contents);
                    return M(n) ? $(n) : Q(n) ? n : q(n);
                  } catch (r) {
                    return M(r)
                      ? $(
                          r.next(function () {
                            return t.map(e);
                          })
                        )
                      : W(r);
                  }
                },
              },
            ]),
            n
          );
        })(B),
        U = (function (e) {
          E(n, e);
          var t = T(n);
          function n(e) {
            var r;
            return (
              N(this, n),
              V(_((r = t.call(this))), 'state', 'hasError'),
              V(_(r), 'contents', void 0),
              (r.contents = e),
              r
            );
          }
          return (
            L(n, [
              {
                key: 'getValue',
                value: function () {
                  throw this.contents;
                },
              },
              {
                key: 'toPromise',
                value: function () {
                  return Promise.reject(this.contents);
                },
              },
              { key: 'valueMaybe', value: function () {} },
              { key: 'promiseMaybe', value: function () {} },
              {
                key: 'errorMaybe',
                value: function () {
                  return this.contents;
                },
              },
              {
                key: 'errorOrThrow',
                value: function () {
                  return this.contents;
                },
              },
              {
                key: 'map',
                value: function (e) {
                  return this;
                },
              },
            ]),
            n
          );
        })(B),
        H = (function (e) {
          E(n, e);
          var t = T(n);
          function n(e) {
            var r;
            return (
              N(this, n), V(_((r = t.call(this))), 'state', 'loading'), V(_(r), 'contents', void 0), (r.contents = e), r
            );
          }
          return (
            L(n, [
              {
                key: 'getValue',
                value: function () {
                  throw this.contents;
                },
              },
              {
                key: 'toPromise',
                value: function () {
                  return this.contents;
                },
              },
              { key: 'valueMaybe', value: function () {} },
              {
                key: 'promiseMaybe',
                value: function () {
                  return this.contents;
                },
              },
              {
                key: 'promiseOrThrow',
                value: function () {
                  return this.contents;
                },
              },
              { key: 'errorMaybe', value: function () {} },
              {
                key: 'map',
                value: function (e) {
                  var t = this;
                  return $(
                    this.contents
                      .then(function (t) {
                        var n = e(t);
                        if (Q(n)) {
                          var r = n;
                          switch (r.state) {
                            case 'hasValue':
                            case 'loading':
                              return r.contents;
                            case 'hasError':
                              throw r.contents;
                          }
                        }
                        return n;
                      })
                      .catch(function (n) {
                        if (M(n))
                          return n.then(function () {
                            return t.map(e).contents;
                          });
                        throw n;
                      })
                  );
                },
              },
            ]),
            n
          );
        })(B);
      function q(e) {
        return Object.freeze(new F(e));
      }
      function W(e) {
        return Object.freeze(new U(e));
      }
      function $(e) {
        return Object.freeze(new H(e));
      }
      function G() {
        return Object.freeze(new H(new Promise(function () {})));
      }
      function K(e) {
        var t = (function (e) {
          return e.every(function (e) {
            return 'hasValue' === e.state;
          })
            ? q(
                e.map(function (e) {
                  return e.contents;
                })
              )
            : e.some(function (e) {
                return 'hasError' === e.state;
              })
            ? W(
                z(
                  e.find(function (e) {
                    return 'hasError' === e.state;
                  }),
                  'Invalid loadable passed to loadableAll'
                ).contents
              )
            : $(
                Promise.all(
                  e.map(function (e) {
                    return e.contents;
                  })
                )
              );
        })(
          (Array.isArray(e)
            ? e
            : Object.getOwnPropertyNames(e).map(function (t) {
                return e[t];
              })
          ).map(function (e) {
            return Q(e) ? e : M(e) ? $(e) : q(e);
          })
        );
        return Array.isArray(e)
          ? t
          : t.map(function (t) {
              return Object.getOwnPropertyNames(e).reduce(function (e, n, r) {
                return S(S({}, e), {}, x({}, n, t[r]));
              }, {});
            });
      }
      function Q(e) {
        return e instanceof B;
      }
      var Y = {
          of: function (e) {
            return M(e) ? $(e) : Q(e) ? e : q(e);
          },
          error: function (e) {
            return W(e);
          },
          loading: function () {
            return G();
          },
          all: K,
          isLoadable: Q,
        },
        X = {
          loadableWithValue: q,
          loadableWithError: W,
          loadableWithPromise: $,
          loadableLoading: G,
          loadableAll: K,
          isLoadable: Q,
          RecoilLoadable: Y,
        },
        J = X.loadableWithValue,
        Z = X.loadableWithError,
        ee = X.loadableWithPromise,
        te = X.loadableLoading,
        ne = X.loadableAll,
        re = X.isLoadable,
        oe = X.RecoilLoadable,
        ae = Object.freeze({
          __proto__: null,
          loadableWithValue: J,
          loadableWithError: Z,
          loadableWithPromise: ee,
          loadableLoading: te,
          loadableAll: ne,
          isLoadable: re,
          RecoilLoadable: oe,
        }),
        ie = new Map()
          .set('recoil_hamt_2020', !0)
          .set('recoil_sync_external_store', !0)
          .set('recoil_suppress_rerender_in_callback', !0)
          .set('recoil_memory_managament_2020', !0);
      function le(e) {
        var t;
        return null !== (t = ie.get(e)) && void 0 !== t && t;
      }
      (le.setPass = function (e) {
        ie.set(e, !0);
      }),
        (le.setFail = function (e) {
          ie.set(e, !1);
        }),
        (le.clear = function () {
          ie.clear();
        });
      var ue = le;
      var se,
        ce,
        fe,
        de = function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return n.error, null;
        },
        pe = de,
        he = null !== (se = e.createMutableSource) && void 0 !== se ? se : e.unstable_createMutableSource,
        ve = null !== (ce = e.useMutableSource) && void 0 !== ce ? ce : e.unstable_useMutableSource,
        me = null !== (fe = e.useSyncExternalStore) && void 0 !== fe ? fe : e.unstable_useSyncExternalStore,
        ge = !1;
      var we = {
          createMutableSource: he,
          useMutableSource: ve,
          useSyncExternalStore: me,
          currentRendererSupportsUseSyncExternalStore: function () {
            var t,
              n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
              r = n.ReactCurrentDispatcher,
              o = n.ReactCurrentOwner,
              a =
                null !=
                (null !== (t = null === r || void 0 === r ? void 0 : r.current) && void 0 !== t
                  ? t
                  : o.currentDispatcher
                ).useSyncExternalStore;
            return (
              !me ||
                a ||
                ge ||
                ((ge = !0), pe('A React renderer without React 18+ API support is being used with React 18+.')),
              a
            );
          },
          reactMode: function () {
            return ue('recoil_transition_support')
              ? { mode: 'TRANSITION_SUPPORT', early: !0, concurrent: !0 }
              : ue('recoil_sync_external_store') && null != me
              ? { mode: 'SYNC_EXTERNAL_STORE', early: !0, concurrent: !1 }
              : ue('recoil_mutable_source') &&
                null != ve &&
                'undefined' !== typeof window &&
                !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE
              ? ue('recoil_suppress_rerender_in_callback')
                ? { mode: 'MUTABLE_SOURCE', early: !0, concurrent: !0 }
                : { mode: 'MUTABLE_SOURCE', early: !1, concurrent: !1 }
              : ue('recoil_suppress_rerender_in_callback')
              ? { mode: 'LEGACY', early: !0, concurrent: !1 }
              : { mode: 'LEGACY', early: !1, concurrent: !1 };
          },
          isFastRefreshEnabled: function () {
            return !1;
          },
        },
        ye = { RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: !0 };
      !(function () {
        var e, t, n;
        if (
          'undefined' !== typeof process &&
          null !=
            (null === (e = process) || void 0 === e
              ? void 0
              : {
                  NODE_ENV: 'production',
                  PUBLIC_URL: '',
                  WDS_SOCKET_HOST: void 0,
                  WDS_SOCKET_PATH: void 0,
                  WDS_SOCKET_PORT: void 0,
                  FAST_REFRESH: !0,
                })
        ) {
          var r =
            null ===
              (t = {
                NODE_ENV: 'production',
                PUBLIC_URL: '',
                WDS_SOCKET_HOST: void 0,
                WDS_SOCKET_PATH: void 0,
                WDS_SOCKET_PORT: void 0,
                FAST_REFRESH: !0,
              }.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) ||
            void 0 === t ||
            null === (n = t.toLowerCase()) ||
            void 0 === n
              ? void 0
              : n.trim();
          if (null != r && '' !== r) {
            if (!['true', 'false'].includes(r))
              throw I(
                "process.env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED value must be 'true', 'false', or empty: ".concat(
                  r
                )
              );
            ye.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = 'true' === r;
          }
        }
      })();
      var be = ye,
        xe = (function () {
          function e(t) {
            N(this, e), V(this, 'key', void 0), (this.key = t);
          }
          return (
            L(e, [
              {
                key: 'toJSON',
                value: function () {
                  return { key: this.key };
                },
              },
            ]),
            e
          );
        })(),
        ke = (function (e) {
          E(n, e);
          var t = T(n);
          function n() {
            return N(this, n), t.apply(this, arguments);
          }
          return L(n);
        })(xe),
        Se = (function (e) {
          E(n, e);
          var t = T(n);
          function n() {
            return N(this, n), t.apply(this, arguments);
          }
          return L(n);
        })(xe);
      var _e = {
          AbstractRecoilValue: xe,
          RecoilState: ke,
          RecoilValueReadOnly: Se,
          isRecoilValue: function (e) {
            return e instanceof ke || e instanceof Se;
          },
        },
        Ee = _e.AbstractRecoilValue,
        Ce = _e.RecoilState,
        Te = _e.RecoilValueReadOnly,
        Ne = _e.isRecoilValue,
        je = Object.freeze({
          __proto__: null,
          AbstractRecoilValue: Ee,
          RecoilState: Ce,
          RecoilValueReadOnly: Te,
          isRecoilValue: Ne,
        });
      var Le = function (e) {};
      var Ae = function (e, t) {
          return a().mark(function n() {
            var r, o, i, l;
            return a().wrap(
              function (n) {
                for (;;)
                  switch ((n.prev = n.next)) {
                    case 0:
                      (r = 0), (o = y(e)), (n.prev = 2), o.s();
                    case 4:
                      if ((i = o.n()).done) {
                        n.next = 10;
                        break;
                      }
                      return (l = i.value), (n.next = 8), t(l, r++);
                    case 8:
                      n.next = 4;
                      break;
                    case 10:
                      n.next = 15;
                      break;
                    case 12:
                      (n.prev = 12), (n.t0 = n.catch(2)), o.e(n.t0);
                    case 15:
                      return (n.prev = 15), o.f(), n.finish(15);
                    case 18:
                    case 'end':
                      return n.stop();
                  }
              },
              n,
              null,
              [[2, 12, 15, 18]]
            );
          })();
        },
        Re = L(function e() {
          N(this, e);
        }),
        Pe = new Re(),
        Oe = new Map(),
        De = new Map();
      var Ie = (function (e) {
        E(n, e);
        var t = T(n);
        function n() {
          return N(this, n), t.apply(this, arguments);
        }
        return L(n);
      })(w(Error));
      var Me = new Map();
      function ze(e) {
        return Me.get(e);
      }
      var Ve = {
        nodes: Oe,
        recoilValues: De,
        registerNode: function (e) {
          be.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED &&
            (function (e) {
              if (Oe.has(e)) {
                var t = 'Duplicate atom key "'.concat(
                  e,
                  '". This is a FATAL ERROR in\n      production. But it is safe to ignore this warning if it occurred because of\n      hot module replacement.'
                );
                console.warn(t);
              }
            })(e.key),
            Oe.set(e.key, e);
          var t = null == e.set ? new je.RecoilValueReadOnly(e.key) : new je.RecoilState(e.key);
          return De.set(e.key, t), t;
        },
        getNode: function (e) {
          var t = Oe.get(e);
          if (null == t) throw new Ie('Missing definition for RecoilValue: "'.concat(e, '""'));
          return t;
        },
        getNodeMaybe: function (e) {
          return Oe.get(e);
        },
        deleteNodeConfigIfPossible: function (e) {
          var t;
          if (ue('recoil_memory_managament_2020')) {
            var n,
              r = Oe.get(e);
            if (null !== r && void 0 !== r && null !== (t = r.shouldDeleteConfigOnRelease) && void 0 !== t && t.call(r))
              Oe.delete(e), null === (n = ze(e)) || void 0 === n || n(), Me.delete(e);
          }
        },
        setConfigDeletionHandler: function (e, t) {
          ue('recoil_memory_managament_2020') && (void 0 === t ? Me.delete(e) : Me.set(e, t));
        },
        getConfigDeletionHandler: ze,
        recoilValuesForKeys: function (e) {
          return Ae(e, function (e) {
            return z(De.get(e));
          });
        },
        NodeMissingError: Ie,
        DefaultValue: Re,
        DEFAULT_VALUE: Pe,
      };
      var Be = {
        enqueueExecution: function (e, t) {
          t();
        },
      };
      var Fe,
        Ue,
        He =
          ((Fe = function (e) {
            var t =
                'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e && 'function' === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                        ? 'symbol'
                        : typeof e;
                    },
              n = {},
              r = Math.pow(2, 5),
              o = r - 1,
              a = r / 2,
              i = r / 4,
              l = {},
              u = function (e) {
                return function () {
                  return e;
                };
              },
              s = (n.hash = function (e) {
                var n = 'undefined' === typeof e ? 'undefined' : t(e);
                if ('number' === n) return e;
                'string' !== n && (e += '');
                for (var r = 0, o = 0, a = e.length; o < a; ++o) r = ((r << 5) - r + e.charCodeAt(o)) | 0;
                return r;
              }),
              c = function (e, t) {
                return (t >>> e) & o;
              },
              f = function (e) {
                return 1 << e;
              },
              d = function (e, t) {
                return (
                  (n = e & (t - 1)),
                  (n =
                    ((n = (858993459 & (n -= (n >> 1) & 1431655765)) + ((n >> 2) & 858993459)) + (n >> 4)) & 252645135),
                  127 & ((n += n >> 8) + (n >> 16))
                );
                var n;
              },
              p = function (e, t, n, r) {
                var o = r;
                if (!e) {
                  var a = r.length;
                  o = new Array(a);
                  for (var i = 0; i < a; ++i) o[i] = r[i];
                }
                return (o[t] = n), o;
              },
              h = function (e, t, n) {
                var r = n.length - 1,
                  o = 0,
                  a = 0,
                  i = n;
                if (e) o = a = t;
                else for (i = new Array(r); o < t; ) i[a++] = n[o++];
                for (++o; o <= r; ) i[a++] = n[o++];
                return e && (i.length = r), i;
              },
              v = { __hamt_isEmpty: !0 },
              m = function (e) {
                return e === v || (e && e.__hamt_isEmpty);
              },
              g = function (e, t, n, r) {
                return { type: 1, edit: e, hash: t, key: n, value: r, _modify: S };
              },
              w = function (e, t, n) {
                return { type: 2, edit: e, hash: t, children: n, _modify: _ };
              },
              y = function (e, t, n) {
                return { type: 3, edit: e, mask: t, children: n, _modify: E };
              },
              b = function (e, t, n) {
                return { type: 4, edit: e, size: t, children: n, _modify: C };
              },
              x = function e(t, n, r, o, a, i) {
                if (r === a) return w(t, r, [i, o]);
                var l = c(n, r),
                  u = c(n, a);
                return y(t, f(l) | f(u), l === u ? [e(t, n + 5, r, o, a, i)] : l < u ? [o, i] : [i, o]);
              },
              k = function (e, t) {
                return e === t.edit;
              },
              S = function (e, t, n, r, o, a, i) {
                if (t(a, this.key)) {
                  var u = r(this.value);
                  return u === this.value
                    ? this
                    : u === l
                    ? (--i.value, v)
                    : k(e, this)
                    ? ((this.value = u), this)
                    : g(e, o, a, u);
                }
                var s = r();
                return s === l ? this : (++i.value, x(e, n, this.hash, this, o, g(e, o, a, s)));
              },
              _ = function (e, t, n, r, o, a, i) {
                if (o === this.hash) {
                  var u = (function (e, t, n, r, o, a, i, u) {
                    for (var s = o.length, c = 0; c < s; ++c) {
                      var f = o[c];
                      if (n(i, f.key)) {
                        var d = f.value,
                          v = a(d);
                        return v === d ? o : v === l ? (--u.value, h(e, c, o)) : p(e, c, g(t, r, i, v), o);
                      }
                    }
                    var m = a();
                    return m === l ? o : (++u.value, p(e, s, g(t, r, i, m), o));
                  })(k(e, this), e, t, this.hash, this.children, r, a, i);
                  return u === this.children ? this : u.length > 1 ? w(e, this.hash, u) : u[0];
                }
                var s = r();
                return s === l ? this : (++i.value, x(e, n, this.hash, this, o, g(e, o, a, s)));
              },
              E = function (e, t, n, r, o, i, l) {
                var u = this.mask,
                  s = this.children,
                  g = c(n, o),
                  w = f(g),
                  x = d(u, w),
                  S = u & w,
                  _ = S ? s[x] : v,
                  E = _._modify(e, t, n + 5, r, o, i, l);
                if (_ === E) return this;
                var C,
                  T = k(e, this),
                  N = u,
                  j = void 0;
                if (S && m(E)) {
                  if (!(N &= ~w)) return v;
                  if (s.length <= 2 && ((C = s[1 ^ x]) === v || 1 === C.type || 2 === C.type)) return s[1 ^ x];
                  j = h(T, x, s);
                } else if (S || m(E)) j = p(T, x, E, s);
                else {
                  if (s.length >= a)
                    return (function (e, t, n, r, o) {
                      for (var a = [], i = r, l = 0, u = 0; i; ++u) 1 & i && (a[u] = o[l++]), (i >>>= 1);
                      return (a[t] = n), b(e, l + 1, a);
                    })(e, g, E, u, s);
                  (N |= w),
                    (j = (function (e, t, n, r) {
                      var o = r.length;
                      if (e) {
                        for (var a = o; a >= t; ) r[a--] = r[a];
                        return (r[t] = n), r;
                      }
                      for (var i = 0, l = 0, u = new Array(o + 1); i < t; ) u[l++] = r[i++];
                      for (u[t] = n; i < o; ) u[++l] = r[i++];
                      return u;
                    })(T, x, E, s));
                }
                return T ? ((this.mask = N), (this.children = j), this) : y(e, N, j);
              },
              C = function (e, t, n, r, o, a, l) {
                var u = this.size,
                  s = this.children,
                  f = c(n, o),
                  d = s[f],
                  h = (d || v)._modify(e, t, n + 5, r, o, a, l);
                if (d === h) return this;
                var g = k(e, this),
                  w = void 0;
                if (m(d) && !m(h)) ++u, (w = p(g, f, h, s));
                else if (!m(d) && m(h)) {
                  if (--u <= i)
                    return (function (e, t, n, r) {
                      for (var o = new Array(t - 1), a = 0, i = 0, l = 0, u = r.length; l < u; ++l)
                        if (l !== n) {
                          var s = r[l];
                          s && !m(s) && ((o[a++] = s), (i |= 1 << l));
                        }
                      return y(e, i, o);
                    })(e, u, f, s);
                  w = p(g, f, v, s);
                } else w = p(g, f, h, s);
                return g ? ((this.size = u), (this.children = w), this) : b(e, u, w);
              };
            function T(e, t, n, r, o) {
              (this._editable = e), (this._edit = t), (this._config = n), (this._root = r), (this._size = o);
            }
            (v._modify = function (e, t, n, r, o, a, i) {
              var u = r();
              return u === l ? v : (++i.value, g(e, o, a, u));
            }),
              (T.prototype.setTree = function (e, t) {
                return this._editable
                  ? ((this._root = e), (this._size = t), this)
                  : e === this._root
                  ? this
                  : new T(this._editable, this._edit, this._config, e, t);
              });
            var N = (n.tryGetHash = function (e, t, n, r) {
              for (var o = r._root, a = 0, i = r._config.keyEq; ; )
                switch (o.type) {
                  case 1:
                    return i(n, o.key) ? o.value : e;
                  case 2:
                    if (t === o.hash)
                      for (var l = o.children, u = 0, s = l.length; u < s; ++u) {
                        var p = l[u];
                        if (i(n, p.key)) return p.value;
                      }
                    return e;
                  case 3:
                    var h = c(a, t),
                      v = f(h);
                    if (o.mask & v) {
                      (o = o.children[d(o.mask, v)]), (a += 5);
                      break;
                    }
                    return e;
                  case 4:
                    if ((o = o.children[c(a, t)])) {
                      a += 5;
                      break;
                    }
                    return e;
                  default:
                    return e;
                }
            });
            T.prototype.tryGetHash = function (e, t, n) {
              return N(e, t, n, this);
            };
            var j = (n.tryGet = function (e, t, n) {
              return N(e, n._config.hash(t), t, n);
            });
            T.prototype.tryGet = function (e, t) {
              return j(e, t, this);
            };
            var L = (n.getHash = function (e, t, n) {
              return N(void 0, e, t, n);
            });
            (T.prototype.getHash = function (e, t) {
              return L(e, t, this);
            }),
              (n.get = function (e, t) {
                return N(void 0, t._config.hash(e), e, t);
              }),
              (T.prototype.get = function (e, t) {
                return j(t, e, this);
              });
            var A = (n.has = function (e, t, n) {
              return N(l, e, t, n) !== l;
            });
            T.prototype.hasHash = function (e, t) {
              return A(e, t, this);
            };
            var R = (n.has = function (e, t) {
              return A(t._config.hash(e), e, t);
            });
            T.prototype.has = function (e) {
              return R(e, this);
            };
            var P = function (e, t) {
              return e === t;
            };
            (n.make = function (e) {
              return new T(0, 0, { keyEq: (e && e.keyEq) || P, hash: (e && e.hash) || s }, v, 0);
            }),
              (n.empty = n.make());
            var O = (n.isEmpty = function (e) {
              return e && !!m(e._root);
            });
            T.prototype.isEmpty = function () {
              return O(this);
            };
            var D = (n.modifyHash = function (e, t, n, r) {
              var o = { value: r._size },
                a = r._root._modify(r._editable ? r._edit : NaN, r._config.keyEq, 0, e, t, n, o);
              return r.setTree(a, o.value);
            });
            T.prototype.modifyHash = function (e, t, n) {
              return D(n, e, t, this);
            };
            var I = (n.modify = function (e, t, n) {
              return D(e, n._config.hash(t), t, n);
            });
            T.prototype.modify = function (e, t) {
              return I(t, e, this);
            };
            var M = (n.setHash = function (e, t, n, r) {
              return D(u(n), e, t, r);
            });
            T.prototype.setHash = function (e, t, n) {
              return M(e, t, n, this);
            };
            var z = (n.set = function (e, t, n) {
              return M(n._config.hash(e), e, t, n);
            });
            T.prototype.set = function (e, t) {
              return z(e, t, this);
            };
            var V = u(l),
              B = (n.removeHash = function (e, t, n) {
                return D(V, e, t, n);
              });
            T.prototype.removeHash = T.prototype.deleteHash = function (e, t) {
              return B(e, t, this);
            };
            var F = (n.remove = function (e, t) {
              return B(t._config.hash(e), e, t);
            });
            T.prototype.remove = T.prototype.delete = function (e) {
              return F(e, this);
            };
            var U = (n.beginMutation = function (e) {
              return new T(e._editable + 1, e._edit + 1, e._config, e._root, e._size);
            });
            T.prototype.beginMutation = function () {
              return U(this);
            };
            var H = (n.endMutation = function (e) {
              return (e._editable = e._editable && e._editable - 1), e;
            });
            T.prototype.endMutation = function () {
              return H(this);
            };
            var q = (n.mutate = function (e, t) {
              var n = U(t);
              return e(n), H(n);
            });
            T.prototype.mutate = function (e) {
              return q(e, this);
            };
            var W = function (e) {
                return e && $(e[0], e[1], e[2], e[3], e[4]);
              },
              $ = function (e, t, n, r, o) {
                for (; n < e; ) {
                  var a = t[n++];
                  if (a && !m(a)) return G(a, r, [e, t, n, r, o]);
                }
                return W(o);
              },
              G = function (e, t, n) {
                switch (e.type) {
                  case 1:
                    return { value: t(e), rest: n };
                  case 2:
                  case 4:
                  case 3:
                    var r = e.children;
                    return $(r.length, r, 0, t, n);
                  default:
                    return W(n);
                }
              },
              K = { done: !0 };
            function Q(e) {
              this.v = e;
            }
            (Q.prototype.next = function () {
              if (!this.v) return K;
              var e = this.v;
              return (this.v = W(e.rest)), e;
            }),
              (Q.prototype[Symbol.iterator] = function () {
                return this;
              });
            var Y = function (e, t) {
                return new Q(G(e._root, t));
              },
              X = function (e) {
                return [e.key, e.value];
              },
              J = (n.entries = function (e) {
                return Y(e, X);
              });
            T.prototype.entries = T.prototype[Symbol.iterator] = function () {
              return J(this);
            };
            var Z = function (e) {
                return e.key;
              },
              ee = (n.keys = function (e) {
                return Y(e, Z);
              });
            T.prototype.keys = function () {
              return ee(this);
            };
            var te = function (e) {
                return e.value;
              },
              ne =
                (n.values =
                T.prototype.values =
                  function (e) {
                    return Y(e, te);
                  });
            T.prototype.values = function () {
              return ne(this);
            };
            var re = (n.fold = function (e, t, n) {
              var r = n._root;
              if (1 === r.type) return e(t, r.value, r.key);
              for (var o = [r.children], a = void 0; (a = o.pop()); )
                for (var i = 0, l = a.length; i < l; ) {
                  var u = a[i++];
                  u && u.type && (1 === u.type ? (t = e(t, u.value, u.key)) : o.push(u.children));
                }
              return t;
            });
            T.prototype.fold = function (e, t) {
              return re(e, t, this);
            };
            var oe = (n.forEach = function (e, t) {
              return re(
                function (n, r, o) {
                  return e(r, o, t);
                },
                null,
                t
              );
            });
            T.prototype.forEach = function (e) {
              return oe(e, this);
            };
            var ae = (n.count = function (e) {
              return e._size;
            });
            (T.prototype.count = function () {
              return ae(this);
            }),
              Object.defineProperty(T.prototype, 'size', { get: T.prototype.count }),
              e.exports ? (e.exports = n) : ((void 0).hamt = n);
          }),
          Fe((Ue = { exports: {} }), Ue.exports),
          Ue.exports),
        qe = (function () {
          function e(t) {
            N(this, e),
              V(this, '_map', void 0),
              (this._map = new Map(null === t || void 0 === t ? void 0 : t.entries()));
          }
          return (
            L(e, [
              {
                key: 'keys',
                value: function () {
                  return this._map.keys();
                },
              },
              {
                key: 'entries',
                value: function () {
                  return this._map.entries();
                },
              },
              {
                key: 'get',
                value: function (e) {
                  return this._map.get(e);
                },
              },
              {
                key: 'has',
                value: function (e) {
                  return this._map.has(e);
                },
              },
              {
                key: 'set',
                value: function (e, t) {
                  return this._map.set(e, t), this;
                },
              },
              {
                key: 'delete',
                value: function (e) {
                  return this._map.delete(e), this;
                },
              },
              {
                key: 'clone',
                value: function () {
                  return $e(this);
                },
              },
              {
                key: 'toMap',
                value: function () {
                  return new Map(this._map);
                },
              },
            ]),
            e
          );
        })(),
        We = (function () {
          function e(t) {
            if ((N(this, e), V(this, '_hamt', He.empty.beginMutation()), t instanceof e)) {
              var n = t._hamt.endMutation();
              (t._hamt = n.beginMutation()), (this._hamt = n.beginMutation());
            } else if (t) {
              var r,
                o = y(t.entries());
              try {
                for (o.s(); !(r = o.n()).done; ) {
                  var a = c(r.value, 2),
                    i = a[0],
                    l = a[1];
                  this._hamt.set(i, l);
                }
              } catch (u) {
                o.e(u);
              } finally {
                o.f();
              }
            }
          }
          return (
            L(e, [
              {
                key: 'keys',
                value: function () {
                  return this._hamt.keys();
                },
              },
              {
                key: 'entries',
                value: function () {
                  return this._hamt.entries();
                },
              },
              {
                key: 'get',
                value: function (e) {
                  return this._hamt.get(e);
                },
              },
              {
                key: 'has',
                value: function (e) {
                  return this._hamt.has(e);
                },
              },
              {
                key: 'set',
                value: function (e, t) {
                  return this._hamt.set(e, t), this;
                },
              },
              {
                key: 'delete',
                value: function (e) {
                  return this._hamt.delete(e), this;
                },
              },
              {
                key: 'clone',
                value: function () {
                  return $e(this);
                },
              },
              {
                key: 'toMap',
                value: function () {
                  return new Map(this._hamt);
                },
              },
            ]),
            e
          );
        })();
      function $e(e) {
        return ue('recoil_hamt_2020') ? new We(e) : new qe(e);
      }
      var Ge = $e;
      var Ke = function (e) {
        for (var t = new Set(), n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
          r[o - 1] = arguments[o];
        var a,
          i = y(e);
        try {
          e: for (i.s(); !(a = i.n()).done; ) {
            var l,
              u = a.value,
              s = y(r);
            try {
              for (s.s(); !(l = s.n()).done; ) {
                var c = l.value;
                if (c.has(u)) continue e;
              }
            } catch (f) {
              s.e(f);
            } finally {
              s.f();
            }
            t.add(u);
          }
        } catch (f) {
          i.e(f);
        } finally {
          i.f();
        }
        return t;
      };
      var Qe = function (e, t) {
        var n = new Map();
        return (
          e.forEach(function (e, r) {
            n.set(r, t(e, r));
          }),
          n
        );
      };
      function Ye(e, t, n, r) {
        var o = n.nodeDeps,
          a = n.nodeToNodeSubscriptions,
          i = o.get(e);
        if (!i || !r || i === r.nodeDeps.get(e)) {
          o.set(e, t);
          var l,
            u = y(null == i ? t : Ke(t, i));
          try {
            for (u.s(); !(l = u.n()).done; ) {
              var s = l.value;
              a.has(s) || a.set(s, new Set()), z(a.get(s)).add(e);
            }
          } catch (h) {
            u.e(h);
          } finally {
            u.f();
          }
          if (i) {
            var c,
              f = y(Ke(i, t));
            try {
              for (f.s(); !(c = f.n()).done; ) {
                var d = c.value;
                if (!a.has(d)) return;
                var p = z(a.get(d));
                p.delete(e), 0 === p.size && a.delete(d);
              }
            } catch (h) {
              f.e(h);
            } finally {
              f.f();
            }
          }
        }
      }
      var Xe = function (e) {
          return {
            nodeDeps: Qe(e.nodeDeps, function (e) {
              return new Set(e);
            }),
            nodeToNodeSubscriptions: Qe(e.nodeToNodeSubscriptions, function (e) {
              return new Set(e);
            }),
          };
        },
        Je = function () {
          return { nodeDeps: new Map(), nodeToNodeSubscriptions: new Map() };
        },
        Ze = function (e, t, n, r) {
          var o,
            a,
            i,
            l,
            u = n.getState();
          r !== u.currentTree.version &&
            r !== (null === (o = u.nextTree) || void 0 === o ? void 0 : o.version) &&
            r !== (null === (a = u.previousTree) || void 0 === a ? void 0 : a.version) &&
            pe('Tried to save dependencies to a discarded tree');
          var s = n.getGraph(r);
          if (
            (Ye(e, t, s),
            r === (null === (i = u.previousTree) || void 0 === i ? void 0 : i.version) &&
              Ye(e, t, n.getGraph(u.currentTree.version), s),
            r === (null === (l = u.previousTree) || void 0 === l ? void 0 : l.version) || r === u.currentTree.version)
          ) {
            var c,
              f = null === (c = u.nextTree) || void 0 === c ? void 0 : c.version;
            if (void 0 !== f) Ye(e, t, n.getGraph(f), s);
          }
        },
        et = 0,
        tt = 0,
        nt = 0,
        rt = function () {
          return et++;
        },
        ot = function () {
          return tt++;
        },
        at = function () {
          return nt++;
        },
        it = Object.freeze({ __proto__: null, persistentMap: Ge }).persistentMap,
        lt = Je,
        ut = rt;
      function st() {
        var e = ut();
        return {
          version: e,
          stateID: e,
          transactionMetadata: {},
          dirtyAtoms: new Set(),
          atomValues: it(),
          nonvalidatedAtoms: it(),
        };
      }
      var ct = {
          makeEmptyTreeState: st,
          makeEmptyStoreState: function () {
            var e = st();
            return {
              currentTree: e,
              nextTree: null,
              previousTree: null,
              commitDepth: 0,
              knownAtoms: new Set(),
              knownSelectors: new Set(),
              transactionSubscriptions: new Map(),
              nodeTransactionSubscriptions: new Map(),
              nodeToComponentSubscriptions: new Map(),
              queuedComponentCallbacks_DEPRECATED: [],
              suspendedComponentResolvers: new Set(),
              graphsByVersion: new Map().set(e.version, lt()),
              retention: {
                referenceCounts: new Map(),
                nodesRetainedByZone: new Map(),
                retainablesToCheckForRelease: new Set(),
              },
              nodeCleanupFunctions: new Map(),
            };
          },
          getNextTreeStateVersion: ut,
        },
        ft = L(function e() {
          N(this, e);
        });
      var dt = {
        RetentionZone: ft,
        retentionZone: function () {
          return new ft();
        },
      };
      var pt = function (e, t) {
        var n = new Set(e);
        return n.add(t), n;
      };
      function ht(e, t) {
        var n, r, o, i;
        return a().wrap(
          function (a) {
            for (;;)
              switch ((a.prev = a.next)) {
                case 0:
                  (n = 0), (r = y(e)), (a.prev = 2), r.s();
                case 4:
                  if ((o = r.n()).done) {
                    a.next = 11;
                    break;
                  }
                  if (((i = o.value), !t(i, n++))) {
                    a.next = 9;
                    break;
                  }
                  return (a.next = 9), i;
                case 9:
                  a.next = 4;
                  break;
                case 11:
                  a.next = 16;
                  break;
                case 13:
                  (a.prev = 13), (a.t0 = a.catch(2)), r.e(a.t0);
                case 16:
                  return (a.prev = 16), r.f(), a.finish(16);
                case 19:
                case 'end':
                  return a.stop();
              }
          },
          O,
          null,
          [[2, 13, 16, 19]]
        );
      }
      var vt = ht;
      var mt = function (e, t) {
          return new Proxy(e, {
            get: function (e, n) {
              return !(n in e) && n in t && (e[n] = t[n]()), e[n];
            },
            ownKeys: function (e) {
              return Object.keys(e);
            },
          });
        },
        gt = Ve.getNode,
        wt = Ve.getNodeMaybe,
        yt = Ve.recoilValuesForKeys,
        bt = dt.RetentionZone,
        xt = pt,
        kt = Object.freeze(new Set()),
        St = (function (e) {
          E(n, e);
          var t = T(n);
          function n() {
            return N(this, n), t.apply(this, arguments);
          }
          return L(n);
        })(w(Error));
      function _t(e, t, n, r) {
        var o = e.getState();
        if (!o.nodeCleanupFunctions.has(n)) {
          var a = gt(n),
            i = (function (e, t, n) {
              if (!ue('recoil_memory_managament_2020')) return function () {};
              var r = e.getState().retention.nodesRetainedByZone;
              function o(e) {
                var n = r.get(e);
                n || r.set(e, (n = new Set())), n.add(t);
              }
              if (n instanceof bt) o(n);
              else if (Array.isArray(n)) {
                var a,
                  i = y(n);
                try {
                  for (i.s(); !(a = i.n()).done; ) o(a.value);
                } catch (l) {
                  i.e(l);
                } finally {
                  i.f();
                }
              }
              return function () {
                if (ue('recoil_memory_managament_2020')) {
                  var r = e.getState().retention;
                  if (n instanceof bt) i(n);
                  else if (Array.isArray(n)) {
                    var o,
                      a = y(n);
                    try {
                      for (a.s(); !(o = a.n()).done; ) i(o.value);
                    } catch (l) {
                      a.e(l);
                    } finally {
                      a.f();
                    }
                  }
                }
                function i(e) {
                  var n = r.nodesRetainedByZone.get(e);
                  null === n || void 0 === n || n.delete(t), n && 0 === n.size && r.nodesRetainedByZone.delete(e);
                }
              };
            })(e, n, a.retainedBy),
            l = a.init(e, t, r);
          o.nodeCleanupFunctions.set(n, function () {
            l(), i();
          });
        }
      }
      function Et(e, t, n) {
        return gt(n).peek(e, t);
      }
      function Ct(e, t, n) {
        for (var r = new Set(), o = Array.from(n), a = e.getGraph(t.version), i = o.pop(); i; i = o.pop()) {
          var l;
          r.add(i);
          var u,
            s = y(null !== (l = a.nodeToNodeSubscriptions.get(i)) && void 0 !== l ? l : kt);
          try {
            for (s.s(); !(u = s.n()).done; ) {
              var c = u.value;
              r.has(c) || o.push(c);
            }
          } catch (f) {
            s.e(f);
          } finally {
            s.f();
          }
        }
        return r;
      }
      var Tt = function (e, t, n) {
          return _t(e, t, n, 'get'), gt(n).get(e, t);
        },
        Nt = Et,
        jt = function (e, t, n, r) {
          var o = gt(n);
          if (null == o.set) throw new St('Attempt to set read-only RecoilValue: '.concat(n));
          var a = o.set;
          return _t(e, t, n, 'set'), a(e, t, r);
        },
        Lt = function (e, t, n) {
          _t(e, e.getState().currentTree, t, n);
        },
        At = function (e, t) {
          var n,
            r = e.getState();
          null === (n = r.nodeCleanupFunctions.get(t)) || void 0 === n || n(), r.nodeCleanupFunctions.delete(t);
        },
        Rt = function (e, t, n) {
          var r,
            o = wt(t);
          return (
            null === o || void 0 === o || null === (r = o.invalidate) || void 0 === r || r.call(o, e),
            S(
              S({}, e),
              {},
              {
                atomValues: e.atomValues.clone().delete(t),
                nonvalidatedAtoms: e.nonvalidatedAtoms.clone().set(t, n),
                dirtyAtoms: xt(e.dirtyAtoms, t),
              }
            )
          );
        },
        Pt = function (e, t, n) {
          var r = e.getState(),
            o = e.getGraph(t.version),
            a = gt(n).nodeType;
          return mt(
            { type: a },
            {
              loadable: function () {
                return Et(e, t, n);
              },
              isActive: function () {
                return r.knownAtoms.has(n) || r.knownSelectors.has(n);
              },
              isSet: function () {
                return 'selector' !== a && t.atomValues.has(n);
              },
              isModified: function () {
                return t.dirtyAtoms.has(n);
              },
              deps: function () {
                var e;
                return yt(null !== (e = o.nodeDeps.get(n)) && void 0 !== e ? e : []);
              },
              subscribers: function () {
                var o, a;
                return {
                  nodes: yt(
                    vt(Ct(e, t, new Set([n])), function (e) {
                      return e !== n;
                    })
                  ),
                  components: Ae(
                    null !==
                      (o =
                        null === (a = r.nodeToComponentSubscriptions.get(n)) || void 0 === a ? void 0 : a.values()) &&
                      void 0 !== o
                      ? o
                      : [],
                    function (e) {
                      return { name: c(e, 1)[0] };
                    }
                  ),
                };
              },
            }
          );
        },
        Ot = Ct,
        Dt = null;
      var It = function (e) {
          Dt = e;
        },
        Mt = function () {
          var e;
          null === (e = Dt) || void 0 === e || e();
        },
        zt = Ot,
        Vt = Tt,
        Bt = jt,
        Ft = at,
        Ut = Ve.getNode,
        Ht = Ve.getNodeMaybe,
        qt = Ve.DefaultValue,
        Wt = we.reactMode,
        $t = je.AbstractRecoilValue,
        Gt = je.RecoilState,
        Kt = je.RecoilValueReadOnly,
        Qt = je.isRecoilValue,
        Yt = Mt;
      function Xt(e, t, n) {
        if ('set' === n.type) {
          var r,
            o = n.recoilValue,
            a = (function (e, t, n, r) {
              var o = n.key;
              if ('function' === typeof r) {
                var a = Vt(e, t, o);
                if ('loading' === a.state) {
                  var i = 'Tried to set atom or selector "'.concat(
                    o,
                    '" using an updater function while the current state is pending, this is not currently supported.'
                  );
                  throw (pe(i), I(i));
                }
                if ('hasError' === a.state) throw a.contents;
                return r(a.contents);
              }
              return r;
            })(e, t, o, n.valueOrUpdater),
            i = y(Bt(e, t, o.key, a).entries());
          try {
            for (i.s(); !(r = i.n()).done; ) {
              var l = c(r.value, 2);
              Jt(t, l[0], l[1]);
            }
          } catch (h) {
            i.e(h);
          } finally {
            i.f();
          }
        } else if ('setLoadable' === n.type) {
          Jt(t, n.recoilValue.key, n.loadable);
        } else if ('markModified' === n.type) {
          var u = n.recoilValue.key;
          t.dirtyAtoms.add(u);
        } else if ('setUnvalidated' === n.type) {
          var s,
            f = n.recoilValue.key,
            d = n.unvalidatedValue,
            p = Ht(f);
          null === p || void 0 === p || null === (s = p.invalidate) || void 0 === s || s.call(p, t),
            t.atomValues.delete(f),
            t.nonvalidatedAtoms.set(f, d),
            t.dirtyAtoms.add(f);
        } else pe('Unknown action '.concat(n.type));
      }
      function Jt(e, t, n) {
        'hasValue' === n.state && n.contents instanceof qt ? e.atomValues.delete(t) : e.atomValues.set(t, n),
          e.dirtyAtoms.add(t),
          e.nonvalidatedAtoms.delete(t);
      }
      function Zt(e, t) {
        e.replaceState(function (n) {
          var r,
            o = nn(n),
            a = y(t);
          try {
            for (a.s(); !(r = a.n()).done; ) {
              var i = r.value;
              Xt(e, o, i);
            }
          } catch (l) {
            a.e(l);
          } finally {
            a.f();
          }
          return rn(e, o), Yt(), o;
        });
      }
      function en(e, t) {
        if (tn.length) {
          var n = tn[tn.length - 1],
            r = n.get(e);
          r || n.set(e, (r = [])), r.push(t);
        } else Zt(e, [t]);
      }
      var tn = [];
      function nn(e) {
        return S(
          S({}, e),
          {},
          {
            atomValues: e.atomValues.clone(),
            nonvalidatedAtoms: e.nonvalidatedAtoms.clone(),
            dirtyAtoms: new Set(e.dirtyAtoms),
          }
        );
      }
      function rn(e, t) {
        var n,
          r = y(zt(e, t, t.dirtyAtoms));
        try {
          for (r.s(); !(n = r.n()).done; ) {
            var o,
              a,
              i = n.value;
            null === (o = Ht(i)) || void 0 === o || null === (a = o.invalidate) || void 0 === a || a.call(o, t);
          }
        } catch (l) {
          r.e(l);
        } finally {
          r.f();
        }
      }
      function on(e, t, n) {
        en(e, { type: 'set', recoilValue: t, valueOrUpdater: n });
      }
      var an = {
        RecoilValueReadOnly: Kt,
        AbstractRecoilValue: $t,
        RecoilState: Gt,
        getRecoilValueAsLoadable: function (e, t) {
          var n,
            r,
            o = t.key,
            a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.getState().currentTree,
            i = e.getState();
          a.version !== i.currentTree.version &&
            a.version !== (null === (n = i.nextTree) || void 0 === n ? void 0 : n.version) &&
            a.version !== (null === (r = i.previousTree) || void 0 === r ? void 0 : r.version) &&
            pe('Tried to read from a discarded tree');
          var l = Vt(e, a, o);
          return 'loading' === l.state && l.contents.catch(function () {}), l;
        },
        setRecoilValue: on,
        setRecoilValueLoadable: function (e, t, n) {
          if (n instanceof qt) return on(e, t, n);
          en(e, { type: 'setLoadable', recoilValue: t, loadable: n });
        },
        markRecoilValueModified: function (e, t) {
          en(e, { type: 'markModified', recoilValue: t });
        },
        setUnvalidatedRecoilValue: function (e, t, n) {
          en(e, { type: 'setUnvalidated', recoilValue: t, unvalidatedValue: n });
        },
        subscribeToRecoilValue: function (e, t, n) {
          var r = t.key,
            o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
            a = Ft(),
            i = e.getState();
          i.nodeToComponentSubscriptions.has(r) || i.nodeToComponentSubscriptions.set(r, new Map()),
            z(i.nodeToComponentSubscriptions.get(r)).set(a, [null !== o && void 0 !== o ? o : '<not captured>', n]);
          var l = Wt();
          if (l.early && ('LEGACY' === l.mode || 'MUTABLE_SOURCE' === l.mode)) {
            var u = e.getState().nextTree;
            u && u.dirtyAtoms.has(r) && n(u);
          }
          return {
            release: function () {
              var t = e.getState(),
                n = t.nodeToComponentSubscriptions.get(r);
              void 0 !== n && n.has(a)
                ? (n.delete(a), 0 === n.size && t.nodeToComponentSubscriptions.delete(r))
                : pe('Subscription missing at release time for atom '.concat(r, '. This is a bug in Recoil.'));
            },
          };
        },
        isRecoilValue: Qt,
        applyAtomValueWrites: function (e, t) {
          var n = e.clone();
          return (
            t.forEach(function (e, t) {
              'hasValue' === e.state && e.contents instanceof qt ? n.delete(t) : n.set(t, e);
            }),
            n
          );
        },
        batchStart: function () {
          var e = new Map();
          return (
            tn.push(e),
            function () {
              var t,
                n = y(e);
              try {
                for (n.s(); !(t = n.n()).done; ) {
                  var r = c(t.value, 2);
                  Zt(r[0], r[1]);
                }
              } catch (o) {
                n.e(o);
              } finally {
                n.f();
              }
              tn.pop() !== e && pe('Incorrect order of batch popping');
            }
          );
        },
        writeLoadableToTreeState: Jt,
        invalidateDownstreams: rn,
        copyTreeState: nn,
        refreshRecoilValue: function (e, t) {
          var n,
            r = e.getState().currentTree,
            o = Ut(t.key);
          null === (n = o.clearCache) || void 0 === n || n.call(o, e, r);
        },
      };
      var ln = function (e, t, n) {
          for (var r = e.entries(), o = r.next(); !o.done; ) {
            var a = o.value;
            if (t.call(n, a[1], a[0], e)) return !0;
            o = r.next();
          }
          return !1;
        },
        un = At,
        sn = Ve.deleteNodeConfigIfPossible,
        cn = Ve.getNode,
        fn = dt.RetentionZone,
        dn = new Set();
      function pn(e, t) {
        var n = e.getState(),
          r = n.currentTree;
        if (n.nextTree) pe('releaseNodesNowOnCurrentTree should only be called at the end of a batch');
        else {
          var o,
            a = new Set(),
            i = y(t);
          try {
            for (i.s(); !(o = i.n()).done; ) {
              var l = o.value;
              if (l instanceof fn) {
                var u,
                  s = y(vn(n, l));
                try {
                  for (s.s(); !(u = s.n()).done; ) {
                    var c = u.value;
                    a.add(c);
                  }
                } catch (h) {
                  s.e(h);
                } finally {
                  s.f();
                }
              } else a.add(l);
            }
          } catch (h) {
            i.e(h);
          } finally {
            i.f();
          }
          var f,
            d = (function (e, t) {
              var n = e.getState(),
                r = n.currentTree,
                o = e.getGraph(r.version),
                a = new Set(),
                i = new Set();
              return l(t), a;
              function l(t) {
                var u,
                  s = new Set(),
                  c = (function (e, t, n, r, o) {
                    var a = e.getGraph(t.version),
                      i = [],
                      l = new Set();
                    for (; n.size > 0; ) u(z(n.values().next().value));
                    return i;
                    function u(e) {
                      if (r.has(e) || o.has(e)) n.delete(e);
                      else if (!l.has(e)) {
                        var t = a.nodeToNodeSubscriptions.get(e);
                        if (t) {
                          var s,
                            c = y(t);
                          try {
                            for (c.s(); !(s = c.n()).done; ) {
                              u(s.value);
                            }
                          } catch (h) {
                            c.e(h);
                          } finally {
                            c.f();
                          }
                        }
                        l.add(e), n.delete(e), i.push(e);
                      }
                    }
                  })(e, r, t, a, i),
                  f = y(c);
                try {
                  for (f.s(); !(u = f.n()).done; ) {
                    var d,
                      p = u.value;
                    if ('recoilRoot' !== cn(p).retainedBy)
                      if ((null !== (d = n.retention.referenceCounts.get(p)) && void 0 !== d ? d : 0) > 0) i.add(p);
                      else if (
                        mn(p).some(function (e) {
                          return n.retention.referenceCounts.get(e);
                        })
                      )
                        i.add(p);
                      else {
                        var v = o.nodeToNodeSubscriptions.get(p);
                        v &&
                        ln(v, function (e) {
                          return i.has(e);
                        })
                          ? i.add(p)
                          : (a.add(p), s.add(p));
                      }
                    else i.add(p);
                  }
                } catch (h) {
                  f.e(h);
                } finally {
                  f.f();
                }
                var m,
                  g = new Set(),
                  w = y(s);
                try {
                  for (w.s(); !(m = w.n()).done; ) {
                    var b,
                      x = m.value,
                      k = y(null !== (S = o.nodeDeps.get(x)) && void 0 !== S ? S : dn);
                    try {
                      for (k.s(); !(b = k.n()).done; ) {
                        var S,
                          _ = b.value;
                        a.has(_) || g.add(_);
                      }
                    } catch (h) {
                      k.e(h);
                    } finally {
                      k.f();
                    }
                  }
                } catch (h) {
                  w.e(h);
                } finally {
                  w.f();
                }
                g.size && l(g);
              }
            })(e, a),
            p = y(d);
          try {
            for (p.s(); !(f = p.n()).done; ) {
              hn(e, r, f.value);
            }
          } catch (h) {
            p.e(h);
          } finally {
            p.f();
          }
        }
      }
      function hn(e, t, n) {
        if (ue('recoil_memory_managament_2020')) {
          un(e, n);
          var r = e.getState();
          r.knownAtoms.delete(n),
            r.knownSelectors.delete(n),
            r.nodeTransactionSubscriptions.delete(n),
            r.retention.referenceCounts.delete(n);
          var o,
            a = y(mn(n));
          try {
            for (a.s(); !(o = a.n()).done; ) {
              var i,
                l = o.value;
              null === (i = r.retention.nodesRetainedByZone.get(l)) || void 0 === i || i.delete(n);
            }
          } catch (h) {
            a.e(h);
          } finally {
            a.f();
          }
          t.atomValues.delete(n), t.dirtyAtoms.delete(n), t.nonvalidatedAtoms.delete(n);
          var u = r.graphsByVersion.get(t.version);
          if (u) {
            var s = u.nodeDeps.get(n);
            if (void 0 !== s) {
              u.nodeDeps.delete(n);
              var c,
                f = y(s);
              try {
                for (f.s(); !(c = f.n()).done; ) {
                  var d,
                    p = c.value;
                  null === (d = u.nodeToNodeSubscriptions.get(p)) || void 0 === d || d.delete(n);
                }
              } catch (h) {
                f.e(h);
              } finally {
                f.f();
              }
            }
            u.nodeToNodeSubscriptions.delete(n);
          }
          sn(n);
        }
      }
      function vn(e, t) {
        var n;
        return null !== (n = e.retention.nodesRetainedByZone.get(t)) && void 0 !== n ? n : dn;
      }
      function mn(e) {
        var t = cn(e).retainedBy;
        return void 0 === t || 'components' === t || 'recoilRoot' === t ? [] : t instanceof fn ? [t] : t;
      }
      function gn(e, t) {
        ue('recoil_memory_managament_2020') &&
          (e.getState().retention.referenceCounts.delete(t),
          (function (e, t) {
            var n = e.getState();
            n.nextTree ? n.retention.retainablesToCheckForRelease.add(t) : pn(e, new Set([t]));
          })(e, t));
      }
      var wn = 12e4,
        yn = function (e, t, n) {
          var r;
          if (ue('recoil_memory_managament_2020')) {
            var o = e.getState().retention.referenceCounts,
              a = (null !== (r = o.get(t)) && void 0 !== r ? r : 0) + n;
            0 === a ? gn(e, t) : o.set(t, a);
          }
        },
        bn = function (e) {
          if (ue('recoil_memory_managament_2020')) {
            var t = e.getState();
            pn(e, t.retention.retainablesToCheckForRelease), t.retention.retainablesToCheckForRelease.clear();
          }
        },
        xn = function (e) {
          return void 0 === e ? 'recoilRoot' : e;
        },
        kn = A.unstable_batchedUpdates,
        Sn = an.batchStart,
        _n = { unstable_batchedUpdates: { unstable_batchedUpdates: kn }.unstable_batchedUpdates }
          .unstable_batchedUpdates,
        En = function (e) {
          _n(function () {
            var t = function () {};
            try {
              (t = Sn()), e();
            } finally {
              t();
            }
          });
        };
      function Cn(e) {
        var t, n, r, o, i, l;
        return a().wrap(
          function (a) {
            for (;;)
              switch ((a.prev = a.next)) {
                case 0:
                  (t = y(e)), (a.prev = 1), t.s();
                case 3:
                  if ((n = t.n()).done) {
                    a.next = 24;
                    break;
                  }
                  (r = n.value), (o = y(r)), (a.prev = 6), o.s();
                case 8:
                  if ((i = o.n()).done) {
                    a.next = 14;
                    break;
                  }
                  return (l = i.value), (a.next = 12), l;
                case 12:
                  a.next = 8;
                  break;
                case 14:
                  a.next = 19;
                  break;
                case 16:
                  (a.prev = 16), (a.t0 = a.catch(6)), o.e(a.t0);
                case 19:
                  return (a.prev = 19), o.f(), a.finish(19);
                case 22:
                  a.next = 3;
                  break;
                case 24:
                  a.next = 29;
                  break;
                case 26:
                  (a.prev = 26), (a.t1 = a.catch(1)), t.e(a.t1);
                case 29:
                  return (a.prev = 29), t.f(), a.finish(29);
                case 32:
                case 'end':
                  return a.stop();
              }
          },
          D,
          null,
          [
            [1, 26, 29, 32],
            [6, 16, 19, 22],
          ]
        );
      }
      var Tn = Cn,
        Nn = 'undefined' === typeof Window || 'undefined' === typeof window,
        jn = 'undefined' !== typeof navigator && 'ReactNative' === navigator.product,
        Ln = {
          isSSR: Nn,
          isReactNative: jn,
          isWindow: function (e) {
            return !Nn && (e === window || e instanceof Window);
          },
        };
      var An = function (e, t) {
          var n, r;
          return [
            function () {
              var o = t.apply(void 0, arguments);
              return n === o ? r : ((n = o), (r = e.apply(void 0, arguments)));
            },
            function () {
              n = null;
            },
          ];
        },
        Rn = En,
        Pn = Lt,
        On = Pt,
        Dn = Je,
        In = ot,
        Mn = Ve.DEFAULT_VALUE,
        zn = Ve.recoilValues,
        Vn = Ve.recoilValuesForKeys,
        Bn = an.AbstractRecoilValue,
        Fn = an.getRecoilValueAsLoadable,
        Un = an.setRecoilValue,
        Hn = an.setUnvalidatedRecoilValue,
        qn = yn,
        Wn = It,
        $n = ct.getNextTreeStateVersion,
        Gn = ct.makeEmptyStoreState,
        Kn = Ln.isSSR,
        Qn = An,
        Yn = (function () {
          function e(t, n) {
            var r = this;
            N(this, e),
              V(this, '_store', void 0),
              V(this, '_refCount', 1),
              V(this, 'getLoadable', function (e) {
                return r.checkRefCount_INTERNAL(), Fn(r._store, e);
              }),
              V(this, 'getPromise', function (e) {
                return r.checkRefCount_INTERNAL(), r.getLoadable(e).toPromise();
              }),
              V(this, 'getNodes_UNSTABLE', function (e) {
                if ((r.checkRefCount_INTERNAL(), !0 === (null === e || void 0 === e ? void 0 : e.isModified))) {
                  if (!1 === (null === e || void 0 === e ? void 0 : e.isInitialized)) return [];
                  var t = r._store.getState().currentTree;
                  return Vn(t.dirtyAtoms);
                }
                var n = r._store.getState().knownAtoms,
                  o = r._store.getState().knownSelectors;
                return null == (null === e || void 0 === e ? void 0 : e.isInitialized)
                  ? zn.values()
                  : !0 === e.isInitialized
                  ? Vn(Tn([n, o]))
                  : vt(zn.values(), function (e) {
                      var t = e.key;
                      return !n.has(t) && !o.has(t);
                    });
              }),
              V(this, 'getInfo_UNSTABLE', function (e) {
                var t = e.key;
                return r.checkRefCount_INTERNAL(), On(r._store, r._store.getState().currentTree, t);
              }),
              V(this, 'map', function (e) {
                r.checkRefCount_INTERNAL();
                var t = new tr(r, Rn);
                return e(t), t;
              }),
              V(
                this,
                'asyncMap',
                (function () {
                  var e = l(
                    a().mark(function e(t) {
                      var n;
                      return a().wrap(function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return r.checkRefCount_INTERNAL(), (n = new tr(r, Rn)).retain(), (e.next = 5), t(n);
                            case 5:
                              return n.autoRelease_INTERNAL(), e.abrupt('return', n);
                            case 7:
                            case 'end':
                              return e.stop();
                          }
                      }, e);
                    })
                  );
                  return function (t) {
                    return e.apply(this, arguments);
                  };
                })()
              ),
              (this._store = {
                storeID: In(),
                parentStoreID: n,
                getState: function () {
                  return t;
                },
                replaceState: function (e) {
                  t.currentTree = e(t.currentTree);
                },
                getGraph: function (e) {
                  var n = t.graphsByVersion;
                  if (n.has(e)) return z(n.get(e));
                  var r = Dn();
                  return n.set(e, r), r;
                },
                subscribeToTransactions: function () {
                  return { release: function () {} };
                },
                addTransactionMetadata: function () {
                  throw I('Cannot subscribe to Snapshots');
                },
              });
            var o,
              i = y(this._store.getState().knownAtoms);
            try {
              for (i.s(); !(o = i.n()).done; ) {
                var u = o.value;
                Pn(this._store, u, 'get'), qn(this._store, u, 1);
              }
            } catch (s) {
              i.e(s);
            } finally {
              i.f();
            }
            this.autoRelease_INTERNAL();
          }
          return (
            L(e, [
              {
                key: 'retain',
                value: function () {
                  var e = this;
                  this._refCount <= 0 && pe('Attempt to retain() Snapshot that was already released.'),
                    this._refCount++;
                  var t = !1;
                  return function () {
                    t || ((t = !0), e._release());
                  };
                },
              },
              {
                key: 'autoRelease_INTERNAL',
                value: function () {
                  var e = this;
                  Kn ||
                    window.setTimeout(function () {
                      return e._release();
                    }, 10);
                },
              },
              {
                key: '_release',
                value: function () {
                  if ((this._refCount--, 0 === this._refCount)) {
                    if (
                      (this._store.getState().nodeCleanupFunctions.forEach(function (e) {
                        return e();
                      }),
                      this._store.getState().nodeCleanupFunctions.clear(),
                      !ue('recoil_memory_managament_2020'))
                    )
                      return;
                  } else this._refCount;
                },
              },
              {
                key: 'isRetained',
                value: function () {
                  return this._refCount > 0;
                },
              },
              {
                key: 'checkRefCount_INTERNAL',
                value: function () {
                  ue('recoil_memory_managament_2020') && this._refCount;
                },
              },
              {
                key: 'getStore_INTERNAL',
                value: function () {
                  return this.checkRefCount_INTERNAL(), this._store;
                },
              },
              {
                key: 'getID',
                value: function () {
                  return this.checkRefCount_INTERNAL(), this._store.getState().currentTree.stateID;
                },
              },
              {
                key: 'getStoreID',
                value: function () {
                  return this.checkRefCount_INTERNAL(), this._store.storeID;
                },
              },
            ]),
            e
          );
        })();
      function Xn(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = e.getState(),
          o = n ? $n() : t.version;
        return {
          currentTree: {
            version: n ? o : t.version,
            stateID: n ? o : t.stateID,
            transactionMetadata: S({}, t.transactionMetadata),
            dirtyAtoms: new Set(t.dirtyAtoms),
            atomValues: t.atomValues.clone(),
            nonvalidatedAtoms: t.nonvalidatedAtoms.clone(),
          },
          commitDepth: 0,
          nextTree: null,
          previousTree: null,
          knownAtoms: new Set(r.knownAtoms),
          knownSelectors: new Set(r.knownSelectors),
          transactionSubscriptions: new Map(),
          nodeTransactionSubscriptions: new Map(),
          nodeToComponentSubscriptions: new Map(),
          queuedComponentCallbacks_DEPRECATED: [],
          suspendedComponentResolvers: new Set(),
          graphsByVersion: new Map().set(o, e.getGraph(t.version)),
          retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set(),
          },
          nodeCleanupFunctions: new Map(
            Ae(r.nodeCleanupFunctions.entries(), function (e) {
              return [c(e, 1)[0], function () {}];
            })
          ),
        };
      }
      var Jn = c(
          Qn(
            function (e, t) {
              var n,
                r = e.getState(),
                o =
                  'latest' === t ? (null !== (n = r.nextTree) && void 0 !== n ? n : r.currentTree) : z(r.previousTree);
              return new Yn(Xn(e, o), e.storeID);
            },
            function (e, t) {
              var n, r;
              return (
                String(t) +
                String(e.storeID) +
                String(null === (n = e.getState().nextTree) || void 0 === n ? void 0 : n.version) +
                String(e.getState().currentTree.version) +
                String(null === (r = e.getState().previousTree) || void 0 === r ? void 0 : r.version)
              );
            }
          ),
          2
        ),
        Zn = Jn[0],
        er = Jn[1];
      Wn(er);
      var tr = (function (e) {
          E(n, e);
          var t = T(n);
          function n(e, r) {
            var o;
            return (
              N(this, n),
              V(
                _(
                  (o = t.call(
                    this,
                    Xn(e.getStore_INTERNAL(), e.getStore_INTERNAL().getState().currentTree, !0),
                    e.getStoreID()
                  ))
                ),
                '_batch',
                void 0
              ),
              V(_(o), 'set', function (e, t) {
                o.checkRefCount_INTERNAL();
                var n = o.getStore_INTERNAL();
                o._batch(function () {
                  qn(n, e.key, 1), Un(o.getStore_INTERNAL(), e, t);
                });
              }),
              V(_(o), 'reset', function (e) {
                o.checkRefCount_INTERNAL();
                var t = o.getStore_INTERNAL();
                o._batch(function () {
                  qn(t, e.key, 1), Un(o.getStore_INTERNAL(), e, Mn);
                });
              }),
              V(_(o), 'setUnvalidatedAtomValues_DEPRECATED', function (e) {
                o.checkRefCount_INTERNAL();
                var t = o.getStore_INTERNAL();
                Rn(function () {
                  var n,
                    r = y(e.entries());
                  try {
                    for (r.s(); !(n = r.n()).done; ) {
                      var o = c(n.value, 2),
                        a = o[0],
                        i = o[1];
                      qn(t, a, 1), Hn(t, new Bn(a), i);
                    }
                  } catch (l) {
                    r.e(l);
                  } finally {
                    r.f();
                  }
                });
              }),
              (o._batch = r),
              o
            );
          }
          return L(n);
        })(Yn),
        nr = {
          Snapshot: Yn,
          MutableSnapshot: tr,
          freshSnapshot: function (e) {
            var t = new Yn(Gn());
            return null != e ? t.map(e) : t;
          },
          cloneSnapshot: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'latest',
              n = Zn(e, t);
            return n.isRetained() ? n : (er(), Zn(e, t));
          },
        },
        rr = nr.Snapshot,
        or = nr.MutableSnapshot,
        ar = nr.freshSnapshot,
        ir = nr.cloneSnapshot,
        lr = Object.freeze({
          __proto__: null,
          Snapshot: rr,
          MutableSnapshot: or,
          freshSnapshot: ar,
          cloneSnapshot: ir,
        });
      var ur = function () {
          for (var e = new Set(), t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
          for (var o = 0, a = n; o < a.length; o++) {
            var i,
              l = a[o],
              u = y(l);
            try {
              for (u.s(); !(i = u.n()).done; ) {
                var s = i.value;
                e.add(s);
              }
            } catch (c) {
              u.e(c);
            } finally {
              u.f();
            }
          }
          return e;
        },
        sr = e.useRef;
      var cr = function (e) {
          var t = sr(e);
          return t.current === e && 'function' === typeof e && (t.current = e()), t;
        },
        fr = ct.getNextTreeStateVersion,
        dr = ct.makeEmptyStoreState,
        pr = At,
        hr = Ot,
        vr = Lt,
        mr = jt,
        gr = Rt,
        wr = Je,
        yr = Xe,
        br = ot,
        xr = we.createMutableSource,
        kr = we.reactMode,
        Sr = an.applyAtomValueWrites,
        _r = bn,
        Er = lr.freshSnapshot,
        Cr = e.useCallback,
        Tr = e.useContext,
        Nr = e.useEffect,
        jr = e.useMemo,
        Lr = e.useRef,
        Ar = e.useState;
      function Rr() {
        throw I('This component must be used inside a <RecoilRoot> component.');
      }
      var Pr = Object.freeze({
          storeID: br(),
          getState: Rr,
          replaceState: Rr,
          getGraph: Rr,
          subscribeToTransactions: Rr,
          addTransactionMetadata: Rr,
        }),
        Or = !1;
      function Dr(e) {
        if (Or)
          throw I(
            'An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.'
          );
        var t = e.getState();
        if (null === t.nextTree) {
          ue('recoil_memory_managament_2020') &&
            ue('recoil_release_on_cascading_update_killswitch_2021') &&
            t.commitDepth > 0 &&
            _r(e);
          var n = t.currentTree.version,
            r = fr();
          (t.nextTree = S(
            S({}, t.currentTree),
            {},
            { version: r, stateID: r, dirtyAtoms: new Set(), transactionMetadata: {} }
          )),
            t.graphsByVersion.set(r, yr(z(t.graphsByVersion.get(n))));
        }
      }
      var Ir = e.createContext({ current: Pr }),
        Mr = function () {
          return Tr(Ir);
        },
        zr = e.createContext(null);
      function Vr(e, t, n) {
        var r,
          o = y(hr(e, n, n.dirtyAtoms));
        try {
          for (o.s(); !(r = o.n()).done; ) {
            var a = r.value,
              i = t.nodeToComponentSubscriptions.get(a);
            if (i) {
              var l,
                u = y(i);
              try {
                for (u.s(); !(l = u.n()).done; ) {
                  var s = c(l.value, 2),
                    f = (s[0], c(s[1], 2));
                  f[0];
                  (0, f[1])(n);
                }
              } catch (d) {
                u.e(d);
              } finally {
                u.f();
              }
            }
          }
        } catch (d) {
          o.e(d);
        } finally {
          o.f();
        }
      }
      function Br(e) {
        var t = e.getState(),
          n = t.currentTree,
          r = n.dirtyAtoms;
        if (r.size) {
          var o,
            a = y(t.nodeTransactionSubscriptions);
          try {
            for (a.s(); !(o = a.n()).done; ) {
              var i = c(o.value, 2),
                l = i[0],
                u = i[1];
              if (r.has(l)) {
                var s,
                  f = y(u);
                try {
                  for (f.s(); !(s = f.n()).done; ) {
                    var d = c(s.value, 2);
                    d[0];
                    (0, d[1])(e);
                  }
                } catch (m) {
                  f.e(m);
                } finally {
                  f.f();
                }
              }
            }
          } catch (m) {
            a.e(m);
          } finally {
            a.f();
          }
          var p,
            h = y(t.transactionSubscriptions);
          try {
            for (h.s(); !(p = h.n()).done; ) {
              var v = c(p.value, 2);
              v[0];
              (0, v[1])(e);
            }
          } catch (m) {
            h.e(m);
          } finally {
            h.f();
          }
          (!kr().early || t.suspendedComponentResolvers.size > 0) &&
            (Vr(e, t, n),
            t.suspendedComponentResolvers.forEach(function (e) {
              return e();
            }),
            t.suspendedComponentResolvers.clear());
        }
        t.queuedComponentCallbacks_DEPRECATED.forEach(function (e) {
          return e(n);
        }),
          t.queuedComponentCallbacks_DEPRECATED.splice(0, t.queuedComponentCallbacks_DEPRECATED.length);
      }
      function Fr(e) {
        var t = e.setNotifyBatcherOfChange,
          n = Mr(),
          r = c(Ar([]), 2)[1];
        return (
          t(function () {
            return r({});
          }),
          Nr(
            function () {
              return (
                t(function () {
                  return r({});
                }),
                function () {
                  t(function () {});
                }
              );
            },
            [t]
          ),
          Nr(function () {
            Be.enqueueExecution('Batcher', function () {
              !(function (e) {
                var t = e.getState();
                t.commitDepth++;
                try {
                  var n = t.nextTree;
                  if (null == n) return;
                  (t.previousTree = t.currentTree),
                    (t.currentTree = n),
                    (t.nextTree = null),
                    Br(e),
                    null != t.previousTree
                      ? t.graphsByVersion.delete(t.previousTree.version)
                      : pe('Ended batch with no previous state, which is unexpected', 'recoil'),
                    (t.previousTree = null),
                    ue('recoil_memory_managament_2020') && null == n && _r(e);
                } finally {
                  t.commitDepth--;
                }
              })(n.current);
            });
          }),
          null
        );
      }
      var Ur = 0;
      function Hr(t) {
        var n,
          r = t.initializeState_DEPRECATED,
          o = t.initializeState,
          a = t.store_INTERNAL,
          i = t.children,
          l = function (e) {
            var t = n.current.graphsByVersion;
            if (t.has(e)) return z(t.get(e));
            var r = wr();
            return t.set(e, r), r;
          },
          u = function (e, t) {
            if (null == t) {
              var n = p.current.getState().transactionSubscriptions,
                r = Ur++;
              return (
                n.set(r, e),
                {
                  release: function () {
                    n.delete(r);
                  },
                }
              );
            }
            var o = p.current.getState().nodeTransactionSubscriptions;
            o.has(t) || o.set(t, new Map());
            var a = Ur++;
            return (
              z(o.get(t)).set(a, e),
              {
                release: function () {
                  var e = o.get(t);
                  e && (e.delete(a), 0 === e.size && o.delete(t));
                },
              }
            );
          },
          s = function (e) {
            Dr(p.current);
            for (var t = 0, n = Object.keys(e); t < n.length; t++) {
              var r = n[t];
              z(p.current.getState().nextTree).transactionMetadata[r] = e[r];
            }
          },
          c = function (e) {
            Dr(p.current);
            var t,
              r = z(n.current.nextTree);
            try {
              (Or = !0), (t = e(r));
            } finally {
              Or = !1;
            }
            t !== r && ((n.current.nextTree = t), kr().early && Vr(p.current, n.current, t), z(f.current)());
          },
          f = Lr(null),
          d = Cr(
            function (e) {
              f.current = e;
            },
            [f]
          ),
          p = cr(function () {
            return null !== a && void 0 !== a
              ? a
              : {
                  storeID: br(),
                  getState: function () {
                    return n.current;
                  },
                  replaceState: c,
                  getGraph: l,
                  subscribeToTransactions: u,
                  addTransactionMetadata: s,
                };
          });
        null != a && (p.current = a),
          (n = cr(function () {
            return null != r
              ? (function (e, t) {
                  var n = dr();
                  return (
                    t({
                      set: function (t, r) {
                        var o,
                          a = n.currentTree,
                          i = mr(e, a, t.key, r),
                          l = new Set(i.keys()),
                          u = a.nonvalidatedAtoms.clone(),
                          s = y(l);
                        try {
                          for (s.s(); !(o = s.n()).done; ) {
                            var c = o.value;
                            u.delete(c);
                          }
                        } catch (f) {
                          s.e(f);
                        } finally {
                          s.f();
                        }
                        n.currentTree = S(
                          S({}, a),
                          {},
                          { dirtyAtoms: ur(a.dirtyAtoms, l), atomValues: Sr(a.atomValues, i), nonvalidatedAtoms: u }
                        );
                      },
                      setUnvalidatedAtomValues: function (e) {
                        e.forEach(function (e, t) {
                          n.currentTree = gr(n.currentTree, t, e);
                        });
                      },
                    }),
                    n
                  );
                })(p.current, r)
              : null != o
              ? (function (e) {
                  var t = Er(e),
                    n = t.getStore_INTERNAL().getState();
                  return (
                    t.retain(),
                    n.nodeCleanupFunctions.forEach(function (e) {
                      return e();
                    }),
                    n.nodeCleanupFunctions.clear(),
                    n
                  );
                })(o)
              : dr();
          }));
        var h = jr(
          function () {
            return null === xr || void 0 === xr
              ? void 0
              : xr(n, function () {
                  return n.current.currentTree.version;
                });
          },
          [n]
        );
        return (
          Nr(
            function () {
              var e,
                t = p.current,
                n = y(new Set(t.getState().knownAtoms));
              try {
                for (n.s(); !(e = n.n()).done; ) {
                  var r = e.value;
                  vr(t, r, 'get');
                }
              } catch (o) {
                n.e(o);
              } finally {
                n.f();
              }
              return function () {
                var e,
                  n = y(t.getState().knownAtoms);
                try {
                  for (n.s(); !(e = n.n()).done; ) {
                    var r = e.value;
                    pr(t, r);
                  }
                } catch (o) {
                  n.e(o);
                } finally {
                  n.f();
                }
              };
            },
            [p]
          ),
          e.createElement(
            Ir.Provider,
            { value: p },
            e.createElement(zr.Provider, { value: h }, e.createElement(Fr, { setNotifyBatcherOfChange: d }), i)
          )
        );
      }
      var qr = function (t) {
          var n = t.override,
            r = p(t, R),
            o = Mr();
          return !1 === n && o.current !== Pr ? t.children : e.createElement(Hr, r);
        },
        Wr = Mr,
        $r = function () {
          var e = Tr(zr);
          return (
            null == e &&
              Le(
                'Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks.'
              ),
            e
          );
        },
        Gr = function () {
          return Mr().current.storeID;
        };
      var Kr = function (e, t) {
          if (e === t) return !0;
          if (e.length !== t.length) return !1;
          for (var n = 0, r = e.length; n < r; n++) if (e[n] !== t[n]) return !1;
          return !0;
        },
        Qr = e.useEffect,
        Yr = e.useRef;
      var Xr = function (e) {
          var t = Yr();
          return (
            Qr(function () {
              t.current = e;
            }),
            t.current
          );
        },
        Jr = Wr,
        Zr = wn,
        eo = yn,
        to = dt.RetentionZone,
        no = e.useEffect,
        ro = e.useRef,
        oo = Ln.isSSR;
      var ao = function (e) {
        if (ue('recoil_memory_managament_2020'))
          return (function (e) {
            var t = Array.isArray(e) ? e : [e],
              n = t.map(function (e) {
                return e instanceof to ? e : e.key;
              }),
              r = Jr();
            no(function () {
              if (ue('recoil_memory_managament_2020')) {
                var e = r.current;
                if (o.current && !oo) window.clearTimeout(o.current), (o.current = null);
                else {
                  var t,
                    a = y(n);
                  try {
                    for (a.s(); !(t = a.n()).done; ) {
                      var i = t.value;
                      eo(e, i, 1);
                    }
                  } catch (l) {
                    a.e(l);
                  } finally {
                    a.f();
                  }
                }
                return function () {
                  var t,
                    r = y(n);
                  try {
                    for (r.s(); !(t = r.n()).done; ) {
                      var o = t.value;
                      eo(e, o, -1);
                    }
                  } catch (l) {
                    r.e(l);
                  } finally {
                    r.f();
                  }
                };
              }
            }, [r].concat(f(n)));
            var o = ro(),
              a = Xr(n);
            if (!oo && (void 0 === a || !Kr(a, n))) {
              var i,
                l = r.current,
                u = y(n);
              try {
                for (u.s(); !(i = u.n()).done; ) {
                  var s = i.value;
                  eo(l, s, 1);
                }
              } catch (h) {
                u.e(h);
              } finally {
                u.f();
              }
              if (a) {
                var c,
                  d = y(a);
                try {
                  for (d.s(); !(c = d.n()).done; ) {
                    var p = c.value;
                    eo(l, p, -1);
                  }
                } catch (h) {
                  d.e(h);
                } finally {
                  d.f();
                }
              }
              o.current && window.clearTimeout(o.current),
                (o.current = window.setTimeout(function () {
                  o.current = null;
                  var e,
                    t = y(n);
                  try {
                    for (t.s(); !(e = t.n()).done; ) {
                      var r = e.value;
                      eo(l, r, -1);
                    }
                  } catch (h) {
                    t.e(h);
                  } finally {
                    t.f();
                  }
                }, Zr));
            }
          })(e);
      };
      var io = function () {
          return '<component name not available>';
        },
        lo = Ve.DEFAULT_VALUE,
        uo = we.currentRendererSupportsUseSyncExternalStore,
        so = we.reactMode,
        co = we.useMutableSource,
        fo = we.useSyncExternalStore,
        po = $r,
        ho = Wr,
        vo = (je.isRecoilValue, an.getRecoilValueAsLoadable),
        mo = an.setRecoilValue,
        go = an.subscribeToRecoilValue,
        wo = e.useCallback,
        yo = e.useEffect,
        bo = e.useMemo,
        xo = e.useRef,
        ko = e.useState;
      function So(e, t, n) {
        if ('hasValue' === e.state) return e.contents;
        if ('loading' === e.state)
          throw new Promise(function (e) {
            n.current.getState().suspendedComponentResolvers.add(e);
          });
        throw 'hasError' === e.state ? e.contents : I('Invalid value of loadable atom "'.concat(t.key, '"'));
      }
      function _o(e) {
        var t = ho(),
          n = io(),
          r = wo(
            function () {
              var n;
              var r = t.current,
                o = r.getState(),
                a = so().early && null !== (n = o.nextTree) && void 0 !== n ? n : o.currentTree;
              return { loadable: vo(r, e, a), key: e.key };
            },
            [t, e]
          ),
          o = wo(function (e) {
            var t;
            return function () {
              var n,
                r,
                o = e();
              return null !== (n = t) &&
                void 0 !== n &&
                n.loadable.is(o.loadable) &&
                (null === (r = t) || void 0 === r ? void 0 : r.key) === o.key
                ? t
                : ((t = o), o);
            };
          }, []),
          a = bo(
            function () {
              return o(r);
            },
            [r, o]
          ),
          i = wo(
            function (r) {
              var o = t.current;
              return go(o, e, r, n).release;
            },
            [t, e, n]
          );
        return fo(i, a, a).loadable;
      }
      function Eo(e) {
        var t = ho(),
          n = wo(
            function () {
              var n,
                r = t.current,
                o = r.getState(),
                a = so().early && null !== (n = o.nextTree) && void 0 !== n ? n : o.currentTree;
              return vo(r, e, a);
            },
            [t, e]
          ),
          r = wo(
            function () {
              return n();
            },
            [n]
          ),
          o = io(),
          a = wo(
            function (r, a) {
              var i = t.current;
              return go(
                i,
                e,
                function () {
                  if (!ue('recoil_suppress_rerender_in_callback')) return a();
                  var e = n();
                  u.current.is(e) || a(), (u.current = e);
                },
                o
              ).release;
            },
            [t, e, o, n]
          ),
          i = po();
        if (null == i) throw I('Recoil hooks must be used in components contained within a <RecoilRoot> component.');
        var l = co(i, r, a),
          u = xo(l);
        return (
          yo(function () {
            u.current = l;
          }),
          l
        );
      }
      function Co(e) {
        var t = ho(),
          n = io(),
          r = wo(
            function () {
              var n;
              var r = t.current,
                o = r.getState(),
                a = so().early && null !== (n = o.nextTree) && void 0 !== n ? n : o.currentTree;
              return vo(r, e, a);
            },
            [t, e]
          ),
          o = wo(
            function () {
              return { loadable: r(), key: e.key };
            },
            [r, e.key]
          ),
          a = wo(
            function (e) {
              var t = o();
              return e.loadable.is(t.loadable) && e.key === t.key ? e : t;
            },
            [o]
          );
        yo(
          function () {
            var r = go(
              t.current,
              e,
              function (e) {
                u(a);
              },
              n
            );
            return u(a), r.release;
          },
          [n, e, t, a]
        );
        var i = c(ko(o), 2),
          l = i[0],
          u = i[1];
        return l.key !== e.key ? o().loadable : l.loadable;
      }
      function To(e) {
        var t = ho(),
          n = c(ko([]), 2)[1],
          r = io(),
          o = wo(
            function () {
              var n;
              var r = t.current,
                o = r.getState(),
                a = so().early && null !== (n = o.nextTree) && void 0 !== n ? n : o.currentTree;
              return vo(r, e, a);
            },
            [t, e]
          ),
          a = o(),
          i = xo(a);
        return (
          yo(function () {
            i.current = a;
          }),
          yo(
            function () {
              var a = t.current,
                l = a.getState(),
                u = go(
                  a,
                  e,
                  function (e) {
                    var t;
                    if (!ue('recoil_suppress_rerender_in_callback')) return n([]);
                    var r = o();
                    (null !== (t = i.current) && void 0 !== t && t.is(r)) || n(r), (i.current = r);
                  },
                  r
                );
              if (l.nextTree)
                a.getState().queuedComponentCallbacks_DEPRECATED.push(function () {
                  (i.current = null), n([]);
                });
              else {
                var s;
                if (!ue('recoil_suppress_rerender_in_callback')) return n([]);
                var c = o();
                (null !== (s = i.current) && void 0 !== s && s.is(c)) || n(c), (i.current = c);
              }
              return u.release;
            },
            [r, o, e, t]
          ),
          a
        );
      }
      function No(e) {
        return (
          ue('recoil_memory_managament_2020') && ao(e),
          { TRANSITION_SUPPORT: Co, SYNC_EXTERNAL_STORE: uo() ? _o : Co, MUTABLE_SOURCE: Eo, LEGACY: To }[so().mode](e)
        );
      }
      function jo(e) {
        var t = ho();
        return So(No(e), e, t);
      }
      function Lo(e) {
        var t = ho();
        return wo(
          function (n) {
            mo(t.current, e, n);
          },
          [t, e]
        );
      }
      function Ao(e) {
        return ue('recoil_memory_managament_2020') && ao(e), Co(e);
      }
      function Ro(e) {
        var t = ho();
        return So(Ao(e), e, t);
      }
      var Po = function (e) {
          return [jo(e), Lo(e)];
        },
        Oo = function (e) {
          return [No(e), Lo(e)];
        },
        Do = jo,
        Io = No,
        Mo = function (e) {
          var t = ho();
          return wo(
            function () {
              mo(t.current, e, lo);
            },
            [t, e]
          );
        },
        zo = Lo,
        Vo = Ao,
        Bo = Ro,
        Fo = function (e) {
          return [Ro(e), Lo(e)];
        };
      var Uo = En,
        Ho = Ve.DEFAULT_VALUE,
        qo = Ve.getNode,
        Wo = Wr,
        $o = an.AbstractRecoilValue,
        Go = an.setRecoilValueLoadable,
        Ko = wn,
        Qo = lr.cloneSnapshot,
        Yo = e.useCallback,
        Xo = e.useEffect,
        Jo = e.useRef,
        Zo = e.useState,
        ea = Ln.isSSR;
      function ta(e) {
        var t = Wo();
        Xo(
          function () {
            return t.current.subscribeToTransactions(e).release;
          },
          [e, t]
        );
      }
      function na(e, t) {
        var n,
          r = e.getState(),
          o = null !== (n = r.nextTree) && void 0 !== n ? n : r.currentTree,
          a = t.getStore_INTERNAL().getState().currentTree;
        Uo(function () {
          for (var n = new Set(), r = 0, i = [o.atomValues.keys(), a.atomValues.keys()]; r < i.length; r++) {
            var l,
              u = y(i[r]);
            try {
              for (u.s(); !(l = u.n()).done; ) {
                var s,
                  c,
                  f = l.value;
                (null === (s = o.atomValues.get(f)) || void 0 === s ? void 0 : s.contents) !==
                  (null === (c = a.atomValues.get(f)) || void 0 === c ? void 0 : c.contents) &&
                  qo(f).shouldRestoreFromSnapshots &&
                  n.add(f);
              }
            } catch (d) {
              u.e(d);
            } finally {
              u.f();
            }
          }
          n.forEach(function (t) {
            Go(e, new $o(t), a.atomValues.has(t) ? z(a.atomValues.get(t)) : Ho);
          }),
            e.replaceState(function (e) {
              return S(S({}, e), {}, { stateID: t.getID() });
            });
        });
      }
      var ra = function () {
          var e = Wo(),
            t = c(
              Zo(function () {
                return Qo(e.current);
              }),
              2
            ),
            n = t[0],
            r = t[1],
            o = Xr(n),
            a = Jo(),
            i = Jo();
          if (
            (ta(
              Yo(function (e) {
                return r(Qo(e));
              }, [])
            ),
            Xo(
              function () {
                var e,
                  t = n.retain();
                a.current &&
                  !ea &&
                  (window.clearTimeout(a.current),
                  (a.current = null),
                  null === (e = i.current) || void 0 === e || e.call(i),
                  (i.current = null));
                return function () {
                  window.setTimeout(t, 10);
                };
              },
              [n]
            ),
            o !== n && !ea)
          ) {
            var l;
            if (a.current)
              window.clearTimeout(a.current),
                (a.current = null),
                null === (l = i.current) || void 0 === l || l.call(i),
                (i.current = null);
            (i.current = n.retain()),
              (a.current = window.setTimeout(function () {
                var e;
                (a.current = null), null === (e = i.current) || void 0 === e || e.call(i), (i.current = null);
              }, Ko));
          }
          return n;
        },
        oa = na,
        aa = function () {
          var e = Wo();
          return Yo(
            function (t) {
              return na(e.current, t);
            },
            [e]
          );
        },
        ia = function (e) {
          ta(
            Yo(
              function (t) {
                var n = Qo(t, 'latest'),
                  r = Qo(t, 'previous');
                e({ snapshot: n, previousSnapshot: r });
              },
              [e]
            )
          );
        },
        la = Pt,
        ua = Wr;
      var sa = function () {
          var e = ua();
          return function (t) {
            var n = t.key;
            return la(e.current, e.current.getState().currentTree, n);
          };
        },
        ca = we.reactMode,
        fa = qr,
        da = Wr,
        pa = e.useMemo;
      var ha = function () {
          'MUTABLE_SOURCE' === ca().mode &&
            console.warn(
              'Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.'
            );
          var t = da().current;
          return pa(
            function () {
              return function (n) {
                var r = n.children;
                return e.createElement(fa, { store_INTERNAL: t }, r);
              };
            },
            [t]
          );
        },
        va = ae.loadableWithValue,
        ma = Lt,
        ga = Ve.DEFAULT_VALUE,
        wa = Ve.getNode,
        ya = an.copyTreeState,
        ba = an.getRecoilValueAsLoadable,
        xa = an.invalidateDownstreams,
        ka = an.writeLoadableToTreeState;
      function Sa(e) {
        return 'atom' === wa(e.key).nodeType;
      }
      var _a = (function () {
        function e(t, n) {
          var r = this;
          N(this, e),
            V(this, '_store', void 0),
            V(this, '_treeState', void 0),
            V(this, '_changes', void 0),
            V(this, 'get', function (e) {
              if (r._changes.has(e.key)) return r._changes.get(e.key);
              if (!Sa(e)) throw I('Reading selectors within atomicUpdate is not supported');
              var t = ba(r._store, e, r._treeState);
              if ('hasValue' === t.state) return t.contents;
              throw 'hasError' === t.state
                ? t.contents
                : I('Expected Recoil atom '.concat(e.key, ' to have a value, but it is in a loading state.'));
            }),
            V(this, 'set', function (e, t) {
              if (!Sa(e)) throw I('Setting selectors within atomicUpdate is not supported');
              if ('function' === typeof t) {
                var n = r.get(e);
                r._changes.set(e.key, t(n));
              } else ma(r._store, e.key, 'set'), r._changes.set(e.key, t);
            }),
            V(this, 'reset', function (e) {
              r.set(e, ga);
            }),
            (this._store = t),
            (this._treeState = n),
            (this._changes = new Map());
        }
        return (
          L(e, [
            {
              key: 'newTreeState_INTERNAL',
              value: function () {
                if (0 === this._changes.size) return this._treeState;
                var e,
                  t = ya(this._treeState),
                  n = y(this._changes);
                try {
                  for (n.s(); !(e = n.n()).done; ) {
                    var r = c(e.value, 2),
                      o = r[0],
                      a = r[1];
                    ka(t, o, va(a));
                  }
                } catch (i) {
                  n.e(i);
                } finally {
                  n.f();
                }
                return xa(this._store, t), t;
              },
            },
          ]),
          e
        );
      })();
      var Ea = function (e) {
          return function (t) {
            e.replaceState(function (n) {
              var r = new _a(e, n);
              return t(r), r.newTreeState_INTERNAL();
            });
          };
        },
        Ca = Ea,
        Ta = Object.freeze({ __proto__: null, atomicUpdater: Ca });
      var Na = function (e, t) {
          if (!e) throw new Error(t);
        },
        ja = Ta.atomicUpdater,
        La = En,
        Aa = Ve.DEFAULT_VALUE,
        Ra = Wr,
        Pa = an.refreshRecoilValue,
        Oa = an.setRecoilValue,
        Da = lr.cloneSnapshot,
        Ia = oa,
        Ma = e.useCallback,
        za = L(function e() {
          N(this, e);
        }),
        Va = new za();
      function Ba(e, t, n, r) {
        var o,
          a,
          i = Va;
        (La(function () {
          var a =
            'useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.';
          if ('function' !== typeof t) throw I(a);
          var l = mt(
              S(
                S({}, null !== r && void 0 !== r ? r : {}),
                {},
                {
                  set: function (t, n) {
                    return Oa(e, t, n);
                  },
                  reset: function (t) {
                    return Oa(e, t, Aa);
                  },
                  refresh: function (t) {
                    return Pa(e, t);
                  },
                  gotoSnapshot: function (t) {
                    return Ia(e, t);
                  },
                  transact_UNSTABLE: function (t) {
                    return ja(e)(t);
                  },
                }
              ),
              {
                snapshot: function () {
                  var t = Da(e);
                  return (o = t.retain()), t;
                },
              }
            ),
            u = t(l);
          if ('function' !== typeof u) throw I(a);
          i = u.apply(void 0, f(n));
        }),
        i instanceof za && Na(!1),
        M(i))
          ? i.finally(function () {
              var e;
              null === (e = o) || void 0 === e || e();
            })
          : null === (a = o) || void 0 === a || a();
        return i;
      }
      var Fa = Ba,
        Ua = function (e, t) {
          var n = Ra();
          return Ma(
            function () {
              for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) r[o] = arguments[o];
              return Ba(n.current, e, r);
            },
            null != t ? [].concat(f(t), [n]) : void 0
          );
        },
        Ha = Wr,
        qa = an.refreshRecoilValue,
        Wa = e.useCallback;
      var $a = function (e) {
          var t = Ha();
          return Wa(
            function () {
              var n = t.current;
              qa(n, e);
            },
            [e, t]
          );
        },
        Ga = Ta.atomicUpdater,
        Ka = Wr,
        Qa = e.useMemo;
      var Ya = function (e, t) {
          var n = Ka();
          return Qa(
            function () {
              return function () {
                for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) r[o] = arguments[o];
                var a = Ga(n.current);
                a(function (t) {
                  e(t).apply(void 0, r);
                });
              };
            },
            null != t ? [].concat(f(t), [n]) : void 0
          );
        },
        Xa = {
          WrappedValue: L(function e(t) {
            N(this, e), V(this, 'value', void 0), (this.value = t);
          }),
        }.WrappedValue,
        Ja = Object.freeze({ __proto__: null, WrappedValue: Xa }),
        Za = we.isFastRefreshEnabled,
        ei = (function (e) {
          E(n, e);
          var t = T(n);
          function n() {
            return N(this, n), t.apply(this, arguments);
          }
          return L(n);
        })(w(Error)),
        ti = (function () {
          function e(t) {
            var n, r, o;
            N(this, e),
              V(this, '_name', void 0),
              V(this, '_numLeafs', void 0),
              V(this, '_root', void 0),
              V(this, '_onHit', void 0),
              V(this, '_onSet', void 0),
              V(this, '_mapNodeValue', void 0),
              (this._name = null === t || void 0 === t ? void 0 : t.name),
              (this._numLeafs = 0),
              (this._root = null),
              (this._onHit =
                null !== (n = null === t || void 0 === t ? void 0 : t.onHit) && void 0 !== n ? n : function () {}),
              (this._onSet =
                null !== (r = null === t || void 0 === t ? void 0 : t.onSet) && void 0 !== r ? r : function () {}),
              (this._mapNodeValue =
                null !== (o = null === t || void 0 === t ? void 0 : t.mapNodeValue) && void 0 !== o
                  ? o
                  : function (e) {
                      return e;
                    });
          }
          return (
            L(e, [
              {
                key: 'size',
                value: function () {
                  return this._numLeafs;
                },
              },
              {
                key: 'root',
                value: function () {
                  return this._root;
                },
              },
              {
                key: 'get',
                value: function (e, t) {
                  var n;
                  return null === (n = this.getLeafNode(e, t)) || void 0 === n ? void 0 : n.value;
                },
              },
              {
                key: 'getLeafNode',
                value: function (e, t) {
                  if (null != this._root)
                    for (var n = this._root; n; ) {
                      if ((null === t || void 0 === t || t.onNodeVisit(n), 'leaf' === n.type)) return this._onHit(n), n;
                      var r = this._mapNodeValue(e(n.nodeKey));
                      n = n.branches.get(r);
                    }
                },
              },
              {
                key: 'set',
                value: function (e, t, n) {
                  var r = this,
                    o = function () {
                      var o,
                        a,
                        i,
                        l,
                        u,
                        s,
                        f,
                        d = y(e);
                      try {
                        for (d.s(); !(f = d.n()).done; ) {
                          var p,
                            h,
                            v,
                            m = c(f.value, 2),
                            g = m[0],
                            w = m[1],
                            b = r._root;
                          if ('leaf' === (null === b || void 0 === b ? void 0 : b.type)) throw r.invalidCacheError();
                          var x = u;
                          if (
                            'branch' !==
                              (u =
                                null !== (p = u = x ? x.branches.get(s) : b) && void 0 !== p
                                  ? p
                                  : { type: 'branch', nodeKey: g, parent: x, branches: new Map(), branchKey: s })
                                .type ||
                            u.nodeKey !== g
                          )
                            throw r.invalidCacheError();
                          null === x || void 0 === x || x.branches.set(s, u),
                            null === n || void 0 === n || null === (h = n.onNodeVisit) || void 0 === h || h.call(n, u),
                            (s = r._mapNodeValue(w)),
                            (r._root = null !== (v = r._root) && void 0 !== v ? v : u);
                        }
                      } catch (_) {
                        d.e(_);
                      } finally {
                        d.f();
                      }
                      var k = u ? (null === (o = u) || void 0 === o ? void 0 : o.branches.get(s)) : r._root;
                      if (null != k && ('leaf' !== k.type || k.branchKey !== s)) throw r.invalidCacheError();
                      var S = { type: 'leaf', value: t, parent: u, branchKey: s };
                      null === (a = u) || void 0 === a || a.branches.set(s, S),
                        (r._root = null !== (i = r._root) && void 0 !== i ? i : S),
                        r._numLeafs++,
                        r._onSet(S),
                        null === n || void 0 === n || null === (l = n.onNodeVisit) || void 0 === l || l.call(n, S);
                    };
                  try {
                    o();
                  } catch (a) {
                    if (!(a instanceof ei)) throw a;
                    this.clear(), o();
                  }
                },
              },
              {
                key: 'delete',
                value: function (e) {
                  var t = this.root();
                  if (!t) return !1;
                  if (e === t) return (this._root = null), (this._numLeafs = 0), !0;
                  for (var n = e.parent, r = e.branchKey; n; ) {
                    var o;
                    if ((n.branches.delete(r), n === t))
                      return 0 === n.branches.size ? ((this._root = null), (this._numLeafs = 0)) : this._numLeafs--, !0;
                    if (n.branches.size > 0) break;
                    (r = null === (o = n) || void 0 === o ? void 0 : o.branchKey), (n = n.parent);
                  }
                  for (; n !== t; n = n.parent) if (null == n) return !1;
                  return this._numLeafs--, !0;
                },
              },
              {
                key: 'clear',
                value: function () {
                  (this._numLeafs = 0), (this._root = null);
                },
              },
              {
                key: 'invalidCacheError',
                value: function () {
                  var e = Za()
                    ? 'Possible Fast Refresh module reload detected.  This may also be caused by an selector returning inconsistent values. Resetting cache.'
                    : 'Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache.';
                  throw (pe(e + (null != this._name ? ' - '.concat(this._name) : '')), new ei());
                },
              },
            ]),
            e
          );
        })(),
        ni = { TreeCache: ti }.TreeCache,
        ri = Object.freeze({ __proto__: null, TreeCache: ni }),
        oi = {
          LRUCache: (function () {
            function e(t) {
              var n;
              N(this, e),
                V(this, '_maxSize', void 0),
                V(this, '_size', void 0),
                V(this, '_head', void 0),
                V(this, '_tail', void 0),
                V(this, '_map', void 0),
                V(this, '_keyMapper', void 0),
                (this._maxSize = t.maxSize),
                (this._size = 0),
                (this._head = null),
                (this._tail = null),
                (this._map = new Map()),
                (this._keyMapper =
                  null !== (n = t.mapKey) && void 0 !== n
                    ? n
                    : function (e) {
                        return e;
                      });
            }
            return (
              L(e, [
                {
                  key: 'head',
                  value: function () {
                    return this._head;
                  },
                },
                {
                  key: 'tail',
                  value: function () {
                    return this._tail;
                  },
                },
                {
                  key: 'size',
                  value: function () {
                    return this._size;
                  },
                },
                {
                  key: 'maxSize',
                  value: function () {
                    return this._maxSize;
                  },
                },
                {
                  key: 'has',
                  value: function (e) {
                    return this._map.has(this._keyMapper(e));
                  },
                },
                {
                  key: 'get',
                  value: function (e) {
                    var t = this._keyMapper(e),
                      n = this._map.get(t);
                    if (n) return this.set(e, n.value), n.value;
                  },
                },
                {
                  key: 'set',
                  value: function (e, t) {
                    var n = this._keyMapper(e);
                    this._map.get(n) && this.delete(e);
                    var r = this.head(),
                      o = { key: e, right: r, left: null, value: t };
                    r ? (r.left = o) : (this._tail = o),
                      this._map.set(n, o),
                      (this._head = o),
                      this._size++,
                      this._maybeDeleteLRU();
                  },
                },
                {
                  key: '_maybeDeleteLRU',
                  value: function () {
                    this.size() > this.maxSize() && this.deleteLru();
                  },
                },
                {
                  key: 'deleteLru',
                  value: function () {
                    var e = this.tail();
                    e && this.delete(e.key);
                  },
                },
                {
                  key: 'delete',
                  value: function (e) {
                    var t = this._keyMapper(e);
                    if (this._size && this._map.has(t)) {
                      var n = z(this._map.get(t)),
                        r = n.right,
                        o = n.left;
                      r && (r.left = n.left),
                        o && (o.right = n.right),
                        n === this.head() && (this._head = r),
                        n === this.tail() && (this._tail = o),
                        this._map.delete(t),
                        this._size--;
                    }
                  },
                },
                {
                  key: 'clear',
                  value: function () {
                    (this._size = 0), (this._head = null), (this._tail = null), (this._map = new Map());
                  },
                },
              ]),
              e
            );
          })(),
        }.LRUCache,
        ai = Object.freeze({ __proto__: null, LRUCache: oi }),
        ii = ai.LRUCache,
        li = ri.TreeCache;
      var ui = function (e) {
        var t = e.name,
          n = e.maxSize,
          r = e.mapNodeValue,
          o =
            void 0 === r
              ? function (e) {
                  return e;
                }
              : r,
          a = new ii({ maxSize: n }),
          i = new li({
            name: t,
            mapNodeValue: o,
            onHit: function (e) {
              a.set(e, !0);
            },
            onSet: function (e) {
              var t = a.tail();
              a.set(e, !0), t && i.size() > n && i.delete(t.key);
            },
          });
        return i;
      };
      function si(e, t, n) {
        if ('string' === typeof e && !e.includes('"') && !e.includes('\\')) return '"'.concat(e, '"');
        switch (typeof e) {
          case 'undefined':
            return '';
          case 'boolean':
            return e ? 'true' : 'false';
          case 'number':
          case 'symbol':
            return String(e);
          case 'string':
            return JSON.stringify(e);
          case 'function':
            if (!0 !== (null === t || void 0 === t ? void 0 : t.allowFunctions))
              throw I('Attempt to serialize function in a Recoil cache key');
            return '__FUNCTION('.concat(e.name, ')__');
        }
        if (null === e) return 'null';
        var r;
        if ('object' !== typeof e) return null !== (r = JSON.stringify(e)) && void 0 !== r ? r : '';
        if (M(e)) return '__PROMISE__';
        if (Array.isArray(e))
          return '['.concat(
            e.map(function (e, n) {
              return si(e, t, n.toString());
            }),
            ']'
          );
        if ('function' === typeof e.toJSON) return si(e.toJSON(n), t, n);
        if (e instanceof Map) {
          var o,
            a = {},
            i = y(e);
          try {
            for (i.s(); !(o = i.n()).done; ) {
              var l = c(o.value, 2),
                u = l[0],
                s = l[1];
              a['string' === typeof u ? u : si(u, t)] = s;
            }
          } catch (f) {
            i.e(f);
          } finally {
            i.f();
          }
          return si(a, t, n);
        }
        return e instanceof Set
          ? si(
              Array.from(e).sort(function (e, n) {
                return si(e, t).localeCompare(si(n, t));
              }),
              t,
              n
            )
          : void 0 !== Symbol && null != e[Symbol.iterator] && 'function' === typeof e[Symbol.iterator]
          ? si(Array.from(e), t, n)
          : '{'.concat(
              Object.keys(e)
                .filter(function (t) {
                  return void 0 !== e[t];
                })
                .sort()
                .map(function (n) {
                  return ''.concat(si(n, t), ':').concat(si(e[n], t, n));
                })
                .join(','),
              '}'
            );
      }
      var ci = function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { allowFunctions: !1 };
          return si(e, t);
        },
        fi = ri.TreeCache,
        di = { equality: 'reference', eviction: 'keep-all', maxSize: 1 / 0 };
      function pi(e) {
        switch (e) {
          case 'reference':
            return function (e) {
              return e;
            };
          case 'value':
            return function (e) {
              return ci(e);
            };
        }
        throw I('Unrecognized equality policy '.concat(e));
      }
      function hi(e, t, n, r) {
        switch (e) {
          case 'keep-all':
            return new fi({ name: r, mapNodeValue: n });
          case 'lru':
            return ui({ name: r, maxSize: z(t), mapNodeValue: n });
          case 'most-recent':
            return ui({ name: r, maxSize: 1, mapNodeValue: n });
        }
        throw I('Unrecognized eviction policy '.concat(e));
      }
      var vi = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : di,
          t = e.equality,
          n = void 0 === t ? di.equality : t,
          r = e.eviction,
          o = void 0 === r ? di.eviction : r,
          a = e.maxSize,
          i = void 0 === a ? di.maxSize : a,
          l = arguments.length > 1 ? arguments[1] : void 0,
          u = pi(n);
        return hi(o, i, u, l);
      };
      var mi = function (e) {
          return function () {
            return null;
          };
        },
        gi = ae.isLoadable,
        wi = ae.loadableWithError,
        yi = ae.loadableWithPromise,
        bi = ae.loadableWithValue,
        xi = Ja.WrappedValue,
        ki = Tt,
        Si = Nt,
        _i = jt,
        Ei = Ze,
        Ci = Ve.DEFAULT_VALUE,
        Ti = Ve.getConfigDeletionHandler,
        Ni = Ve.getNode,
        ji = Ve.registerNode,
        Li = je.isRecoilValue,
        Ai = an.markRecoilValueModified,
        Ri = xn,
        Pi = Fa,
        Oi = mi,
        Di = L(function e() {
          N(this, e);
        }),
        Ii = new Di(),
        Mi = [],
        zi = new Map(),
        Vi = (function () {
          var e = 0;
          return function () {
            return e++;
          };
        })();
      function Bi(e) {
        var t = null,
          n = e.key,
          r = e.get,
          o = e.cachePolicy_UNSTABLE,
          a = null != e.set ? e.set : void 0;
        var i = new Set(),
          l = vi(null !== o && void 0 !== o ? o : { equality: 'reference', eviction: 'keep-all' }, n),
          u = Ri(e.retainedBy_UNSTABLE),
          s = new Map(),
          f = 0;
        function d() {
          return !ue('recoil_memory_managament_2020') || f > 0;
        }
        function p(e) {
          return (
            e.getState().knownSelectors.add(n),
            f++,
            function () {
              f--;
            }
          );
        }
        function h() {
          return void 0 !== Ti(n) && !d();
        }
        function v(e, t, n, r, o) {
          j(t, r, o), m(e, n);
        }
        function m(e, t) {
          N(e, t) && T(e), g(t, !0);
        }
        function g(e, n) {
          var r = zi.get(e);
          if (null != r) {
            var o,
              a = y(r);
            try {
              for (a.s(); !(o = a.n()).done; ) {
                var i = o.value;
                Ai(i, z(t));
              }
            } catch (l) {
              a.e(l);
            } finally {
              a.f();
            }
            n && zi.delete(e);
          }
        }
        function w(e, t) {
          var n = zi.get(t);
          null == n && zi.set(t, (n = new Set())), n.add(e);
        }
        function b(e, t, n, r, o, a) {
          return t
            .then(function (r) {
              if (!d()) throw (T(e), Ii);
              null != a.loadingDepKey && a.loadingDepPromise === t
                ? n.atomValues.set(a.loadingDepKey, bi(r))
                : e.getState().knownSelectors.forEach(function (e) {
                    n.atomValues.delete(e);
                  });
              var i = S(e, n);
              if (i && 'loading' !== i.state) {
                if (((N(e, o) || null == C(e)) && m(e, o), 'hasValue' === i.state)) return i.contents;
                throw i.contents;
              }
              if (!N(e, o)) {
                var l = E(e, n);
                if (null != l) return l.loadingLoadable.contents;
              }
              var u = c(k(e, n, o), 2),
                s = u[0],
                f = u[1];
              if (('loading' !== s.state && v(e, n, o, s, f), 'hasError' === s.state)) throw s.contents;
              return s.contents;
            })
            .catch(function (t) {
              if (t instanceof Di) throw Ii;
              if (!d()) throw (T(e), Ii);
              var a = wi(t);
              throw (v(e, n, o, a, r), t);
            });
        }
        function x(e, t, r, o) {
          var a, l, u, s, c, f, d;
          (N(e, o) ||
            t.version ===
              (null === (a = e.getState()) || void 0 === a || null === (l = a.currentTree) || void 0 === l
                ? void 0
                : l.version) ||
            t.version ===
              (null === (u = e.getState()) || void 0 === u || null === (s = u.nextTree) || void 0 === s
                ? void 0
                : s.version)) &&
            Ei(
              n,
              r,
              e,
              null !==
                (c =
                  null === (f = e.getState()) || void 0 === f || null === (d = f.nextTree) || void 0 === d
                    ? void 0
                    : d.version) && void 0 !== c
                ? c
                : e.getState().currentTree.version
            );
          var p,
            h = y(r);
          try {
            for (h.s(); !(p = h.n()).done; ) {
              var v = p.value;
              i.add(v);
            }
          } catch (m) {
            h.e(m);
          } finally {
            h.f();
          }
        }
        function k(e, o, a) {
          var i,
            l,
            u = Oi(n),
            s = !0,
            c = !0,
            f = function () {
              u(), (c = !1);
            },
            p = !1,
            h = { loadingDepKey: null, loadingDepPromise: null },
            m = new Map();
          function w(t) {
            var n = t.key,
              r = ki(e, o, n);
            switch (
              (m.set(n, r),
              s ||
                (x(e, o, new Set(m.keys()), a),
                (function (e, t) {
                  N(e, t) && (z(C(e)).stateVersions.clear(), g(t, !1));
                })(e, a)),
              r.state)
            ) {
              case 'hasValue':
                return r.contents;
              case 'hasError':
                throw r.contents;
              case 'loading':
                throw ((h.loadingDepKey = n), (h.loadingDepPromise = r.contents), r.contents);
            }
            throw I('Invalid Loadable state');
          }
          try {
            (i = r({
              get: w,
              getCallback: function (n) {
                return function () {
                  if (c)
                    throw I(
                      'Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.'
                    );
                  null == t && Na(!1);
                  for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];
                  return Pi(e, n, o, { node: t });
                };
              },
            })),
              (i = Li(i) ? w(i) : i),
              gi(i) && ('hasError' === i.state && (p = !0), (i = i.contents)),
              M(i)
                ? (i = (function (e, t, n, r, o, a) {
                    return t
                      .then(function (t) {
                        if (!d()) throw (T(e), Ii);
                        var a = bi(t);
                        return v(e, n, o, a, r), t;
                      })
                      .catch(function (t) {
                        if (!d()) throw (T(e), Ii);
                        if (M(t)) return b(e, t, n, r, o, a);
                        var i = wi(t);
                        throw (v(e, n, o, i, r), t);
                      });
                  })(e, i, o, m, a, h).finally(f))
                : f(),
              (i = i instanceof xi ? i.value : i);
          } catch (y) {
            M((i = y)) ? (i = b(e, i, o, m, a, h).finally(f)) : ((p = !0), f());
          }
          return (
            (l = p ? wi(i) : M(i) ? yi(i) : bi(i)),
            (s = !1),
            (function (e, t, n) {
              if (N(e, t)) {
                var r = C(e);
                null != r && (r.depValuesDiscoveredSoFarDuringAsyncWork = n);
              }
            })(e, a, m),
            x(e, o, new Set(m.keys()), a),
            [l, m]
          );
        }
        function S(e, t) {
          var r = t.atomValues.get(n);
          if (null != r) return r;
          var o,
            a = new Set();
          try {
            r = l.get(
              function (n) {
                return 'string' !== typeof n && Na(!1), ki(e, t, n).contents;
              },
              {
                onNodeVisit: function (e) {
                  'branch' === e.type && e.nodeKey !== n && a.add(e.nodeKey);
                },
              }
            );
          } catch (i) {
            throw I('Problem with cache lookup for selector "'.concat(n, '": ').concat(i.message));
          }
          r && (t.atomValues.set(n, r), x(e, t, a, null === (o = C(e)) || void 0 === o ? void 0 : o.executionID));
          return r;
        }
        function _(e, t) {
          var n = S(e, t);
          if (null != n) return T(e), n;
          var r,
            o = E(e, t);
          if (null != o)
            return (
              'loading' === (null === (r = o.loadingLoadable) || void 0 === r ? void 0 : r.state) &&
                w(e, o.executionID),
              o.loadingLoadable
            );
          var a = Vi(),
            i = c(k(e, t, a), 2),
            l = i[0],
            u = i[1];
          return (
            'loading' === l.state
              ? (!(function (e, t, n, r, o) {
                  s.set(e, {
                    depValuesDiscoveredSoFarDuringAsyncWork: r,
                    executionID: t,
                    loadingLoadable: n,
                    stateVersions: new Map([[o.version, !0]]),
                  });
                })(e, a, l, u, t),
                w(e, a))
              : (T(e), j(t, l, u)),
            l
          );
        }
        function E(e, t) {
          function n(n) {
            var r,
              o = y(n);
            try {
              for (o.s(); !(r = o.n()).done; ) {
                var a = c(r.value, 2),
                  i = a[0],
                  l = a[1];
                if (!ki(e, t, i).is(l)) return !0;
              }
            } catch (u) {
              o.e(u);
            } finally {
              o.f();
            }
            return !1;
          }
          var r,
            o = y(
              Tn([
                s.has(e) ? [z(s.get(e))] : [],
                Ae(
                  vt(s, function (t) {
                    return c(t, 1)[0] !== e;
                  }),
                  function (e) {
                    return c(e, 2)[1];
                  }
                ),
              ])
            );
          try {
            for (o.s(); !(r = o.n()).done; ) {
              var a = r.value;
              if (a.stateVersions.get(t.version) || !n(a.depValuesDiscoveredSoFarDuringAsyncWork))
                return a.stateVersions.set(t.version, !0), a;
              a.stateVersions.set(t.version, !1);
            }
          } catch (i) {
            o.e(i);
          } finally {
            o.f();
          }
        }
        function C(e) {
          return s.get(e);
        }
        function T(e) {
          s.delete(e);
        }
        function N(e, t) {
          var n;
          return t === (null === (n = C(e)) || void 0 === n ? void 0 : n.executionID);
        }
        function j(e, t, r) {
          e.atomValues.set(n, t);
          try {
            l.set(
              (function (e) {
                return Array.from(e.entries()).map(function (e) {
                  var t = c(e, 2);
                  return [t[0], t[1].contents];
                });
              })(r),
              t
            );
          } catch (o) {
            throw I('Problem with setting cache for selector "'.concat(n, '": ').concat(o.message));
          }
        }
        function L(e, t) {
          var r = t.atomValues.get(n);
          return null != r
            ? r
            : l.get(function (n) {
                var r;
                return (
                  'string' !== typeof n && Na(!1), null === (r = Si(e, t, n)) || void 0 === r ? void 0 : r.contents
                );
              });
        }
        function A(e, t) {
          return (function (e) {
            if (Mi.includes(n)) {
              var t = 'Recoil selector has circular dependencies: '.concat(Mi.slice(Mi.indexOf(n)).join(' \u2192 '));
              return wi(I(t));
            }
            Mi.push(n);
            try {
              return e();
            } finally {
              Mi.pop();
            }
          })(function () {
            return _(e, t);
          });
        }
        function R(e) {
          e.atomValues.delete(n);
        }
        function P(e, n) {
          null == t && Na(!1);
          var r,
            o = y(i);
          try {
            for (o.s(); !(r = o.n()).done; ) {
              var a,
                u = r.value,
                s = Ni(u);
              null === (a = s.clearCache) || void 0 === a || a.call(s, e, n);
            }
          } catch (c) {
            o.e(c);
          } finally {
            o.f();
          }
          i.clear(), R(n), l.clear(), Ai(e, t);
        }
        if (null != a) {
          return (t = ji({
            key: n,
            nodeType: 'selector',
            peek: L,
            get: A,
            set: function (e, t, r) {
              var o = !1,
                i = new Map();
              function l(r) {
                var a = r.key;
                if (o) throw I('Recoil: Async selector sets are not currently supported.');
                var i = ki(e, t, a);
                if ('hasValue' === i.state) return i.contents;
                if ('loading' === i.state) {
                  var l = 'Getting value of asynchronous atom or selector "'
                    .concat(a, '" in a pending state while setting selector "')
                    .concat(n, '" is not yet supported.');
                  throw (pe(l), I(l));
                }
                throw i.contents;
              }
              function u(n, r) {
                if (o) {
                  var a = 'Recoil: Async selector sets are not currently supported.';
                  throw (pe(a), I(a));
                }
                var u = 'function' === typeof r ? r(l(n)) : r;
                _i(e, t, n.key, u).forEach(function (e, t) {
                  return i.set(t, e);
                });
              }
              var s = a(
                {
                  set: u,
                  get: l,
                  reset: function (e) {
                    u(e, Ci);
                  },
                },
                r
              );
              if (void 0 !== s)
                throw M(s)
                  ? I('Recoil: Async selector sets are not currently supported.')
                  : I('Recoil: selector set should be a void function.');
              return (o = !0), i;
            },
            init: p,
            invalidate: R,
            clearCache: P,
            shouldDeleteConfigOnRelease: h,
            dangerouslyAllowMutability: e.dangerouslyAllowMutability,
            shouldRestoreFromSnapshots: !1,
            retainedBy: u,
          }));
        }
        return (t = ji({
          key: n,
          nodeType: 'selector',
          peek: L,
          get: A,
          init: p,
          invalidate: R,
          clearCache: P,
          shouldDeleteConfigOnRelease: h,
          dangerouslyAllowMutability: e.dangerouslyAllowMutability,
          shouldRestoreFromSnapshots: !1,
          retainedBy: u,
        }));
      }
      Bi.value = function (e) {
        return new xi(e);
      };
      var Fi = Bi,
        Ui = ae.isLoadable,
        Hi = ae.loadableWithError,
        qi = ae.loadableWithPromise,
        Wi = ae.loadableWithValue,
        $i = Ja.WrappedValue,
        Gi = Pt,
        Ki = Ve.DEFAULT_VALUE,
        Qi = Ve.DefaultValue,
        Yi = Ve.getConfigDeletionHandler,
        Xi = Ve.registerNode,
        Ji = Ve.setConfigDeletionHandler,
        Zi = je.isRecoilValue,
        el = an.getRecoilValueAsLoadable,
        tl = an.markRecoilValueModified,
        nl = an.setRecoilValue,
        rl = an.setRecoilValueLoadable,
        ol = xn,
        al = function (e) {
          return e instanceof $i ? e.value : e;
        };
      function il(e) {
        var t = e.key,
          n = e.persistence_UNSTABLE,
          r = ol(e.retainedBy_UNSTABLE),
          o = 0;
        function a(e) {
          return qi(
            e
              .then(function (e) {
                return (i = Wi(e)), e;
              })
              .catch(function (e) {
                throw ((i = Hi(e)), e);
              })
          );
        }
        var i = M(e.default)
          ? a(e.default)
          : Ui(e.default)
          ? 'loading' === e.default.state
            ? a(e.default.contents)
            : e.default
          : Wi(al(e.default));
        s(i.contents);
        var l = void 0,
          u = new Map();
        function s(e) {
          return e;
        }
        function c(e, n) {
          var r, o;
          return null !== (r = null !== (o = n.atomValues.get(t)) && void 0 !== o ? o : l) && void 0 !== r ? r : i;
        }
        var d = Xi({
          key: t,
          nodeType: 'atom',
          peek: c,
          get: function (e, r) {
            if (r.atomValues.has(t)) return z(r.atomValues.get(t));
            if (r.nonvalidatedAtoms.has(t)) {
              if (null != l) return l;
              if (null == n)
                return (
                  Le('Tried to restore a persisted value for atom '.concat(t, ' but it has no persistence settings.')),
                  i
                );
              var o = r.nonvalidatedAtoms.get(t),
                a = n.validator(o, Ki),
                u = a instanceof Qi ? i : Wi(a);
              return (l = u);
            }
            return i;
          },
          set: function (e, n, r) {
            if (n.atomValues.has(t)) {
              var o = z(n.atomValues.get(t));
              if ('hasValue' === o.state && r === o.contents) return new Map();
            } else if (!n.nonvalidatedAtoms.has(t) && r instanceof Qi) return new Map();
            return (l = void 0), new Map().set(t, Wi(r));
          },
          init: function (n, r, a) {
            var l;
            if ((o++, n.getState().knownAtoms.add(t), 'loading' === i.state)) {
              i.contents.finally(function () {
                var e;
                (null !== (e = n.getState().nextTree) && void 0 !== e ? e : n.getState().currentTree).atomValues.has(
                  t
                ) || tl(n, d);
              });
            }
            var s = null !== (l = e.effects) && void 0 !== l ? l : e.effects_UNSTABLE;
            if (null != s) {
              var p,
                h = function (e) {
                  if (w && e.key === t) {
                    var o = g;
                    return o instanceof Qi
                      ? c(n, r)
                      : M(o)
                      ? qi(
                          o.then(function (e) {
                            return e instanceof Qi ? i.toPromise() : e;
                          })
                        )
                      : Wi(o);
                  }
                  return el(n, e);
                },
                v = function (e) {
                  return h(e).toPromise();
                },
                m = function (e) {
                  var r,
                    o = Gi(
                      n,
                      null !== (r = n.getState().nextTree) && void 0 !== r ? r : n.getState().currentTree,
                      e.key
                    );
                  return !w || e.key !== t || g instanceof Qi ? o : S(S({}, o), {}, { isSet: !0, loadable: h(e) });
                },
                g = Ki,
                w = !0,
                b = !1,
                x = null,
                k = function (e) {
                  return function (t) {
                    if (w) {
                      var r = h(d),
                        o = 'hasValue' === r.state ? r.contents : Ki;
                      (g = 'function' === typeof t ? t(o) : t),
                        M(g) &&
                          (g = g.then(function (t) {
                            return (x = { effect: e, value: t }), t;
                          }));
                    } else {
                      if (M(t)) throw I('Setting atoms to async values is not implemented.');
                      'function' !== typeof t && (x = { effect: e, value: al(t) }),
                        nl(
                          n,
                          d,
                          'function' === typeof t
                            ? function (n) {
                                var r = al(t(n));
                                return (x = { effect: e, value: r }), r;
                              }
                            : al(t)
                        );
                    }
                  };
                },
                _ = function (e) {
                  return function () {
                    return k(e)(Ki);
                  };
                },
                E = function (e) {
                  return function (r) {
                    var o,
                      a = n.subscribeToTransactions(function (n) {
                        var o,
                          a = n.getState(),
                          l = a.currentTree,
                          u = a.previousTree;
                        u ||
                          (pe(
                            'Transaction subscribers notified without a next tree being present -- this is a bug in Recoil'
                          ),
                          (u = l));
                        var s = null !== (o = l.atomValues.get(t)) && void 0 !== o ? o : i;
                        if ('hasValue' === s.state) {
                          var c,
                            f,
                            d,
                            p,
                            h = s.contents,
                            v = null !== (c = u.atomValues.get(t)) && void 0 !== c ? c : i,
                            m = 'hasValue' === v.state ? v.contents : Ki;
                          (null === (f = x) || void 0 === f ? void 0 : f.effect) !== e ||
                          (null === (d = x) || void 0 === d ? void 0 : d.value) !== h
                            ? r(h, m, !l.atomValues.has(t))
                            : (null === (p = x) || void 0 === p ? void 0 : p.effect) === e && (x = null);
                        }
                      }, t).release;
                    u.set(n, [].concat(f(null !== (o = u.get(n)) && void 0 !== o ? o : []), [a]));
                  };
                },
                C = y(s);
              try {
                for (C.s(); !(p = C.n()).done; ) {
                  var T = p.value;
                  try {
                    var N,
                      j = T({
                        node: d,
                        storeID: n.storeID,
                        parentStoreID_UNSTABLE: n.parentStoreID,
                        trigger: a,
                        setSelf: k(T),
                        resetSelf: _(T),
                        onSet: E(T),
                        getPromise: v,
                        getLoadable: h,
                        getInfo_UNSTABLE: m,
                      });
                    if (null != j) u.set(n, [].concat(f(null !== (N = u.get(n)) && void 0 !== N ? N : []), [j]));
                  } catch (R) {
                    (g = R), (b = !0);
                  }
                }
              } catch (P) {
                C.e(P);
              } finally {
                C.f();
              }
              if (((w = !1), !(g instanceof Qi))) {
                var L,
                  A = b
                    ? Hi(g)
                    : M(g)
                    ? qi(
                        (function (e, n) {
                          var r = n
                            .then(function (n) {
                              var o, a;
                              return (
                                (null ===
                                  (a = (
                                    null !== (o = e.getState().nextTree) && void 0 !== o ? o : e.getState().currentTree
                                  ).atomValues.get(t)) || void 0 === a
                                  ? void 0
                                  : a.contents) === r && nl(e, d, n),
                                n
                              );
                            })
                            .catch(function (n) {
                              var o, a;
                              throw (
                                ((null ===
                                  (a = (
                                    null !== (o = e.getState().nextTree) && void 0 !== o ? o : e.getState().currentTree
                                  ).atomValues.get(t)) || void 0 === a
                                  ? void 0
                                  : a.contents) === r && rl(e, d, Hi(n)),
                                n)
                              );
                            });
                          return r;
                        })(n, g)
                      )
                    : Wi(al(g));
                A.contents,
                  r.atomValues.set(t, A),
                  null === (L = n.getState().nextTree) || void 0 === L || L.atomValues.set(t, A);
              }
            }
            return function () {
              var e;
              o--,
                null === (e = u.get(n)) ||
                  void 0 === e ||
                  e.forEach(function (e) {
                    return e();
                  }),
                u.delete(n);
            };
          },
          invalidate: function () {
            l = void 0;
          },
          shouldDeleteConfigOnRelease: function () {
            return void 0 !== Yi(t) && o <= 0;
          },
          dangerouslyAllowMutability: e.dangerouslyAllowMutability,
          persistence_UNSTABLE: e.persistence_UNSTABLE
            ? { type: e.persistence_UNSTABLE.type, backButton: e.persistence_UNSTABLE.backButton }
            : void 0,
          shouldRestoreFromSnapshots: !0,
          retainedBy: r,
        });
        return d;
      }
      function ll(e) {
        var t = Object.assign(
            {},
            ((function (e) {
              if (null == e) throw new TypeError('Cannot destructure ' + e);
            })(e),
            e)
          ),
          n = 'default' in e ? e.default : new Promise(function () {});
        return Zi(n)
          ? (function (e) {
              var t = ll(
                  S(
                    S({}, e),
                    {},
                    {
                      default: Ki,
                      persistence_UNSTABLE:
                        void 0 === e.persistence_UNSTABLE
                          ? void 0
                          : S(
                              S({}, e.persistence_UNSTABLE),
                              {},
                              {
                                validator: function (t) {
                                  return t instanceof Qi ? t : z(e.persistence_UNSTABLE).validator(t, Ki);
                                },
                              }
                            ),
                      effects: e.effects,
                      effects_UNSTABLE: e.effects_UNSTABLE,
                    }
                  )
                ),
                n = Fi({
                  key: ''.concat(e.key, '__withFallback'),
                  get: function (n) {
                    var r = (0, n.get)(t);
                    return r instanceof Qi ? e.default : r;
                  },
                  set: function (e, n) {
                    return (0, e.set)(t, n);
                  },
                  cachePolicy_UNSTABLE: { eviction: 'most-recent' },
                  dangerouslyAllowMutability: e.dangerouslyAllowMutability,
                });
              return Ji(n.key, Yi(e.key)), n;
            })(S(S({}, t), {}, { default: n }))
          : il(S(S({}, t), {}, { default: n }));
      }
      ll.value = function (e) {
        return new $i(e);
      };
      var ul = ll,
        sl = {
          MapCache: (function () {
            function e(t) {
              var n;
              N(this, e),
                V(this, '_map', void 0),
                V(this, '_keyMapper', void 0),
                (this._map = new Map()),
                (this._keyMapper =
                  null !== (n = null === t || void 0 === t ? void 0 : t.mapKey) && void 0 !== n
                    ? n
                    : function (e) {
                        return e;
                      });
            }
            return (
              L(e, [
                {
                  key: 'size',
                  value: function () {
                    return this._map.size;
                  },
                },
                {
                  key: 'has',
                  value: function (e) {
                    return this._map.has(this._keyMapper(e));
                  },
                },
                {
                  key: 'get',
                  value: function (e) {
                    return this._map.get(this._keyMapper(e));
                  },
                },
                {
                  key: 'set',
                  value: function (e, t) {
                    this._map.set(this._keyMapper(e), t);
                  },
                },
                {
                  key: 'delete',
                  value: function (e) {
                    this._map.delete(this._keyMapper(e));
                  },
                },
                {
                  key: 'clear',
                  value: function () {
                    this._map.clear();
                  },
                },
              ]),
              e
            );
          })(),
        }.MapCache,
        cl = Object.freeze({ __proto__: null, MapCache: sl }),
        fl = ai.LRUCache,
        dl = cl.MapCache,
        pl = { equality: 'reference', eviction: 'none', maxSize: 1 / 0 };
      function hl(e) {
        switch (e) {
          case 'reference':
            return function (e) {
              return e;
            };
          case 'value':
            return function (e) {
              return ci(e);
            };
        }
        throw I('Unrecognized equality policy '.concat(e));
      }
      function vl(e, t, n) {
        switch (e) {
          case 'keep-all':
            return new dl({ mapKey: n });
          case 'lru':
            return new fl({ mapKey: n, maxSize: z(t) });
          case 'most-recent':
            return new fl({ mapKey: n, maxSize: 1 });
        }
        throw I('Unrecognized eviction policy '.concat(e));
      }
      var ml = function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : pl,
            t = e.equality,
            n = void 0 === t ? pl.equality : t,
            r = e.eviction,
            o = void 0 === r ? pl.eviction : r,
            a = e.maxSize,
            i = void 0 === a ? pl.maxSize : a,
            l = hl(n),
            u = vl(o, i, l);
          return u;
        },
        gl = Ve.setConfigDeletionHandler;
      var wl = function (e) {
          var t,
            n,
            r = ml({
              equality:
                null !== (t = null === (n = e.cachePolicyForParams_UNSTABLE) || void 0 === n ? void 0 : n.equality) &&
                void 0 !== t
                  ? t
                  : 'value',
              eviction: 'keep-all',
            });
          return function (t) {
            var n,
              o,
              a = r.get(t);
            if (null != a) return a;
            e.cachePolicyForParams_UNSTABLE;
            var i = p(e, P),
              l = 'default' in e ? e.default : new Promise(function () {}),
              u = ul(
                S(
                  S({}, i),
                  {},
                  {
                    key: ''.concat(e.key, '__').concat(null !== (n = ci(t)) && void 0 !== n ? n : 'void'),
                    default: 'function' === typeof l ? l(t) : l,
                    retainedBy_UNSTABLE:
                      'function' === typeof e.retainedBy_UNSTABLE ? e.retainedBy_UNSTABLE(t) : e.retainedBy_UNSTABLE,
                    effects:
                      'function' === typeof e.effects
                        ? e.effects(t)
                        : 'function' === typeof e.effects_UNSTABLE
                        ? e.effects_UNSTABLE(t)
                        : null !== (o = e.effects) && void 0 !== o
                        ? o
                        : e.effects_UNSTABLE,
                  }
                )
              );
            return (
              r.set(t, u),
              gl(u.key, function () {
                r.delete(t);
              }),
              u
            );
          };
        },
        yl = Ve.setConfigDeletionHandler,
        bl = 0;
      var xl = function (e) {
          var t,
            n,
            r = ml({
              equality:
                null !== (t = null === (n = e.cachePolicyForParams_UNSTABLE) || void 0 === n ? void 0 : n.equality) &&
                void 0 !== t
                  ? t
                  : 'value',
              eviction: 'keep-all',
            });
          return function (t) {
            var n, o;
            try {
              o = r.get(t);
            } catch (f) {
              throw I('Problem with cache lookup for selector '.concat(e.key, ': ').concat(f.message));
            }
            if (null != o) return o;
            var a,
              i = ''
                .concat(e.key, '__selectorFamily/')
                .concat(null !== (n = ci(t, { allowFunctions: !0 })) && void 0 !== n ? n : 'void', '/')
                .concat(bl++),
              l = function (n) {
                return e.get(t)(n);
              },
              u = e.cachePolicy_UNSTABLE,
              s = 'function' === typeof e.retainedBy_UNSTABLE ? e.retainedBy_UNSTABLE(t) : e.retainedBy_UNSTABLE;
            if (null != e.set) {
              var c = e.set;
              a = Fi({
                key: i,
                get: l,
                set: function (e, n) {
                  return c(t)(e, n);
                },
                cachePolicy_UNSTABLE: u,
                dangerouslyAllowMutability: e.dangerouslyAllowMutability,
                retainedBy_UNSTABLE: s,
              });
            } else
              a = Fi({
                key: i,
                get: l,
                cachePolicy_UNSTABLE: u,
                dangerouslyAllowMutability: e.dangerouslyAllowMutability,
                retainedBy_UNSTABLE: s,
              });
            return (
              r.set(t, a),
              yl(a.key, function () {
                r.delete(t);
              }),
              a
            );
          };
        },
        kl = xl({
          key: '__constant',
          get: function (e) {
            return function () {
              return e;
            };
          },
          cachePolicyForParams_UNSTABLE: { equality: 'reference' },
        });
      var Sl = function (e) {
          return kl(e);
        },
        _l = xl({
          key: '__error',
          get: function (e) {
            return function () {
              throw I(e);
            };
          },
          cachePolicyForParams_UNSTABLE: { equality: 'reference' },
        });
      var El = function (e) {
        return _l(e);
      };
      var Cl = function (e) {
          return e;
        },
        Tl = ae.loadableWithError,
        Nl = ae.loadableWithPromise,
        jl = ae.loadableWithValue;
      function Ll(e, t) {
        var n,
          r = Array(t.length).fill(void 0),
          o = Array(t.length).fill(void 0),
          a = y(t.entries());
        try {
          for (a.s(); !(n = a.n()).done; ) {
            var i = c(n.value, 2),
              l = i[0],
              u = i[1];
            try {
              r[l] = e(u);
            } catch (s) {
              o[l] = s;
            }
          }
        } catch (f) {
          a.e(f);
        } finally {
          a.f();
        }
        return [r, o];
      }
      function Al(e) {
        return null != e && !M(e);
      }
      function Rl(e) {
        return Array.isArray(e)
          ? e
          : Object.getOwnPropertyNames(e).map(function (t) {
              return e[t];
            });
      }
      function Pl(e, t) {
        return Array.isArray(e)
          ? t
          : Object.getOwnPropertyNames(e).reduce(function (e, n, r) {
              return S(S({}, e), {}, x({}, n, t[r]));
            }, {});
      }
      function Ol(e, t, n) {
        return Pl(
          e,
          n.map(function (e, n) {
            return null == e ? jl(t[n]) : M(e) ? Nl(e) : Tl(e);
          })
        );
      }
      var Dl = xl({
          key: '__waitForNone',
          get: function (e) {
            return function (t) {
              var n = c(Ll(t.get, Rl(e)), 2),
                r = n[0],
                o = n[1];
              return Ol(e, r, o);
            };
          },
          dangerouslyAllowMutability: !0,
        }),
        Il = xl({
          key: '__waitForAny',
          get: function (e) {
            return function (t) {
              var n = c(Ll(t.get, Rl(e)), 2),
                r = n[0],
                o = n[1];
              return o.some(function (e) {
                return !M(e);
              })
                ? Ol(e, r, o)
                : new Promise(function (t) {
                    var n,
                      a = y(o.entries());
                    try {
                      var i = function () {
                        var a = c(n.value, 2),
                          i = a[0],
                          l = a[1];
                        M(l) &&
                          l
                            .then(function (n) {
                              (r[i] = n), (o[i] = void 0), t(Ol(e, r, o));
                            })
                            .catch(function (n) {
                              (o[i] = n), t(Ol(e, r, o));
                            });
                      };
                      for (a.s(); !(n = a.n()).done; ) i();
                    } catch (l) {
                      a.e(l);
                    } finally {
                      a.f();
                    }
                  });
            };
          },
          dangerouslyAllowMutability: !0,
        }),
        Ml = {
          waitForNone: Dl,
          waitForAny: Il,
          waitForAll: xl({
            key: '__waitForAll',
            get: function (e) {
              return function (t) {
                var n = c(Ll(t.get, Rl(e)), 2),
                  r = n[0],
                  o = n[1];
                if (
                  o.every(function (e) {
                    return null == e;
                  })
                )
                  return Pl(e, r);
                var a = o.find(Al);
                if (null != a) throw a;
                return Promise.all(o).then(function (t) {
                  return Pl(
                    e,
                    ((n = r),
                    t.map(function (e, t) {
                      return void 0 === e ? n[t] : e;
                    }))
                  );
                  var n;
                });
              };
            },
            dangerouslyAllowMutability: !0,
          }),
          waitForAllSettled: xl({
            key: '__waitForAllSettled',
            get: function (e) {
              return function (t) {
                var n = c(Ll(t.get, Rl(e)), 2),
                  r = n[0],
                  o = n[1];
                return o.every(function (e) {
                  return !M(e);
                })
                  ? Ol(e, r, o)
                  : Promise.all(
                      o.map(function (e, t) {
                        return M(e)
                          ? e
                              .then(function (e) {
                                (r[t] = e), (o[t] = void 0);
                              })
                              .catch(function (e) {
                                (r[t] = void 0), (o[t] = e);
                              })
                          : null;
                      })
                    ).then(function () {
                      return Ol(e, r, o);
                    });
              };
            },
            dangerouslyAllowMutability: !0,
          }),
          noWait: xl({
            key: '__noWait',
            get: function (e) {
              return function (t) {
                var n = t.get;
                try {
                  return Fi.value(jl(n(e)));
                } catch (r) {
                  return Fi.value(M(r) ? Nl(r) : Tl(r));
                }
              };
            },
            dangerouslyAllowMutability: !0,
          }),
        },
        zl = ae.RecoilLoadable,
        Vl = Ve.DefaultValue,
        Bl = qr,
        Fl = Gr,
        Ul = je.isRecoilValue,
        Hl = dt.retentionZone,
        ql = lr.freshSnapshot,
        Wl = {
          DefaultValue: Vl,
          isRecoilValue: Ul,
          RecoilLoadable: zl,
          RecoilEnv: be,
          RecoilRoot: Bl,
          useRecoilStoreID: Fl,
          useRecoilBridgeAcrossReactRoots_UNSTABLE: ha,
          atom: ul,
          selector: Fi,
          atomFamily: wl,
          selectorFamily: xl,
          constSelector: Sl,
          errorSelector: El,
          readOnlySelector: Cl,
          noWait: Ml.noWait,
          waitForNone: Ml.waitForNone,
          waitForAny: Ml.waitForAny,
          waitForAll: Ml.waitForAll,
          waitForAllSettled: Ml.waitForAllSettled,
          useRecoilValue: Do,
          useRecoilValueLoadable: Io,
          useRecoilState: Po,
          useRecoilStateLoadable: Oo,
          useSetRecoilState: zo,
          useResetRecoilState: Mo,
          useGetRecoilValueInfo_UNSTABLE: sa,
          useRecoilRefresher_UNSTABLE: $a,
          useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: Vo,
          useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: Bo,
          useRecoilState_TRANSITION_SUPPORT_UNSTABLE: Fo,
          useRecoilCallback: Ua,
          useRecoilTransaction_UNSTABLE: Ya,
          useGotoRecoilSnapshot: aa,
          useRecoilSnapshot: ra,
          useRecoilTransactionObserver_UNSTABLE: ia,
          snapshot_UNSTABLE: ql,
          useRetain: ao,
          retentionZone: Hl,
        },
        $l = Wl.RecoilRoot,
        Gl = Wl.atom,
        Kl = Wl.useRecoilValue,
        Ql = Wl.useRecoilState,
        Yl = Wl.useSetRecoilState,
        Xl = Wl.useResetRecoilState,
        Jl = function (e) {
          return function (t) {
            var n = t.setSelf,
              r = t.onSet,
              o = localStorage.getItem(e);
            null != o && n(JSON.parse(o)),
              r(function (t) {
                localStorage.setItem(e, JSON.stringify(t));
              });
          };
        },
        Zl = 'holiday_',
        eu = Gl({ key: 'page', default: {}, effects_UNSTABLE: [Jl(''.concat(Zl, 'page'))] }),
        tu = Gl({
          key: 'shopifyCollections',
          default: [],
          effects_UNSTABLE: [Jl(''.concat(Zl, 'shopifyCollections'))],
        }),
        nu = Gl({ key: 'upsells', default: [], effects_UNSTABLE: [Jl(''.concat(Zl, 'upsells'))] }),
        ru = Gl({ key: 'swatches', default: [], effects_UNSTABLE: [Jl(''.concat(Zl, 'swatches'))] }),
        ou = Gl({ key: 'sizeCharts', default: [], effects_UNSTABLE: [Jl(''.concat(Zl, 'sizeCharts'))] }),
        au = (function () {
          var e = l(
            a().mark(function e(t, n) {
              var r;
              return a().wrap(
                function (e) {
                  for (;;)
                    switch ((e.prev = e.next)) {
                      case 0:
                        if (t.length) {
                          e.next = 2;
                          break;
                        }
                        return e.abrupt('return');
                      case 2:
                        return (
                          (r = []),
                          (e.prev = 3),
                          t.forEach(function (e) {
                            var t = n.find(function (t) {
                                return t.title === e.title;
                              }),
                              o = t.sizeChart,
                              a = t.multipleProductTypes,
                              i = t.productTypeLayout,
                              l = t.sizeList,
                              u = void 0,
                              s = void 0;
                            i &&
                              ((u = []),
                              i.split('||').forEach(function (e) {
                                var t = e.split('::'),
                                  n = { header: t[0], types: [] };
                                t[1] &&
                                  t[1].split(',').forEach(function (e) {
                                    return n.types.push(e);
                                  }),
                                  u.push(n);
                              })),
                              l && (s = l.split(',')),
                              r.push({
                                title: e.title,
                                upsellTitle: e.ageGroupTitle,
                                sizeChart: o,
                                multipleProductTypes: a,
                                productTypeLayout: u,
                                sizeList: s,
                              });
                          }),
                          (e.next = 7),
                          Promise.all(
                            t.map(
                              (function () {
                                var e = l(
                                  a().mark(function e(t) {
                                    var n, o, i;
                                    return a().wrap(function (e) {
                                      for (;;)
                                        switch ((e.prev = e.next)) {
                                          case 0:
                                            return (
                                              (n = ''
                                                .concat(window.location.origin, '/collections/')
                                                .concat(t.handle, '/products.json?limit=250')),
                                              (e.next = 3),
                                              fetch(n)
                                            );
                                          case 3:
                                            return (o = e.sent), (e.next = 6), o.json();
                                          case 6:
                                            (i = e.sent),
                                              (r.find(function (e) {
                                                return e.title === t.title;
                                              }).products = i.products);
                                          case 9:
                                          case 'end':
                                            return e.stop();
                                        }
                                    }, e);
                                  })
                                );
                                return function (t) {
                                  return e.apply(this, arguments);
                                };
                              })()
                            )
                          )
                        );
                      case 7:
                        e.next = 12;
                        break;
                      case 9:
                        (e.prev = 9), (e.t0 = e.catch(3)), console.warn(e.t0);
                      case 12:
                        return e.abrupt('return', r);
                      case 13:
                      case 'end':
                        return e.stop();
                    }
                },
                e,
                null,
                [[3, 9]]
              );
            })
          );
          return function (t, n) {
            return e.apply(this, arguments);
          };
        })(),
        iu = au,
        lu = (function () {
          var e = l(
            a().mark(function e(t) {
              var n, r, o, i;
              return a().wrap(function (e) {
                for (;;)
                  switch ((e.prev = e.next)) {
                    case 0:
                      return (
                        (n = []),
                        (r = t
                          .map(function (e) {
                            return e.products;
                          })
                          .flat()),
                        (o = r
                          .map(function (e) {
                            return e.tags.find(function (e) {
                              return e.includes('type_tag');
                            });
                          })
                          .filter(function (e) {
                            return !!e;
                          })),
                        (i = f(new Set(o))),
                        (e.next = 6),
                        Promise.all(
                          i.map(
                            (function () {
                              var e = l(
                                a().mark(function e(t) {
                                  var r, o, i, l;
                                  return a().wrap(function (e) {
                                    for (;;)
                                      switch ((e.prev = e.next)) {
                                        case 0:
                                          return (
                                            (r = t
                                              .split(':')[1]
                                              .replaceAll('/', '-')
                                              .replaceAll(' ', '-')
                                              .replaceAll("'", '')
                                              .toLowerCase()),
                                            (o = ''
                                              .concat(window.location.origin, '/collections/')
                                              .concat(r, '?view=json-data')),
                                            (e.next = 4),
                                            fetch(o)
                                          );
                                        case 4:
                                          return (i = e.sent), (e.next = 7), i.json();
                                        case 7:
                                          (l = e.sent), n.push({ tag: t, sizeChart: l.metafields.sizeChart });
                                        case 9:
                                        case 'end':
                                          return e.stop();
                                      }
                                  }, e);
                                })
                              );
                              return function (t) {
                                return e.apply(this, arguments);
                              };
                            })()
                          )
                        )
                      );
                    case 6:
                      return e.abrupt('return', n);
                    case 7:
                    case 'end':
                      return e.stop();
                  }
              }, e);
            })
          );
          return function (t) {
            return e.apply(this, arguments);
          };
        })(),
        uu = lu;
      function su() {
        return (
          (su = l(
            a().mark(function e(t) {
              var n;
              return a().wrap(
                function (e) {
                  for (;;)
                    switch ((e.prev = e.next)) {
                      case 0:
                        if (t.length) {
                          e.next = 2;
                          break;
                        }
                        return e.abrupt('return', []);
                      case 2:
                        return (
                          (e.prev = 2),
                          (e.next = 5),
                          Promise.all(
                            t.map(
                              (function () {
                                var e = l(
                                  a().mark(function e(t) {
                                    var n, r, o, i, l, u, s;
                                    return a().wrap(function (e) {
                                      for (;;)
                                        switch ((e.prev = e.next)) {
                                          case 0:
                                            return (
                                              (n = t.handle),
                                              (r = t.title),
                                              (o = t.ageGroup),
                                              (i = t.ageGroupOnly),
                                              (l = ''
                                                .concat(window.location.origin, '/collections/')
                                                .concat(n, '/products.json')),
                                              (e.next = 4),
                                              fetch(l)
                                            );
                                          case 4:
                                            return (u = e.sent), (e.next = 7), u.json();
                                          case 7:
                                            return (
                                              (s = e.sent),
                                              e.abrupt('return', {
                                                title: r,
                                                products: s.products,
                                                ageGroup: o,
                                                ageGroupOnly: i,
                                              })
                                            );
                                          case 9:
                                          case 'end':
                                            return e.stop();
                                        }
                                    }, e);
                                  })
                                );
                                return function (t) {
                                  return e.apply(this, arguments);
                                };
                              })()
                            )
                          )
                        );
                      case 5:
                        return (n = e.sent), e.abrupt('return', n);
                      case 9:
                        (e.prev = 9), (e.t0 = e.catch(2)), console.warn(e.t0);
                      case 12:
                      case 'end':
                        return e.stop();
                    }
                },
                e,
                null,
                [[2, 9]]
              );
            })
          )),
          su.apply(this, arguments)
        );
      }
      var cu,
        fu = function (e) {
          return su.apply(this, arguments);
        },
        du = (function () {
          var e = l(
            a().mark(function e(t) {
              var n, r, o;
              return a().wrap(
                function (e) {
                  for (;;)
                    switch ((e.prev = e.next)) {
                      case 0:
                        return (
                          (n = t.map(function (e) {
                            return e.tags.find(function (e) {
                              return e.includes('print_tag:');
                            });
                          })),
                          (r = f(new Set(n))),
                          (o = []),
                          (e.prev = 3),
                          (e.next = 6),
                          Promise.all(
                            r.map(
                              (function () {
                                var e = l(
                                  a().mark(function e(t) {
                                    var n, r, i, l;
                                    return a().wrap(function (e) {
                                      for (;;)
                                        switch ((e.prev = e.next)) {
                                          case 0:
                                            if (t) {
                                              e.next = 2;
                                              break;
                                            }
                                            return e.abrupt('return');
                                          case 2:
                                            return (
                                              (n = t.split(':')[1].replaceAll(' & ', '-').replaceAll(' ', '-')),
                                              (r = ''
                                                .concat(window.location.origin, '/collections/')
                                                .concat(n, '?view=json-data')),
                                              (e.next = 6),
                                              fetch(r)
                                            );
                                          case 6:
                                            return (i = e.sent), (e.next = 9), i.json();
                                          case 9:
                                            (l = e.sent), o.push({ printTag: t, swatch: l.metafields.swatch });
                                          case 11:
                                          case 'end':
                                            return e.stop();
                                        }
                                    }, e);
                                  })
                                );
                                return function (t) {
                                  return e.apply(this, arguments);
                                };
                              })()
                            )
                          )
                        );
                      case 6:
                        e.next = 11;
                        break;
                      case 8:
                        (e.prev = 8), (e.t0 = e.catch(3)), console.log(e.t0);
                      case 11:
                        return e.abrupt('return', o);
                      case 12:
                      case 'end':
                        return e.stop();
                    }
                },
                e,
                null,
                [[3, 8]]
              );
            })
          );
          return function (t) {
            return e.apply(this, arguments);
          };
        })(),
        pu = du;
      function hu() {
        return (
          (hu = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          hu.apply(this, arguments)
        );
      }
      !(function (e) {
        (e.Pop = 'POP'), (e.Push = 'PUSH'), (e.Replace = 'REPLACE');
      })(cu || (cu = {}));
      var vu,
        mu = 'popstate';
      function gu(e, t) {
        if (!e) {
          'undefined' !== typeof console && console.warn(t);
          try {
            throw new Error(t);
          } catch (n) {}
        }
      }
      function wu(e) {
        return { usr: e.state, key: e.key };
      }
      function yu(e, t, n, r) {
        return (
          void 0 === n && (n = null),
          hu(
            { pathname: 'string' === typeof e ? e : e.pathname, search: '', hash: '' },
            'string' === typeof t ? xu(t) : t,
            { state: n, key: (t && t.key) || r || Math.random().toString(36).substr(2, 8) }
          )
        );
      }
      function bu(e) {
        var t = e.pathname,
          n = void 0 === t ? '/' : t,
          r = e.search,
          o = void 0 === r ? '' : r,
          a = e.hash,
          i = void 0 === a ? '' : a;
        return (
          o && '?' !== o && (n += '?' === o.charAt(0) ? o : '?' + o),
          i && '#' !== i && (n += '#' === i.charAt(0) ? i : '#' + i),
          n
        );
      }
      function xu(e) {
        var t = {};
        if (e) {
          var n = e.indexOf('#');
          n >= 0 && ((t.hash = e.substr(n)), (e = e.substr(0, n)));
          var r = e.indexOf('?');
          r >= 0 && ((t.search = e.substr(r)), (e = e.substr(0, r))), e && (t.pathname = e);
        }
        return t;
      }
      function ku(e) {
        var t =
            'undefined' !== typeof window && 'undefined' !== typeof window.location && 'null' !== window.location.origin
              ? window.location.origin
              : 'unknown://unknown',
          n = 'string' === typeof e ? e : bu(e);
        return new URL(n, t);
      }
      function Su(e, t, n, r) {
        void 0 === r && (r = {});
        var o = r,
          a = o.window,
          i = void 0 === a ? document.defaultView : a,
          l = o.v5Compat,
          u = void 0 !== l && l,
          s = i.history,
          c = cu.Pop,
          f = null;
        function d() {
          (c = cu.Pop), f && f({ action: c, location: p.location });
        }
        var p = {
          get action() {
            return c;
          },
          get location() {
            return e(i, s);
          },
          listen: function (e) {
            if (f) throw new Error('A history only accepts one active listener');
            return (
              i.addEventListener(mu, d),
              (f = e),
              function () {
                i.removeEventListener(mu, d), (f = null);
              }
            );
          },
          createHref: function (e) {
            return t(i, e);
          },
          encodeLocation: function (e) {
            var t = ku('string' === typeof e ? e : bu(e));
            return { pathname: t.pathname, search: t.search, hash: t.hash };
          },
          push: function (e, t) {
            c = cu.Push;
            var r = yu(p.location, e, t);
            n && n(r, e);
            var o = wu(r),
              a = p.createHref(r);
            try {
              s.pushState(o, '', a);
            } catch (l) {
              i.location.assign(a);
            }
            u && f && f({ action: c, location: p.location });
          },
          replace: function (e, t) {
            c = cu.Replace;
            var r = yu(p.location, e, t);
            n && n(r, e);
            var o = wu(r),
              a = p.createHref(r);
            s.replaceState(o, '', a), u && f && f({ action: c, location: p.location });
          },
          go: function (e) {
            return s.go(e);
          },
        };
        return p;
      }
      function _u(e, t, n) {
        void 0 === n && (n = '/');
        var r = Ru(('string' === typeof t ? xu(t) : t).pathname || '/', n);
        if (null == r) return null;
        var o = Eu(e);
        !(function (e) {
          e.sort(function (e, t) {
            return e.score !== t.score
              ? t.score - e.score
              : (function (e, t) {
                  var n =
                    e.length === t.length &&
                    e.slice(0, -1).every(function (e, n) {
                      return e === t[n];
                    });
                  return n ? e[e.length - 1] - t[t.length - 1] : 0;
                })(
                  e.routesMeta.map(function (e) {
                    return e.childrenIndex;
                  }),
                  t.routesMeta.map(function (e) {
                    return e.childrenIndex;
                  })
                );
          });
        })(o);
        for (var a = null, i = 0; null == a && i < o.length; ++i) a = ju(o[i], Au(r));
        return a;
      }
      function Eu(e, t, n, r) {
        return (
          void 0 === t && (t = []),
          void 0 === n && (n = []),
          void 0 === r && (r = ''),
          e.forEach(function (e, o) {
            var a = { relativePath: e.path || '', caseSensitive: !0 === e.caseSensitive, childrenIndex: o, route: e };
            a.relativePath.startsWith('/') &&
              (Pu(
                a.relativePath.startsWith(r),
                'Absolute route path "' +
                  a.relativePath +
                  '" nested under path "' +
                  r +
                  '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'
              ),
              (a.relativePath = a.relativePath.slice(r.length)));
            var i = zu([r, a.relativePath]),
              l = n.concat(a);
            e.children &&
              e.children.length > 0 &&
              (Pu(
                !0 !== e.index,
                'Index routes must not have child routes. Please remove all child routes from route path "' + i + '".'
              ),
              Eu(e.children, t, l, i)),
              (null != e.path || e.index) && t.push({ path: i, score: Nu(i, e.index), routesMeta: l });
          }),
          t
        );
      }
      !(function (e) {
        (e.data = 'data'), (e.deferred = 'deferred'), (e.redirect = 'redirect'), (e.error = 'error');
      })(vu || (vu = {}));
      var Cu = /^:\w+$/,
        Tu = function (e) {
          return '*' === e;
        };
      function Nu(e, t) {
        var n = e.split('/'),
          r = n.length;
        return (
          n.some(Tu) && (r += -2),
          t && (r += 2),
          n
            .filter(function (e) {
              return !Tu(e);
            })
            .reduce(function (e, t) {
              return e + (Cu.test(t) ? 3 : '' === t ? 1 : 10);
            }, r)
        );
      }
      function ju(e, t) {
        for (var n = e.routesMeta, r = {}, o = '/', a = [], i = 0; i < n.length; ++i) {
          var l = n[i],
            u = i === n.length - 1,
            s = '/' === o ? t : t.slice(o.length) || '/',
            c = Lu({ path: l.relativePath, caseSensitive: l.caseSensitive, end: u }, s);
          if (!c) return null;
          Object.assign(r, c.params);
          var f = l.route;
          a.push({ params: r, pathname: zu([o, c.pathname]), pathnameBase: Vu(zu([o, c.pathnameBase])), route: f }),
            '/' !== c.pathnameBase && (o = zu([o, c.pathnameBase]));
        }
        return a;
      }
      function Lu(e, t) {
        'string' === typeof e && (e = { path: e, caseSensitive: !1, end: !0 });
        var n = (function (e, t, n) {
            void 0 === t && (t = !1);
            void 0 === n && (n = !0);
            Ou(
              '*' === e || !e.endsWith('*') || e.endsWith('/*'),
              'Route path "' +
                e +
                '" will be treated as if it were "' +
                e.replace(/\*$/, '/*') +
                '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "' +
                e.replace(/\*$/, '/*') +
                '".'
            );
            var r = [],
              o =
                '^' +
                e
                  .replace(/\/*\*?$/, '')
                  .replace(/^\/*/, '/')
                  .replace(/[\\.*+^$?{}|()[\]]/g, '\\$&')
                  .replace(/:(\w+)/g, function (e, t) {
                    return r.push(t), '([^\\/]+)';
                  });
            e.endsWith('*')
              ? (r.push('*'), (o += '*' === e || '/*' === e ? '(.*)$' : '(?:\\/(.+)|\\/*)$'))
              : n
              ? (o += '\\/*$')
              : '' !== e && '/' !== e && (o += '(?:(?=\\/|$))');
            var a = new RegExp(o, t ? void 0 : 'i');
            return [a, r];
          })(e.path, e.caseSensitive, e.end),
          r = c(n, 2),
          o = r[0],
          a = r[1],
          i = t.match(o);
        if (!i) return null;
        var l = i[0],
          u = l.replace(/(.)\/+$/, '$1'),
          s = i.slice(1);
        return {
          params: a.reduce(function (e, t, n) {
            if ('*' === t) {
              var r = s[n] || '';
              u = l.slice(0, l.length - r.length).replace(/(.)\/+$/, '$1');
            }
            return (
              (e[t] = (function (e, t) {
                try {
                  return decodeURIComponent(e);
                } catch (n) {
                  return (
                    Ou(
                      !1,
                      'The value for the URL param "' +
                        t +
                        '" will not be decoded because the string "' +
                        e +
                        '" is a malformed URL segment. This is probably due to a bad percent encoding (' +
                        n +
                        ').'
                    ),
                    e
                  );
                }
              })(s[n] || '', t)),
              e
            );
          }, {}),
          pathname: l,
          pathnameBase: u,
          pattern: e,
        };
      }
      function Au(e) {
        try {
          return decodeURI(e);
        } catch (t) {
          return (
            Ou(
              !1,
              'The URL path "' +
                e +
                '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding (' +
                t +
                ').'
            ),
            e
          );
        }
      }
      function Ru(e, t) {
        if ('/' === t) return e;
        if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
        var n = t.endsWith('/') ? t.length - 1 : t.length,
          r = e.charAt(n);
        return r && '/' !== r ? null : e.slice(n) || '/';
      }
      function Pu(e, t) {
        if (!1 === e || null === e || 'undefined' === typeof e) throw new Error(t);
      }
      function Ou(e, t) {
        if (!e) {
          'undefined' !== typeof console && console.warn(t);
          try {
            throw new Error(t);
          } catch (n) {}
        }
      }
      function Du(e, t, n, r) {
        return (
          "Cannot include a '" +
          e +
          "' character in a manually specified `to." +
          t +
          '` field [' +
          JSON.stringify(r) +
          '].  Please separate it out to the `to.' +
          n +
          '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.'
        );
      }
      function Iu(e) {
        return e.filter(function (e, t) {
          return 0 === t || (e.route.path && e.route.path.length > 0);
        });
      }
      function Mu(e, t, n, r) {
        var o;
        void 0 === r && (r = !1),
          'string' === typeof e
            ? (o = xu(e))
            : (Pu(!(o = hu({}, e)).pathname || !o.pathname.includes('?'), Du('?', 'pathname', 'search', o)),
              Pu(!o.pathname || !o.pathname.includes('#'), Du('#', 'pathname', 'hash', o)),
              Pu(!o.search || !o.search.includes('#'), Du('#', 'search', 'hash', o)));
        var a,
          i = '' === e || '' === o.pathname,
          l = i ? '/' : o.pathname;
        if (r || null == l) a = n;
        else {
          var u = t.length - 1;
          if (l.startsWith('..')) {
            for (var s = l.split('/'); '..' === s[0]; ) s.shift(), (u -= 1);
            o.pathname = s.join('/');
          }
          a = u >= 0 ? t[u] : '/';
        }
        var c = (function (e, t) {
            void 0 === t && (t = '/');
            var n = 'string' === typeof e ? xu(e) : e,
              r = n.pathname,
              o = n.search,
              a = void 0 === o ? '' : o,
              i = n.hash,
              l = void 0 === i ? '' : i,
              u = r
                ? r.startsWith('/')
                  ? r
                  : (function (e, t) {
                      var n = t.replace(/\/+$/, '').split('/');
                      return (
                        e.split('/').forEach(function (e) {
                          '..' === e ? n.length > 1 && n.pop() : '.' !== e && n.push(e);
                        }),
                        n.length > 1 ? n.join('/') : '/'
                      );
                    })(r, t)
                : t;
            return { pathname: u, search: Bu(a), hash: Fu(l) };
          })(o, a),
          f = l && '/' !== l && l.endsWith('/'),
          d = (i || '.' === l) && n.endsWith('/');
        return c.pathname.endsWith('/') || (!f && !d) || (c.pathname += '/'), c;
      }
      var zu = function (e) {
          return e.join('/').replace(/\/\/+/g, '/');
        },
        Vu = function (e) {
          return e.replace(/\/+$/, '').replace(/^\/*/, '/');
        },
        Bu = function (e) {
          return e && '?' !== e ? (e.startsWith('?') ? e : '?' + e) : '';
        },
        Fu = function (e) {
          return e && '#' !== e ? (e.startsWith('#') ? e : '#' + e) : '';
        },
        Uu = (function (e) {
          E(n, e);
          var t = T(n);
          function n() {
            return N(this, n), t.apply(this, arguments);
          }
          return L(n);
        })(w(Error));
      var Hu = L(function e(t, n, r, o) {
        N(this, e),
          void 0 === o && (o = !1),
          (this.status = t),
          (this.statusText = n || ''),
          (this.internal = o),
          r instanceof Error ? ((this.data = r.toString()), (this.error = r)) : (this.data = r);
      });
      function qu(e) {
        return e instanceof Hu;
      }
      var Wu = ['post', 'put', 'patch', 'delete'],
        $u = (new Set(Wu), ['get'].concat(Wu));
      new Set($u),
        new Set([301, 302, 303, 307, 308]),
        new Set([307, 308]),
        'undefined' !== typeof window && 'undefined' !== typeof window.document && window.document.createElement;
      function Gu() {
        return (
          (Gu = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Gu.apply(this, arguments)
        );
      }
      var Ku =
          'function' === typeof Object.is
            ? Object.is
            : function (e, t) {
                return (e === t && (0 !== e || 1 / e === 1 / t)) || (e !== e && t !== t);
              },
        Qu = e.useState,
        Yu = e.useEffect,
        Xu = e.useLayoutEffect,
        Ju = e.useDebugValue;
      function Zu(e) {
        var t = e.getSnapshot,
          n = e.value;
        try {
          var r = t();
          return !Ku(n, r);
        } catch (o) {
          return !0;
        }
      }
      'undefined' === typeof window || 'undefined' === typeof window.document || window.document.createElement,
        (function (e) {
          e.useSyncExternalStore;
        })(t);
      var es = e.createContext(null);
      var ts = e.createContext(null);
      var ns = e.createContext(null);
      var rs = e.createContext(null);
      var os = e.createContext(null);
      var as = e.createContext(null);
      var is = e.createContext({ outlet: null, matches: [] });
      var ls = e.createContext(null);
      function us() {
        return null != e.useContext(as);
      }
      function ss() {
        return us() || Pu(!1), e.useContext(as).location;
      }
      function cs() {
        us() || Pu(!1);
        var t = e.useContext(os),
          n = t.basename,
          r = t.navigator,
          o = e.useContext(is).matches,
          a = ss().pathname,
          i = JSON.stringify(
            Iu(o).map(function (e) {
              return e.pathnameBase;
            })
          ),
          l = e.useRef(!1);
        return (
          e.useEffect(function () {
            l.current = !0;
          }),
          e.useCallback(
            function (e, t) {
              if ((void 0 === t && (t = {}), l.current))
                if ('number' !== typeof e) {
                  var o = Mu(e, JSON.parse(i), a, 'path' === t.relative);
                  '/' !== n && (o.pathname = '/' === o.pathname ? n : zu([n, o.pathname])),
                    (t.replace ? r.replace : r.push)(o, t.state, t);
                } else r.go(e);
            },
            [n, r, i, a]
          )
        );
      }
      function fs(t, n) {
        var r = (void 0 === n ? {} : n).relative,
          o = e.useContext(is).matches,
          a = ss().pathname,
          i = JSON.stringify(
            Iu(o).map(function (e) {
              return e.pathnameBase;
            })
          );
        return e.useMemo(
          function () {
            return Mu(t, JSON.parse(i), a, 'path' === r);
          },
          [t, i, a, r]
        );
      }
      function ds() {
        var t = (function () {
            var t,
              n = e.useContext(ls),
              r = ws(hs.UseRouteError),
              o = e.useContext(is),
              a = o.matches[o.matches.length - 1];
            if (n) return n;
            return o || Pu(!1), !a.route.id && Pu(!1), null == (t = r.errors) ? void 0 : t[a.route.id];
          })(),
          n = qu(t) ? t.status + ' ' + t.statusText : t instanceof Error ? t.message : JSON.stringify(t),
          r = t instanceof Error ? t.stack : null,
          o = 'rgba(200,200,200, 0.5)',
          a = { padding: '0.5rem', backgroundColor: o },
          i = { padding: '2px 4px', backgroundColor: o };
        return e.createElement(
          e.Fragment,
          null,
          e.createElement('h2', null, 'Unhandled Thrown Error!'),
          e.createElement('h3', { style: { fontStyle: 'italic' } }, n),
          r ? e.createElement('pre', { style: a }, r) : null,
          e.createElement('p', null, '\ud83d\udcbf Hey developer \ud83d\udc4b'),
          e.createElement(
            'p',
            null,
            'You can provide a way better UX than this when your app throws errors by providing your own\xa0',
            e.createElement('code', { style: i }, 'errorElement'),
            ' props on\xa0',
            e.createElement('code', { style: i }, '<Route>')
          )
        );
      }
      var ps,
        hs,
        vs = (function (t) {
          E(r, t);
          var n = T(r);
          function r(e) {
            var t;
            return N(this, r), ((t = n.call(this, e)).state = { location: e.location, error: e.error }), t;
          }
          return (
            L(
              r,
              [
                {
                  key: 'componentDidCatch',
                  value: function (e, t) {
                    console.error('React Router caught the following error during render', e, t);
                  },
                },
                {
                  key: 'render',
                  value: function () {
                    return this.state.error
                      ? e.createElement(ls.Provider, { value: this.state.error, children: this.props.component })
                      : this.props.children;
                  },
                },
              ],
              [
                {
                  key: 'getDerivedStateFromError',
                  value: function (e) {
                    return { error: e };
                  },
                },
                {
                  key: 'getDerivedStateFromProps',
                  value: function (e, t) {
                    return t.location !== e.location
                      ? { error: e.error, location: e.location }
                      : { error: e.error || t.error, location: t.location };
                  },
                },
              ]
            ),
            r
          );
        })(e.Component);
      function ms(t) {
        var n = t.routeContext,
          r = t.match,
          o = t.children,
          a = e.useContext(es);
        return (
          a && r.route.errorElement && (a._deepestRenderedBoundaryId = r.route.id),
          e.createElement(is.Provider, { value: n }, o)
        );
      }
      function gs(t, n, r) {
        if ((void 0 === n && (n = []), null == t)) {
          if (null == r || !r.errors) return null;
          t = r.matches;
        }
        var o = t,
          a = null == r ? void 0 : r.errors;
        if (null != a) {
          var i = o.findIndex(function (e) {
            return e.route.id && (null == a ? void 0 : a[e.route.id]);
          });
          i >= 0 || Pu(!1), (o = o.slice(0, Math.min(o.length, i + 1)));
        }
        return o.reduceRight(function (t, i, l) {
          var u = i.route.id ? (null == a ? void 0 : a[i.route.id]) : null,
            s = r ? i.route.errorElement || e.createElement(ds, null) : null,
            c = function () {
              return e.createElement(
                ms,
                { match: i, routeContext: { outlet: t, matches: n.concat(o.slice(0, l + 1)) } },
                u ? s : void 0 !== i.route.element ? i.route.element : t
              );
            };
          return r && (i.route.errorElement || 0 === l)
            ? e.createElement(vs, { location: r.location, component: s, error: u, children: c() })
            : c();
        }, null);
      }
      function ws(t) {
        var n = e.useContext(ns);
        return n || Pu(!1), n;
      }
      !(function (e) {
        e.UseRevalidator = 'useRevalidator';
      })(ps || (ps = {})),
        (function (e) {
          (e.UseLoaderData = 'useLoaderData'),
            (e.UseActionData = 'useActionData'),
            (e.UseRouteError = 'useRouteError'),
            (e.UseNavigation = 'useNavigation'),
            (e.UseRouteLoaderData = 'useRouteLoaderData'),
            (e.UseMatches = 'useMatches'),
            (e.UseRevalidator = 'useRevalidator');
        })(hs || (hs = {}));
      var ys;
      function bs(t) {
        var n = t.to,
          r = t.replace,
          o = t.state,
          a = t.relative;
        us() || Pu(!1);
        var i = e.useContext(ns),
          l = cs();
        return (
          e.useEffect(function () {
            (i && 'idle' !== i.navigation.state) || l(n, { replace: r, state: o, relative: a });
          }),
          null
        );
      }
      function xs(e) {
        Pu(!1);
      }
      function ks(t) {
        var n = t.basename,
          r = void 0 === n ? '/' : n,
          o = t.children,
          a = void 0 === o ? null : o,
          i = t.location,
          l = t.navigationType,
          u = void 0 === l ? cu.Pop : l,
          s = t.navigator,
          c = t.static,
          f = void 0 !== c && c;
        us() && Pu(!1);
        var d = r.replace(/^\/*/, '/'),
          p = e.useMemo(
            function () {
              return { basename: d, navigator: s, static: f };
            },
            [d, s, f]
          );
        'string' === typeof i && (i = xu(i));
        var h = i,
          v = h.pathname,
          m = void 0 === v ? '/' : v,
          g = h.search,
          w = void 0 === g ? '' : g,
          y = h.hash,
          b = void 0 === y ? '' : y,
          x = h.state,
          k = void 0 === x ? null : x,
          S = h.key,
          _ = void 0 === S ? 'default' : S,
          E = e.useMemo(
            function () {
              var e = Ru(m, d);
              return null == e ? null : { pathname: e, search: w, hash: b, state: k, key: _ };
            },
            [d, m, w, b, k, _]
          );
        return null == E
          ? null
          : e.createElement(
              os.Provider,
              { value: p },
              e.createElement(as.Provider, { children: a, value: { location: E, navigationType: u } })
            );
      }
      function Ss(t) {
        var n = t.children,
          r = t.location,
          o = e.useContext(ts);
        return (function (t, n) {
          us() || Pu(!1);
          var r,
            o = e.useContext(os).navigator,
            a = e.useContext(ns),
            i = e.useContext(is).matches,
            l = i[i.length - 1],
            u = l ? l.params : {},
            s = (l && l.pathname, l ? l.pathnameBase : '/'),
            c = (l && l.route, ss());
          if (n) {
            var f,
              d = 'string' === typeof n ? xu(n) : n;
            '/' === s || (null == (f = d.pathname) ? void 0 : f.startsWith(s)) || Pu(!1), (r = d);
          } else r = c;
          var p = r.pathname || '/',
            h = _u(t, { pathname: '/' === s ? p : p.slice(s.length) || '/' }),
            v = gs(
              h &&
                h.map(function (e) {
                  return Object.assign({}, e, {
                    params: Object.assign({}, u, e.params),
                    pathname: zu([s, o.encodeLocation ? o.encodeLocation(e.pathname).pathname : e.pathname]),
                    pathnameBase:
                      '/' === e.pathnameBase
                        ? s
                        : zu([s, o.encodeLocation ? o.encodeLocation(e.pathnameBase).pathname : e.pathnameBase]),
                  });
                }),
              i,
              a || void 0
            );
          return n && v
            ? e.createElement(
                as.Provider,
                {
                  value: {
                    location: Gu({ pathname: '/', search: '', hash: '', state: null, key: 'default' }, r),
                    navigationType: cu.Pop,
                  },
                },
                v
              )
            : v;
        })(o && !n ? o.router.routes : Es(n), r);
      }
      !(function (e) {
        (e[(e.pending = 0)] = 'pending'), (e[(e.success = 1)] = 'success'), (e[(e.error = 2)] = 'error');
      })(ys || (ys = {}));
      var _s = new Promise(function () {});
      e.Component;
      function Es(t, n) {
        void 0 === n && (n = []);
        var r = [];
        return (
          e.Children.forEach(t, function (t, o) {
            if (e.isValidElement(t))
              if (t.type !== e.Fragment) {
                t.type !== xs && Pu(!1), t.props.index && t.props.children && Pu(!1);
                var a = [].concat(f(n), [o]),
                  i = {
                    id: t.props.id || a.join('-'),
                    caseSensitive: t.props.caseSensitive,
                    element: t.props.element,
                    index: t.props.index,
                    path: t.props.path,
                    loader: t.props.loader,
                    action: t.props.action,
                    errorElement: t.props.errorElement,
                    hasErrorBoundary: null != t.props.errorElement,
                    shouldRevalidate: t.props.shouldRevalidate,
                    handle: t.props.handle,
                  };
                t.props.children && (i.children = Es(t.props.children, a)), r.push(i);
              } else r.push.apply(r, Es(t.props.children, n));
          }),
          r
        );
      }
      function Cs() {
        return (
          (Cs = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Cs.apply(this, arguments)
        );
      }
      function Ts(e, t) {
        if (null == e) return {};
        var n,
          r,
          o = {},
          a = Object.keys(e);
        for (r = 0; r < a.length; r++) (n = a[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o;
      }
      var Ns = ['onClick', 'relative', 'reloadDocument', 'replace', 'state', 'target', 'to', 'preventScrollReset'];
      function js(t) {
        var n,
          r = t.basename,
          o = t.children,
          a = t.window,
          i = e.useRef();
        null == i.current &&
          (i.current =
            (void 0 === (n = { window: a, v5Compat: !0 }) && (n = {}),
            Su(
              function (e, t) {
                var n = xu(e.location.hash.substr(1)),
                  r = n.pathname,
                  o = void 0 === r ? '/' : r,
                  a = n.search,
                  i = void 0 === a ? '' : a,
                  l = n.hash;
                return yu(
                  '',
                  { pathname: o, search: i, hash: void 0 === l ? '' : l },
                  (t.state && t.state.usr) || null,
                  (t.state && t.state.key) || 'default'
                );
              },
              function (e, t) {
                var n = e.document.querySelector('base'),
                  r = '';
                if (n && n.getAttribute('href')) {
                  var o = e.location.href,
                    a = o.indexOf('#');
                  r = -1 === a ? o : o.slice(0, a);
                }
                return r + '#' + ('string' === typeof t ? t : bu(t));
              },
              function (e, t) {
                gu(
                  '/' === e.pathname.charAt(0),
                  'relative pathnames are not supported in hash history.push(' + JSON.stringify(t) + ')'
                );
              },
              n
            )));
        var l = i.current,
          u = c(e.useState({ action: l.action, location: l.location }), 2),
          s = u[0],
          f = u[1];
        return (
          e.useLayoutEffect(
            function () {
              return l.listen(f);
            },
            [l]
          ),
          e.createElement(ks, {
            basename: r,
            children: o,
            location: s.location,
            navigationType: s.action,
            navigator: l,
          })
        );
      }
      var Ls = e.forwardRef(function (t, n) {
        var r = t.onClick,
          o = t.relative,
          a = t.reloadDocument,
          i = t.replace,
          l = t.state,
          u = t.target,
          s = t.to,
          c = t.preventScrollReset,
          f = Ts(t, Ns),
          d = (function (t, n) {
            var r = (void 0 === n ? {} : n).relative;
            us() || Pu(!1);
            var o = e.useContext(os),
              a = o.basename,
              i = o.navigator,
              l = fs(t, { relative: r }),
              u = l.hash,
              s = l.pathname,
              c = l.search,
              f = s;
            return '/' !== a && (f = '/' === s ? a : zu([a, s])), i.createHref({ pathname: f, search: c, hash: u });
          })(s, { relative: o }),
          p = (function (t, n) {
            var r = void 0 === n ? {} : n,
              o = r.target,
              a = r.replace,
              i = r.state,
              l = r.preventScrollReset,
              u = r.relative,
              s = cs(),
              c = ss(),
              f = fs(t, { relative: u });
            return e.useCallback(
              function (e) {
                if (
                  (function (e, t) {
                    return (
                      0 === e.button &&
                      (!t || '_self' === t) &&
                      !(function (e) {
                        return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
                      })(e)
                    );
                  })(e, o)
                ) {
                  e.preventDefault();
                  var n = void 0 !== a ? a : bu(c) === bu(f);
                  s(t, { replace: n, state: i, preventScrollReset: l, relative: u });
                }
              },
              [c, s, f, a, i, o, t, l, u]
            );
          })(s, { replace: i, state: l, target: u, preventScrollReset: c, relative: o });
        return e.createElement(
          'a',
          Cs({}, f, {
            href: d,
            onClick: a
              ? r
              : function (e) {
                  r && r(e), e.defaultPrevented || p(e);
                },
            ref: n,
            target: u,
          })
        );
      });
      var As, Rs;
      (function (e) {
        (e.UseScrollRestoration = 'useScrollRestoration'),
          (e.UseSubmitImpl = 'useSubmitImpl'),
          (e.UseFetcher = 'useFetcher');
      })(As || (As = {})),
        (function (e) {
          (e.UseFetchers = 'useFetchers'), (e.UseScrollRestoration = 'useScrollRestoration');
        })(Rs || (Rs = {}));
      var Ps = n(184),
        Os = function () {
          var e = Kl(eu),
            t = e.settings,
            n = t.text_color,
            r = t.bg_color;
          return (0, Ps.jsx)('div', {
            className: 'relative w-full xl:mx-auto xl:w-1/2',
            style: { '--text-color': n, '--bg-color': r },
            children: (0, Ps.jsxs)('div', {
              className: 'relative z-10 px-4 pt-10 text-center xl:pt-0 xl:text-left',
              children: [
                (0, Ps.jsx)('h2', {
                  className: 'mb-2 font-galano text-3xl font-bold leading-tight xl:text-4xl xl:leading-tight',
                  style: { color: n },
                  children: e.title,
                }),
                (0, Ps.jsx)('p', {
                  className: 'font-galano text-sm font-medium leading-normal xl:text-xl xl:leading-normal',
                  style: { color: n },
                  children: e.description,
                }),
                (0, Ps.jsx)(Ls, {
                  to: '/name-and-age',
                  className:
                    'mt-10 block w-full rounded border-2 border-solid border-[var(--text-color)] bg-[var(--text-color)] px-12 py-6 text-center text-xl font-bold leading-tight text-[var(--bg-color)] transition-colors hover:bg-[var(--bg-color)] hover:text-[var(--text-color)] xl:mr-auto xl:max-w-fit',
                  children: 'Get Started',
                }),
              ],
            }),
          });
        },
        Ds = function () {
          var e = Kl(eu).settings,
            t = e.mobile_banner_image,
            n = e.desktop_banner_image,
            r = e.active_bg_color;
          return (0, Ps.jsxs)('div', {
            className: 'aspect-square rotate-[-6deg] overflow-hidden rounded-[3px] p-2.5',
            style: { backgroundColor: r },
            children: [
              (0, Ps.jsx)('img', {
                className: 'lazyload aspect-square h-auto w-full rounded-md object-cover object-center xl:hidden',
                src: (null === t || void 0 === t ? void 0 : t.src) || t,
                alt: (null === t || void 0 === t ? void 0 : t.alt) || 'Family wearing matching holiday themed pajamas',
              }),
              (0, Ps.jsx)('img', {
                className: 'lazyload hidden aspect-square h-auto w-full rounded-md object-cover object-center xl:block',
                src: (null === n || void 0 === n ? void 0 : n.src) || n,
                alt: (null === n || void 0 === n ? void 0 : n.alt) || 'Family wearing matching holiday themed pajamas',
              }),
            ],
          });
        },
        Is = function () {
          var e = Kl(eu).settings,
            t = e.bottom_right_image,
            n = e.bottom_right_image_max_width,
            r = e.bottom_right_image_bottom,
            o = e.bottom_right_image_right;
          return (0, Ps.jsx)('img', {
            className: 'pointer-events-none absolute bottom-0  right-0 h-auto w-full object-cover object-center',
            style: { maxWidth: n, bottom: r, right: o },
            alt: (null === t || void 0 === t ? void 0 : t.alt) || 'Bottom Right Image',
            src: (null === t || void 0 === t ? void 0 : t.src) || t,
          });
        },
        Ms = function () {
          var e = Kl(eu).settings,
            t = e.bottom_left_image,
            n = e.bottom_left_image_max_width,
            r = e.bottom_left_image_bottom,
            o = e.bottom_left_image_left;
          return (0, Ps.jsx)('img', {
            className: 'pointer-events-none absolute bottom-0  left-0 h-auto w-full object-cover object-center',
            style: { maxWidth: n, bottom: r, right: o },
            alt: (null === t || void 0 === t ? void 0 : t.alt) || 'Bottom Left Image',
            src: (null === t || void 0 === t ? void 0 : t.src) || t,
          });
        },
        zs = function () {
          return (0, Ps.jsxs)(Ps.Fragment, { children: [(0, Ps.jsx)(Ms, {}), (0, Ps.jsx)(Is, {})] });
        },
        Vs = function () {
          var e = Kl(eu).settings,
            t = e.desktop_homepage_top_image,
            n = e.mobile_homepage_top_image;
          return (0, Ps.jsxs)(Ps.Fragment, {
            children: [
              (0, Ps.jsx)('img', {
                className: 'pointer-events-none absolute left-0 right-0 top-0 z-10 hidden w-full md:block xl:block',
                alt: (null === t || void 0 === t ? void 0 : t.alt) || 'Top Image',
                src: (null === t || void 0 === t ? void 0 : t.src) || t,
              }),
              (0, Ps.jsx)('img', {
                className: 'pointer-events-none absolute left-0 right-0 top-0 z-10 w-full md:hidden',
                alt: (null === n || void 0 === n ? void 0 : n.alt) || 'Top Image',
                src: (null === n || void 0 === n ? void 0 : n.src) || n,
              }),
            ],
          });
        },
        Bs = function () {
          var e = Kl(eu).settings.bg_color;
          return (0, Ps.jsxs)('div', {
            className: 'bundle-page-wrapper relative overflow-hidden pb-48 xl:pb-14',
            style: { backgroundColor: e },
            children: [
              (0, Ps.jsx)(Vs, {}),
              (0, Ps.jsxs)('div', {
                className:
                  'relative z-10 mx-auto xl:flex xl:max-w-7xl xl:items-center xl:justify-center xl:gap-24 xl:py-14',
                children: [
                  (0, Ps.jsx)('div', {
                    className: 'xl:max-w-1/2 w-full px-12 pt-12 xl:p-0 xl:pt-14',
                    children: (0, Ps.jsx)(Ds, {}),
                  }),
                  (0, Ps.jsx)(Os, {}),
                ],
              }),
              (0, Ps.jsx)(zs, {}),
            ],
          });
        },
        Fs = function () {
          return (0, Ps.jsx)(Bs, {});
        },
        Us = Gl({ key: 'bundler', default: [], effects_UNSTABLE: [Jl(''.concat(Zl, 'bundler'))] }),
        Hs = Gl({
          key: 'inProgressBundleGroupAtom',
          default: {
            typeGroups: [
              {
                filteredCollection: { title: '', items: [] },
                selectedItem: [{ selectedProduct: {}, selectedVariant: {}, selectedPrint: {}, includeInBundle: !0 }],
              },
            ],
            personsName: '',
            parentCollection: { title: '', items: [] },
          },
          effects_UNSTABLE: [Jl(''.concat(Zl, 'inProgressBundleGroupAtom'))],
        }),
        qs = function (e, t) {
          var n = new Map();
          return (
            e.forEach(function (e) {
              var r = e[t],
                o = n.get(r);
              null == o ? n.set(r, [e]) : o.push(e);
            }),
            f(n.values())
          );
        },
        Ws = function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : '',
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : void 0,
            o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : void 0,
            a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : '',
            i = qs(e.products, 'product_type'),
            l = [],
            u = e.products.find(function (e) {
              return e.id === r;
            });
          i.forEach(function (n) {
            var i,
              s = !!n.find(function (e) {
                return e.id === r;
              });
            i = r && o && s ? u : n[0];
            var c = n.map(function (e) {
                return e.tags.find(function (e) {
                  return e.includes('print_tag:');
                });
              }),
              d = f(new Set(c)),
              p = t.filter(function (e) {
                return d.includes(e.printTag);
              }),
              h = t.find(function (e) {
                return (
                  i.tags.find(function (e) {
                    return e.includes('print_tag:');
                  }) === e.printTag
                );
              }),
              v = !0,
              m = i.product_type;
            ((r && e.productTypeLayout && !e.productTypeLayout[0].types.includes(m) && !a.types.includes(m)) ||
              (r && r !== i.id)) &&
              (v = !1);
            var g = {
              filteredCollection: { title: n[0].product_type, items: n },
              selectedItem: {
                selectedProduct: i,
                selectedPrint: h,
                selectedVariant: o,
                swatches: p,
                includeInBundle: v,
              },
            };
            l.push(g);
          });
          var s = a.header ? a.header : e.productTypeLayout && e.productTypeLayout[0].header,
            c = { typeGroups: l, personsName: n, activeTab: s, parentCollection: e };
          return c;
        },
        $s = function (e) {
          var t = e.collection,
            n = e.onClick,
            r = (e.onChange, Kl(Hs)),
            o = r && r.parentCollection && r.parentCollection.title === t.title;
          return window.matchMedia('(min-width: 1025px)').matches
            ? (0, Ps.jsx)('li', {
                className: 'm-0 list-none',
                children: (0, Ps.jsx)('button', {
                  className: ''.concat(
                    o ? 'active' : '',
                    ' bundler-age-group-button group flex w-full flex-col items-center rounded border-2 border-solid border-[var(--bg-color)] bg-[var(--active-bg-color)] px-6 py-4 font-galano text-lg font-medium text-[var(--bg-color)] transition-all hover:bg-[var(--bg-color)] hover:font-bold hover:text-[var(--active-bg-color)] [&.active]:bg-[var(--bg-color)] [&.active]:font-bold [&.active]:text-[var(--text-color)]'
                  ),
                  onClick: function () {
                    return n(t);
                  },
                  children: t.title,
                }),
              })
            : (0, Ps.jsx)('li', {
                className: 'm-0 list-none pr-4',
                children: (0, Ps.jsx)('button', {
                  className: ''.concat(
                    o ? 'active' : '',
                    ' bundler-age-group-button group flex w-full flex-col items-center rounded border-2 border-solid border-[var(--active-bg-color)] bg-[var(--bg-color)] px-6 py-4 font-galano text-lg font-medium text-[var(--active-bg-color)] transition-all hover:bg-[var(--active-bg-color)] hover:font-bold hover:text-[var(--bg-color)] [&.active]:bg-[var(--active-bg-color)] [&.active]:font-bold [&.active]:text-[var(--bg-color)]'
                  ),
                  onClick: function () {
                    return n(t);
                  },
                  children: t.title,
                }),
              });
        },
        Gs = function (e) {
          var t = e.classes,
            n = e.style;
          return (0, Ps.jsx)('svg', {
            class: t,
            style: n,
            xmlns: 'http://www.w3.org/2000/svg',
            width: '14',
            height: '12',
            viewBox: '0 0 14 12',
            fill: 'none',
            children: (0, Ps.jsx)('path', {
              d: 'M0.777779 5.18522C0.348223 5.18522 0 5.55001 0 6C0 6.44998 0.348223 6.81478 0.777779 6.81478V5.18522ZM13.7722 6.57613C14.0759 6.25795 14.0759 5.74205 13.7722 5.42386L8.82246 0.238644C8.51873 -0.0795479 8.02626 -0.0795479 7.72252 0.238644C7.41878 0.556831 7.41878 1.07273 7.72252 1.39091L12.1223 6L7.72252 10.609C7.41878 10.9272 7.41878 11.4432 7.72252 11.7614C8.02626 12.0795 8.51873 12.0795 8.82246 11.7614L13.7722 6.57613ZM0.777779 6.81478H13.2222V5.18522H0.777779V6.81478Z',
              fill: 'inherit',
            }),
          });
        },
        Ks = function () {
          var t = Kl(Us),
            n = Kl(ru),
            r = c(Ql(Hs), 2),
            o = r[0],
            i = r[1],
            u = Kl(tu),
            s = Kl(eu).settings,
            d = s.text_color,
            p = s.active_bg_color,
            h = s.bg_color,
            v = Yl(Us),
            m = ss(),
            g = (0, e.useRef)(null);
          null === g.current && (g.current = o);
          var w = o.typeGroups.filter(function (e) {
              return !0 === e.selectedItem.includeInBundle;
            }).length,
            y = o.typeGroups.find(function (e) {
              var t = e.selectedItem;
              return !!t.selectedVariant && t.includeInBundle;
            }),
            b = 0 === w || !y,
            x = f(
              new Set(
                u.map(function (e) {
                  return e;
                })
              )
            ),
            k = (function () {
              var e = l(
                a().mark(function e(t) {
                  var r;
                  return a().wrap(function (e) {
                    for (;;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          (r = Ws(t, n, o.personsName)), i(r);
                        case 2:
                        case 'end':
                          return e.stop();
                      }
                  }, e);
                })
              );
              return function (t) {
                return e.apply(this, arguments);
              };
            })();
          return (0, Ps.jsx)(Ps.Fragment, {
            children: (0, Ps.jsxs)('div', {
              className: 'age-group-container relative pt-10',
              style: { '--text-color': d, '--active-bg-color': p, '--bg-color': h },
              children: [
                (0, Ps.jsxs)('div', {
                  className: 'mb-8 px-4',
                  children: [
                    (0, Ps.jsx)('label', {
                      for: 'bundler-name-input',
                      className:
                        'mb-5 !font-galano !text-sm !font-bold !normal-case !leading-tight !tracking-normal !text-[var(--text-color)] ',
                      children: "What's their name?",
                    }),
                    (0, Ps.jsx)('input', {
                      className:
                        'bundler-name-input w-full rounded border-2 border-solid !border-[var(--text-color)] bg-[var(--bg-color)] p-4 font-galano text-base font-bold leading-tight text-[var(--text-color)] placeholder:font-galano placeholder:font-medium placeholder:opacity-70 focus:border-2 focus:outline-none focus:placeholder:text-transparent',
                      id: 'bundler-name-input',
                      type: 'text',
                      placeholder: 'Enter Name',
                      onChange: function (e) {
                        return (
                          (t = e.target.value),
                          void i(function (e) {
                            return S(S({}, e), {}, { personsName: t });
                          })
                        );
                        var t;
                      },
                      value: o.personsName,
                    }),
                  ],
                }),
                (0, Ps.jsxs)('div', {
                  className: 'mb-10 pl-4',
                  children: [
                    (0, Ps.jsx)('div', {
                      className: 'mb-4',
                      id: 'age-group-label',
                      children: (0, Ps.jsxs)('h3', {
                        className:
                          'mb-0 text-sm font-bold normal-case leading-tight tracking-normal text-[var(--text-color)]',
                        children: [
                          'What size do they wear? ',
                          (0, Ps.jsx)('span', { className: 'align-top', children: '*' }),
                        ],
                      }),
                    }),
                    (0, Ps.jsxs)('div', {
                      className: 'relative',
                      children: [
                        (0, Ps.jsx)('ul', {
                          className: 'm-0 flex list-none flex-col gap-3.5',
                          'data-slick': JSON.stringify({
                            slidesToShow: 3.5,
                            slidesToScroll: 1,
                            mobileFirst: !0,
                            variableWidth: !0,
                            infinite: !1,
                            nextArrow: '.age-selector-next',
                            responsive: [{ breakpoint: 992, settings: 'unslick' }],
                          }),
                          'aria-labelledby': 'age-group-label',
                          children: x.map(function (e) {
                            return (0, Ps.jsx)($s, { collection: e, onClick: k });
                          }),
                        }),
                        (0, Ps.jsx)('button', {
                          className:
                            'age-selector-next absolute right-0 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full shadow-md xl:right-5',
                          style: { color: h, backgroundColor: p },
                          children: (0, Ps.jsx)(Gs, { classes: 'w-4 h-auto', style: { fill: h } }),
                        }),
                      ],
                    }),
                  ],
                }),
                (0, Ps.jsxs)('div', {
                  className: 'w-full px-4',
                  children: [
                    t.length < 20 && o.parentCollection.title
                      ? (0, Ps.jsx)(Ls, {
                          to: '/size-and-style',
                          className:
                            'block w-full rounded border-2 border-solid border-[var(--text-color)] bg-[var(--text-color)] px-12 py-6 text-center text-2xl font-bold leading-tight text-[var(--bg-color)] transition-colors hover:bg-[var(--bg-color)] hover:text-[var(--text-color)]',
                          children: 'Next Step',
                        })
                      : (0, Ps.jsx)(Ls, {
                          to: '/name-and-age',
                          className: ''.concat(
                            t.length >= 20 && o.parentCollection ? 'hidden' : 'block',
                            ' w-full rounded border-2 border-solid border-[var(--text-color)] bg-[var(--text-color)] px-12 py-6 text-center text-2xl font-bold leading-tight text-[var(--bg-color)] opacity-60 hover:cursor-not-allowed'
                          ),
                          children: 'Next Step',
                        }),
                    t.length >= 20 &&
                      !!o.parentCollection &&
                      (0, Ps.jsx)('button', {
                        className:
                          'block w-full rounded border-2 border-solid border-[var(--text-color)] bg-[var(--text-color)] p-6 text-2xl font-bold leading-tight text-[var(--bg-color)] opacity-60 transition-colors hover:cursor-not-allowed',
                        disabled: !0,
                        children: 'Max quantity in bundle',
                      }),
                    t.length > 0
                      ? (0, Ps.jsxs)(Ls, {
                          className:
                            'mx-auto mt-7 flex w-full max-w-fit items-center justify-center gap-2.5 text-center text-lg font-medium leading-tight xl:text-xl xl:leading-tight',
                          to: '/current-bundle',
                          onClick: function (e) {
                            var t;
                            if (
                              null !== m &&
                              void 0 !== m &&
                              null !== (t = m.state) &&
                              void 0 !== t &&
                              t.editBundleItem &&
                              !b
                            ) {
                              var n = g.current,
                                r = n.typeGroups
                                  .filter(function (e) {
                                    return (
                                      e.selectedItem.includeInBundle &&
                                      !!e.selectedItem.selectedVariant &&
                                      e.selectedItem.selectedVariant.available
                                    );
                                  })
                                  .map(function (e) {
                                    return S(
                                      S({}, e.selectedItem),
                                      {},
                                      {
                                        quantity: 1,
                                        personsName: n.personsName,
                                        parentCollection: n.parentCollection.title,
                                      }
                                    );
                                  });
                              v(function (e) {
                                return [].concat(f(e), f(r));
                              });
                            }
                          },
                          style: { color: p },
                          children: [
                            (0, Ps.jsx)(Gs, { classes: 'w-3.5 h-auto rotate-180', style: { fill: p } }),
                            'Back to Bundle',
                          ],
                        })
                      : '',
                  ],
                }),
              ],
            }),
          });
        },
        Qs = function () {
          var t = Kl(Us),
            n = Kl(ru),
            r = c(Ql(Hs), 2),
            o = r[0],
            i = r[1],
            u = Kl(tu),
            s = Kl(eu).settings,
            d = s.text_color,
            p = s.active_bg_color,
            h = s.bg_color,
            v = Yl(Us),
            m = ss(),
            g = (0, e.useRef)(null);
          null === g.current && (g.current = o);
          var w = o.typeGroups.filter(function (e) {
              return !0 === e.selectedItem.includeInBundle;
            }).length,
            y = o.typeGroups.find(function (e) {
              var t = e.selectedItem;
              return !!t.selectedVariant && t.includeInBundle;
            }),
            b = 0 === w || !y,
            x = f(
              new Set(
                u.map(function (e) {
                  return e;
                })
              )
            ),
            k = (function () {
              var e = l(
                a().mark(function e(t) {
                  var r;
                  return a().wrap(function (e) {
                    for (;;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          (r = Ws(t, n, o.personsName)), i(r);
                        case 2:
                        case 'end':
                          return e.stop();
                      }
                  }, e);
                })
              );
              return function (t) {
                return e.apply(this, arguments);
              };
            })();
          return (0, Ps.jsx)(Ps.Fragment, {
            children: (0, Ps.jsxs)('div', {
              className:
                'age-group-container relative mx-auto w-full max-w-2xl rounded-[20px] bg-[var(--active-bg-color)] p-14',
              style: { '--text-color': d, '--active-bg-color': p, '--bg-color': h },
              children: [
                (0, Ps.jsxs)('div', {
                  className: 'mb-10',
                  children: [
                    (0, Ps.jsx)('label', {
                      for: 'bundler-name-input',
                      className:
                        'mb-5 !font-galano !text-base !font-bold !normal-case !leading-tight !tracking-normal !text-[var(--bg-color)]',
                      children: "What's their name?",
                    }),
                    (0, Ps.jsx)('input', {
                      className:
                        'bundler-name-input w-full rounded border-2 border-solid !border-[var(--bg-color)] bg-[var(--active-bg-color)] p-4 font-galano text-lg font-bold leading-tight text-[var(--bg-color)] placeholder:font-galano placeholder:font-medium placeholder:opacity-70 focus:border-2 focus:outline-none focus:placeholder:text-transparent',
                      id: 'bundler-name-input',
                      type: 'text',
                      placeholder: 'Enter Name',
                      onChange: function (e) {
                        return (
                          (t = e.target.value),
                          void i(function (e) {
                            return S(S({}, e), {}, { personsName: t });
                          })
                        );
                        var t;
                      },
                      value: o.personsName,
                    }),
                  ],
                }),
                (0, Ps.jsxs)('div', {
                  className: 'mb-10',
                  children: [
                    (0, Ps.jsx)('div', {
                      className: 'mb-4',
                      id: 'age-group-label',
                      children: (0, Ps.jsxs)('h3', {
                        className:
                          'mb-0 text-base font-bold normal-case leading-tight tracking-normal text-[var(--bg-color)]',
                        children: [
                          'What size do they wear? ',
                          (0, Ps.jsx)('span', { className: 'align-top', children: '*' }),
                        ],
                      }),
                    }),
                    (0, Ps.jsx)('div', {
                      className: 'relative',
                      children: (0, Ps.jsx)('ul', {
                        className: 'm-0 grid list-none grid-cols-3 gap-4',
                        'aria-labelledby': 'age-group-label',
                        children: x.map(function (e) {
                          return (0, Ps.jsx)($s, { collection: e, onClick: k });
                        }),
                      }),
                    }),
                  ],
                }),
                (0, Ps.jsxs)('div', {
                  className: 'w-full',
                  children: [
                    t.length < 20 && o.parentCollection.title
                      ? (0, Ps.jsx)(Ls, {
                          to: '/size-and-style',
                          className:
                            'mr-auto block w-full max-w-fit rounded border-2 border-solid border-[var(--bg-color)] bg-[var(--bg-color)] px-12 py-6 text-center text-2xl font-bold leading-tight text-[var(--text-color)] transition-colors hover:bg-[var(--text-color)] hover:text-[var(--bg-color)]',
                          children: 'Next Step',
                        })
                      : (0, Ps.jsx)(Ls, {
                          to: '/name-and-age',
                          className: ''.concat(
                            t.length >= 20 && o.parentCollection ? 'hidden' : 'block',
                            ' mr-auto w-full max-w-fit rounded border-2 border-solid border-[var(--bg-color)] bg-[var(--bg-color)] px-12 py-6 text-center text-2xl font-bold leading-tight text-[var(--text-color)] opacity-60 transition-colors hover:cursor-not-allowed'
                          ),
                          children: 'Next Step',
                        }),
                    t.length >= 20 &&
                      !!o.parentCollection &&
                      (0, Ps.jsx)('button', {
                        className:
                          'mr-auto block w-full max-w-fit rounded border-2 border-solid border-[var(--bg-color)] bg-[var(--bg-color)] p-6 text-2xl font-bold leading-tight text-[var(--text-color)] opacity-60 transition-colors hover:cursor-not-allowed',
                        disabled: !0,
                        children: 'Max quantity in bundle',
                      }),
                    t.length > 0
                      ? (0, Ps.jsxs)(Ls, {
                          className:
                            'mr-auto mt-7 flex w-full max-w-fit items-center justify-center gap-2.5 text-center text-lg font-medium leading-tight',
                          to: '/current-bundle',
                          onClick: function (e) {
                            var t;
                            if (
                              null !== m &&
                              void 0 !== m &&
                              null !== (t = m.state) &&
                              void 0 !== t &&
                              t.editBundleItem &&
                              !b
                            ) {
                              var n = g.current,
                                r = n.typeGroups
                                  .filter(function (e) {
                                    return (
                                      e.selectedItem.includeInBundle &&
                                      !!e.selectedItem.selectedVariant &&
                                      e.selectedItem.selectedVariant.available
                                    );
                                  })
                                  .map(function (e) {
                                    return S(
                                      S({}, e.selectedItem),
                                      {},
                                      {
                                        quantity: 1,
                                        personsName: n.personsName,
                                        parentCollection: n.parentCollection.title,
                                      }
                                    );
                                  });
                              v(function (e) {
                                return [].concat(f(e), f(r));
                              });
                            }
                          },
                          style: { color: h },
                          children: [
                            (0, Ps.jsx)(Gs, { classes: 'w-3.5 h-auto rotate-180', style: { fill: h } }),
                            'Back to Bundle',
                          ],
                        })
                      : '',
                  ],
                }),
              ],
            }),
          });
        },
        Ys = function () {
          var t = window.matchMedia('(min-width: 1025px)').matches,
            n = Kl(eu),
            r = n.settings,
            o = r.bg_color,
            a = r.text_color,
            i = r.active_bg_color,
            l = r.bundle_bg_color,
            u = Yl(Us),
            s = Kl(Us),
            c = Kl(Hs),
            d = ss(),
            p = (0, e.useRef)(null);
          null === p.current && (p.current = c);
          var h = c.typeGroups.filter(function (e) {
              return !0 === e.selectedItem.includeInBundle;
            }).length,
            v = c.typeGroups.find(function (e) {
              var t = e.selectedItem;
              return !!t.selectedVariant && t.includeInBundle;
            }),
            m = 0 === h || !v;
          return (0, Ps.jsxs)('div', {
            className: 'bundle-page-wrapper relative overflow-hidden bg-[var(--bg-color)] pb-20 lg:pb-16',
            style: { '--bg-color': o, '--active-bg-color': i, '--bundle-bg-color': l, '--text-color': a },
            children: [
              (0, Ps.jsxs)('div', {
                className: 'relative z-10 bg-[var(--bg-color)] lg:bg-transparent',
                children: [
                  (0, Ps.jsx)(Vs, {}),
                  (0, Ps.jsxs)('div', {
                    className: 'relative z-10 px-4 py-11 xl:py-16',
                    children: [
                      (0, Ps.jsx)('h1', {
                        className:
                          'mb-4 text-center font-galano text-xl font-medium capitalize leading-tight tracking-normal xl:text-2xl',
                        style: { color: a },
                        children: n.title,
                      }),
                      (0, Ps.jsx)('h2', {
                        className:
                          'mb-0 text-center font-galano text-4xl font-bold capitalize leading-tight tracking-normal xl:text-5xl xl:leading-tight',
                        style: { color: a },
                        children: 'Add a Family Member',
                      }),
                      s.length > 0
                        ? (0, Ps.jsxs)(Ls, {
                            className:
                              'mx-auto mt-4 flex w-full max-w-fit items-center justify-center gap-2.5 text-center font-galano text-xl font-medium leading-tight xl:hidden xl:text-2xl xl:leading-tight',
                            style: { color: i },
                            to: '/current-bundle',
                            onClick: function (e) {
                              var t;
                              if (
                                null !== d &&
                                void 0 !== d &&
                                null !== (t = d.state) &&
                                void 0 !== t &&
                                t.editBundleItem &&
                                !m
                              ) {
                                var n = p.current,
                                  r = n.typeGroups
                                    .filter(function (e) {
                                      return (
                                        e.selectedItem.includeInBundle &&
                                        !!e.selectedItem.selectedVariant &&
                                        e.selectedItem.selectedVariant.available
                                      );
                                    })
                                    .map(function (e) {
                                      return S(
                                        S({}, e.selectedItem),
                                        {},
                                        {
                                          quantity: 1,
                                          personsName: n.personsName,
                                          parentCollection: n.parentCollection.title,
                                        }
                                      );
                                    });
                                u(function (e) {
                                  return [].concat(f(e), f(r));
                                });
                              }
                            },
                            children: ['View Bundle', (0, Ps.jsx)(Gs, { classes: 'w-3.5 h-auto', style: { fill: i } })],
                          })
                        : '',
                    ],
                  }),
                ],
              }),
              (0, Ps.jsx)('div', {
                className: 'relative z-10',
                children: t ? (0, Ps.jsx)(Qs, {}) : (0, Ps.jsx)(Ks, {}),
              }),
              (0, Ps.jsx)(zs, {}),
            ],
          });
        },
        Xs = function (e) {
          var t = e.item,
            n = e.index,
            r = e.refParam,
            o = t.selectedItem,
            a = o.selectedProduct,
            i = a.images,
            l = a.title,
            u = o.includeInBundle,
            s = Kl(eu).settings,
            c = s.active_bg_color,
            f = s.bg_color,
            d = {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !0,
              infinite: !1,
              adaptiveHeight: !1,
              prevArrow: '.bundler-prev-arrow-'.concat(n),
              nextArrow: '.bundler-next-arrow-'.concat(n),
            };
          return (0, Ps.jsxs)('div', {
            className: 'relative xl:h-fit',
            children: [
              (0, Ps.jsx)('button', {
                className:
                  'bundler-slideshow-arrow absolute left-1.5 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full shadow-md xl:left-5 bundler-prev-arrow-'.concat(
                    n
                  ),
                style: { color: f, backgroundColor: c },
                children: (0, Ps.jsx)(Gs, { classes: 'w-4 h-auto rotate-180', style: { fill: f } }),
              }),
              (0, Ps.jsx)('button', {
                className:
                  'bundler-slideshow-arrow absolute right-1.5 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full shadow-md xl:right-5 bundler-next-arrow-'.concat(
                    n
                  ),
                style: { color: f, backgroundColor: c },
                children: (0, Ps.jsx)(Gs, { classes: 'w-4 h-auto', style: { fill: f } }),
              }),
              (0, Ps.jsx)('div', {
                className: 'block max-w-full',
                children:
                  i &&
                  (0, Ps.jsx)('ul', {
                    className: 'm-0 w-full max-w-full list-none',
                    ref: r,
                    'data-slick': JSON.stringify(d),
                    children: i.slice(0, 2).map(function (e) {
                      return (0,
                      Ps.jsx)('li', { className: 'm-0 aspect-square', children: (0, Ps.jsx)('img', { src: e.src, alt: l, className: 'h-full object-cover object-center xl:rounded-lg '.concat(u ? '' : 'opacity-60') }) });
                    }),
                  }),
              }),
            ],
          });
        },
        Js = function (e) {
          var t = e.item,
            n = e.onChangePrint,
            r = e.itemIndex,
            o = c(Ql(Hs), 2),
            a = o[0],
            i = o[1],
            l = t.selectedItem,
            u = l.selectedPrint,
            s = l.selectedVariant,
            f = l.swatches,
            d = l.includeInBundle,
            p = a.parentCollection.products,
            h = Kl(eu).settings.bg_color,
            v =
              u &&
              u.printTag &&
              u.printTag
                .split(':')[1]
                .replaceAll('-', ' ')
                .split(' ')
                .map(function (e) {
                  return e[0].toUpperCase() + e.substr(1);
                })
                .join(' '),
            m = function (e) {
              var o,
                l = 'BUTTON' === e.target.tagName ? e.target.value : e.target.parentElement.value,
                u = f.find(function (e) {
                  return e.printTag === l;
                }),
                c = p.find(function (e) {
                  return (
                    t.filteredCollection.title === e.product_type &&
                    e.tags
                      .filter(function (e) {
                        return e.toLowerCase().includes('print_tag');
                      })[0]
                      .toLowerCase() === l.toLowerCase()
                  );
                });
              s &&
                void 0 ===
                  (o = c.variants.find(function (e) {
                    return e.title === s.title;
                  })) &&
                (o = c.variants.find(function (e) {
                  return !0 === e.available;
                }));
              var d = a.typeGroups.map(function (e) {
                return e.selectedItem.selectedProduct.id === t.selectedItem.selectedProduct.id
                  ? S(
                      S({}, e),
                      {},
                      {
                        selectedItem: S(
                          S({}, e.selectedItem),
                          {},
                          { selectedPrint: u, selectedProduct: c, selectedVariant: o }
                        ),
                      }
                    )
                  : e;
              });
              n(r),
                i(function (e) {
                  return S(S({}, e), {}, { typeGroups: d });
                });
            };
          return (0, Ps.jsxs)('div', {
            className: 'w-full '.concat(d ? '' : 'opacity-60'),
            children: [
              (0, Ps.jsxs)('p', {
                className:
                  'mb-2.5 flex items-center justify-start gap-2 text-left font-galano text-sm font-medium leading-tight xl:text-lg xl:leading-tight',
                style: { color: h },
                children: [(0, Ps.jsx)('span', { class: 'opacity-65', children: 'Print:' }), v],
              }),
              (0, Ps.jsx)('ul', {
                className: 'm-0 flex list-none flex-wrap justify-start gap-2.5',
                children: f.map(function (e) {
                  var t = e.swatch,
                    n = e.printTag;
                  return (0, Ps.jsx)('li', {
                    className: 'm-0',
                    children: (0, Ps.jsx)('button', {
                      className:
                        'flex h-16 w-16 items-center justify-center rounded-full border border-solid p-[3px] transition-opacity hover:opacity-80 xl:h-[74px] xl:w-[74px] xl:p-1',
                      style: { borderColor: n === u.printTag ? h : 'transparent' },
                      onClick: function (e) {
                        return m(e);
                      },
                      onKeyPress: function (e) {
                        return m(e);
                      },
                      value: n,
                      disabled: !d,
                      children: (0, Ps.jsx)('img', {
                        src: t,
                        alt: ''.concat(n.split(':')[1], ' Print Swatch'),
                        className: 'h-full w-full rounded-full',
                      }),
                    }),
                  });
                }),
              }),
            ],
          });
        },
        Zs = function (e) {
          var t = e.classes,
            n = Kl(eu).settings.bg_color;
          return (0, Ps.jsxs)('svg', {
            className: t,
            viewBox: '0 0 16 16',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg',
            children: [
              (0, Ps.jsx)('path', {
                d: 'M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z',
                stroke: n,
                'stroke-width': '1.3',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
              }),
              (0, Ps.jsx)('path', {
                d: 'M8 10.8V8',
                stroke: n,
                'stroke-width': '1.3',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
              }),
              (0, Ps.jsx)('path', {
                d: 'M8 5.2002H8.008',
                stroke: n,
                'stroke-width': '1.3',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
              }),
            ],
          });
        },
        ec = function (e) {
          var t = e.classes,
            n = e.pathClasses;
          return (0, Ps.jsxs)('svg', {
            class: t,
            width: '18',
            height: '15',
            viewBox: '0 0 18 15',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg',
            children: [
              (0, Ps.jsx)('path', {
                className: n,
                d: 'M3 0.999754C7.21393 5.21368 11.5104 9.51016 15.7279 13.7277',
                stroke: 'black',
                'stroke-width': '2',
                'stroke-miterlimit': '10',
                'stroke-linecap': 'round',
              }),
              (0, Ps.jsx)('path', {
                className: n,
                d: 'M3 14.0002C7.21393 9.78632 11.5104 5.48984 15.7279 1.27232',
                stroke: 'black',
                'stroke-width': '2',
                'stroke-miterlimit': '10',
                'stroke-linecap': 'round',
              }),
            ],
          });
        },
        tc = function (e) {
          var t = e.title,
            n = e.sizeChart,
            r = e.visible,
            o = e.setVisible,
            a = function () {
              document.body.classList.remove('overflow-hidden'), o(!1);
            };
          return (0, Ps.jsxs)('div', {
            children: [
              (0, Ps.jsx)('div', {
                className: r ? 'fixed inset-0 z-[1002] bg-white opacity-40' : 'hidden',
                onClick: a,
              }),
              (0, Ps.jsx)('button', {
                className: r ? 'fixed right-2.5 top-2.5 z-[1003]' : 'hidden',
                onClick: a,
                children: (0, Ps.jsx)(ec, {
                  classes: 'w-8 h-8 p-2 rounded-full bg-fir bundler-upsell-modal-close',
                  pathClasses: 'stroke-eggnog',
                }),
              }),
              (0, Ps.jsx)('img', {
                src: n,
                alt: ''.concat(t, ' size chart'),
                className: r
                  ? 'fixed left-1/2 top-1/2 z-[1003] block h-auto w-[95vw] -translate-x-1/2 -translate-y-1/2 xl:mx-5 xl:my-8 xl:w-1/3'
                  : 'hidden',
              }),
            ],
          });
        },
        nc = function (t) {
          var n,
            r = t.item,
            o = t.activeTabItemsLength,
            a = t.index,
            i = c(Ql(Hs), 2),
            l = i[0],
            u = i[1],
            s = Kl(ou),
            f = r.selectedItem.selectedProduct.tags.find(function (e) {
              return e.includes('type_tag:');
            }),
            d = s.find(function (e) {
              return e.tag === f;
            });
          n = d ? d.sizeChart : l.parentCollection.sizeChart;
          var p = r.selectedItem,
            h = p.selectedProduct,
            v = p.selectedVariant,
            m = p.includeInBundle,
            g = r.filteredCollection.title,
            w = Kl(eu).settings,
            y = w.active_bg_color,
            b = w.bg_color,
            x = '\n    .bundler-variant-select-label {\n      color: '
              .concat(
                b,
                ' !important;\n    }\n\n    .bundler-variant-select-label:not(.bundler-variant-select-label-disabled) {\n      box-shadow: inset 0 0 0 1px '
              )
              .concat(
                b,
                ' !important;\n    }\n\n    .bundler-variant-select-label:not(.bundler-variant-select-label-disabled):hover {\n      box-shadow: inset 0 0 0 2px '
              )
              .concat(
                b,
                ' !important;\n    }\n\n    .pdp-variant-select-label.pdp-variant-select-label-disabled.bundler-variant-select-label-disabled {\n      color: '
              )
              .concat(b, ' !important;\n      box-shadow: inset 0 0 0 1px ')
              .concat(
                b,
                ' !important;\n      opacity: 0.5;\n    }\n\n    .pdp-variant-select-label-disabled.bundler-variant-select-label-disabled:before {\n      background-color: '
              )
              .concat(
                b,
                ' !important;\n    }\n\n    .bundler-variant-select-label:focus {\n      box-shadow: inset 0 0 0 3px '
              )
              .concat(
                b,
                ' !important;\n    }\n\n    .bundler-variant-select-label-active {\n      box-shadow: inset 0 0 0 3px '
              )
              .concat(b, ' !important;\n      background-color: ')
              .concat(b, ' !important;\n      color: ')
              .concat(y, ' !important;\n    }\n  '),
            k = l.parentCollection.sizeList,
            _ = c((0, e.useState)(!1), 2),
            E = _[0],
            C = _[1],
            T = function (e, t, n) {
              if (!n) {
                e.preventDefault();
                var i = h.variants.find(function (e) {
                    return e.id === t;
                  }),
                  s = l.typeGroups.map(function (e) {
                    return e.selectedItem.selectedProduct.id === r.selectedItem.selectedProduct.id
                      ? S(S({}, e), {}, { selectedItem: S(S({}, e.selectedItem), {}, { selectedVariant: i }) })
                      : (o > 1 &&
                          0 === a &&
                          ((document.documentElement.style.scrollBehavior = 'smooth'),
                          document.getElementById('item-1').scrollIntoView()),
                        e);
                  });
                u(function (e) {
                  return S(S({}, e), {}, { typeGroups: s });
                });
              }
            };
          return (0, Ps.jsxs)('div', {
            className: 'mt-5 '.concat(m ? '' : 'opacity-60'),
            children: [
              (0, Ps.jsxs)('div', {
                className: 'mb-3 flex items-center justify-between font-galano font-medium',
                children: [
                  (0, Ps.jsx)('p', {
                    className:
                      'xl:leading-tigh m-0 text-left font-galano text-sm font-medium leading-tight opacity-65 xl:text-lg',
                    style: { color: b },
                    children: 'Size',
                  }),
                  !n.includes('no-image') &&
                    (0, Ps.jsxs)('div', {
                      children: [
                        (0, Ps.jsxs)('button', {
                          className: 'm-0 flex items-center gap-2 p-0 text-sm font-medium leading-tight',
                          onClick: function () {
                            !1 !== r.selectedItem.includeInBundle &&
                              (document.body.classList.add('overflow-hidden'), C(!0));
                          },
                          children: [
                            (0, Ps.jsx)(Zs, { classes: 'w-[14px] h-[14px]' }),
                            (0, Ps.jsx)('span', {
                              className: 'underline',
                              style: { color: b },
                              children: 'Size Chart',
                            }),
                          ],
                        }),
                        (0, Ps.jsx)(tc, { title: g, sizeChart: n, visible: E, setVisible: C }),
                      ],
                    }),
                ],
              }),
              (0, Ps.jsxs)('ul', {
                className: 'm-0 grid list-none grid-cols-3 gap-x-1.5 gap-y-3',
                children: [
                  (0, Ps.jsx)('style', { children: x }),
                  h.variants &&
                    h.variants.map(function (e, t) {
                      return !k || k.includes(e.title.replaceAll('*', ''))
                        ? (0, Ps.jsx)('li', {
                            className: 'm-0',
                            children: (0, Ps.jsxs)('label', {
                              class:
                                'pdp-variant-select-label bundler-variant-select-label !px-1 !font-galano lg:!px-1.5 text-center'
                                  .concat(
                                    v && e.id === v.id && m ? ' bundler-variant-select-label-active !font-bold' : ''
                                  )
                                  .concat(
                                    !1 !== e.available && m
                                      ? ''
                                      : ' pdp-variant-select-label-disabled bundler-variant-select-label-disabled'
                                  ),
                              onClick: function (t) {
                                return T(t, e.id, !1 === e.available || !m);
                              },
                              'data-variant-id': e.id,
                              tabindex: 1,
                              children: [
                                e.title.replaceAll('*', ''),
                                !1 === e.available && (0, Ps.jsx)('div', { class: 'oos-horizontal-line' }),
                                (0, Ps.jsx)('input', {
                                  type: 'radio',
                                  class: 'sr-only',
                                  name: ''.concat(h.title, ' ').concat(e.title),
                                  value: e.id,
                                  'data-variant-id': e.id,
                                  'data-price': e.price,
                                  'data-compare-at-price': e.compare_at_price,
                                  disabled: !1 === e.available || !m,
                                }),
                              ],
                            }),
                          })
                        : (0, Ps.jsx)(Ps.Fragment, {});
                    }),
                ],
              }),
            ],
          });
        },
        rc = function (t) {
          t.activeTabItems;
          var n,
            r,
            o = Yl(Us),
            a = Kl(Hs),
            i = ss(),
            l = (0, e.useRef)(null);
          null === l.current && (l.current = a);
          var u = a.typeGroups.filter(function (e) {
              return !0 === e.selectedItem.includeInBundle;
            }).length,
            s = a.typeGroups.find(function (e) {
              var t = e.selectedItem;
              return !!t.selectedVariant && t.includeInBundle;
            }),
            c = 0 === u || !s,
            d = Kl(eu).settings,
            p = d.active_bg_color,
            h = d.bg_color,
            v = function (e) {
              var t;
              if (null !== i && void 0 !== i && null !== (t = i.state) && void 0 !== t && t.editBundleItem && !c) {
                var n = l.current,
                  r = n.typeGroups
                    .filter(function (e) {
                      return (
                        e.selectedItem.includeInBundle &&
                        !!e.selectedItem.selectedVariant &&
                        e.selectedItem.selectedVariant.available
                      );
                    })
                    .map(function (e) {
                      return S(
                        S({}, e.selectedItem),
                        {},
                        { quantity: 1, personsName: n.personsName, parentCollection: n.parentCollection.title }
                      );
                    });
                o(function (e) {
                  return [].concat(f(e), f(r));
                });
              }
            };
          return (0, Ps.jsxs)('div', {
            className: 'relative w-full py-10 xl:pb-0',
            style: { '--bg-color': h, '--active-bg-color': p },
            children: [
              (0, Ps.jsx)(Ls, {
                className: ''.concat(
                  c ? 'btn-disabled' : '',
                  ' mb-7 block w-full rounded border-2 border-solid border-[var(--active-bg-color)] bg-[var(--active-bg-color)] px-12 py-6 text-center text-xl font-bold leading-tight text-[var(--bg-color)] transition-colors [&.btn-disabled]:cursor-not-allowed [&.btn-disabled]:opacity-60 [&:not(.btn-disabled)]:hover:bg-[var(--bg-color)] [&:not(.btn-disabled)]:hover:text-[var(--active-bg-color)]'
                ),
                to: c ? '/size-and-style' : '/current-bundle',
                onClick: function (e) {
                  if (c) e.preventDefault();
                  else {
                    var t = a.typeGroups
                      .filter(function (e) {
                        return (
                          e.selectedItem.includeInBundle &&
                          !!e.selectedItem.selectedVariant &&
                          e.selectedItem.selectedVariant.available
                        );
                      })
                      .map(function (e) {
                        return S(
                          S({}, e.selectedItem),
                          {},
                          { quantity: 1, personsName: a.personsName, parentCollection: a.parentCollection.title }
                        );
                      });
                    o(function (e) {
                      return [].concat(f(e), f(t));
                    });
                  }
                },
                disabled: c,
                children: c
                  ? 'Please Select a Size'
                  : ''.concat(
                      null !== i && void 0 !== i && null !== (n = i.state) && void 0 !== n && n.editBundleItem
                        ? 'Update'
                        : 'Add to Bundle'
                    ),
              }),
              null !== i && void 0 !== i && null !== (r = i.state) && void 0 !== r && r.editBundleItem
                ? (0, Ps.jsxs)(Ls, {
                    className:
                      'mx-auto flex w-full max-w-fit items-center justify-center gap-2.5 text-center text-base font-medium leading-tight',
                    to: '/current-bundle',
                    onClick: v,
                    style: { color: p },
                    children: [
                      (0, Ps.jsx)(Gs, { classes: 'w-3.5 h-auto rotate-180', style: { fill: p } }),
                      'Back to Bundle',
                    ],
                  })
                : (0, Ps.jsxs)(Ls, {
                    className:
                      'mx-auto flex w-full max-w-fit items-center justify-center gap-2.5 text-center text-base font-medium leading-tight',
                    onClick: v,
                    to: '/name-and-age',
                    style: { color: p },
                    children: [(0, Ps.jsx)(Gs, { classes: 'w-3.5 h-auto rotate-180', style: { fill: p } }), 'Previous'],
                  }),
            ],
          });
        },
        oc = function (e) {
          var t = e.layout,
            n = c(Ql(Hs), 2),
            r = n[0],
            o = n[1],
            a = Kl(eu).settings,
            i = a.text_color,
            l = a.bg_color,
            u = a.active_bg_color,
            s = function (e) {
              var t = e.target.value,
                n = r.parentCollection.productTypeLayout.find(function (e) {
                  return e.header === t;
                }).types,
                a = r.typeGroups.map(function (e) {
                  var t = e.selectedItem.selectedProduct.product_type,
                    r = !1;
                  return (
                    n.includes(t) && (r = !0),
                    S(S({}, e), {}, { selectedItem: S(S({}, e.selectedItem), {}, { includeInBundle: r }) })
                  );
                });
              o(function (e) {
                return S(S({}, e), {}, { activeTab: t, typeGroups: a });
              });
            };
          return (0, Ps.jsxs)('div', {
            className: 'mb-6 w-full rounded-md p-4 lg:rounded-lg lg:px-14 lg:py-11',
            style: { '--text-color': i, '--active-bg-color': u, '--bg-color': l, backgroundColor: u },
            children: [
              (0, Ps.jsx)('p', {
                className: 'mb-2.5 text-center font-galano text-sm font-medium opacity-65 lg:text-left lg:text-lg',
                style: { color: l },
                children: 'Choose a Style',
              }),
              (0, Ps.jsx)('div', {
                className: 'flex justify-center gap-2 lg:gap-4',
                children: t.map(function (e) {
                  return (0,
                  Ps.jsx)('button', { className: 'rounded border-2 border-solid p-4 text-center font-galano text-base transition-all hover:font-bold lg:text-xl w-1/'.concat(t.length, ' ').concat(r.activeTab === e.header ? '!bg-[var(--bg-color)] font-bold !text-[var(--text-color)]' : 'font-medium'), style: { color: l, borderColor: l }, onClick: s, value: e.header, children: e.header });
                }),
              }),
            ],
          });
        },
        ac = function (e) {
          var t = e.classes,
            n = e.item,
            r = n.selectedItem.includeInBundle,
            o = c(Ql(Hs), 2),
            a = o[0],
            i = o[1],
            l = Kl(eu).settings,
            u = l.bg_color,
            s = l.active_bg_color;
          return (0, Ps.jsxs)('div', {
            className: 'mb-5 mr-auto flex w-fit cursor-pointer items-center rounded px-3 py-2 outline '
              .concat(r ? 'outline-1 outline-[var(--bg-color)]' : 'outline-2 outline-[var(--bg-color)]', ' ')
              .concat(t),
            style: { '--bg-color': u, '--active-bg-color': s },
            children: [
              (0, Ps.jsx)('input', {
                type: 'checkbox',
                checked: r,
                id: 'bundler-checkbox-'.concat(n.selectedItem.selectedProduct.id),
                onClick: function (e) {
                  return (function (e) {
                    var t = a.typeGroups.map(function (e) {
                      return e.selectedItem.selectedProduct.id === n.selectedItem.selectedProduct.id
                        ? S(S({}, e), {}, { selectedItem: S(S({}, e.selectedItem), {}, { includeInBundle: !r }) })
                        : e;
                    });
                    i(function (e) {
                      return S(S({}, e), {}, { typeGroups: t });
                    });
                  })();
                },
                className:
                  'bundler-custom-checkbox !h-5 !w-5 !cursor-pointer !appearance-none rounded-[3px] border-solid border-[var(--bg-color)] focus:border-[var(--bg-color)] '.concat(
                    r ? '!border' : ' !border-2 '
                  ),
              }),
              (0, Ps.jsx)('label', {
                className:
                  'mb-0 font-galano !text-sm !normal-case leading-tight !tracking-normal text-[var(--bg-color)] hover:cursor-pointer xl:!text-base '.concat(
                    r ? 'font-medium' : ' font-bold'
                  ),
                htmlFor: 'bundler-checkbox-'.concat(n.selectedItem.selectedProduct.id),
                children: 'Include in Bundle',
              }),
            ],
          });
        },
        ic = function (t) {
          var n = t.state,
            r = t.item,
            o = t.classes,
            a = Kl(Hs),
            i = n.personsName,
            l = (0, e.useRef)(null);
          null === l.current && (l.current = a);
          var u = Kl(eu),
            s = u.title,
            c = u.settings.bg_color,
            f = r.selectedItem.selectedProduct,
            d = f.tags,
            p = f.product_type,
            h = f.variants[0].price,
            v = d.find(function (e) {
              return e.includes('category_title:');
            })
              ? d
                  .find(function (e) {
                    return e.includes('category_title:');
                  })
                  .split(':')[1]
              : p;
          return (0, Ps.jsxs)('div', {
            className: o,
            children: [
              (0, Ps.jsx)('h1', {
                class: 'mb-2 hidden font-galano text-base font-bold capitalize leading-tight tracking-normal lg:block',
                style: { color: c },
                children: s,
              }),
              (0, Ps.jsxs)('h2', {
                class:
                  'mb-1.5 font-galano text-xl font-bold leading-tight tracking-normal xl:mb-2 xl:text-3xl xl:leading-tight',
                style: { color: c },
                children: ['Customize ', i ? ''.concat(i, "'s") : 'Your', ' ', v],
              }),
              (0, Ps.jsxs)('p', {
                className: 'mb-5 text-left font-galano text-lg font-bold leading-tight xl:text-xl xl:leading-tight',
                style: { color: c },
                children: ['$', h],
              }),
            ],
          });
        },
        lc = function () {
          var t = (0, e.useRef)([]),
            n = Kl(tu),
            r = Kl(Hs),
            o = Kl(eu).settings,
            a = o.bg_color,
            i = o.active_bg_color,
            l = n.find(function (e) {
              return r.parentCollection.title === e.title;
            }),
            u = r.parentCollection.productTypeLayout,
            s = r.typeGroups;
          if (l && l.productTypeLayout) {
            var c = l.productTypeLayout.find(function (e) {
              return e.header === r.activeTab;
            }).types;
            s = c
              .map(function (e) {
                return r.typeGroups.find(function (t) {
                  return t.filteredCollection.title.trim() === e.trim();
                });
              })
              .filter(function (e) {
                return void 0 !== e;
              });
          }
          t.current = s.map(function (n, r) {
            var o;
            return null !== (o = t.current[r]) && void 0 !== o ? o : (0, e.createRef)();
          });
          var f = function (e) {
            var n, r;
            null === t ||
              void 0 === t ||
              null === (n = t.current[e]) ||
              void 0 === n ||
              null === (r = n.current) ||
              void 0 === r ||
              r.slick.slickGoTo(0, !1);
          };
          return (0, Ps.jsxs)('div', {
            className: 'bundle-page-wrapper relative overflow-hidden',
            style: { backgroundColor: a },
            children: [
              (0, Ps.jsx)(Vs, {}),
              (0, Ps.jsxs)('div', {
                className: 'relative z-10 mx-auto max-w-7xl px-14 py-16',
                children: [
                  s.map(function (e, n) {
                    return (0,
                    Ps.jsx)('div', { className: s.length > 1 && n + 1 !== s.length ? 'mb-20' : '', children: (0, Ps.jsxs)('div', { className: 'grid grid-cols-2 gap-10', id: 'item-'.concat(n), children: [(0, Ps.jsx)(Xs, { item: e, index: n, refParam: t.current[n] }), (0, Ps.jsxs)('div', { class: 'flex flex-col items-center justify-start', children: [u && u.length > 1 && n < 1 && (0, Ps.jsx)(oc, { layout: u }), (0, Ps.jsxs)('div', { className: 'relative w-full rounded-lg px-14 py-11', style: { backgroundColor: i }, children: [(0, Ps.jsx)(ic, { item: e, state: r }), s.length > 1 && (0, Ps.jsx)(ac, { classes: '', item: e }), (0, Ps.jsx)(Js, { item: e, itemIndex: n, onChangePrint: f }), (0, Ps.jsx)(nc, { item: e, activeTabItemsLength: s.length, index: n })] }), s.length < 2 && (0, Ps.jsx)(rc, { activeTabItems: s })] })] }) });
                  }),
                  s.length > 1 &&
                    (0, Ps.jsx)('div', {
                      class: 'mx-auto w-full max-w-2xl',
                      children: (0, Ps.jsx)(rc, { activeTabItems: s }),
                    }),
                ],
              }),
              (0, Ps.jsx)(zs, {}),
            ],
          });
        },
        uc = function (t) {
          t.state, t.item;
          var n = t.classes,
            r = Yl(Us),
            o = Kl(Hs),
            a = ss(),
            i = (0, e.useRef)(null);
          null === i.current && (i.current = o);
          var l = o.typeGroups.filter(function (e) {
              return !0 === e.selectedItem.includeInBundle;
            }).length,
            u = o.typeGroups.find(function (e) {
              var t = e.selectedItem;
              return !!t.selectedVariant && t.includeInBundle;
            }),
            s = 0 === l || !u,
            c = Kl(eu),
            d = c.title,
            p = c.settings,
            h = p.text_color,
            v = p.active_bg_color,
            m = Kl(Us);
          return (0, Ps.jsxs)('div', {
            className: n,
            children: [
              (0, Ps.jsx)('h1', {
                className:
                  'mb-0 text-center font-galano text-4xl font-bold capitalize leading-tight tracking-normal xl:text-5xl xl:leading-tight',
                style: { color: h },
                children: d,
              }),
              m.length > 0
                ? (0, Ps.jsxs)(Ls, {
                    className:
                      'mx-auto flex w-full max-w-fit items-center justify-center gap-2.5 text-center font-galano text-lg font-medium leading-tight xl:hidden xl:text-2xl xl:leading-tight',
                    style: { color: v },
                    to: '/current-bundle',
                    onClick: function (e) {
                      var t;
                      if (
                        null !== a &&
                        void 0 !== a &&
                        null !== (t = a.state) &&
                        void 0 !== t &&
                        t.editBundleItem &&
                        !s
                      ) {
                        var n = i.current,
                          o = n.typeGroups
                            .filter(function (e) {
                              return (
                                e.selectedItem.includeInBundle &&
                                !!e.selectedItem.selectedVariant &&
                                e.selectedItem.selectedVariant.available
                              );
                            })
                            .map(function (e) {
                              return S(
                                S({}, e.selectedItem),
                                {},
                                { quantity: 1, personsName: n.personsName, parentCollection: n.parentCollection.title }
                              );
                            });
                        r(function (e) {
                          return [].concat(f(e), f(o));
                        });
                      }
                    },
                    children: ['View Bundle', (0, Ps.jsx)(Gs, { classes: 'w-3.5 h-auto', style: { fill: v } })],
                  })
                : '',
            ],
          });
        },
        sc = function () {
          var t = (0, e.useRef)([]),
            n = Kl(tu),
            r = Kl(Hs),
            o = Kl(eu).settings,
            a = o.bg_color,
            i = o.active_bg_color,
            l = n.find(function (e) {
              return r.parentCollection.title === e.title;
            }),
            u = r.parentCollection.productTypeLayout,
            s = r.typeGroups;
          if (l && l.productTypeLayout) {
            var c = l.productTypeLayout.find(function (e) {
              return e.header === r.activeTab;
            }).types;
            s = c
              .map(function (e) {
                return r.typeGroups.find(function (t) {
                  return t.filteredCollection.title.trim() === e.trim();
                });
              })
              .filter(function (e) {
                return void 0 !== e;
              });
          }
          t.current = s.map(function (n, r) {
            var o;
            return null !== (o = t.current[r]) && void 0 !== o ? o : (0, e.createRef)();
          });
          var f = function (e) {
            var n, r;
            null === t ||
              void 0 === t ||
              null === (n = t.current[e]) ||
              void 0 === n ||
              null === (r = n.current) ||
              void 0 === r ||
              r.slick.slickGoTo(0, !1);
          };
          return (0, Ps.jsxs)('div', {
            className: 'bundle-page-wrapper relative overflow-hidden px-4 py-10',
            style: { backgroundColor: a },
            children: [
              (0, Ps.jsx)(Vs, {}),
              (0, Ps.jsx)('div', {
                className: 'relative z-10',
                children: (0, Ps.jsxs)('div', {
                  className: 'overflow-visible',
                  children: [
                    s.map(function (e, n) {
                      return (0,
                      Ps.jsxs)('div', { className: s.length > 1 && n + 1 !== s.length ? 'mb-10' : '', children: [n > 0 ? '' : (0, Ps.jsx)(uc, { state: r, item: e, classes: 'flex flex-col items-center justify-center gap-4 mb-10' }), u && u.length > 1 && n < 1 && (0, Ps.jsx)(oc, { layout: u }), (0, Ps.jsxs)('div', { class: 'overflow-hidden rounded-2xl', style: { backgroundColor: i }, id: 'item-'.concat(n), children: [(0, Ps.jsx)(Xs, { item: e, index: n, refParam: t.current[n] }), (0, Ps.jsxs)('div', { class: 'w-full px-4 py-5', children: [(0, Ps.jsx)(ic, { item: e, state: r }), s.length > 1 && (0, Ps.jsx)(ac, { classes: '', item: e }), (0, Ps.jsx)(Js, { item: e, itemIndex: n, onChangePrint: f }), (0, Ps.jsx)(nc, { item: e, activeTabItemsLength: s.length, index: n })] })] })] });
                    }),
                    (0, Ps.jsx)(rc, { activeTabItems: s }),
                  ],
                }),
              }),
              (0, Ps.jsx)(zs, {}),
            ],
          });
        },
        cc = function () {
          return window.matchMedia('(min-width: 1025px)').matches ? (0, Ps.jsx)(lc, {}) : (0, Ps.jsx)(sc, {});
        },
        fc = function (e) {
          var t = e.classes,
            n = Kl(Us),
            r = Kl(eu).settings,
            o = r.active_bg_color,
            a = r.text_color,
            i = r.bg_color;
          return (0, Ps.jsxs)('div', {
            className: ''.concat(
              t,
              ' relative z-10 mb-10 flex items-center justify-center gap-3 border-0 px-4 text-center xl:mb-0 xl:justify-start xl:border-b-2 xl:border-solid xl:border-eggnog/40 xl:px-0 xl:pb-6'
            ),
            style: { '--active-bg-color': o, '--text-color': a, '--bg-color': i },
            children: [
              (0, Ps.jsx)('h1', {
                className:
                  'mb-0 text-center font-galano text-3xl font-bold capitalize leading-tight tracking-normal text-[var(--text-color)] lg:text-[var(--bg-color)] xl:text-4xl xl:leading-tight',
                children: 'Your Bundle',
              }),
              (0, Ps.jsx)('div', {
                className:
                  'flex h-10 w-10 items-center justify-center rounded-full bg-fir/20 p-2 text-[var(--text-color)] lg:bg-eggnog/20 lg:text-[var(--bg-color)]',
                children: (0, Ps.jsx)('span', {
                  className: 'mt-0.5 font-galano text-lg font-bold leading-tight xl:text-xl xl:leading-tight',
                  children: n.length,
                }),
              }),
            ],
          });
        },
        dc = n(110),
        pc = n.n(dc),
        hc = (function () {
          var e = l(
            a().mark(function e(t) {
              var n, r;
              return a().wrap(function (e) {
                for (;;)
                  switch ((e.prev = e.next)) {
                    case 0:
                      (n = { items: [] }),
                        t.forEach(function (e) {
                          var t = {
                            quantity: e.quantity ? e.quantity : 1,
                            id: e.selectedVariant.id,
                            properties: { _personsName: e.personsName, _bundleItem: !0, _bundleSource: 'Holiday' },
                          };
                          n.items.push(t);
                        });
                      try {
                        (r = new Event('addBundleToCart')),
                          pc().ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            dataType: 'json',
                            data: n,
                            success: function (e) {
                              return document.dispatchEvent(r);
                            },
                            error: function (e) {
                              return console.log(e);
                            },
                          });
                      } catch (o) {
                        console.log(o);
                      }
                    case 3:
                    case 'end':
                      return e.stop();
                  }
              }, e);
            })
          );
          return function (t) {
            return e.apply(this, arguments);
          };
        })(),
        vc = hc,
        mc = function (e) {
          var t = e.classes,
            n = e.setBundleAdded,
            r = Kl(Us),
            o = Kl(eu).settings,
            a = o.active_bg_color,
            i = o.text_color,
            l = o.bundle_bg_color,
            u = o.bg_color,
            s = Xl(Hs),
            c = Xl(Us),
            f = Xl(Hs),
            d = r.map(function (e) {
              return parseInt(e.selectedVariant.price) * e.quantity;
            }),
            p = 0;
          d.length > 0 &&
            (p = d
              .reduce(function (e, t) {
                return e + t;
              })
              .toFixed(2));
          return (0, Ps.jsxs)('div', {
            className: ''.concat(
              t,
              ' relative z-10 hidden h-fit flex-col items-center justify-center gap-5 rounded-[20px] bg-[var(--bundle-bg-color)] p-9 xl:flex'
            ),
            style: { '--bundle-bg-color': l, '--text-color': i, '--active-bg-color': a, '--bg-color': u },
            children: [
              (0, Ps.jsx)(fc, { classes: 'w-full' }),
              (0, Ps.jsxs)('div', {
                className: 'flex w-full items-center justify-between pt-4',
                children: [
                  (0, Ps.jsx)('p', {
                    className: 'm-0 font-galano text-lg font-bold text-[var(--bg-color)]',
                    children: 'Subtotal',
                  }),
                  (0, Ps.jsxs)('p', {
                    className: 'm-0 font-galano text-lg font-bold text-[var(--bg-color)]',
                    children: ['$', p],
                  }),
                ],
              }),
              r.length < 20
                ? (0, Ps.jsx)(Ls, {
                    className:
                      'block w-full rounded  border-2 border-solid border-[var(--bg-color)] bg-[var(--text-color)] py-6 text-center font-galano text-xl font-bold leading-tight text-[var(--bg-color)] transition-colors hover:bg-[var(--bg-color)] hover:text-[var(--text-color)]',
                    onClick: function () {
                      return s();
                    },
                    to: '/name-and-age',
                    children: r.length ? '+ Add Another Member' : '+ Add a Family Member',
                  })
                : (0, Ps.jsx)('button', {
                    className:
                      'block w-full rounded  border-2 border-solid border-[var(--bg-color)] bg-[var(--text-color)] py-6 text-center font-galano text-xl font-bold leading-tight text-[var(--bg-color)] transition-colors hover:cursor-not-allowed',
                    disabled: !0,
                    children: 'Max quantity in bundle',
                  }),
              r.length > 0
                ? (0, Ps.jsx)('button', {
                    className:
                      'block w-full rounded border-2 border-solid border-[var(--bg-color)] bg-[var(--bg-color)] px-12 py-6 text-center font-galano text-xl font-bold leading-tight text-[var(--text-color)] transition-colors hover:bg-[var(--text-color)] hover:text-[var(--bg-color)]',
                    onClick: function () {
                      vc(r).then(function () {
                        c(), f(), n(!0);
                      });
                    },
                    children: 'Add Bundle to Cart',
                  })
                : '',
            ],
          });
        },
        gc = function (e) {
          var t = e.classes,
            n = Kl(eu).settings.bg_color;
          return (0, Ps.jsx)('svg', {
            className: t,
            width: '18',
            height: '2',
            viewBox: '0 0 18 2',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg',
            children: (0, Ps.jsx)('path', {
              d: 'M1 1H17',
              stroke: n,
              'stroke-width': '2',
              'stroke-linecap': 'round',
              fill: '{% if color %}{{ color }}{% else %}#3D3C3D{% endif %}',
            }),
          });
        },
        wc = function (e) {
          var t = e.classes,
            n = Kl(eu).settings.bg_color;
          return (0, Ps.jsxs)('svg', {
            className: t,
            width: '18',
            height: '18',
            viewBox: '0 0 18 18',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg',
            children: [
              (0, Ps.jsx)('path', {
                d: 'M1 9H17',
                stroke: n,
                'stroke-width': '2',
                'stroke-linecap': 'round',
                fill: '{% if color %}{{ color }}{% else %}#3D3C3D{% endif %}',
              }),
              (0, Ps.jsx)('path', {
                d: 'M9 17L9 1',
                stroke: n,
                'stroke-width': '2',
                'stroke-linecap': 'round',
                fill: '{% if color %}{{ color }}{% else %}#3D3C3D{% endif %}',
              }),
            ],
          });
        },
        yc = function (e) {
          var t = e.item,
            n = e.index,
            r = c(Ql(Us), 2),
            o = r[0],
            a = r[1],
            i = function (e) {
              if (!((1 === t.quantity && 'minus' === e) || (10 === t.quantity && 'plus' === e))) {
                var r = t.quantity;
                'plus' === e ? (r = t.quantity + 1) : 'minus' === e && (r = t.quantity - 1);
                var i = o.map(function (e, t) {
                  return n === t ? S(S({}, e), {}, { quantity: r }) : e;
                });
                a(i);
              }
            };
          return (0, Ps.jsxs)('div', {
            className:
              'bundle-action-button max-w-1/2 m-0 flex h-fit w-full items-center justify-between rounded-[3px] border border-solid border-[var(--bg-color)] bg-[var(--active-bg-color)] p-0',
            children: [
              (0, Ps.jsx)('button', {
                className: 'h-full p-0 py-1.5 pl-1.5 leading-none',
                onClick: function () {
                  return i('minus');
                },
                children: (0, Ps.jsx)(gc, { classes: 'block w-[9px] h-auto m-auto' }),
              }),
              (0, Ps.jsx)('label', {
                className: 'pointer-events-none mb-0 py-1.5 text-center',
                children: (0, Ps.jsx)('input', {
                  className:
                    'bundle-upsell-quantity-input pointer-events-none w-fit border-0 p-0 text-center font-galano text-xs font-medium leading-normal text-[var(--bg-color)]',
                  type: 'number',
                  name: 'quantity',
                  min: '1',
                  max: '10',
                  readOnly: !0,
                  value: t.quantity,
                }),
              }),
              (0, Ps.jsx)('button', {
                className: 'h-full p-0 py-1.5 pr-1.5 leading-none',
                onClick: function () {
                  return i('plus');
                },
                children: (0, Ps.jsx)(wc, { classes: 'block w-2.5 h-auto m-auto' }),
              }),
            ],
          });
        },
        bc = function (t) {
          var n = t.item,
            r = t.index,
            o = Yl(Us),
            a = Kl(ru),
            i = Kl(tu),
            l = Yl(Hs),
            u = c((0, e.useState)(''), 2),
            s = u[0],
            f = u[1],
            d = Kl(eu).settings,
            p = d.bg_color,
            h = d.text_color,
            v = d.active_bg_color,
            m = n.selectedProduct,
            g = m.images,
            w = m.title,
            y = n.selectedVariant,
            b = y.title,
            x = y.id,
            k = y.price,
            S = n.personsName,
            _ = n.parentCollection;
          return (0, Ps.jsx)(Ps.Fragment, {
            children: (0, Ps.jsx)('li', {
              className:
                'bundle-item m-0 rounded-2xl bg-[var(--active-bg-color)] p-4 opacity-100 transition-opacity duration-700 js-bundler-item-'
                  .concat(x, ' ')
                  .concat(s),
              style: { '--bg-color': p, '--active-bg-color': v, '--text-color': h },
              children: (0, Ps.jsxs)('div', {
                className: 'flex items-start justify-center gap-5 xl:flex-col xl:items-center xl:justify-start',
                children: [
                  (0, Ps.jsx)('img', {
                    src: g[0].src,
                    alt: w,
                    className: 'aspect-square h-auto w-full max-w-[40%] rounded-md object-cover xl:max-w-full',
                  }),
                  (0, Ps.jsxs)('div', {
                    className: 'grow',
                    children: [
                      (0, Ps.jsxs)('h6', {
                        className:
                          'mb-2 font-galano text-base font-bold normal-case leading-tight tracking-normal text-[var(--bg-color)] xl:text-lg xl:leading-tight',
                        children: [
                          '' !== S && (0, Ps.jsxs)('span', { className: '!font-bold', children: [S, "'s "] }),
                          w,
                        ],
                      }),
                      'Default Title' !== b &&
                        (0, Ps.jsxs)('p', {
                          className:
                            'mb-2 font-galano text-sm font-medium leading-tight text-[var(--bg-color)] xl:text-base xl:leading-tight',
                          children: ['Size: ', b],
                        }),
                      (0, Ps.jsxs)('p', {
                        className:
                          'mb-2.5 font-galano text-sm font-medium leading-tight text-[var(--bg-color)] xl:text-base xl:leading-tight',
                        children: ['$', k],
                      }),
                      (0, Ps.jsxs)('div', {
                        className: 'flex w-full items-center justify-center gap-1.5',
                        children: [
                          n.swatches
                            ? (0, Ps.jsx)(Ls, {
                                className:
                                  'bundle-action-button max-w-1/2 m-0 h-fit w-full rounded-[3px] border border-solid border-[var(--bg-color)] bg-[var(--active-bg-color)] p-1.5 text-center font-galano text-xs font-medium leading-normal text-[var(--bg-color)] transition-colors hover:bg-[var(--bg-color)] hover:text-[var(--active-bg-color)]',
                                onClick: function () {
                                  return (function (e) {
                                    var t,
                                      n = e.selectedProduct.id,
                                      u = e.selectedVariant,
                                      s = i.find(function (e) {
                                        return e.title === _;
                                      });
                                    if (s.productTypeLayout) {
                                      var c = e.selectedProduct.product_type,
                                        f = {};
                                      s.productTypeLayout.forEach(function (e) {
                                        return e.types.forEach(function (t) {
                                          t === c && (f = e);
                                        });
                                      }),
                                        (t = Ws(s, a, S, n, u, f));
                                    } else t = Ws(s, a, S, n, u);
                                    l(t),
                                      o(function (e) {
                                        return e.filter(function (e, t) {
                                          return t !== r;
                                        });
                                      });
                                  })(n);
                                },
                                to: '/size-and-style',
                                state: { editBundleItem: !0 },
                                children: 'Edit',
                              })
                            : (0, Ps.jsx)(yc, { item: n, index: r }),
                          (0, Ps.jsx)('button', {
                            className:
                              'bundle-action-button max-w-1/2 m-0 h-fit w-full rounded-[3px] border border-solid border-[var(--bg-color)] bg-[var(--active-bg-color)] p-1.5 text-center font-galano text-xs font-medium leading-normal text-[var(--bg-color)] transition-colors hover:bg-[var(--bg-color)] hover:text-[var(--active-bg-color)]',
                            onClick: function (e) {
                              return (
                                f('!opacity-0'),
                                void setTimeout(function () {
                                  o(function (e) {
                                    return e.filter(function (e, t) {
                                      return t !== r;
                                    });
                                  }),
                                    f('');
                                }, 1e3)
                              );
                            },
                            children: 'Remove',
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
            }),
          });
        },
        xc = function () {
          var e = Kl(Us),
            t = Kl(eu).settings,
            n = t.active_bg_color,
            r = t.text_color,
            o = t.bg_color,
            a = Xl(Hs);
          return (0, Ps.jsxs)('div', {
            style: { '--bg-color': o, '--active-bg-color': n, '--text-color': r },
            children: [
              e.length
                ? (0, Ps.jsx)('ul', {
                    className: 'm-0 grid list-none grid-cols-1 gap-4 p-0 xl:grid-cols-2',
                    children: e.map(function (e, t) {
                      return (0, Ps.jsx)(bc, { item: e, index: t });
                    }),
                  })
                : (0, Ps.jsx)('p', {
                    className: 'mb-0 text-center text-xl font-medium leading-tight text-[var(--text-color)] xl:mt-20',
                    children: 'Your bundle is empty. Add a family member to get started.',
                  }),
              e.length < 20
                ? (0, Ps.jsx)(Ls, {
                    className:
                      'mt-8 block w-full rounded border-2 border-solid border-[var(--text-color)] bg-[var(--bg-color)] p-6 text-center font-galano text-xl font-bold leading-tight text-[var(--text-color)] transition-colors hover:bg-[var(--text-color)] hover:text-[var(--bg-color)] xl:hidden',
                    onClick: function () {
                      return a();
                    },
                    to: '/name-and-age',
                    children: e.length ? '+ Add Another Member' : '+ Add a Family Member',
                  })
                : (0, Ps.jsx)('button', {
                    className:
                      'mt-8 block w-full rounded border-2 border-solid border-[var(--text-color)] bg-[var(--bg-color)] p-6 text-center font-galano text-xl font-bold leading-tight text-[var(--text-color)] opacity-60 transition-colors hover:cursor-not-allowed xl:hidden',
                    disabled: !0,
                    children: 'Max quantity in bundle',
                  }),
            ],
          });
        },
        kc = Gl({
          key: 'activeUpsell',
          default: { visible: !1, upsell: {} },
          effects_UNSTABLE: [Jl(''.concat(Zl, 'activeUpsell'))],
        }),
        Sc = function (e) {
          var t,
            n,
            r = e.upsell,
            o = e.bundleLength,
            a = (e.stopNaviation, Yl(kc)),
            i = Kl(eu).settings.bg_color;
          return r.products.length < 1
            ? null
            : (0, Ps.jsx)('li', {
                className: 'lg:max-w-72 m-0 px-3 lg:px-0',
                children: (0, Ps.jsxs)('div', {
                  class: 'flex flex-col items-center justify-start gap-4',
                  children: [
                    (0, Ps.jsx)('img', {
                      class: 'aspect-square w-full rounded-md object-cover object-center lg:rounded-lg',
                      src:
                        null === (t = r.products[0]) || void 0 === t || null === (n = t.images[0]) || void 0 === n
                          ? void 0
                          : n.src,
                      alt: r.products[0].title,
                    }),
                    (0, Ps.jsxs)('div', {
                      class: 'relative my-auto flex w-full flex-col',
                      children: [
                        (0, Ps.jsx)('p', {
                          class: 'mb-1.5 text-center font-galano text-base font-bold leading-tight lg:leading-tight',
                          style: { color: i },
                          children: r.title,
                        }),
                        (0, Ps.jsxs)('p', {
                          class: 'mb-2.5 text-center font-galano text-sm font-medium leading-tight lg:leading-tight',
                          style: { color: i },
                          children: ['$', r.products[0].variants[0].price],
                        }),
                        o < 20
                          ? (0, Ps.jsx)('button', {
                              class:
                                'w-full rounded border-2 border-solid border-[var(--bg-color)] py-2.5 font-galano text-sm font-bold leading-tight text-[var(--bg-color)] transition-colors hover:bg-[var(--bg-color)] hover:text-[var(--text-color)] lg:leading-tight',
                              onClick: function () {
                                document.body.classList.add('overflow-hidden'), a({ visible: !0, upsell: r });
                              },
                              children: 'Choose Print',
                            })
                          : (0, Ps.jsx)('button', {
                              class:
                                'w-full rounded border-2 border-solid border-[var(--text-color)] py-2.5 font-galano text-sm font-bold leading-tight text-[var(--text-color)] disabled:opacity-60 lg:leading-tight',
                              disabled: !0,
                              children: 'Max quantity in bundle',
                            }),
                      ],
                    }),
                  ],
                }),
              });
        };
      function _c(e) {
        var t = e.activeProduct,
          n = e.setActiveSize,
          r = e.activeSize,
          o = Kl(eu).settings,
          a = o.text_color,
          i = o.bg_color;
        if (!t.product_type.includes('Luxe Bow')) return null;
        var l = '\n    .bundler-variant-select-label {\n      color: '
            .concat(
              i,
              ' !important;\n    }\n\n    .bundler-variant-select-label:not(.bundler-variant-select-label-disabled) {\n      box-shadow: inset 0 0 0 1px '
            )
            .concat(
              i,
              ' !important;\n    }\n\n    .bundler-variant-select-label:not(.bundler-variant-select-label-disabled):hover {\n      box-shadow: inset 0 0 0 2px '
            )
            .concat(
              i,
              ' !important;\n    }\n\n    .pdp-variant-select-label.pdp-variant-select-label-disabled.bundler-variant-select-label-disabled {\n      color: '
            )
            .concat(i, ' !important;\n      box-shadow: inset 0 0 0 1px ')
            .concat(
              i,
              ' !important;\n      opacity: 0.5;\n    }\n\n    .pdp-variant-select-label-disabled.bundler-variant-select-label-disabled:before {\n      background-color: '
            )
            .concat(
              i,
              ' !important;\n    }\n\n    .bundler-variant-select-label:focus {\n      box-shadow: inset 0 0 0 3px '
            )
            .concat(
              i,
              ' !important;\n    }\n\n    .bundler-variant-select-label-active {\n      box-shadow: inset 0 0 0 3px '
            )
            .concat(i, ' !important;\n      background-color: ')
            .concat(i, ' !important;\n      color: ')
            .concat(a, ' !important;\n    }\n  '),
          u = t.variants.length >= 3;
        return (0, Ps.jsx)('div', {
          className: '',
          children: (0, Ps.jsxs)('ul', {
            className: 'm-0 mb-8  grid list-none  justify-center gap-x-1.5 gap-y-3 '.concat(
              u ? 'grid-cols-3' : 'grid-cols-2'
            ),
            children: [
              (0, Ps.jsx)('style', { children: l }),
              t.variants &&
                t.variants.map(function (e, o) {
                  var a = e.title;
                  return (0, Ps.jsx)('li', {
                    className: 'm-0',
                    children: (0, Ps.jsxs)('label', {
                      class: 'pdp-variant-select-label bundler-variant-select-label text-center !font-galano '
                        .concat(r === a ? ' bundler-variant-select-label-active !font-bold' : '')
                        .concat(
                          !1 === e.available
                            ? ' pdp-variant-select-label-disabled bundler-variant-select-label-disabled'
                            : ''
                        ),
                      onClick: function (e) {
                        n(a);
                      },
                      'data-variant-id': e.id,
                      tabindex: 1,
                      children: [
                        e.title.replaceAll('*', ''),
                        !1 === e.available && (0, Ps.jsx)('div', { class: 'oos-horizontal-line' }),
                        (0, Ps.jsx)('input', {
                          type: 'radio',
                          class: 'sr-only',
                          name: ''.concat(t.title, ' ').concat(e.title),
                          value: e.id,
                          'data-variant-id': e.id,
                          'data-price': e.price,
                          'data-compare-at-price': e.compare_at_price,
                          disabled: !1 === e.available,
                        }),
                      ],
                    }),
                  });
                }),
            ],
          }),
        });
      }
      var Ec = function () {
          var t = c(Ql(kc), 2),
            n = t[0],
            r = n.visible,
            o = n.upsell,
            a = t[1],
            i = c((0, e.useState)(o.products[0]), 2),
            l = i[0],
            u = i[1],
            s = c((0, e.useState)(''), 2),
            d = s[0],
            p = s[1],
            h = Yl(Us),
            v = Kl(ru),
            m = Kl(eu).settings,
            g = m.text_color,
            w = m.bundle_bg_color,
            y = m.active_bg_color,
            b = m.bg_color,
            x = l.tags.find(function (e) {
              return e.includes('print_tag:');
            }),
            k = l.title.split(' - ')[0],
            S = o.products[0].tags.find(function (e) {
              return e.includes('category_title:');
            })
              ? o.products[0].tags
                  .find(function (e) {
                    return e.includes('category_title:');
                  })
                  .split(':')[1]
              : o.products[0].product_type,
            _ = function () {
              document.body.classList.remove('overflow-hidden'), a({ visible: !1, upsell: {} });
            },
            E =
              l.variants.find(function (e) {
                return e.title === d;
              }) || l.variants[0],
            C = v.filter(function (e) {
              var t = e.printTag.replaceAll('/', '-').replaceAll(' ', '-').replaceAll("'", '').toLowerCase();
              return o.products.find(function (e) {
                var n = e.tags.find(function (e) {
                  return e.toLowerCase().includes('print_tag:');
                });
                return !!n && n.replaceAll('/', '-').replaceAll(' ', '-').replaceAll("'", '').toLowerCase() === t;
              });
            }),
            T = l.product_type.includes('Luxe Bow');
          return (0, Ps.jsxs)('div', {
            class: ''.concat(r ? 'relative z-[1003]' : 'hidden', ' '),
            children: [
              (0, Ps.jsx)('div', {
                className: r ? 'fixed bottom-0 left-0 right-0 top-0 z-[1002] bg-white opacity-40' : 'hidden',
                onClick: _,
              }),
              (0, Ps.jsx)('div', {
                className: 'fixed bottom-0 left-0 right-0 top-0 z-[1003] mx-auto max-w-fit overflow-auto',
                style: { '--bundle-bg-color': w, '--text-color': g, '--active-bg-color': y, '--bg-color': b },
                children: (0, Ps.jsx)('div', {
                  className: 'flex min-h-full items-stretch rounded-lg md:items-center md:justify-center',
                  children: (0, Ps.jsxs)('div', {
                    className: r
                      ? ' no-scrollbar relative overflow-scroll rounded-lg px-5 py-12 text-center md:h-[95vh] md:w-full md:max-w-md'
                      : 'hidden',
                    style: { backgroundColor: y },
                    children: [
                      (0, Ps.jsx)('button', {
                        className: 'absolute right-0 top-0 p-4',
                        onClick: _,
                        children: (0, Ps.jsx)(ec, { classes: 'w-6 h-6 stroke-eggnog', pathClasses: 'stroke-eggnog' }),
                      }),
                      (0, Ps.jsxs)('h6', {
                        className: 'mb-1.5 font-galano text-2xl font-medium normal-case tracking-normal',
                        style: { color: b },
                        children: ['Pick a Print for Your ', S],
                      }),
                      (0, Ps.jsxs)('p', {
                        className: 'mb-4 font-galano text-base font-medium',
                        style: { color: b },
                        children: ['$', l.variants[0].price],
                      }),
                      (0, Ps.jsx)('img', {
                        className: 'mx-auto mb-4 aspect-square h-auto w-full rounded-lg object-cover object-center',
                        src: l.images[0].src,
                        alt: l.title,
                      }),
                      (0, Ps.jsx)('p', {
                        className: 'font-600 mb-4 font-galano text-sm font-medium',
                        style: { color: b },
                        children: k,
                      }),
                      (0, Ps.jsx)('fieldset', {
                        className: 'm-0 mb-4 flex list-none flex-wrap justify-start gap-1 border-0 p-0 xl:gap-2',
                        children: C.map(function (e) {
                          return (0, Ps.jsxs)('label', {
                            className:
                              'm-0 flex h-16 w-16 items-center justify-center rounded-full border border-solid p-[3px] transition-opacity hover:cursor-pointer hover:opacity-80 xl:h-[74px] xl:w-[74px] xl:p-1',
                            style: { borderColor: e.printTag === x ? b : 'transparent' },
                            onClick: function () {
                              return (function (e) {
                                var t = e.printTag
                                    .replaceAll('/', '-')
                                    .replaceAll(' ', '-')
                                    .replaceAll("'", '')
                                    .toLowerCase(),
                                  n = o.products.find(function (e) {
                                    return (
                                      e.tags
                                        .find(function (e) {
                                          return e.toLowerCase().includes('print_tag:');
                                        })
                                        .replaceAll('/', '-')
                                        .replaceAll(' ', '-')
                                        .replaceAll("'", '')
                                        .toLowerCase() === t
                                    );
                                  });
                                u(n);
                              })(e);
                            },
                            children: [
                              (0, Ps.jsx)('img', {
                                src: e.swatch,
                                alt: ''.concat(e.printTag.split(':')[1], ' print swatch'),
                                className: 'h-full w-full rounded-full bg-white',
                              }),
                              (0, Ps.jsx)('input', {
                                type: 'radio',
                                className: 'pointer-events-none fixed opacity-0',
                                name: 'color',
                                value: e.printTag,
                              }),
                            ],
                          });
                        }),
                      }),
                      T,
                      (0, Ps.jsx)(_c, { activeProduct: l, activeSize: d, setActiveSize: p }),
                      (T && '' === d) || !E.available
                        ? (0, Ps.jsx)('button', {
                            className:
                              'block w-full rounded border-2 border-solid border-[var(--bg-color)] bg-[var(--bg-color)] px-12 py-6 text-center text-xl font-bold leading-tight text-[var(--text-color)] transition-colors [&:disabled]:opacity-60',
                            disabled: !0,
                            children: T && E.available ? 'Select a Size' : 'Out of Stock',
                          })
                        : (0, Ps.jsx)(Ls, {
                            className:
                              'block w-full rounded border-2 border-solid border-[var(--bg-color)] bg-[var(--bg-color)] px-12 py-6 text-center text-xl font-bold leading-tight text-[var(--text-color)] transition-colors hover:bg-[var(--text-color)] hover:text-[var(--bg-color)]',
                            to: '/current-bundle',
                            onClick: function (e) {
                              e.preventDefault(),
                                h(function (e) {
                                  return [].concat(f(e), [
                                    { quantity: 1, personsName: '', selectedProduct: l, selectedVariant: E },
                                  ]);
                                }),
                                document.body.classList.remove('overflow-hidden'),
                                a({ visible: !1, upsell: {} });
                            },
                            children: 'Add to Bundle',
                          }),
                    ],
                  }),
                }),
              }),
            ],
          });
        },
        Cc = function () {
          var e = Kl(eu).settings,
            t = e.upsell_header,
            n = e.text_color,
            r = e.bg_color,
            o = e.active_bg_color,
            a = Kl(kc),
            i = Kl(nu),
            l = Kl(Us),
            u = i.filter(function (e) {
              return 'false' === e.ageGroupOnly;
            }),
            s =
              '\n    .slick-dots {\n      margin-bottom: 24px !important;\n      position: relative !important;\n    }\n    .slick-dots li button::before {\n      border-color: '
                .concat(
                  n,
                  ' !important;\n      border-width: 1px !important;\n    }\n    .slick-dots li.slick-active button::before {\n      background-color: '
                )
                .concat(n, ' !important;\n    }\n  ');
          return (0, Ps.jsxs)('div', {
            className: '',
            children: [
              i.length > 2 ? (0, Ps.jsx)('style', { children: s }) : '',
              (0, Ps.jsx)('h6', {
                className:
                  'mb-5 text-center font-galano text-xl font-medium normal-case leading-normal tracking-normal xl:mb-7',
                style: { color: n },
                children: t,
              }),
              a.visible && (0, Ps.jsx)(Ec, {}),
              i.length > 2
                ? (0, Ps.jsx)('ul', {
                    className:
                      'no-scrollbar !m-0 list-none lg:flex lg:items-start lg:justify-center lg:gap-10 lg:overflow-scroll',
                    'data-slick': JSON.stringify({
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      dots: !0,
                      mobileFirst: !0,
                      responsive: [{ breakpoint: 1024, settings: 'unslick' }],
                    }),
                    style: { '--active-bg-color': o, '--text-color': n, '--bg-color': r },
                    children: u.map(function (e) {
                      return (0, Ps.jsx)(Sc, { upsell: e, bundleLength: l.length });
                    }),
                  })
                : (0, Ps.jsx)('ul', {
                    className: '!m-0 flex list-none items-start justify-center gap-6 overflow-scroll lg:gap-10',
                    style: { '--active-bg-color': o, '--text-color': n, '--bg-color': r },
                    children: u.map(function (e) {
                      return (0, Ps.jsx)(Sc, { upsell: e, bundleLength: l.length });
                    }),
                  }),
            ],
          });
        },
        Tc = function (e) {
          var t = e.setBundleAdded,
            n = Kl(Us),
            r = Kl(eu).settings,
            o = r.text_color,
            a = r.active_bg_color,
            i = Xl(Us),
            l = Xl(Hs),
            u = n.map(function (e) {
              return parseInt(e.selectedVariant.price) * e.quantity;
            }),
            s = 0;
          u.length > 0 &&
            (s = u
              .reduce(function (e, t) {
                return e + t;
              })
              .toFixed(2));
          return (0, Ps.jsxs)('div', {
            className:
              'sticky bottom-4 left-0 right-0 z-[1001] mx-4 flex flex-col items-center justify-center gap-3 rounded-2xl bg-white p-4 xl:hidden',
            style: { '--active-bg-color': a, '--text-color': o },
            children: [
              (0, Ps.jsxs)('div', {
                className: 'flex w-full items-center justify-between',
                children: [
                  (0, Ps.jsx)('p', {
                    className: 'm-0 font-galano text-base font-bold text-galaxy',
                    children: 'Subtotal',
                  }),
                  (0, Ps.jsxs)('p', {
                    className: 'm-0 font-galano text-base font-bold text-galaxy',
                    children: ['$', s],
                  }),
                ],
              }),
              (0, Ps.jsx)('button', {
                className:
                  'block w-full rounded border-2 border-solid border-[var(--active-bg-color)] bg-[var(--active-bg-color)] py-6 text-center font-galano text-xl font-bold leading-tight text-white transition-colors hover:border-sky hover:bg-sky hover:text-galaxy',
                onClick: function () {
                  vc(n).then(function () {
                    i(), l(), t(!0);
                  });
                },
                children: 'Add Bundle to Cart',
              }),
            ],
          });
        },
        Nc = function () {
          var t = c((0, e.useState)(!1), 2),
            n = t[0],
            r = t[1],
            o = Kl(eu).settings,
            a = o.bg_color,
            i = o.bundle_bg_color,
            l = Kl(Us),
            u = Kl(nu);
          return n
            ? (0, Ps.jsx)(bs, { to: '/success' })
            : (0, Ps.jsxs)('div', {
                className: 'bundle-page-wrapper relative pb-20 xl:pb-12',
                style: { backgroundColor: i },
                children: [
                  (0, Ps.jsxs)('div', {
                    className: 'w-full px-4 pb-14 pt-10 xl:px-0 xl:pt-14',
                    style: { backgroundColor: a },
                    children: [
                      (0, Ps.jsx)(Vs, {}),
                      (0, Ps.jsxs)('div', {
                        className: 'relative z-10 w-full xl:mx-auto xl:max-w-5xl',
                        children: [
                          (0, Ps.jsx)(fc, { classes: 'xl:hidden' }),
                          (0, Ps.jsxs)('div', {
                            className: 'relative z-10 xl:grid xl:grid-cols-2 xl:gap-14',
                            children: [(0, Ps.jsx)(mc, { setBundleAdded: r, classes: '' }), (0, Ps.jsx)(xc, {})],
                          }),
                        ],
                      }),
                    ],
                  }),
                  0 !== u.length &&
                    (0, Ps.jsx)('div', {
                      className: 'w-full px-4 py-11 xl:mx-auto xl:max-w-6xl',
                      children: (0, Ps.jsx)(Cc, {}),
                    }),
                  l.length > 0 ? (0, Ps.jsx)(Tc, { setBundleAdded: r }) : '',
                ],
              });
        },
        jc = function () {
          var e = Kl(eu).settings,
            t = e.success_page_image,
            n = e.success_header,
            r = e.success_subheader,
            o = e.success_button_text,
            a = e.success_button_url,
            i = e.bg_color,
            l = e.active_bg_color,
            u = e.text_color;
          return (0, Ps.jsxs)('div', {
            className: 'bundle-page-wrapper relative overflow-hidden pb-48 xl:pb-14',
            style: { backgroundColor: i },
            children: [
              (0, Ps.jsx)(Vs, {}),
              (0, Ps.jsxs)('div', {
                className:
                  'relative z-10 mx-auto xl:flex xl:max-w-7xl xl:items-center xl:justify-center xl:gap-24 xl:py-14',
                children: [
                  (0, Ps.jsx)('div', {
                    className: 'xl:max-w-1/2 w-full px-12 pt-12 xl:p-0 xl:pt-14',
                    children: (0, Ps.jsx)('div', {
                      className: 'aspect-square rotate-[-6deg] overflow-hidden rounded-[3px] p-2.5',
                      style: { backgroundColor: l },
                      children: (0, Ps.jsx)('img', {
                        className: 'lazyload aspect-square h-auto w-full rounded-md object-cover object-center',
                        src: 'https:'.concat(t),
                        alt: 'Family wearing holiday matching pajamas',
                      }),
                    }),
                  }),
                  (0, Ps.jsx)('div', {
                    className: 'relative w-full xl:mx-auto xl:w-1/2',
                    style: { '--text-color': u, '--bg-color': i },
                    children: (0, Ps.jsxs)('div', {
                      className: 'relative z-10 px-4 pt-10 text-center xl:pt-0',
                      children: [
                        (0, Ps.jsx)('h2', {
                          className: 'mb-2 font-galano text-3xl font-bold leading-tight xl:text-4xl xl:leading-tight',
                          style: { color: u },
                          children: n,
                        }),
                        (0, Ps.jsx)('p', {
                          className: 'mb-8 font-galano text-sm font-medium leading-normal xl:text-xl xl:leading-normal',
                          style: { color: u },
                          children: r,
                        }),
                        (0, Ps.jsx)('a', {
                          href: a,
                          className:
                            'block w-full rounded border-2 border-solid border-[var(--text-color)] bg-[var(--text-color)] px-12 py-6 text-center text-xl font-bold leading-tight text-[var(--bg-color)] transition-colors hover:bg-[var(--bg-color)] hover:text-[var(--text-color)] lg:mx-auto lg:w-2/3',
                          children: o,
                        }),
                        (0, Ps.jsx)('a', {
                          href: 'https://littlesleepies.com/pages/family-matching-bundler#/',
                          className:
                            'mt-4 block w-full rounded border-2 border-solid border-[var(--text-color)] bg-[var(--bg-color)] px-12 py-6 text-center text-xl font-bold leading-tight text-[var(--text-color)] transition-colors hover:bg-[var(--text-color)] hover:text-[var(--bg-color)] lg:mx-auto lg:w-2/3 lg:px-0',
                          children: 'Build Another Bundle',
                        }),
                      ],
                    }),
                  }),
                ],
              }),
              (0, Ps.jsx)(zs, {}),
            ],
          });
        },
        Lc = function (t) {
          var n = ss();
          return (
            (0, e.useEffect)(
              function () {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              },
              [n]
            ),
            (0, Ps.jsx)(e.Fragment, { children: t.children })
          );
        };
      function Ac() {
        return (
          (Ac = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          Ac.apply(this, arguments)
        );
      }
      function Rc(e, t) {
        (e.prototype = Object.create(t.prototype)), (e.prototype.constructor = e), v(e, t);
      }
      var Pc = e.createContext(null);
      function Oc(t, n) {
        var r = Object.create(null);
        return (
          t &&
            e.Children.map(t, function (e) {
              return e;
            }).forEach(function (t) {
              r[t.key] = (function (t) {
                return n && (0, e.isValidElement)(t) ? n(t) : t;
              })(t);
            }),
          r
        );
      }
      function Dc(e, t, n) {
        return null != n[t] ? n[t] : e.props[t];
      }
      function Ic(t, n, r) {
        var o = Oc(t.children),
          a = (function (e, t) {
            function n(n) {
              return n in t ? t[n] : e[n];
            }
            (e = e || {}), (t = t || {});
            var r,
              o = Object.create(null),
              a = [];
            for (var i in e) i in t ? a.length && ((o[i] = a), (a = [])) : a.push(i);
            var l = {};
            for (var u in t) {
              if (o[u])
                for (r = 0; r < o[u].length; r++) {
                  var s = o[u][r];
                  l[o[u][r]] = n(s);
                }
              l[u] = n(u);
            }
            for (r = 0; r < a.length; r++) l[a[r]] = n(a[r]);
            return l;
          })(n, o);
        return (
          Object.keys(a).forEach(function (i) {
            var l = a[i];
            if ((0, e.isValidElement)(l)) {
              var u = i in n,
                s = i in o,
                c = n[i],
                f = (0, e.isValidElement)(c) && !c.props.in;
              !s || (u && !f)
                ? s || !u || f
                  ? s &&
                    u &&
                    (0, e.isValidElement)(c) &&
                    (a[i] = (0, e.cloneElement)(l, {
                      onExited: r.bind(null, l),
                      in: c.props.in,
                      exit: Dc(l, 'exit', t),
                      enter: Dc(l, 'enter', t),
                    }))
                  : (a[i] = (0, e.cloneElement)(l, { in: !1 }))
                : (a[i] = (0, e.cloneElement)(l, {
                    onExited: r.bind(null, l),
                    in: !0,
                    exit: Dc(l, 'exit', t),
                    enter: Dc(l, 'enter', t),
                  }));
            }
          }),
          a
        );
      }
      var Mc =
          Object.values ||
          function (e) {
            return Object.keys(e).map(function (t) {
              return e[t];
            });
          },
        zc = (function (t) {
          function n(e, n) {
            var r,
              o = (r = t.call(this, e, n) || this).handleExited.bind(_(r));
            return (r.state = { contextValue: { isMounting: !0 }, handleExited: o, firstRender: !0 }), r;
          }
          Rc(n, t);
          var r = n.prototype;
          return (
            (r.componentDidMount = function () {
              (this.mounted = !0), this.setState({ contextValue: { isMounting: !1 } });
            }),
            (r.componentWillUnmount = function () {
              this.mounted = !1;
            }),
            (n.getDerivedStateFromProps = function (t, n) {
              var r,
                o,
                a = n.children,
                i = n.handleExited;
              return {
                children: n.firstRender
                  ? ((r = t),
                    (o = i),
                    Oc(r.children, function (t) {
                      return (0,
                      e.cloneElement)(t, { onExited: o.bind(null, t), in: !0, appear: Dc(t, 'appear', r), enter: Dc(t, 'enter', r), exit: Dc(t, 'exit', r) });
                    }))
                  : Ic(t, a, i),
                firstRender: !1,
              };
            }),
            (r.handleExited = function (e, t) {
              var n = Oc(this.props.children);
              e.key in n ||
                (e.props.onExited && e.props.onExited(t),
                this.mounted &&
                  this.setState(function (t) {
                    var n = Ac({}, t.children);
                    return delete n[e.key], { children: n };
                  }));
            }),
            (r.render = function () {
              var t = this.props,
                n = t.component,
                r = t.childFactory,
                o = d(t, ['component', 'childFactory']),
                a = this.state.contextValue,
                i = Mc(this.state.children).map(r);
              return (
                delete o.appear,
                delete o.enter,
                delete o.exit,
                null === n
                  ? e.createElement(Pc.Provider, { value: a }, i)
                  : e.createElement(Pc.Provider, { value: a }, e.createElement(n, o, i))
              );
            }),
            n
          );
        })(e.Component);
      (zc.propTypes = {}),
        (zc.defaultProps = {
          component: 'div',
          childFactory: function (e) {
            return e;
          },
        });
      var Vc = zc;
      function Bc(e, t) {
        return e
          .replace(new RegExp('(^|\\s)' + t + '(?:\\s|$)', 'g'), '$1')
          .replace(/\s+/g, ' ')
          .replace(/^\s*|\s*$/g, '');
      }
      var Fc = !1,
        Uc = function (e) {
          return e.scrollTop;
        },
        Hc = 'unmounted',
        qc = 'exited',
        Wc = 'entering',
        $c = 'entered',
        Gc = 'exiting',
        Kc = (function (t) {
          function n(e, n) {
            var r;
            r = t.call(this, e, n) || this;
            var o,
              a = n && !n.isMounting ? e.enter : e.appear;
            return (
              (r.appearStatus = null),
              e.in
                ? a
                  ? ((o = qc), (r.appearStatus = Wc))
                  : (o = $c)
                : (o = e.unmountOnExit || e.mountOnEnter ? Hc : qc),
              (r.state = { status: o }),
              (r.nextCallback = null),
              r
            );
          }
          Rc(n, t),
            (n.getDerivedStateFromProps = function (e, t) {
              return e.in && t.status === Hc ? { status: qc } : null;
            });
          var r = n.prototype;
          return (
            (r.componentDidMount = function () {
              this.updateStatus(!0, this.appearStatus);
            }),
            (r.componentDidUpdate = function (e) {
              var t = null;
              if (e !== this.props) {
                var n = this.state.status;
                this.props.in ? n !== Wc && n !== $c && (t = Wc) : (n !== Wc && n !== $c) || (t = Gc);
              }
              this.updateStatus(!1, t);
            }),
            (r.componentWillUnmount = function () {
              this.cancelNextCallback();
            }),
            (r.getTimeouts = function () {
              var e,
                t,
                n,
                r = this.props.timeout;
              return (
                (e = t = n = r),
                null != r &&
                  'number' !== typeof r &&
                  ((e = r.exit), (t = r.enter), (n = void 0 !== r.appear ? r.appear : t)),
                { exit: e, enter: t, appear: n }
              );
            }),
            (r.updateStatus = function (e, t) {
              if ((void 0 === e && (e = !1), null !== t))
                if ((this.cancelNextCallback(), t === Wc)) {
                  if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var n = this.props.nodeRef ? this.props.nodeRef.current : A.findDOMNode(this);
                    n && Uc(n);
                  }
                  this.performEnter(e);
                } else this.performExit();
              else this.props.unmountOnExit && this.state.status === qc && this.setState({ status: Hc });
            }),
            (r.performEnter = function (e) {
              var t = this,
                n = this.props.enter,
                r = this.context ? this.context.isMounting : e,
                o = this.props.nodeRef ? [r] : [A.findDOMNode(this), r],
                a = o[0],
                i = o[1],
                l = this.getTimeouts(),
                u = r ? l.appear : l.enter;
              (!e && !n) || Fc
                ? this.safeSetState({ status: $c }, function () {
                    t.props.onEntered(a);
                  })
                : (this.props.onEnter(a, i),
                  this.safeSetState({ status: Wc }, function () {
                    t.props.onEntering(a, i),
                      t.onTransitionEnd(u, function () {
                        t.safeSetState({ status: $c }, function () {
                          t.props.onEntered(a, i);
                        });
                      });
                  }));
            }),
            (r.performExit = function () {
              var e = this,
                t = this.props.exit,
                n = this.getTimeouts(),
                r = this.props.nodeRef ? void 0 : A.findDOMNode(this);
              t && !Fc
                ? (this.props.onExit(r),
                  this.safeSetState({ status: Gc }, function () {
                    e.props.onExiting(r),
                      e.onTransitionEnd(n.exit, function () {
                        e.safeSetState({ status: qc }, function () {
                          e.props.onExited(r);
                        });
                      });
                  }))
                : this.safeSetState({ status: qc }, function () {
                    e.props.onExited(r);
                  });
            }),
            (r.cancelNextCallback = function () {
              null !== this.nextCallback && (this.nextCallback.cancel(), (this.nextCallback = null));
            }),
            (r.safeSetState = function (e, t) {
              (t = this.setNextCallback(t)), this.setState(e, t);
            }),
            (r.setNextCallback = function (e) {
              var t = this,
                n = !0;
              return (
                (this.nextCallback = function (r) {
                  n && ((n = !1), (t.nextCallback = null), e(r));
                }),
                (this.nextCallback.cancel = function () {
                  n = !1;
                }),
                this.nextCallback
              );
            }),
            (r.onTransitionEnd = function (e, t) {
              this.setNextCallback(t);
              var n = this.props.nodeRef ? this.props.nodeRef.current : A.findDOMNode(this),
                r = null == e && !this.props.addEndListener;
              if (n && !r) {
                if (this.props.addEndListener) {
                  var o = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback],
                    a = o[0],
                    i = o[1];
                  this.props.addEndListener(a, i);
                }
                null != e && setTimeout(this.nextCallback, e);
              } else setTimeout(this.nextCallback, 0);
            }),
            (r.render = function () {
              var t = this.state.status;
              if (t === Hc) return null;
              var n = this.props,
                r = n.children,
                o =
                  (n.in,
                  n.mountOnEnter,
                  n.unmountOnExit,
                  n.appear,
                  n.enter,
                  n.exit,
                  n.timeout,
                  n.addEndListener,
                  n.onEnter,
                  n.onEntering,
                  n.onEntered,
                  n.onExit,
                  n.onExiting,
                  n.onExited,
                  n.nodeRef,
                  d(n, [
                    'children',
                    'in',
                    'mountOnEnter',
                    'unmountOnExit',
                    'appear',
                    'enter',
                    'exit',
                    'timeout',
                    'addEndListener',
                    'onEnter',
                    'onEntering',
                    'onEntered',
                    'onExit',
                    'onExiting',
                    'onExited',
                    'nodeRef',
                  ]));
              return e.createElement(
                Pc.Provider,
                { value: null },
                'function' === typeof r ? r(t, o) : e.cloneElement(e.Children.only(r), o)
              );
            }),
            n
          );
        })(e.Component);
      function Qc() {}
      (Kc.contextType = Pc),
        (Kc.propTypes = {}),
        (Kc.defaultProps = {
          in: !1,
          mountOnEnter: !1,
          unmountOnExit: !1,
          appear: !1,
          enter: !0,
          exit: !0,
          onEnter: Qc,
          onEntering: Qc,
          onEntered: Qc,
          onExit: Qc,
          onExiting: Qc,
          onExited: Qc,
        }),
        (Kc.UNMOUNTED = Hc),
        (Kc.EXITED = qc),
        (Kc.ENTERING = Wc),
        (Kc.ENTERED = $c),
        (Kc.EXITING = Gc);
      var Yc = Kc,
        Xc = function (e, t) {
          return (
            e &&
            t &&
            t.split(' ').forEach(function (t) {
              return (
                (r = t),
                void ((n = e).classList
                  ? n.classList.remove(r)
                  : 'string' === typeof n.className
                  ? (n.className = Bc(n.className, r))
                  : n.setAttribute('class', Bc((n.className && n.className.baseVal) || '', r)))
              );
              var n, r;
            })
          );
        },
        Jc = (function (t) {
          function n() {
            for (var e, n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
            return (
              ((e = t.call.apply(t, [this].concat(r)) || this).appliedClasses = { appear: {}, enter: {}, exit: {} }),
              (e.onEnter = function (t, n) {
                var r = e.resolveArguments(t, n),
                  o = r[0],
                  a = r[1];
                e.removeClasses(o, 'exit'),
                  e.addClass(o, a ? 'appear' : 'enter', 'base'),
                  e.props.onEnter && e.props.onEnter(t, n);
              }),
              (e.onEntering = function (t, n) {
                var r = e.resolveArguments(t, n),
                  o = r[0],
                  a = r[1] ? 'appear' : 'enter';
                e.addClass(o, a, 'active'), e.props.onEntering && e.props.onEntering(t, n);
              }),
              (e.onEntered = function (t, n) {
                var r = e.resolveArguments(t, n),
                  o = r[0],
                  a = r[1] ? 'appear' : 'enter';
                e.removeClasses(o, a), e.addClass(o, a, 'done'), e.props.onEntered && e.props.onEntered(t, n);
              }),
              (e.onExit = function (t) {
                var n = e.resolveArguments(t)[0];
                e.removeClasses(n, 'appear'),
                  e.removeClasses(n, 'enter'),
                  e.addClass(n, 'exit', 'base'),
                  e.props.onExit && e.props.onExit(t);
              }),
              (e.onExiting = function (t) {
                var n = e.resolveArguments(t)[0];
                e.addClass(n, 'exit', 'active'), e.props.onExiting && e.props.onExiting(t);
              }),
              (e.onExited = function (t) {
                var n = e.resolveArguments(t)[0];
                e.removeClasses(n, 'exit'), e.addClass(n, 'exit', 'done'), e.props.onExited && e.props.onExited(t);
              }),
              (e.resolveArguments = function (t, n) {
                return e.props.nodeRef ? [e.props.nodeRef.current, t] : [t, n];
              }),
              (e.getClassNames = function (t) {
                var n = e.props.classNames,
                  r = 'string' === typeof n,
                  o = r ? '' + (r && n ? n + '-' : '') + t : n[t];
                return {
                  baseClassName: o,
                  activeClassName: r ? o + '-active' : n[t + 'Active'],
                  doneClassName: r ? o + '-done' : n[t + 'Done'],
                };
              }),
              e
            );
          }
          Rc(n, t);
          var r = n.prototype;
          return (
            (r.addClass = function (e, t, n) {
              var r = this.getClassNames(t)[n + 'ClassName'],
                o = this.getClassNames('enter').doneClassName;
              'appear' === t && 'done' === n && o && (r += ' ' + o),
                'active' === n && e && Uc(e),
                r &&
                  ((this.appliedClasses[t][n] = r),
                  (function (e, t) {
                    e &&
                      t &&
                      t.split(' ').forEach(function (t) {
                        return (
                          (r = t),
                          void ((n = e).classList
                            ? n.classList.add(r)
                            : (function (e, t) {
                                return e.classList
                                  ? !!t && e.classList.contains(t)
                                  : -1 !== (' ' + (e.className.baseVal || e.className) + ' ').indexOf(' ' + t + ' ');
                              })(n, r) ||
                              ('string' === typeof n.className
                                ? (n.className = n.className + ' ' + r)
                                : n.setAttribute('class', ((n.className && n.className.baseVal) || '') + ' ' + r)))
                        );
                        var n, r;
                      });
                  })(e, r));
            }),
            (r.removeClasses = function (e, t) {
              var n = this.appliedClasses[t],
                r = n.base,
                o = n.active,
                a = n.done;
              (this.appliedClasses[t] = {}), r && Xc(e, r), o && Xc(e, o), a && Xc(e, a);
            }),
            (r.render = function () {
              var t = this.props,
                n = (t.classNames, d(t, ['classNames']));
              return e.createElement(
                Yc,
                Ac({}, n, {
                  onEnter: this.onEnter,
                  onEntered: this.onEntered,
                  onEntering: this.onEntering,
                  onExit: this.onExit,
                  onExiting: this.onExiting,
                  onExited: this.onExited,
                })
              );
            }),
            n
          );
        })(e.Component);
      (Jc.defaultProps = { classNames: '' }), (Jc.propTypes = {});
      var Zc = Jc;
      var ef = function () {
          var t = c(Ql(tu), 2),
            n = t[0],
            r = t[1],
            o = Yl(ru),
            i = Yl(ou),
            u = c(Ql(nu), 2),
            s = u[0],
            f = u[1],
            d = c(Ql(eu), 2),
            p = d[0],
            h = d[1],
            v = ss();
          if (
            ((0, e.useEffect)(
              function () {
                var e = document.getElementById('family-matching-bundler-json').textContent,
                  t = JSON.parse(e).blocks,
                  n = t.filter(function (e) {
                    return 'collection' === e.type;
                  }),
                  o = (function () {
                    var e = l(
                      a().mark(function e() {
                        var o;
                        return a().wrap(function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                return (e.next = 2), iu(n, t);
                              case 2:
                                (o = e.sent), r(o);
                              case 4:
                              case 'end':
                                return e.stop();
                            }
                        }, e);
                      })
                    );
                    return function () {
                      return e.apply(this, arguments);
                    };
                  })();
                o();
              },
              [r]
            ),
            (0, e.useEffect)(
              function () {
                if (n.length > 0) {
                  var e = (function () {
                    var e = l(
                      a().mark(function e() {
                        var t;
                        return a().wrap(function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                return (e.next = 2), uu(n);
                              case 2:
                                (t = e.sent), i(t);
                              case 4:
                              case 'end':
                                return e.stop();
                            }
                        }, e);
                      })
                    );
                    return function () {
                      return e.apply(this, arguments);
                    };
                  })();
                  e();
                }
              },
              [n, i]
            ),
            (0, e.useEffect)(
              function () {
                var e = (function () {
                  var e = l(
                    a().mark(function e() {
                      var t, r, i, l;
                      return a().wrap(function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (t = n
                                  .map(function (e) {
                                    return e.products;
                                  })
                                  .flat()),
                                (r = s
                                  .map(function (e) {
                                    return e.products;
                                  })
                                  .flat()),
                                (i = t.concat(r)),
                                (e.next = 5),
                                pu(i)
                              );
                            case 5:
                              (l = e.sent), o(l);
                            case 7:
                            case 'end':
                              return e.stop();
                          }
                      }, e);
                    })
                  );
                  return function () {
                    return e.apply(this, arguments);
                  };
                })();
                e();
              },
              [n, o, s]
            ),
            (0, e.useEffect)(
              function () {
                var e = JSON.parse(document.getElementById('family-matching-bundler-json').textContent).blocks.filter(
                    function (e) {
                      return 'upsell' === e.type;
                    }
                  ),
                  t = (function () {
                    var t = l(
                      a().mark(function t() {
                        var n;
                        return a().wrap(function (t) {
                          for (;;)
                            switch ((t.prev = t.next)) {
                              case 0:
                                return (t.next = 2), fu(e);
                              case 2:
                                (n = t.sent) && f(n);
                              case 4:
                              case 'end':
                                return t.stop();
                            }
                        }, t);
                      })
                    );
                    return function () {
                      return t.apply(this, arguments);
                    };
                  })();
                t();
              },
              [f]
            ),
            (0, e.useEffect)(
              function () {
                var e = JSON.parse(document.getElementById('family-matching-bundler-json').textContent).page;
                h(e);
              },
              [h]
            ),
            p && p.settings && n.length > 0)
          )
            return (0, Ps.jsx)(Lc, {
              children: (0, Ps.jsx)(Vc, {
                children: (0, Ps.jsx)(
                  Zc,
                  {
                    classNames: 'fade',
                    timeout: 1e3,
                    children: (0, Ps.jsxs)(Ss, {
                      location: v,
                      children: [
                        (0, Ps.jsx)(xs, { path: '/', element: (0, Ps.jsx)(Fs, {}) }),
                        (0, Ps.jsx)(xs, { path: 'name-and-age', element: (0, Ps.jsx)(Ys, {}) }),
                        (0, Ps.jsx)(xs, { path: 'size-and-style', element: (0, Ps.jsx)(cc, {}) }),
                        (0, Ps.jsx)(xs, { path: 'current-bundle', element: (0, Ps.jsx)(Nc, {}) }),
                        (0, Ps.jsx)(xs, { path: 'success', element: (0, Ps.jsx)(jc, {}) }),
                      ],
                    }),
                  },
                  v.pathname
                ),
              }),
            });
        },
        tf = function (e) {
          e &&
            e instanceof Function &&
            n
              .e(787)
              .then(n.bind(n, 787))
              .then(function (t) {
                var n = t.getCLS,
                  r = t.getFID,
                  o = t.getFCP,
                  a = t.getLCP,
                  i = t.getTTFB;
                n(e), r(e), o(e), a(e), i(e);
              });
        },
        nf = Gl({
          key: 'inProgressBundleItemAtom',
          default: {
            selectedProduct: {},
            selectedVariant: {},
            selectedPrint: {},
            personsName: '',
            collection: { title: '' },
          },
          effects_UNSTABLE: [Jl(''.concat(Zl, 'inProgressBundleItemAtom'))],
        }),
        rf = Gl({ key: 'activeDrawer', default: { visible: !1 } }),
        of = function () {
          var t = Kl(Us),
            n = Kl(nf),
            r = Kl(Hs),
            o = Kl(eu),
            a = Kl(tu),
            i = Kl(nu),
            l = Kl(ru),
            u = Kl(ou),
            s = Kl(rf);
          return (
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: bundler'), console.log(t);
              },
              [t]
            ),
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: activeDrawer'), console.log(s);
              },
              [s]
            ),
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: swatches'), console.log(l);
              },
              [l]
            ),
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: sizeCharts'), console.log(u);
              },
              [u]
            ),
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: upsells'), console.log(i);
              },
              [i]
            ),
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: inProgressBundleItem'), console.log(n);
              },
              [n]
            ),
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: inProgressBundleGroup'), console.log(r);
              },
              [r]
            ),
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: page'), console.log(o);
              },
              [o]
            ),
            (0, e.useEffect)(
              function () {
                console.log('Changed atom: collection'), console.log(a);
              },
              [a]
            ),
            null
          );
        };
      r
        .createRoot(document.getElementById('root'))
        .render(
          (0, Ps.jsxs)($l, { children: [(0, Ps.jsx)(of, {}), (0, Ps.jsx)(js, { children: (0, Ps.jsx)(ef, {}) })] })
        ),
        tf();
    })();
})();
//# sourceMappingURL=main.1585e94e.js.map
